import { j as s, $ as Jr, a as ta, b as ea, c as na, d as sa, e as oa, g as ra, i as aa, n as E, O as ia, k as Es, l as Ls, w as En, Z as la, H as ca, m as Nn, o as yt, p as to, r as ir, q as da, t as As, W as ha, u as ua, A as pa, F as ma, v as lr, x as cr, y as $s, z as dr, B as Ln, C as ga, D as fa, E as ba, G as xa, I as ya, J as _a, K as hr, L as Ca, M as wa } from "./vendor-DSFjHoVg.js";
import f from "classnames";
import { memo as Mn, forwardRef as $, PureComponent as D, useState as V, useCallback as P, useEffect as tt, cloneElement as sn, isValidElement as Pt, Component as _t, Children as Ft, createRef as B, createContext as Bt, useRef as Y, useMemo as U, useContext as qt, Fragment as Yt, useImperativeHandle as ke, createElement as va, lazy as Sa, Suspense as Ia, useReducer as Da } from "react";
import { I as N, T as L, w as on, r as Ss, B as rt, a as Ze, b as ka, E as Bs, e as Ta } from "./emoji-D9B2480I.js";
import { c as eT, f as nT, d as sT, i as oT } from "./emoji-D9B2480I.js";
import { useKey as ur, useMount as Te, useUnmount as Qt, useUpdateEffect as Gt, useToggle as ja, useSetState as Na, useClickAway as pr, useEvent as rn, usePrevious as Je, useDebounce as Pa } from "react-use";
import j from "moment-timezone";
import { v4 as tn } from "uuid";
import { noop as Fa } from "ts-essentials";
import { a as aT } from "./svg-D-6lUDMH.js";
import Ra from "react-dom";
const Ea = "h-button--button__root", La = "h-button--button__normal", Aa = "h-button--button__large", $a = "h-button--button__primary", Ba = "h-button--button__active", Oa = "h-button--button__label", Ha = "h-button--button__secondary", Wa = "h-button--button__tertiary", Ma = "h-button--button__danger", za = "h-button--button__disabled", Va = "h-button--button__loading", Ka = "h-button--button__withLabel", Ua = "h-button--button__slot", qa = "h-button--button__content", Ct = {
  root: Ea,
  normal: La,
  large: Aa,
  primary: $a,
  active: Ba,
  label: Oa,
  secondary: Ha,
  tertiary: Wa,
  danger: Ma,
  disabled: za,
  loading: Va,
  withLabel: Ka,
  slot: Ua,
  content: qa
}, Q = Mn(
  $(function({
    children: t,
    className: e,
    type: n = "button",
    variant: o = "primary",
    size: r = "normal",
    icon: i,
    slotStart: l,
    slotEnd: c,
    active: d = !1,
    isLoading: h = !1,
    loadingIndicator: u = /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: "Loading..." }),
    label: p,
    styleText: m = !0,
    disabled: g = !1,
    onClick: b,
    ...x
  }, w) {
    const y = f(
      {
        [Ct.root]: !0,
        [Ct[o]]: !0,
        [Ct[r]]: !0,
        [Ct.active]: d,
        [Ct.disabled]: g,
        [Ct.loading]: h,
        [Ct.withLabel]: !c && !!p
      },
      e
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...x,
        type: n,
        className: y,
        onClick: g ? void 0 : b,
        disabled: g,
        ref: w,
        children: h ? u : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          (l || i) && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: i ? /* @__PURE__ */ s.jsx(N, { name: i }) : l }),
          (m || t) && /* @__PURE__ */ s.jsx("span", { className: Ct.content, children: m ? /* @__PURE__ */ s.jsx(
            L.Paragraph,
            {
              as: "span",
              variant: "3",
              wrap: "nowrap",
              color: "inherit",
              children: t
            }
          ) : t }),
          p && /* @__PURE__ */ s.jsx(
            L.Paragraph,
            {
              as: "span",
              variant: "4",
              wrap: "nowrap",
              color: "inherit",
              className: Ct.label,
              children: p
            }
          ),
          c && /* @__PURE__ */ s.jsx("span", { className: Ct.slot, children: c })
        ] })
      }
    );
  })
), Ga = "h-button-navigationButton--navigationButton__root", Ya = {
  root: Ga
}, YD = ({
  className: a,
  navigate: t,
  onClick: e,
  ...n
}) => {
  const o = (r) => {
    e?.(r), t();
  };
  return /* @__PURE__ */ s.jsx(
    Q,
    {
      ...n,
      variant: n.variant ?? "tertiary",
      onClick: o,
      className: f(a, Ya.root)
    }
  );
}, Qa = "h-spinner--spinner__root", Xa = {
  root: Qa
};
class zn extends D {
  render() {
    const { className: t, size: e, color: n, trackColor: o, bgColor: r, ...i } = this.props, l = f(
      {
        [Xa.root]: !0
      },
      t
    ), c = typeof e == "number" ? e : 32, d = typeof e == "number" ? `${c}px` : "32px", h = `${Math.max(Math.floor(c / 8), 1)}px`, u = {
      height: d,
      width: d,
      borderWidth: h
    };
    return o && o.length && (u.borderColor = o), n && n.length && (u.borderTopColor = n), r && r.length && (u.backgroundColor = r), /* @__PURE__ */ s.jsx("div", { ...i, style: u, className: l });
  }
}
const Za = "h-iconButton--iconButton__root", Ja = {
  root: Za
}, K = Mn(
  $(function({
    children: t,
    className: e,
    icon: n,
    iconProps: o,
    iconSize: r,
    variant: i = "primary",
    ...l
  }, c) {
    return /* @__PURE__ */ s.jsx(
      Q,
      {
        ref: c,
        "aria-label": n,
        ...l,
        variant: i,
        className: f(Ja.root, e),
        loadingIndicator: /* @__PURE__ */ s.jsx(zn, { size: 16 }),
        styleText: !1,
        slotStart: /* @__PURE__ */ s.jsx(N, { size: r || 16, name: n, ...o })
      }
    );
  })
), ti = "h-tooltip--tooltip__content", ei = "h-tooltip--tooltip__contentLight", ni = "h-tooltip--tooltip__contentHasHead", si = "h-tooltip--tooltip__body", oi = "h-tooltip--tooltip__head", ri = "h-tooltip--tooltip__arrow", ie = {
  content: ti,
  contentLight: ei,
  contentHasHead: ni,
  body: si,
  head: oi,
  arrow: ri
}, ai = 400;
function gt({
  children: a,
  content: t,
  onOpenChange: e,
  side: n = "top",
  className: o,
  head: r,
  defaultOpen: i,
  alwaysShow: l,
  disabled: c,
  delayDuration: d = ai,
  align: h,
  "aria-label": u,
  wrap: p = "span",
  wrapProps: m,
  requireClick: g,
  light: b,
  ...x
}) {
  const [w, y] = V(
    g ? !1 : void 0
  ), v = P(() => {
    y(!1), window.removeEventListener("click", v);
  }, []);
  tt(() => () => {
    window.removeEventListener("click", v);
  }, [v]);
  const _ = Jr();
  if (c || !t)
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: a });
  const C = (I) => {
    I.stopPropagation(), window[w ? "removeEventListener" : "addEventListener"](
      "click",
      v
    ), y(!w);
  }, S = f(
    ie.content,
    {
      [ie.contentHasHead]: !!r,
      [ie.contentLight]: b
    },
    o
  );
  return /* @__PURE__ */ s.jsx(ta, { children: /* @__PURE__ */ s.jsxs(
    ea,
    {
      open: w ?? (l ? !0 : void 0),
      defaultOpen: i,
      delayDuration: d,
      "aria-label": u,
      onOpenChange: e,
      children: [
        /* @__PURE__ */ s.jsx(na, { asChild: !0, children: p !== "none" ? /* @__PURE__ */ s.jsx(
          p,
          {
            onClick: g ? C : void 0,
            ...m,
            ...x,
            children: a
          }
        ) : g && Pt(a) ? sn(a, { onClick: C }) : a }),
        /* @__PURE__ */ s.jsx(sa, { children: /* @__PURE__ */ s.jsx(
          oa,
          {
            id: _,
            side: n,
            sideOffset: 4,
            align: h,
            className: S,
            style: { zIndex: 2147483647 },
            children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              r && /* @__PURE__ */ s.jsx("div", { className: ie.head, children: r }),
              /* @__PURE__ */ s.jsx("div", { className: ie.body, children: t }),
              /* @__PURE__ */ s.jsx(ra, { className: ie.arrow })
            ] })
          }
        ) })
      ]
    }
  ) });
}
const ii = "h-attachment--attachment__root", li = "h-attachment--attachment__icon", ci = "h-attachment--attachment__name", es = {
  root: ii,
  icon: li,
  name: ci
}, eo = {
  /* images */
  jpg: "file-image",
  jpeg: "file-image",
  bmp: "file-image",
  gif: "file-image",
  tiff: "file-image",
  png: "file-image",
  /* video */
  mp4: "file-video",
  m4v: "file-video",
  mpeg: "file-video",
  mov: "file-video",
  avi: "file-video",
  wmv: "file-video",
  webm: "file-video",
  flv: "file-video",
  /* audio */
  wav: "file-audio",
  mp3: "file-audio",
  aiff: "file-audio",
  acc: "file-audio",
  ogg: "file-audio",
  wma: "file-audio",
  flac: "file-audio",
  alac: "file-audio",
  /* documents */
  pdf: "file-pdf",
  csv: "file-csv",
  doc: "file-word",
  docx: "file-word",
  xls: "file-excel",
  xlsx: "file-excel",
  ppt: "file-powerpoint",
  pptx: "file-powerpoint",
  /* archives */
  zip: "file-archive",
  rar: "file-archive",
  arc: "file-archive",
  "7z": "file-archive",
  s7z: "file-archive",
  tar: "file-archive",
  bz2: "file-archive",
  gz: "file-archive"
};
function di(a) {
  const t = a.split(".").pop()?.toLowerCase();
  return !t || !eo[t] ? "file" : eo[t];
}
class QD extends D {
  render() {
    const {
      className: t,
      fileName: e,
      label: n,
      onDownload: o,
      onPreview: r,
      isPreviewLoading: i,
      isDownloadLoading: l,
      extraButtons: c,
      ...d
    } = this.props, h = f(
      {
        [es.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      /* @__PURE__ */ s.jsx(
        N,
        {
          className: es.icon,
          name: di(e),
          size: 24,
          color: "neutral.700"
        }
      ),
      /* @__PURE__ */ s.jsx(
        gt,
        {
          content: n || e,
          wrap: "div",
          wrapProps: { className: es.name },
          children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "4", color: "secondary", children: n || e })
        }
      ),
      r && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: i,
          variant: "secondary",
          icon: "eye",
          onClick: i ? void 0 : r
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        K,
        {
          isLoading: l,
          variant: "secondary",
          icon: "download",
          onClick: l ? void 0 : o
        }
      ),
      c
    ] });
  }
}
const hi = "h-avatar--avatar__root", Pn = {
  root: hi,
  "avatar-24": "h-avatar--avatar__avatar-24",
  "avatar-32": "h-avatar--avatar__avatar-32",
  "avatar-40": "h-avatar--avatar__avatar-40"
}, ui = {
  24: 16,
  32: 20,
  40: 24
}, pi = ({
  icon: a,
  size: t,
  color: e = "inherit"
}) => /* @__PURE__ */ s.jsx(N, { name: a, size: ui[t], color: e }), mi = "h-image--image__image", gi = "h-image--image__error", fi = "h-image--image__complete", ns = {
  image: mi,
  error: gi,
  complete: fi
};
class Os extends _t {
  static defaultProps;
  mounted;
  constructor(t) {
    super(t), this.state = {
      imageSrc: "",
      loadingError: !1,
      loadingComplete: !1
    }, this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.mounted = !0;
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { src: t } = this.props;
    this.handleSource(t);
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { src: e } = this.props;
    t.src !== e && this.handleSource(t.src);
  }
  componentWillUnmount() {
    this.mounted = !1;
  }
  handleSource(t) {
    typeof t == "string" ? this.setState({
      imageSrc: t
    }) : t().then((e) => {
      this.mounted && typeof e == "string" && this.setState({
        imageSrc: e
      });
    }).catch(() => {
      this.mounted && this.setState({
        loadingError: !0
      });
    });
  }
  onLoad(t) {
    this.setState({
      loadingComplete: !0,
      loadingError: !1
    }), this.props.onLoad?.(t);
  }
  onError(t) {
    this.setState({
      loadingError: !0,
      loadingComplete: !1
    }), this.props.onError?.(t);
  }
  render() {
    const { className: t, src: e, alt: n, ...o } = this.props, { imageSrc: r } = this.state, { loadingError: i, loadingComplete: l } = this.state, c = f(
      {
        [ns.image]: !0,
        [ns.error]: !!i,
        [ns.complete]: !!l
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "img",
      {
        ...o,
        className: c,
        onError: this.onError,
        onLoad: this.onLoad,
        src: r,
        alt: n || ""
      }
    );
  }
}
Os.defaultProps = {
  className: "",
  alt: ""
};
const bi = "h-avatar--imageAvatar__root", xi = {
  root: bi
}, yi = ({
  src: a,
  alt: t = "avatar"
}) => /* @__PURE__ */ s.jsx(Os, { src: a, alt: t, className: xi.root }), _i = "h-avatar--textAvatar__root", Fn = {
  root: _i,
  "avatar-24": "h-avatar--textAvatar__avatar-24",
  "avatar-32": "h-avatar--textAvatar__avatar-32",
  "avatar-40": "h-avatar--textAvatar__avatar-40"
}, Ci = {
  24: Fn["avatar-24"],
  32: Fn["avatar-32"],
  40: Fn["avatar-40"]
}, wi = ({ text: a = "", size: t }) => /* @__PURE__ */ s.jsx("div", { className: f(Fn.root, Ci[t]), children: a.trim().split(" ").map(
  (e, n, o) => o.length === 1 ? e : e[0]
).join("").slice(0, 2) }), vi = [
  {
    contentColor: "var(--dixa-avatar-content-green)",
    backgroundColor: "var(--dixa-avatar-background-green)"
  },
  {
    contentColor: "var(--dixa-avatar-content-purple)",
    backgroundColor: "var(--dixa-avatar-background-purple)"
  },
  {
    contentColor: "var(--dixa-avatar-content-blue)",
    backgroundColor: "var(--dixa-avatar-background-blue)"
  },
  {
    contentColor: "var(--dixa-avatar-content-orange)",
    backgroundColor: "var(--dixa-avatar-background-orange)"
  },
  {
    contentColor: "var(--dixa-avatar-content-red)",
    backgroundColor: "var(--dixa-avatar-background-red)"
  }
];
class Si {
  constructor(t) {
    this.colors = t, this.colors = t;
  }
  generate(t) {
    const e = this.getRandomIndex(t);
    return this.colors[e];
  }
  getRandomIndex(t) {
    const e = aa(t);
    return Math.floor(e() * this.colors.length);
  }
}
var J = /* @__PURE__ */ ((a) => (a.Icon = "Icon", a.Image = "Image", a.Text = "Text", a))(J || {});
function le(a) {
  return a.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, "");
}
function wt(a) {
  return !!a && a.trim().length !== 0;
}
function Ii(a) {
  if (a.icon)
    return {
      type: J.Icon,
      icon: a.icon,
      backgroundColor: a.color?.backgroundColor,
      iconColor: a.color?.contentColor
    };
  const { user: t } = a;
  if (!t)
    return {
      type: J.Icon,
      icon: "user-slash"
    };
  if (wt(t.avatar_url))
    return {
      type: J.Image,
      src: t.avatar_url,
      alt: t.name || t.display_name || t.email || t.phone_number || t.given_name || t.family_name || ""
    };
  if (wt(t.name)) {
    const e = le(t.name.trim()).split(" ");
    if (e.length === 1)
      return {
        type: J.Text,
        text: e[0]?.[0] ?? ""
      };
    const n = e[0], o = e[e.length - 1];
    return {
      type: J.Text,
      text: (n?.[0] ?? "") + (o?.[0] ?? "")
    };
  }
  if (wt(t.display_name))
    return {
      type: J.Text,
      text: le(t.display_name.trim())
    };
  if (wt(t.given_name) && wt(t.family_name))
    return {
      type: J.Text,
      text: le(t.given_name.trim())[0] + le(t.family_name.trim())[0]
    };
  if (wt(t.given_name) && !wt(t.family_name))
    return {
      type: J.Text,
      text: le(t.given_name.trim())[0]
    };
  if (!wt(t.given_name) && wt(t.family_name))
    return {
      type: J.Text,
      text: le(t.family_name.trim())[0]
    };
  if (wt(t.email)) {
    const [e] = t.email.split("@");
    return {
      type: J.Text,
      text: e.trim()
    };
  }
  return wt(t.phone_number) ? {
    type: J.Text,
    text: t.phone_number.slice(-2)
  } : t.id ? {
    type: J.Icon,
    icon: "user-secret"
  } : {
    type: J.Icon,
    icon: "user-slash"
  };
}
const vt = {
  backgroundColor: "var(--dixa-color-neutral-200)",
  contentColor: "var(--dixa-color-neutral-700)"
}, no = {
  shopify: {
    backgroundColor: "rgba(148, 190, 69, 0.1)",
    // this is the same as the content color but has opacity
    contentColor: "#94BE45"
  },
  agillic: {
    ...vt,
    contentColor: "#000"
  },
  magento: {
    backgroundColor: "rgba(193, 72, 0, 0.1)",
    contentColor: "#C14800"
  },
  salesforce: {
    backgroundColor: "rgba(3, 161, 224, 0.1)",
    contentColor: "#03A1E0"
  },
  busylight: {
    backgroundColor: "rgba(27, 190, 246, 0.1)",
    contentColor: "#1BBEF6"
  },
  podio: {
    backgroundColor: "rgba(80, 145, 189, 0.1)",
    contentColor: "#5091BD"
  },
  "user-secret": vt,
  "user-slash": vt,
  "map-pin": vt,
  "web-form": vt,
  code: vt,
  history: vt,
  smile: vt,
  key: vt,
  webhooks: vt,
  plug: vt
}, Di = {
  24: Pn["avatar-24"],
  32: Pn["avatar-32"],
  40: Pn["avatar-40"]
};
class ki extends D {
  static defaultProps = {
    size: "32",
    colorGenerator: new Si(vi)
  };
  getAvatarChild(t, e) {
    if (t.type === J.Icon)
      return /* @__PURE__ */ s.jsx(
        pi,
        {
          size: e,
          icon: t.icon,
          color: t.iconColor
        }
      );
    if (t.type === J.Image)
      return /* @__PURE__ */ s.jsx(yi, { src: t.src, alt: t.alt });
    if (t.type === J.Text)
      return /* @__PURE__ */ s.jsx(wi, { size: e, text: t.text });
  }
  calculateColor(t) {
    if (t.type === J.Icon) {
      if (t.backgroundColor && t.iconColor)
        return {
          backgroundColor: t.backgroundColor,
          contentColor: t.iconColor
        };
      if (no[t.icon])
        return no[t.icon];
    }
    return t.type === J.Image ? {
      backgroundColor: "transparent",
      contentColor: "initial"
    } : this.props.user?.id ? this.props.colorGenerator.generate(this.props.user.id.toString()) : this.props.icon ? this.props.colorGenerator.generate(this.props.icon) : t.type === J.Text ? this.props.colorGenerator.generate(t.text) : this.props.colorGenerator.generate();
  }
  render() {
    const { className: t, size: e } = this.props, n = Ii(this.props), o = this.getAvatarChild(n, e), r = this.calculateColor(n);
    return /* @__PURE__ */ s.jsx(
      "div",
      {
        style: {
          backgroundColor: r.backgroundColor,
          color: r.contentColor
        },
        className: f(
          Pn.root,
          Di[e],
          t
        ),
        children: o
      }
    );
  }
}
const mr = on(ki, {
  fallback: null
}), Ti = "h-badge--badge__badge", ji = "h-badge--badge__badgeSmall", Ni = "h-badge--badge__badgeMedium", Pi = "h-badge--badge__badgePrimary", Fi = "h-badge--badge__badgeSecondary", Ri = "h-badge--badge__badgeSuccess", Ei = "h-badge--badge__badgeInfo", Li = "h-badge--badge__badgeWarning", Ai = "h-badge--badge__badgeError", $t = {
  badge: Ti,
  badgeSmall: ji,
  badgeMedium: Ni,
  badgePrimary: Pi,
  badgeSecondary: Fi,
  badgeSuccess: Ri,
  badgeInfo: Ei,
  badgeWarning: Li,
  badgeError: Ai
}, $i = {
  small: $t.badgeSmall,
  medium: $t.badgeMedium
}, Bi = {
  primary: $t.badgePrimary,
  secondary: $t.badgeSecondary,
  success: $t.badgeSuccess,
  info: $t.badgeInfo,
  warning: $t.badgeWarning,
  error: $t.badgeError
}, Oi = "badge";
function XD(a) {
  const { className: t, size: e, variant: n, children: o, ...r } = a, i = f(
    $t.badge,
    $i[e],
    Bi[n],
    t
  );
  return /* @__PURE__ */ s.jsx("span", { className: i, ...r, "data-testid": Oi, children: o });
}
const O = $(function({
  flexWrap: t,
  flexDirection: e,
  justifyItems: n,
  justifyContent: o,
  alignItems: r,
  alignContent: i,
  gap: l,
  style: c,
  children: d,
  ...h
}, u) {
  const p = {
    ...t && { flexWrap: t },
    ...e && { flexDirection: e },
    ...n && { justifyItems: n },
    ...o && { justifyContent: o },
    ...r && { alignItems: r },
    ...i && { alignContent: i },
    ...l && { gap: Ss(l) },
    display: "flex",
    ...c
  };
  return /* @__PURE__ */ s.jsx(rt, { ...h, style: p, ref: u, children: d });
}), Hi = "h-banner--banner__root", Wi = "h-banner--banner__rootWithClose", Mi = "h-banner--banner__iconContainer", zi = "h-banner--banner__closeIcon", Vi = "h-banner--banner__headline", Ki = "h-banner--banner__rootInfo", Ui = "h-banner--banner__icon", qi = "h-banner--banner__description", Gi = "h-banner--banner__rootWarning", Yi = "h-banner--banner__rootAnnouncement", Qi = "h-banner--banner__rootSuccess", Xi = "h-banner--banner__rootFail", bt = {
  root: Hi,
  rootWithClose: Wi,
  iconContainer: Mi,
  closeIcon: zi,
  headline: Vi,
  rootInfo: Ki,
  icon: Ui,
  description: qi,
  rootWarning: Gi,
  rootAnnouncement: Yi,
  rootSuccess: Qi,
  rootFail: Xi
}, Zi = (a, t) => {
  if (t !== void 0)
    return t;
  switch (a) {
    case "info":
    case "announcement":
      return "info";
    case "warning":
      return "exclamation-triangle-filled";
    case "success":
      return "check-circle-filled";
    default:
      return "close-circle-filled";
  }
}, ZD = ({
  actionSlot: a,
  className: t,
  description: e,
  headline: n,
  icon: o,
  variant: r,
  onClose: i
}) => {
  const l = f(bt.root, t, {
    [bt.rootInfo]: r === "info",
    [bt.rootAnnouncement]: r === "announcement",
    [bt.rootWarning]: r === "warning",
    [bt.rootSuccess]: r === "success",
    [bt.rootFail]: r === "fail",
    [bt.rootWithClose]: i
  }), c = Zi(r, o);
  return /* @__PURE__ */ s.jsxs("div", { className: l, children: [
    /* @__PURE__ */ s.jsxs(O, { justifyContent: "center", children: [
      c && /* @__PURE__ */ s.jsx("span", { className: bt.iconContainer, children: /* @__PURE__ */ s.jsx(N, { name: c, size: 16, className: bt.icon }) }),
      /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", children: [
        n && /* @__PURE__ */ s.jsx(
          L.Heading,
          {
            as: "span",
            variant: "heading-3",
            className: bt.headline,
            children: n
          }
        ),
        sn(e, {
          className: bt.description
        })
      ] })
    ] }),
    a ? /* @__PURE__ */ s.jsx(O, { gap: "250", margin: "0 0 0 250", children: a }) : i && /* @__PURE__ */ s.jsx(
      K,
      {
        icon: "close",
        variant: "tertiary",
        className: bt.closeIcon,
        onClick: i
      }
    )
  ] });
}, Ji = "h-buttonGroup--buttonGroup__root", tl = "h-buttonGroup--buttonGroup__button", el = "h-buttonGroup--buttonGroup__buttonWithBorder", nl = "h-buttonGroup--buttonGroup__buttonWithoutBorder", dn = {
  root: Ji,
  button: tl,
  buttonWithBorder: el,
  buttonWithoutBorder: nl
}, JD = ({
  className: a,
  children: t,
  variant: e,
  size: n,
  disabled: o
}) => {
  const r = f(dn.root, a);
  return /* @__PURE__ */ s.jsx("div", { className: r, role: "group", children: Ft.map(t, (i) => {
    if (!Pt(i))
      return null;
    const l = (e ?? i.props.variant) === "secondary", c = f(i.props.className, {
      [dn.button]: !0,
      [dn.buttonWithBorder]: l,
      [dn.buttonWithoutBorder]: !l
    });
    return sn(i, {
      className: c,
      disabled: o ?? i.props.disabled,
      variant: e ?? i.props.variant,
      size: n
    });
  }) });
}, sl = "h-divider--divider__root", ol = "h-divider--divider__withChildren", rl = "h-divider--divider__horizontal", al = "h-divider--divider__vertical", ss = {
  root: sl,
  withChildren: ol,
  horizontal: rl,
  vertical: al
}, Vn = $(function({
  className: t,
  children: e,
  as: n,
  orientation: o = "horizontal",
  color: r,
  margin: i,
  padding: l,
  ...c
}, d) {
  const h = n ?? (e ? "div" : "hr"), u = f(
    ss.root,
    ss[o],
    {
      [ss.withChildren]: !!e
    },
    t
  ), p = {
    ...c.style,
    ...r ? { "--divider-color": Ze(r) } : {},
    ...i ? { margin: Ss(i) } : {},
    ...l ? { padding: Ss(l) } : {}
  };
  return /* @__PURE__ */ s.jsx(
    h,
    {
      ...c,
      ref: d,
      className: u,
      style: p,
      children: typeof e == "string" ? /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: e }) : e
    }
  );
}), il = "h-buttonList--buttonList__buttonList", ll = "h-buttonList--buttonList__inner", so = {
  buttonList: il,
  inner: ll
};
let cl = class extends D {
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Vn, { as: "li", color: "tertiary", padding: "200 250", ...n, children: t });
  }
};
const dl = "h-buttonList--item__item", hl = "h-buttonList--item__icon", ul = "h-buttonList--item__button", pl = "h-buttonList--item__buttonDisabled", ml = "h-buttonList--item__buttonCentered", gl = "h-buttonList--item__checkmark", fl = "h-buttonList--item__buttonLoading", bl = "h-buttonList--item__buttonContent", Ot = {
  item: dl,
  icon: hl,
  button: ul,
  buttonDisabled: pl,
  buttonCentered: ml,
  checkmark: gl,
  buttonLoading: fl,
  buttonContent: bl
}, xl = function({
  icon: t,
  children: e,
  className: n,
  isSelected: o,
  isCentered: r,
  isLoading: i,
  isDisabled: l,
  buttonClassName: c,
  buttonProps: d,
  onClick: h,
  ...u
}, p) {
  const m = f(
    {
      [Ot.item]: !0
    },
    n
  ), g = f(
    Ot.button,
    {
      [Ot.buttonCentered]: r,
      [Ot.buttonLoading]: i,
      [Ot.buttonDisabled]: l
    },
    c
  ), b = l ? { tabIndex: -1 } : {};
  return /* @__PURE__ */ s.jsx("li", { ref: p, ...u, className: m, children: /* @__PURE__ */ s.jsxs(
    "button",
    {
      ...b,
      ...d,
      className: g,
      onClick: h,
      children: [
        /* @__PURE__ */ s.jsxs("span", { className: Ot.buttonContent, children: [
          t && /* @__PURE__ */ s.jsx(N, { className: Ot.icon, name: t }),
          /* @__PURE__ */ s.jsx(L.Paragraph, { variant: o ? "1" : "2", children: e })
        ] }),
        o && /* @__PURE__ */ s.jsx(
          N,
          {
            name: "done",
            size: 20,
            color: "neutral.700",
            className: Ot.checkmark
          }
        )
      ]
    }
  ) });
}, yl = $(xl);
class oo extends D {
  static get Item() {
    return yl;
  }
  static get Header() {
    return cl;
  }
  static get Divider() {
    return _l;
  }
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(
      {
        [so.buttonList]: !0
      },
      e
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: /* @__PURE__ */ s.jsx("ul", { className: so.inner, children: t }) });
  }
}
const _l = () => /* @__PURE__ */ s.jsx(Vn, { as: "li", margin: "100 0" }), Cl = "h-checkbox--checkbox__root", wl = "h-checkbox--checkbox__rootDisabled", vl = "h-checkbox--checkbox__rootChecked", Sl = "h-checkbox--checkbox__rootIndeterminate", Il = "h-checkbox--checkbox__checkbox", Dl = "h-checkbox--checkbox__input", ce = {
  root: Cl,
  rootDisabled: wl,
  rootChecked: vl,
  rootIndeterminate: Sl,
  checkbox: Il,
  input: Dl
};
class an extends D {
  inputRef;
  constructor(t) {
    super(t), this.inputRef = B();
  }
  componentDidMount() {
    const t = this.inputRef.current;
    t && (t.indeterminate = !!this.props.indeterminate);
  }
  componentDidUpdate(t) {
    const e = this.inputRef.current;
    e && t.indeterminate !== this.props.indeterminate && (e.indeterminate = !!this.props.indeterminate);
  }
  render() {
    const {
      className: t,
      onChange: e,
      id: n,
      name: o,
      checked: r,
      indeterminate: i,
      disabled: l,
      tabIndex: c,
      ...d
    } = this.props, h = f(
      {
        [ce.root]: !0,
        [ce.rootDisabled]: l,
        [ce.rootChecked]: r,
        [ce.rootIndeterminate]: i
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("span", { className: h, "data-testid": "habla-checkbox", ...d, children: [
      /* @__PURE__ */ s.jsx(
        "span",
        {
          role: "checkbox",
          "aria-checked": i ? "mixed" : r,
          className: ce.checkbox
        }
      ),
      /* @__PURE__ */ s.jsx(
        "input",
        {
          id: n,
          type: "checkbox",
          "aria-hidden": "true",
          name: o,
          className: ce.input,
          onChange: e || E,
          checked: r,
          disabled: l,
          ref: this.inputRef,
          tabIndex: c
        }
      )
    ] });
  }
}
const kl = "h-collapseCard--collapseCard__card", Tl = {
  card: kl
}, Hs = Bt({
  isOpen: !1,
  onToggle: E
}), jl = "h-collapseCard--content__content", Nl = "h-collapseCard--content__contentIsOpen", ro = {
  content: jl,
  contentIsOpen: Nl
};
class Pl extends D {
  static displayName = "CollapseCard.Content";
  getRootClassName(t) {
    return f(ro.content, this.props.className, {
      [ro.contentIsOpen]: t
    });
  }
  render() {
    const { children: t, className: e, ...n } = this.props;
    return /* @__PURE__ */ s.jsx(Hs.Consumer, { children: ({ isOpen: o }) => o ? /* @__PURE__ */ s.jsx(
      "ul",
      {
        ...n,
        className: this.getRootClassName(o),
        "data-testid": "content",
        children: t
      }
    ) : null });
  }
}
function Kn(a) {
  return {
    role: "button",
    onClick: a,
    onKeyDown: (t) => {
      t.key === "Enter" && a(t);
    }
  };
}
const Fl = [
  "ArrowLeft",
  "ArrowUp",
  "ArrowRight",
  "ArrowDown",
  " "
], Rl = ["Escape", "Esc"], Un = (a) => Fl.includes(a), je = (a) => Rl.includes(a), El = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]",
  '[tabindex]:not([tabindex="-1"]):not([disabled])'
], ao = El.join(
  ':not([hidden]):not([tabindex="-1"]),'
), gr = Mn(function({
  containerRef: t,
  children: e,
  isActive: n,
  autoFocus: o,
  restoreFocus: r,
  onActiveStateChange: i,
  bringInFocusOnTab: l
}) {
  const c = n !== void 0, d = n === void 0 || n, h = Y(null), u = Y(
    // type null is needed to make ref mutable.
    d ? document.activeElement : null
  ), p = t || h;
  ur(
    "Tab",
    (b) => {
      if (!d)
        return;
      const x = p.current?.querySelectorAll(ao), w = !p.current?.contains(
        b.target instanceof Element ? b.target : null
      );
      if (!x)
        return;
      const y = x[0], v = x[x.length - 1];
      if (!b.shiftKey && document.activeElement === v || !b.shiftKey && l && w)
        return y?.focus(), b.preventDefault();
      (b.shiftKey && document.activeElement === y || b.shiftKey && l && w) && (v?.focus(), b.preventDefault());
    },
    void 0,
    [d]
  );
  const m = () => {
    setTimeout(() => {
      o && (o === !0 ? p.current?.querySelector(ao)?.focus() : o.current && o.current.focus());
    });
  }, g = () => {
    document.activeElement !== document.body && !p.current?.contains(document.activeElement) || setTimeout(() => {
      r && (r === !0 ? u.current?.focus() : r.current && r.current.focus());
    });
  };
  return Te(() => {
    c || (m(), i?.(!0));
  }), Qt(() => {
    c || (g(), i?.(!1));
  }), Gt(() => {
    n === !0 ? (u.current = document.activeElement, m()) : n === !1 && g(), i?.(!!n);
  }, [n]), t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: e }) : /* @__PURE__ */ s.jsx("div", { ref: h, children: e });
}), Ll = "h-dropdown--dropdown__dropdown", Al = "h-dropdown--dropdown__dropdownOpen", $l = "h-dropdown--dropdown__dropdownFromRight", Bl = "h-dropdown--dropdown__dropdownFromBottom", Ol = "h-dropdown--dropdown__dropdownAnimating", Hl = "h-dropdown--dropdown__dropdownFixed", Wl = "h-dropdown--dropdown__loader", Ml = "h-dropdown--dropdown__error", zl = "h-dropdown--dropdown__errorIcon", Et = {
  dropdown: Ll,
  dropdownOpen: Al,
  dropdownFromRight: $l,
  dropdownFromBottom: Bl,
  dropdownAnimating: Ol,
  dropdownFixed: Hl,
  loader: Wl,
  error: Ml,
  errorIcon: zl
};
class Xt extends D {
  dropdownRef;
  timeoutAnimationStart;
  timeoutAnimationEnd;
  static defaultProps = {
    onClose: () => {
    },
    closeOnBlur: !0
  };
  constructor(t) {
    super(t), this.state = {
      fromRight: !1,
      fromBottom: !1,
      fromTop: !1,
      width: null,
      height: null,
      animating: !1
    }, this.timeoutAnimationStart = void 0, this.timeoutAnimationEnd = void 0, this.dropdownRef = B(), this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this), this.handleFixedScroll = this.handleFixedScroll.bind(this), this.handleOnClose = this.handleOnClose.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this);
  }
  componentDidMount() {
    this.calculatePosition();
  }
  getSnapshotBeforeUpdate() {
    if (this.dropdownRef.current) {
      const t = this.dropdownRef.current.getBoundingClientRect();
      return {
        oldWidth: t.width,
        oldHeight: t.height
      };
    }
    return null;
  }
  componentDidUpdate(t, e, n) {
    const { isOpen: o, isLoading: r, errorMessage: i, fixed: l, closeOnBlur: c } = this.props;
    if (n && (r !== t.isLoading || i !== t.errorMessage)) {
      const d = r !== t.isLoading && r;
      this.animate(n.oldWidth, n.oldHeight, d);
    }
    o && this.calculatePosition(), o !== t.isOpen && (window[o ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutsideDropdown
    ), c && window[o ? "addEventListener" : "removeEventListener"](
      "blur",
      this.handleOnClose
    ), l && window[o ? "addEventListener" : "removeEventListener"](
      "scroll",
      this.handleFixedScroll,
      !0
    ));
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleClickOutsideDropdown), window.removeEventListener("scroll", this.handleFixedScroll), window.removeEventListener("blur", this.handleOnClose), window.clearInterval(this.timeoutAnimationStart), window.clearInterval(this.timeoutAnimationEnd);
  }
  handleOnClose() {
    const { onClose: t } = this.props;
    t();
  }
  animate(t, e, n) {
    if (this.dropdownRef.current) {
      const o = this.dropdownRef.current.getBoundingClientRect();
      this.setState({
        width: t,
        height: e,
        animating: !n
      }), this.timeoutAnimationStart = window.setTimeout(() => {
        this.setState({
          width: o.width,
          height: o.height
        }), this.timeoutAnimationEnd = window.setTimeout(() => {
          this.setState({
            width: null,
            height: null,
            animating: !1
          });
        }, 200);
      });
    }
  }
  handleClickOutsideDropdown(t) {
    if (!this.dropdownRef || !(t.target instanceof Node)) return;
    const { onClose: e } = this.props;
    this.dropdownRef.current && t.target !== this.dropdownRef.current && !this.dropdownRef.current.contains(t.target) && e();
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  handleFixedScroll() {
    this.forceUpdate();
  }
  calculatePosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const t = this.dropdownRef.current.parentElement.getBoundingClientRect(), e = t.left + t.width / 2, n = t.top + t.height / 2, o = window.innerWidth / 2, r = window.innerHeight / 2;
      this.setState({
        fromRight: e > o,
        fromBottom: n > r,
        fromTop: n <= r
      });
    }
  }
  getFixedPosition() {
    if (this.dropdownRef.current && this.dropdownRef.current.parentElement) {
      const { fromRight: t, fromBottom: e, fromTop: n } = this.state, o = this.dropdownRef.current.parentElement.getBoundingClientRect(), r = {};
      return t ? r.right = `${window.innerWidth - o.right}px` : r.left = `${o.left}px`, e && (r.bottom = `${window.innerHeight - o.top}px`), n && (r.top = `${o.top + o.height}px`), r;
    }
    return {};
  }
  render() {
    const {
      className: t,
      children: e,
      onClose: n,
      isOpen: o,
      isLoading: r,
      closeOnBlur: i,
      errorMessage: l,
      fixed: c,
      style: d,
      autoFocus: h,
      restoreFocus: u,
      bringInFocusOnTab: p,
      ...m
    } = this.props, { fromRight: g, fromBottom: b, animating: x, width: w, height: y } = this.state, v = f(
      {
        [Et.dropdown]: !0,
        [Et.dropdownOpen]: o,
        [Et.dropdownFromRight]: g,
        [Et.dropdownFromBottom]: b,
        [Et.dropdownAnimating]: x,
        [Et.dropdownFixed]: c
      },
      t
    );
    let _ = { ...d };
    w && y && (_.width = `${w}px`, _.height = `${y}px`), c && (_ = { ..._, ...this.getFixedPosition() });
    const C = !r && !l;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...m,
        className: v,
        ref: this.dropdownRef,
        style: _,
        onClick: this.handleDropdownClick,
        role: "menu",
        "aria-expanded": o,
        children: [
          r && /* @__PURE__ */ s.jsx("div", { className: Et.loader }),
          !!l && !r && /* @__PURE__ */ s.jsxs("div", { className: Et.error, children: [
            /* @__PURE__ */ s.jsx(N, { className: Et.errorIcon, name: "exclamation" }),
            /* @__PURE__ */ s.jsx("span", { children: l })
          ] }),
          C && /* @__PURE__ */ s.jsx(
            gr,
            {
              containerRef: this.dropdownRef,
              isActive: o,
              autoFocus: h,
              restoreFocus: u,
              bringInFocusOnTab: p,
              children: e
            }
          )
        ]
      }
    );
  }
}
const Vl = "h-dropdownButton--dropdownButton__root", Kl = "h-dropdownButton--dropdownButton__wrapper", os = {
  root: Vl,
  wrapper: Kl
}, ln = Bt({
  toggleDropdown: E,
  openDropdown: E,
  closeDropdown: E,
  dropdownOpen: !1
});
class re extends _t {
  buttonWrapperRef;
  buttonRef;
  contextState;
  timeoutId;
  static defaultProps = {
    allowEscClose: !0
  };
  constructor(t) {
    super(t);
    const e = t.show ?? !1;
    this.state = {
      dropdownOpen: e,
      pristine: !0,
      fromBottom: !1
    }, this.timeoutId = null, this.buttonWrapperRef = B(), this.buttonRef = B(), this.handleDropdownToggle = this.handleDropdownToggle.bind(this), this.close = this.close.bind(this), this.open = this.open.bind(this), this.toggle = this.toggle.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.contextState = {
      toggleDropdown: this.toggle,
      openDropdown: this.open,
      closeDropdown: this.close,
      dropdownOpen: e
    };
  }
  componentDidMount() {
    this.props.allowEscClose && this.props.show && window.addEventListener("keydown", this.handleKeyDown, !0), this.setState({ fromBottom: this.shouldDropdownBeAboveButton() });
  }
  componentDidUpdate(t) {
    this.toggleDropdownIfNeeded(t);
  }
  componentWillUnmount() {
    this.props.allowEscClose && window.removeEventListener("keydown", this.handleKeyDown, !0), this.timeoutId && window.clearTimeout(this.timeoutId);
  }
  shouldToggleDropdown(t) {
    return t.show !== this.props.show;
  }
  handleKeyDown(t) {
    je(t.key) && this.state.dropdownOpen && (t.stopPropagation(), this.close());
  }
  toggleDropdownIfNeeded(t) {
    this.shouldToggleDropdown(t) && (this.props.show ? this.open() : this.close());
  }
  /**
   * HACK: To get around node and dom types not being compatible and both
   * overloading setTimeout
   *
   * @param callback
   * @param delay
   * @returns
   */
  setTimeout(t, e = 0) {
    return window.setTimeout(t, e);
  }
  handleDropdownToggle() {
    const { dropdownOpen: t } = this.state, e = () => {
      this.timeoutId = this.setTimeout(() => {
        this.toggle(!t);
      });
    }, n = this.shouldDropdownBeAboveButton();
    t ? e() : this.setState(
      { fromBottom: n },
      e
    );
  }
  close() {
    this.toggle(!1);
  }
  open() {
    this.toggle(!0);
  }
  toggle(t) {
    const { allowEscClose: e, onToggle: n } = this.props, { pristine: o, dropdownOpen: r } = this.state, i = t ?? !r;
    this.contextState = { ...this.contextState, dropdownOpen: i }, this.setState({ dropdownOpen: i, pristine: !1 }), e && (i ? window.addEventListener : window.removeEventListener)("keydown", this.handleKeyDown, !0), n?.(i, o);
  }
  shouldDropdownBeAboveButton() {
    const t = this.buttonWrapperRef.current?.getBoundingClientRect();
    return t ? t.bottom > window.innerHeight / 2 : !1;
  }
  renderTheTriggerButton() {
    const {
      icon: t,
      buttonProps: e,
      children: n,
      noArrow: o,
      noStyle: r,
      onMouseEnter: i,
      onMouseLeave: l
    } = this.props, { fromBottom: c } = this.state;
    return r ? /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: this.buttonRef,
        className: e?.className,
        ...e,
        onMouseEnter: i,
        onMouseLeave: l,
        ...Kn(this.handleDropdownToggle),
        children: n
      }
    ) : t && !n ? /* @__PURE__ */ s.jsx(
      K,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: i,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle
      }
    ) : /* @__PURE__ */ s.jsx(
      Q,
      {
        ref: this.buttonRef,
        icon: t,
        variant: "secondary",
        onMouseEnter: i,
        onMouseLeave: l,
        ...e,
        onClick: this.handleDropdownToggle,
        slotEnd: o ? void 0 : /* @__PURE__ */ s.jsx(N, { name: c ? "angle-up" : "angle-down" }),
        children: n
      }
    );
  }
  render() {
    const {
      className: t,
      children: e,
      icon: n,
      dropdown: o,
      buttonProps: r,
      dropdownProps: i,
      noArrow: l,
      noStyle: c,
      show: d,
      onToggle: h,
      isLoading: u,
      errorMessage: p,
      fixed: m,
      onMouseEnter: g,
      onMouseLeave: b,
      allowEscClose: x,
      ...w
    } = this.props, { dropdownOpen: y, pristine: v } = this.state, _ = f({ [os.root]: os.root }, t);
    return /* @__PURE__ */ s.jsx(ln.Provider, { value: this.contextState, children: /* @__PURE__ */ s.jsx("div", { ...w, className: _, ref: this.buttonWrapperRef, children: /* @__PURE__ */ s.jsxs("div", { className: os.wrapper, children: [
      this.renderTheTriggerButton(),
      /* @__PURE__ */ s.jsx(
        Xt,
        {
          restoreFocus: this.buttonRef,
          ...i,
          isOpen: y,
          onClose: this.close,
          isLoading: u,
          errorMessage: p,
          fixed: m,
          children: (y || !v) && o
        }
      )
    ] }) }) });
  }
}
const Ul = "h-collapseCard--header__header", ql = "h-collapseCard--header__headerOpen", Gl = "h-collapseCard--header__headerHasDropdown", Yl = "h-collapseCard--header__title", hn = {
  header: Ul,
  headerOpen: ql,
  headerHasDropdown: Gl,
  title: Yl
};
class Ql extends D {
  // It's important to keep the displayName because it's used by the collapseCard
  // To determine the type of it's children
  static displayName = "CollapseCard.Header";
  static defaultProps = {
    title: ""
  };
  getRootClassName(t) {
    const { dropdown: e, className: n } = this.props;
    return f(
      hn.header,
      { [hn.headerOpen]: t, [hn.headerHasDropdown]: !!e },
      n
    );
  }
  render() {
    const {
      children: t,
      className: e,
      title: n,
      avatar: o,
      wrap: r = "nowrap",
      dropdown: i,
      onDropdownToggle: l,
      dropdownTrigger: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(Hs.Consumer, { children: ({ isOpen: h, onToggle: u }) => {
      const p = this.getRootClassName(h);
      return /* @__PURE__ */ s.jsxs(
        "div",
        {
          ...d,
          onClick: u,
          className: p,
          "data-testid": "header",
          children: [
            /* @__PURE__ */ s.jsxs(O, { alignItems: "center", padding: "400 0", children: [
              o,
              /* @__PURE__ */ s.jsx("div", { onMouseDown: (m) => m.stopPropagation(), children: /* @__PURE__ */ s.jsx(
                L.Paragraph,
                {
                  variant: "1",
                  wrap: r,
                  className: hn.title,
                  children: t
                }
              ) })
            ] }),
            /* @__PURE__ */ s.jsxs(O, { alignItems: "center", children: [
              !!i && /* @__PURE__ */ s.jsx(
                re,
                {
                  onClick: (m) => m.stopPropagation(),
                  icon: c ? void 0 : "dots-h",
                  dropdown: i,
                  buttonProps: { variant: "tertiary" },
                  onToggle: l,
                  children: c
                }
              ),
              /* @__PURE__ */ s.jsx(
                K,
                {
                  icon: h ? "angle-down" : "angle-right",
                  variant: "tertiary"
                }
              )
            ] })
          ]
        }
      );
    } });
  }
}
const Xl = "h-collapseCard--line__line", Zl = "h-collapseCard--line__lineHasLabel", Jl = "h-collapseCard--line__value", tc = "h-collapseCard--line__lineHideOverflow", un = {
  line: Xl,
  lineHasLabel: Zl,
  value: Jl,
  lineHideOverflow: tc
};
class ec extends D {
  render() {
    const { label: t, children: e, className: n, hideOverflow: o, ...r } = this.props, i = f(
      {
        [un.line]: !0,
        [un.lineHasLabel]: !!t,
        [un.lineHideOverflow]: o
      },
      n
    );
    return /* @__PURE__ */ s.jsxs("li", { ...r, className: i, children: [
      t && /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", subdued: !0, wrap: "nowrap", children: t }),
      t ? /* @__PURE__ */ s.jsx("span", { className: un.value, children: e }) : e
    ] });
  }
}
const nc = "h-collapseCard--readMore__readMore", sc = {
  readMore: nc
};
class oc extends D {
  render() {
    const { onClick: t, url: e, children: n, className: o, ...r } = this.props, i = f({ [sc.readMore]: !0 }, o);
    return e ? /* @__PURE__ */ s.jsx(L.ExternalLink, { ...r, href: e, className: i, children: n }) : /* @__PURE__ */ s.jsx(
      Q,
      {
        variant: "secondary",
        ...r,
        onClick: t,
        className: i,
        children: n
      }
    );
  }
}
const rc = "h-collapseCard--status__status", ac = {
  status: rc
};
class ic extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f({ [ac.status]: !0 }, e);
    return /* @__PURE__ */ s.jsx("li", { ...n, className: o, children: t });
  }
}
class lc extends D {
  static defaultProps = {
    isOpen: !1
  };
  constructor(t) {
    super(t), this.handleToggle = this.handleToggle.bind(this);
  }
  static Line = ec;
  static Header = Ql;
  static Content = Pl;
  static ReadMore = oc;
  static Status = ic;
  handleToggle() {
    this.props.onToggle(!this.props.isOpen);
  }
  isHeader(t) {
    return t?.type?.displayName === "CollapseCard.Header" && Pt(t);
  }
  isContent(t) {
    return t?.type?.displayName === "CollapseCard.Content" && Pt(t);
  }
  getHeaderChildren() {
    return Ft.toArray(this.props.children).filter(this.isHeader);
  }
  getContentChildren() {
    return Ft.toArray(this.props.children).filter(this.isContent);
  }
  getRootClassName() {
    const { className: t } = this.props;
    return f(Tl.card, t);
  }
  render() {
    const { className: t, onToggle: e, isOpen: n, children: o, ...r } = this.props;
    return /* @__PURE__ */ s.jsx(
      Hs.Provider,
      {
        value: { isOpen: n, onToggle: this.handleToggle },
        children: /* @__PURE__ */ s.jsxs("div", { ...r, className: this.getRootClassName(), children: [
          this.getHeaderChildren(),
          this.getContentChildren()
        ] })
      }
    );
  }
}
const ek = on(lc, {
  fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong" }) })
}), cc = "h-collapsible--collapsible__root", dc = "h-collapsible--collapsible__collapsible", hc = "h-collapsible--collapsible__children", rs = {
  root: cc,
  collapsible: dc,
  children: hc
};
class nk extends D {
  childrenRef;
  resizeObserver = null;
  constructor(t) {
    super(t), this.childrenRef = B(), this.measureChildrenHeight = this.measureChildrenHeight.bind(this), this.state = {
      childrenHeight: t.isOpen ? "auto" : 0
    };
  }
  componentDidMount() {
    this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentDidUpdate(t) {
    t.isOpen !== this.props.isOpen && this.measureChildrenHeight(), this.setupResizeObserver();
  }
  componentWillUnmount() {
    this.disconnectResizeObserver();
  }
  setupResizeObserver() {
    this.childrenRef.current && !this.resizeObserver && (this.resizeObserver = new ResizeObserver(() => {
      this.measureChildrenHeight();
    }), this.resizeObserver.observe(this.childrenRef.current));
  }
  disconnectResizeObserver() {
    this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null);
  }
  measureChildrenHeight() {
    const t = this.childrenRef.current;
    t && this.setState({
      childrenHeight: t.offsetHeight
    });
  }
  render() {
    const { className: t, header: e, isOpen: n, children: o, ...r } = this.props, { childrenHeight: i } = this.state, l = f(
      {
        [rs.root]: !0
      },
      t
    ), c = {
      maxHeight: n ? i : 0
    };
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx("div", { children: e }) }),
      !!o && /* @__PURE__ */ s.jsx("div", { style: c, className: rs.collapsible, children: /* @__PURE__ */ s.jsx("span", { className: rs.children, ref: this.childrenRef, children: o }) })
    ] });
  }
}
const uc = "h-colorPicker--colorPicker__root", pc = {
  root: uc
}, mc = "h-inputWrapper--inputWrapper__root", gc = "h-inputWrapper--inputWrapper__rootDisabled", fc = "h-inputWrapper--inputWrapper__rootActive", bc = "h-inputWrapper--inputWrapper__rootHasError", xc = "h-inputWrapper--inputWrapper__rootHasWarning", yc = "h-inputWrapper--inputWrapper__rootHasSuccess", _c = "h-inputWrapper--inputWrapper__inputWrapper", Cc = "h-inputWrapper--inputWrapper__rootWithPrefix", wc = "h-inputWrapper--inputWrapper__rootWithSuffix", vc = "h-inputWrapper--inputWrapper__suffixesContainer", Sc = "h-inputWrapper--inputWrapper__prefix", Ic = "h-inputWrapper--inputWrapper__suffix", Dc = "h-inputWrapper--inputWrapper__prefixDropdownButton", kc = "h-inputWrapper--inputWrapper__suffixDropdownButton", Tc = "h-inputWrapper--inputWrapper__prefixButton", jc = "h-inputWrapper--inputWrapper__suffixButton", Nc = "h-inputWrapper--inputWrapper__icon", it = {
  root: mc,
  rootDisabled: gc,
  rootActive: fc,
  rootHasError: bc,
  rootHasWarning: xc,
  rootHasSuccess: yc,
  inputWrapper: _c,
  rootWithPrefix: Cc,
  rootWithSuffix: wc,
  suffixesContainer: vc,
  prefix: Sc,
  suffix: Ic,
  prefixDropdownButton: Dc,
  suffixDropdownButton: kc,
  prefixButton: Tc,
  suffixButton: jc,
  icon: Nc
}, Is = Bt({
  position: null,
  disabled: !1,
  active: !1,
  status: "success"
}), Pc = "inputWrapper";
class Fc extends D {
  renderIcon() {
    const { icon: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx(N, { className: it.icon, name: t }) : null;
  }
  isButtonAddon(t) {
    return !!t && "type" in t && t.type === "button";
  }
  isCustomAddon(t) {
    return !!t && "type" in t && (!t.type || t.type === "custom");
  }
  renderAddon(t) {
    const e = this.props[t], { disabled: n } = this.props;
    if (!e)
      return null;
    let o;
    if (typeof e != "object" || !("type" in e))
      o = /* @__PURE__ */ s.jsx("div", { className: f(it[t]), children: e });
    else if (this.isCustomAddon(e))
      o = e.noWrap ? e.value : /* @__PURE__ */ s.jsx("div", { className: it[t], children: e.value });
    else if (this.isButtonAddon(e)) {
      const {
        className: r,
        disabled: i,
        ...l
      } = e.button;
      o = /* @__PURE__ */ s.jsx(
        K,
        {
          className: f(
            {
              [it[t]]: !e.noStyle,
              [it[`${t}Button`]]: !e.noStyle
            },
            r
          ),
          disabled: n || i,
          ...l
        }
      );
    }
    return o;
  }
  getContextValue(t) {
    const { disabled: e, active: n, status: o } = this.props;
    return {
      position: t,
      disabled: !!e,
      active: !!n,
      status: o || "success"
    };
  }
  render() {
    const {
      className: t,
      disabled: e,
      active: n,
      status: o,
      prefix: r,
      suffix: i,
      icon: l,
      children: c,
      innerRef: d,
      ...h
    } = this.props, u = f(
      it.root,
      {
        [it.rootActive]: n,
        [it.rootDisabled]: e,
        [it.rootHasError]: o === "error",
        [it.rootHasWarning]: o === "warning",
        [it.rootHasSuccess]: o === "success",
        [it.rootWithPrefix]: !!r,
        [it.rootWithSuffix]: !!i
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Pc,
        className: u,
        ref: d,
        ...h,
        children: [
          /* @__PURE__ */ s.jsx(Is.Provider, { value: this.getContextValue("prefix"), children: this.renderAddon("prefix") }),
          /* @__PURE__ */ s.jsx("div", { className: it.inputWrapper, children: c }),
          /* @__PURE__ */ s.jsxs("span", { className: it.suffixesContainer, children: [
            this.renderIcon(),
            /* @__PURE__ */ s.jsx(Is.Provider, { value: this.getContextValue("suffix"), children: this.renderAddon("suffix") })
          ] })
        ]
      }
    );
  }
}
const Rt = $(function(t, e) {
  return /* @__PURE__ */ s.jsx(Fc, { innerRef: e, ...t, children: t.children });
}), Rc = "h-colorPicker-input--colorPickerInput__input", Ec = {
  input: Rc
}, Lc = ({
  className: a,
  ...t
}) => /* @__PURE__ */ s.jsx(Rt, { prefix: "#", children: /* @__PURE__ */ s.jsx(
  ia,
  {
    className: f(Ec.input, a),
    "aria-label": "Enter hex value",
    placeholder: "Hex value",
    ...t
  }
) }), Ac = "h-colorPicker-presets--colorPickerPresets__root", $c = {
  root: Ac
}, Bc = "h-colorPicker-presets-preset--colorPickerPreset__root", Oc = "h-colorPicker-presets-preset--colorPickerPreset__rootIsSelected", Hc = "h-colorPicker-presets-preset--colorPickerPreset__rootAlpha", Wc = "h-colorPicker-presets-preset--colorPickerPreset__preset", pn = {
  root: Bc,
  rootIsSelected: Oc,
  rootAlpha: Hc,
  preset: Wc
}, Mc = ({
  color: a,
  onSelect: t,
  isSelected: e,
  alpha: n,
  className: o
}) => /* @__PURE__ */ s.jsx(
  "li",
  {
    className: f(pn.root, o, {
      [pn.rootIsSelected]: e,
      [pn.rootAlpha]: n
    }),
    children: /* @__PURE__ */ s.jsx(
      "button",
      {
        type: "button",
        "aria-label": a,
        className: pn.preset,
        style: { backgroundColor: a },
        onClick: () => {
          t?.(a);
        }
      }
    )
  }
);
Es([Ls]);
const zc = ({
  presets: a,
  className: t,
  onChange: e,
  color: n,
  alpha: o,
  ...r
}) => /* @__PURE__ */ s.jsx(
  O,
  {
    as: "ul",
    gap: "200",
    flexWrap: "wrap",
    className: f($c.root, t),
    ...r,
    children: a.map((i) => /* @__PURE__ */ s.jsx(
      Mc,
      {
        onSelect: e,
        color: i,
        isSelected: n === (i.startsWith("#") ? i : En(i).toHex()),
        alpha: o
      },
      i
    ))
  }
);
Es([Ls]);
const Vc = ({
  onChange: a,
  color: t,
  alpha: e,
  className: n,
  ...o
}) => {
  const r = P((i) => {
    setTimeout(() => {
      a?.(En(i).toHex());
    });
  }, []);
  return e ? /* @__PURE__ */ s.jsx(
    ca,
    {
      className: n,
      color: En(t ?? "").toRgbString(),
      onChange: r,
      ...o
    }
  ) : /* @__PURE__ */ s.jsx(
    la,
    {
      className: n,
      color: t,
      onChange: a,
      ...o
    }
  );
};
Es([Ls]);
const Kc = "colorPickerTestId", qn = ({
  className: a,
  color: t,
  onChange: e,
  alpha: n,
  children: o,
  ...r
}) => {
  const [i, l] = V();
  return U(() => {
    const c = t?.startsWith("#") ? t : En(t ?? "").toHex();
    l(c);
  }, [t]), /* @__PURE__ */ s.jsx(
    O,
    {
      flexDirection: "column",
      gap: "250",
      className: f(pc.root, a),
      "data-testid": Kc,
      ...r,
      children: Ft.map(
        o,
        (c) => Pt(c) && sn(c, {
          onChange: e,
          color: i,
          alpha: n,
          ...c.props
        })
      )
    }
  );
};
qn.Input = Lc;
qn.Sliders = Vc;
qn.Presets = zc;
const Uc = "h-columns--columns__root", qc = {
  root: Uc
}, Gc = "1fr", Yc = $(function({ as: t = "div", children: e, className: n, style: o, ...r }, i) {
  const c = Ft.toArray(e).map((d) => d.props.size ?? Gc).join(" ");
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...r,
      ref: i,
      className: f(qc.root, n),
      style: { ...o, gridTemplateColumns: c },
      children: e
    }
  );
}), Qc = "h-columns-column--column__root", Xc = {
  root: Qc
}, Zc = "h-columns-column-row--columnRow__root", Jc = "h-columns-column-row--columnRow__noMinHeight", td = "h-columns-column-row--columnRow__noVerticalPadding", ed = "h-columns-column-row--columnRow__noHorizontalPadding", nd = "h-columns-column-row--columnRow__borderTop", sd = "h-columns-column-row--columnRow__borderBottom", od = "h-columns-column-row--columnRow__scrollable", rd = "h-columns-column-row--columnRow__slottable", Ht = {
  root: Zc,
  noMinHeight: Jc,
  noVerticalPadding: td,
  noHorizontalPadding: ed,
  borderTop: nd,
  borderBottom: sd,
  scrollable: od,
  slottable: rd
}, ad = 1, id = $(function({
  as: t = "div",
  children: e,
  className: n,
  noVerticalPadding: o,
  noHorizontalPadding: r,
  noMinHeight: i,
  borderTop: l,
  borderBottom: c,
  scrollable: d,
  size: h,
  slottable: u,
  style: p,
  ...m
}, g) {
  const b = f(n, Ht.root, {
    [Ht.slottable]: u,
    [Ht.noVerticalPadding]: u ?? o,
    [Ht.noHorizontalPadding]: r,
    [Ht.borderTop]: l,
    [Ht.borderBottom]: c,
    [Ht.scrollable]: d,
    [Ht.noMinHeight]: i
  });
  return /* @__PURE__ */ s.jsx(
    t,
    {
      ...m,
      ref: g,
      className: b,
      style: {
        ...p,
        flexGrow: h ?? d ? ad : void 0
      },
      children: e
    }
  );
}), ld = "h-columns-column-slot--columnSlot__root", cd = "h-columns-column-slot--columnSlot__noVerticalPadding", io = {
  root: ld,
  noVerticalPadding: cd
}, dd = ({
  children: a,
  className: t,
  noVerticalPadding: e,
  placement: n = "start"
}) => {
  const o = f(io.root, t, {
    [io.noVerticalPadding]: e
  });
  return /* @__PURE__ */ s.jsx(
    O,
    {
      alignItems: "center",
      alignSelf: "stretch",
      justifySelf: n,
      className: o,
      children: a
    }
  );
}, pt = ({
  as: a,
  children: t,
  className: e
}) => /* @__PURE__ */ s.jsx(
  O,
  {
    as: a,
    flexDirection: "column",
    className: f(Xc.root, e),
    children: t
  }
);
pt.Row = id;
pt.Slot = dd;
const hd = "h-copyToClipboard--copyToClipboard__copyToClipboard", ud = "h-copyToClipboard--copyToClipboard__copyToClipboardTooltip", lo = {
  copyToClipboard: hd,
  copyToClipboardTooltip: ud
};
class pd extends _t {
  timerHandle;
  static defaultProps = {
    tooltip: !0,
    disabled: !1,
    transitionDuration: 2e3,
    clickedProps: {}
  };
  constructor(t) {
    super(t), this.state = { clicked: !1 }, this.handleClick = this.handleClick.bind(this);
  }
  componentWillUnmount() {
    this.timerHandle && clearTimeout(this.timerHandle);
  }
  executeCopy(t) {
    const e = document.body;
    if (!t || !document.body)
      return;
    const n = document.createElement("textarea");
    n.value = t, n.setAttribute("readonly", ""), n.style.position = "absolute", n.style.left = "-9999px", e.appendChild(n), n.select(), document.execCommand("copy"), e.removeChild(n);
  }
  handleClick(t) {
    const { disabled: e, textToCopy: n, transitionDuration: o, onClick: r } = this.props;
    e || (typeof r == "function" && r(t), this.executeCopy(n), this.setState({ clicked: !0 }, () => {
      this.timerHandle = setTimeout(() => {
        this.setState({ clicked: !1 });
      }, o);
    }));
  }
  render() {
    const { className: t, children: e, clickedProps: n, tooltip: o } = this.props, { clicked: r } = this.state, i = f(
      lo.copyToClipboard,
      { [lo.copyToClipboardTooltip]: r && o },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: i, children: Ft.map(e, (l) => Pt(l) ? sn(l, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onClick: this.handleClick.bind(this),
      ...r ? n : {}
    }) : l) });
  }
}
class sk extends D {
  render() {
    const { buttonProps: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx(pd, { ...e, children: /* @__PURE__ */ s.jsx(K, { icon: "copy", variant: "secondary", ...t }) });
  }
}
const md = "h-simplePagination--simplePagination__paginationButton", co = {
  paginationButton: md
}, gd = "simplePaginationTestId", fd = ({
  nextButtonClick: a = E,
  previousButtonClick: t = E,
  nextButtonText: e = "Next page",
  previousButtonText: n = "Previous page",
  nextButtonDisabled: o = !1,
  previousButtonDisabled: r = !1,
  nextButtonHidden: i = !1,
  previousButtonHidden: l = !1,
  nextButtonExtraProps: c,
  previousButtonExtraProps: d,
  loading: h = !1,
  loadingText: u = "Loading...",
  ...p
}) => /* @__PURE__ */ s.jsxs("div", { "data-testid": gd, ...p, children: [
  !l && /* @__PURE__ */ s.jsx(
    Q,
    {
      disabled: r || h,
      onClick: t,
      variant: "secondary",
      ...d,
      className: f(
        co.paginationButton,
        d?.className
      ),
      children: h ? u : n
    }
  ),
  !i && /* @__PURE__ */ s.jsx(
    Q,
    {
      disabled: o || h,
      onClick: a,
      variant: "secondary",
      ...c,
      className: f(
        co.paginationButton,
        c?.className
      ),
      children: h ? u : e
    }
  )
] }), Gn = Bt(
  void 0
);
var ct = /* @__PURE__ */ ((a) => (a.Foot = "table-foot", a.Body = "table-body", a.Head = "table-head", a.Row = "table-row", a.PaginationRow = "table-pagination-row", a.Td = "table-body-cell", a.Th = "table-header-cell", a.RowExpansionTrigger = "table-row-expansion-trigger", a.LoadingRow = "table-loading-row", a.LoadingFailedRow = "table-loading-failed-row", a.EmptyRow = "table-empty-row", a))(ct || {});
const bd = "h-table-tfoot--tfoot__root", xd = "h-table-tfoot--tfoot__rootIsLoading", ho = {
  root: bd,
  rootIsLoading: xd
}, fr = Bt(
  void 0
), uo = ({ className: a, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Gn.Consumer, { children: (o) => o?.status.loading && ["spinner"].includes(o?.loading.loadingStrategy) ? null : /* @__PURE__ */ s.jsx(fr.Provider, { value: { isTableFoot: !0 }, children: /* @__PURE__ */ s.jsx(
  "tfoot",
  {
    ...e,
    ref: n,
    className: f(
      {
        [ho.rootIsLoading]: o?.status.loading
      },
      ho.root,
      a
    ),
    "data-testid": ct.Foot,
    children: t
  }
) }) }), yd = Object.assign($(uo), { name: uo.name }), _d = "h-table-thead--thead__root", Cd = "h-table-thead--thead__rootIsLoading", po = {
  root: _d,
  rootIsLoading: Cd
}, br = Bt(
  void 0
), mo = ({ className: a, ...t }, e) => /* @__PURE__ */ s.jsx(Gn.Consumer, { children: (n) => {
  const o = f(po.root, a, {
    [po.rootIsLoading]: n?.status.loading
  });
  return /* @__PURE__ */ s.jsx(br.Provider, { value: { isTableHead: !0 }, children: /* @__PURE__ */ s.jsx(
    "thead",
    {
      ...t,
      ref: e,
      className: o,
      "data-testid": ct.Head
    }
  ) });
} }), wd = Object.assign($(mo), { name: mo.name }), Ne = (a) => {
  const t = qt(Gn);
  if (!t)
    throw new Error(
      "TableContext not accessible. Make sure <TableContextReader> is a child of <Table>"
    );
  const e = qt(br) || {
    isTableHead: !1
  }, n = qt(fr) || {
    isTableFoot: !1
  };
  return a.children({
    ...t,
    ...e,
    ...n
  });
}, vd = "h-table-tableFooter--tableFooter__root", Sd = "h-table-tableFooter--tableFooter__rootIsLoading", go = {
  root: vd,
  rootIsLoading: Sd
}, fo = ({ children: a, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Ne, { children: ({ status: o }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ref: n,
    className: f(
      {
        [go.rootIsLoading]: o.loading
      },
      go.root,
      t
    ),
    ...e,
    children: a
  }
) }), Ws = Object.assign($(fo), {
  name: fo.name
});
function Id(a) {
  return Ft.toArray(a).reduce(
    (t, e) => {
      const n = e;
      return n.type === Ws ? t.footers.push(n) : t.children.push(n), t;
    },
    { children: [], footers: [] }
  );
}
var An = /* @__PURE__ */ ((a) => (a.PageNumber = "page-number", a.PrevPageButton = "prev-page-button", a.NextPageButton = "next-page-button", a))(An || {});
const Dd = "h-pagination--pageNumber__button", kd = "h-pagination--pageNumber__text", Td = "h-pagination--pageNumber__textSelected", as = {
  button: Dd,
  text: kd,
  textSelected: Td
}, jd = ({
  number: a,
  isSelected: t = !1,
  onClick: e
}) => {
  const n = f(as.text, {
    [as.textSelected]: t
  });
  return /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
    Q,
    {
      styleText: !1,
      variant: "tertiary",
      onClick: () => e(a),
      "data-testid": An.PageNumber,
      className: as.button,
      children: /* @__PURE__ */ s.jsx("span", { className: n, children: a })
    }
  ) });
}, Nd = "h-pagination--pagination__root", Pd = "h-pagination--pagination__pageNumberSeparatorWrapper", bo = {
  root: Nd,
  pageNumberSeparatorWrapper: Pd
};
class Fd extends _t {
  static defaultProps = {
    pageRangeDisplayed: 6
  };
  constructor(t) {
    super(t), this.handlePageSelect = this.handlePageSelect.bind(this), this.goToPrevPage = this.goToPrevPage.bind(this), this.goToNextPage = this.goToNextPage.bind(this);
  }
  arePropsValid() {
    const { currentPage: t, pageCount: e, pageRangeDisplayed: n } = this.props, o = (r) => !Number.isNaN(r) && Number.isInteger(r) && r > 0;
    return [t, e, n].every(
      o
    );
  }
  thereIsEnoughPagesToRender() {
    return this.props.pageCount > 1;
  }
  getBoundaries() {
    return {
      canGoToPrevPage: this.props.currentPage > 1,
      canGoToNextPage: this.props.currentPage < this.props.pageCount
    };
  }
  goToPrevPage() {
    this.getBoundaries().canGoToPrevPage && this.handlePageSelect(this.props.currentPage - 1);
  }
  goToNextPage() {
    this.getBoundaries().canGoToNextPage && this.handlePageSelect(this.props.currentPage + 1);
  }
  handlePageSelect(t) {
    const { currentPage: e, onPageChange: n } = this.props;
    t !== e && n(t);
  }
  areAllPagedDisplayable() {
    const { pageCount: t, pageRangeDisplayed: e } = this.props;
    return e >= t;
  }
  leadingTruncationIsNeeded() {
    const { start: e } = this.calculateMiddlePagesRange();
    return e - 1 > 1;
  }
  trailingTruncationIsNeeded() {
    const { pageCount: t } = this.props, { start: e, length: n } = this.calculateMiddlePagesRange(), o = e - 1 + n;
    return t - o > 1;
  }
  getMiddlePagesLength() {
    const { pageRangeDisplayed: t } = this.props;
    return t - 2;
  }
  calculateMiddlePagesRange(t) {
    const { pageCount: e, currentPage: n } = this.props, o = Math.max(
      this.getMiddlePagesLength() - (t?.extraPadding ?? 0),
      1
    ), r = o % 2 === 0 ? o / 2 - 1 : Math.floor(o / 2);
    return { start: Nn(
      n - r,
      2,
      e - o
    ), length: o };
  }
  createPageNumbers(t, e = 1) {
    return Array.from({ length: t }, (n, o) => o + e);
  }
  renderPageNumbers(t, e = 1) {
    return this.createPageNumbers(t, e).map(
      (n) => this.renderSinglePageNumber(n)
    );
  }
  renderSinglePageNumber(t) {
    const { currentPage: e } = this.props, n = t === e;
    return /* @__PURE__ */ s.jsx(
      jd,
      {
        number: t,
        isSelected: n,
        onClick: this.handlePageSelect
      },
      t
    );
  }
  renderAllPages() {
    return this.renderPageNumbers(this.props.pageCount);
  }
  renderGap(t = 0) {
    return /* @__PURE__ */ s.jsx("li", { className: bo.pageNumberSeparatorWrapper, children: /* @__PURE__ */ s.jsx(ka, { name: "dots-h" }) }, `gap-${t}`);
  }
  renderLeadingTruncation() {
    return this.leadingTruncationIsNeeded() ? [this.renderSinglePageNumber(1), this.renderGap()] : this.renderSinglePageNumber(1);
  }
  renderTrailingTruncation() {
    const { pageCount: t } = this.props;
    return this.trailingTruncationIsNeeded() ? [this.renderGap(), this.renderSinglePageNumber(t)] : this.renderSinglePageNumber(t);
  }
  renderMiddlePageNumbers() {
    if (this.leadingTruncationIsNeeded() && this.trailingTruncationIsNeeded()) {
      const { start: n, length: o } = this.calculateMiddlePagesRange({
        extraPadding: 1
      });
      return this.renderPageNumbers(o, n);
    }
    const { start: t, length: e } = this.calculateMiddlePagesRange();
    return this.renderPageNumbers(e, t);
  }
  renderPages() {
    return this.areAllPagedDisplayable() ? this.renderAllPages() : [
      this.renderLeadingTruncation(),
      this.renderMiddlePageNumbers(),
      this.renderTrailingTruncation()
    ];
  }
  warnAboutBadProps() {
    console.error("Pagination can not render due to bad props", this.props);
  }
  render() {
    const { className: t } = this.props;
    return this.thereIsEnoughPagesToRender() ? this.arePropsValid() ? /* @__PURE__ */ s.jsxs("ul", { className: f(bo.root, t), children: [
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-left",
          variant: "tertiary",
          onClick: this.goToPrevPage,
          disabled: !this.getBoundaries().canGoToPrevPage,
          "data-testid": An.PrevPageButton
        }
      ) }),
      this.renderPages(),
      /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "angle-right",
          variant: "tertiary",
          onClick: this.goToNextPage,
          disabled: !this.getBoundaries().canGoToNextPage,
          "data-testid": An.NextPageButton
        }
      ) })
    ] }) : (this.warnAboutBadProps(), null) : null;
  }
}
const xo = ({ children: a, ...t }, e) => /* @__PURE__ */ s.jsx(Ne, { children: ({ pagination: n }) => !n.paginated || n.pageCount <= 1 ? null : /* @__PURE__ */ s.jsx(Ws, { children: /* @__PURE__ */ s.jsx("div", { ref: e, ...t, "data-testid": ct.PaginationRow, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
  Fd,
  {
    currentPage: n.selectedPage,
    pageCount: n.pageCount,
    onPageChange: n.onPageChange,
    pageRangeDisplayed: n.pageRangeDisplayed
  }
) }) }) }) }), Rd = Object.assign($(xo), {
  name: xo.name
}), Ed = "h-table-tbody--tbody__root", Ld = "h-table-tbody--tbody__rootIsLoading", Ad = "h-table-tbody--tbody__rootIsLoadingFade", is = {
  root: Ed,
  rootIsLoading: Ld,
  rootIsLoadingFade: Ad
}, $d = "h-emptyState--emptyState__textWrapper", Bd = "h-emptyState--emptyState__rootSmall", Od = "h-emptyState--emptyState__rootLarge", ls = {
  textWrapper: $d,
  rootSmall: Bd,
  rootLarge: Od
}, Hd = ({
  className: a,
  title: t,
  description: e,
  icon: n = "info",
  iconColor: o = "neutral.500",
  size: r = "large",
  buttonProps: i
}) => {
  const l = f(
    {
      [ls.rootSmall]: r === "small",
      [ls.rootLarge]: r === "large"
    },
    a
  );
  return /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      alignItems: "center",
      gap: "300",
      className: l,
      children: [
        n && /* @__PURE__ */ s.jsx(N, { name: n, size: 20, color: Ze(o) }),
        /* @__PURE__ */ s.jsxs(
          O,
          {
            flexDirection: "column",
            alignItems: "center",
            gap: "100",
            className: ls.textWrapper,
            children: [
              /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", children: t }),
              /* @__PURE__ */ s.jsx(
                L.Paragraph,
                {
                  variant: "2",
                  as: typeof e == "string" ? "p" : "div",
                  children: e
                }
              )
            ]
          }
        ),
        i?.children && /* @__PURE__ */ s.jsx(Q, { ...i })
      ]
    }
  );
};
function Wd(a) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.EmptyRow, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", padding: "500", children: /* @__PURE__ */ s.jsx(Hd, { ...a }) }) }) });
}
function Md({
  onRetry: a,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingFailedRow, ...t, children: /* @__PURE__ */ s.jsx("td", { colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong..." }),
        a && /* @__PURE__ */ s.jsx(Q, { variant: "tertiary", onClick: a, children: "Try again" })
      ]
    }
  ) }) });
}
function zd({
  ...a
}) {
  return /* @__PURE__ */ s.jsx("tr", { "data-testid": ct.LoadingRow, ...a, children: /* @__PURE__ */ s.jsx("td", { align: "center", colSpan: 100, children: /* @__PURE__ */ s.jsxs(
    O,
    {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "500",
      children: [
        /* @__PURE__ */ s.jsx(zn, {}),
        /* @__PURE__ */ s.jsx(rt, { margin: "300", children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Loading..." }) })
      ]
    }
  ) }) });
}
const yo = ({ children: a, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Ne, { children: ({
  status: { loading: o, loadingFailed: r, onLoadingRetry: i, emptyState: l },
  loading: { loadingStrategy: c }
}) => {
  const d = r && !o, h = ["spinner"].includes(c) ? !o && !d : !d;
  return /* @__PURE__ */ s.jsxs(
    "tbody",
    {
      ...e,
      "data-testid": ct.Body,
      ref: n,
      className: f(
        {
          [is.rootIsLoading]: o,
          [is.rootIsLoadingFade]: o && c === "fade"
        },
        is.root,
        t
      ),
      children: [
        c === "spinner" && o && /* @__PURE__ */ s.jsx(zd, {}),
        d && /* @__PURE__ */ s.jsx(Md, { onRetry: i }),
        l && /* @__PURE__ */ s.jsx(Wd, { ...l }),
        h && a
      ]
    }
  );
} }), Vd = Object.assign($(yo), { name: yo.name }), Kd = "h-table-td--td__root", Ud = "h-table-td--td__rootExtraPaddingForFirstChild", qd = "h-table-td--td__rootStickyFooterTd", cs = {
  root: Kd,
  rootExtraPaddingForFirstChild: Ud,
  rootStickyFooterTd: qd
}, _o = ({ className: a, children: t, ...e }, n) => /* @__PURE__ */ s.jsx(Ne, { children: ({ rows: o, presentation: r, isTableFoot: i }) => {
  const l = f(
    cs.root,
    {
      [cs.rootExtraPaddingForFirstChild]: !o.expandableRows,
      [cs.rootStickyFooterTd]: r.stickyFooter === !0 && i === !0
    },
    a
  );
  return /* @__PURE__ */ s.jsx(
    rt,
    {
      as: "td",
      ref: n,
      className: l,
      ...e,
      "data-testid": ct.Td,
      children: t
    }
  );
} }), se = Object.assign($(_o), { name: _o.name }), Gd = "h-table-th--th__root", Yd = "h-table-th--th__rootSticky", Qd = "h-table-th--th__rootShowBG", Xd = "h-table-th--th__rootClickable", Zd = "h-table-th--th__icon", Jd = "h-table-th--th__contentWrapper", th = "h-table-th--th__tooltip", Zt = {
  root: Gd,
  rootSticky: Yd,
  rootShowBG: Qd,
  rootClickable: Xd,
  icon: Zd,
  contentWrapper: Jd,
  tooltip: th
};
class Co extends D {
  context = void 0;
  columnIsInSortableColumns() {
    return this.context?.sorting.sortableColumns?.some(
      (t) => t === this.props.columnId
    ) ?? !0;
  }
  getContextualInfo() {
    const { columnId: t } = this.props, { context: e } = this;
    return {
      sortByThisColumn: e?.sorting.sortStatus?.sortBy === t,
      sortDirection: e?.sorting.sortStatus?.direction,
      columnIsSortable: e?.sorting.sortable && !yt(t) ? this.columnIsInSortableColumns() : !1
    };
  }
  getTheNewSortDirection(t) {
    const { sortByThisColumn: e, sortDirection: n } = this.getContextualInfo(), o = {
      sortBy: t,
      direction: "asc"
    };
    if (!e)
      return o;
    switch (n) {
      // not sorted => make it asc
      case void 0:
        return o;
      // desc sorted => not sorted
      case "desc":
        return null;
      // asc sorted => make it desc
      case "asc":
        return {
          sortBy: t,
          direction: "desc"
        };
      default:
        return o;
    }
  }
  getClickHandler() {
    const { onClick: t } = this.props, { context: e } = this;
    return (n) => {
      const { columnIsSortable: o } = this.getContextualInfo(), { columnId: r } = this.props;
      t?.(n), o && !yt(r) && e?.sorting.onSortChange(this.getTheNewSortDirection(r));
    };
  }
  renderIcon(t) {
    return t ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: Zt.icon,
        name: t === "asc" ? "sort-up" : "sort-down"
      }
    ) : null;
  }
  warnAboutNoColumnIdProps() {
    console.error(`
      <Table.Th> needs a 'columnId' prop when table is sortable.
      Pass 'columndId: null' prop if you want that column not to be sortable.
    `);
  }
  render() {
    return /* @__PURE__ */ s.jsx(Ne, { children: (t) => {
      this.context = t;
      const { sorting: e, presentation: n } = t;
      e.sortable && this.props.columnId === void 0 && this.warnAboutNoColumnIdProps();
      const {
        className: o,
        children: r,
        tooltip: i,
        columnId: l,
        thRef: c,
        ...d
      } = this.props, { sortByThisColumn: h, columnIsSortable: u, sortDirection: p } = this.getContextualInfo(), m = f(
        Zt.root,
        {
          [Zt.rootClickable]: u,
          [Zt.rootSticky]: n.stickyHeader,
          [Zt.rootShowBG]: n.headerWithBackground
        },
        o
      ), g = f({
        [Zt.tooltip]: i
      });
      return /* @__PURE__ */ s.jsx(
        rt,
        {
          as: "th",
          ...d,
          ref: c,
          className: m,
          onClick: this.getClickHandler(),
          "data-testid": ct.Th,
          children: /* @__PURE__ */ s.jsxs("span", { className: Zt.contentWrapper, children: [
            /* @__PURE__ */ s.jsx(gt, { content: i, disabled: !i, children: /* @__PURE__ */ s.jsx("span", { className: g, children: r }) }),
            h && this.renderIcon(p)
          ] })
        }
      );
    } });
  }
}
const Ds = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx(Co, { ...t, thRef: e });
    }
  ),
  { name: Co.name }
), eh = (a) => a === !1, nh = "h-table-tr--tr__trHoverable", sh = "h-table-tr--tr__expansionTriggerWrapper", oh = "h-table-tr--tr__expansionTriggerWrapperExpanded", rh = "h-table-tr--tr__checkboxCell", ah = "h-table-tr--tr__checkboxCellExpanded", ih = "h-table-tr--tr__expandedRowContentWrapper", St = {
  trHoverable: nh,
  expansionTriggerWrapper: sh,
  expansionTriggerWrapperExpanded: oh,
  checkboxCell: rh,
  checkboxCellExpanded: ah,
  expandedRowContentWrapper: ih
}, lh = ({
  rowId: a,
  isExpandable: t,
  isExpanded: e,
  onExpansionToggle: n,
  expandableContent: o,
  isSelectable: r,
  isSelected: i,
  onSelect: l,
  isHoverable: c,
  children: d,
  trRef: h,
  ...u
}) => {
  const p = f(u.className, {
    [St.trHoverable]: c
  }) || void 0;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "tr",
      {
        ...u,
        ref: h,
        className: p,
        "data-testid": ct.Row,
        children: [
          t && /* @__PURE__ */ s.jsx(
            se,
            {
              className: f(St.expansionTriggerWrapper, {
                [St.expansionTriggerWrapperExpanded]: e
              }),
              children: o && /* @__PURE__ */ s.jsx(
                K,
                {
                  variant: "tertiary",
                  icon: e ? "angle-down" : "angle-right",
                  "data-testid": ct.RowExpansionTrigger,
                  onClick: () => {
                    yt(a) || n(a);
                  }
                }
              )
            }
          ),
          r && /* @__PURE__ */ s.jsx(
            se,
            {
              className: f(St.checkboxCell, {
                [St.checkboxCellExpanded]: e
              }),
              children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
                an,
                {
                  checked: i,
                  name: `selection-trigger-${a}`,
                  id: `selection-trigger-${a}`,
                  onChange: () => {
                    yt(a) || l(a);
                  }
                }
              ) })
            }
          ),
          d
        ]
      }
    ),
    t && e && /* @__PURE__ */ s.jsxs("tr", { "data-testid": ct.Row, children: [
      /* @__PURE__ */ s.jsx(se, { className: St.expansionTriggerWrapper }),
      r && /* @__PURE__ */ s.jsx(se, { className: St.checkboxCell }),
      /* @__PURE__ */ s.jsx(
        se,
        {
          colSpan: Number.MAX_SAFE_INTEGER,
          className: St.expandedRowContentWrapper,
          children: o
        }
      )
    ] })
  ] });
}, ch = ({
  isExpandable: a,
  children: t,
  trRef: e,
  ...n
}) => /* @__PURE__ */ s.jsxs("tr", { ...n, ref: e, "data-testid": ct.Row, children: [
  a && /* @__PURE__ */ s.jsx(se, { className: St.expansionTriggerWrapper, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t
] }), dh = ({
  isExpandable: a,
  isSelectable: t,
  allRowsSelected: e,
  allRowsSelectedIndeterminate: n,
  onAllRowsSelect: o,
  children: r,
  trRef: i,
  ...l
}) => /* @__PURE__ */ s.jsxs("tr", { ...l, ref: i, "data-testid": ct.Row, children: [
  a && /* @__PURE__ */ s.jsx(Ds, { className: St.expansionTriggerWrapper, columnId: null, children: /* @__PURE__ */ s.jsx("span", {}) }),
  t && /* @__PURE__ */ s.jsx(Ds, { className: St.checkboxCell, columnId: null, children: /* @__PURE__ */ s.jsx(O, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ s.jsx(
    an,
    {
      checked: e,
      indeterminate: n,
      onChange: o,
      name: "all-rows-selector",
      id: "all-rows-selector"
    }
  ) }) }),
  r
] });
class wo extends D {
  context = void 0;
  isRowExpanded(t, e) {
    return t.includes(e);
  }
  hasSelectableRow() {
    const { rowId: t } = this.props;
    return this.context?.rows.selectableRows === !0 && !yt(t);
  }
  hasExpandableRow() {
    const { expandableContent: t, rowId: e } = this.props;
    return this.context?.rows.expandableRows === !0 && !yt(t) && !yt(e);
  }
  shouldRenderRegularTr() {
    return [this.hasExpandableRow(), this.hasSelectableRow()].every(eh);
  }
  rowIdIsPresent(t) {
    return !yt(t);
  }
  render() {
    const { children: t, expandableContent: e, rowId: n, ...o } = this.props;
    return /* @__PURE__ */ s.jsx(Ne, { children: (r) => {
      this.context = r;
      const { rows: i } = r;
      if (r.isTableHead)
        return /* @__PURE__ */ s.jsx(
          dh,
          {
            ...o,
            isExpandable: i.expandableRows,
            isSelectable: i.selectableRows,
            allRowsSelected: i.allRowsSelected,
            allRowsSelectedIndeterminate: i.allRowsSelectedIndeterminate,
            onAllRowsSelect: i.onAllRowsSelect,
            children: t
          }
        );
      if (r.isTableFoot)
        return /* @__PURE__ */ s.jsx(ch, { ...o, isExpandable: i.expandableRows, children: t });
      const l = yt(n) ? !1 : this.isRowExpanded(i.expandedRows, n), c = yt(n) ? !1 : i.selectedRowIds.includes(n);
      return /* @__PURE__ */ s.jsx(
        lh,
        {
          ...o,
          rowId: n,
          isExpanded: l,
          isSelected: c,
          onSelect: i.onRowSelect,
          isExpandable: i.expandableRows,
          expandableContent: e,
          isSelectable: i.selectableRows,
          onExpansionToggle: i.onExpansionToggle,
          isHoverable: r.presentation.hoverable,
          children: t
        }
      );
    } });
  }
}
const hh = Object.assign(
  $(function(t, e) {
    return /* @__PURE__ */ s.jsx(wo, { ...t, trRef: e });
  }),
  { name: wo.name }
), uh = "h-table--table__wrapper", ph = "h-table--table__wrapperIsFramed", mh = "h-table--table__wrapperIsLoading", gh = "h-table--table__innerWrapper", fh = "h-table--table__wrapperIsDisabled", bh = "h-table--table__table", de = {
  wrapper: uh,
  wrapperIsFramed: ph,
  wrapperIsLoading: mh,
  innerWrapper: gh,
  wrapperIsDisabled: fh,
  table: bh
};
class $n extends D {
  static defaultProps = {
    headerWithBackground: !0,
    stickyHeader: !1,
    stickyFooter: !1,
    framed: !0,
    hoverable: !1,
    loadingStrategy: "spinner"
  };
  constructor(t) {
    super(t), this.state = {
      expandedRows: t.expandableRowsProps?.initiallyExpandedRows ?? []
    }, this.handleExpansionToggle = this.handleExpansionToggle.bind(this);
  }
  static fallback = /* @__PURE__ */ s.jsx(
    O,
    {
      justifyContent: "center",
      alignItems: "center",
      style: { minHeight: "10vh" },
      children: /* @__PURE__ */ s.jsx(L.Paragraph, { children: "Oops! something went wrong..." })
    }
  );
  handleExpansionToggle(t) {
    this.state.expandedRows.includes(t) ? this.setState(({ expandedRows: e }) => ({
      expandedRows: e.filter((n) => n !== t)
    })) : this.setState(({ expandedRows: e }) => ({
      expandedRows: [...e, t]
    }));
  }
  getContextValue() {
    const {
      props: {
        headerWithBackground: t,
        stickyHeader: e,
        stickyFooter: n,
        sortingProps: o,
        paginationProps: r,
        selectableRowsProps: i,
        expandableRowsProps: l,
        loading: c,
        loadingFailed: d,
        onLoadingRetry: h,
        emptyState: u,
        loadingStrategy: p,
        hoverable: m
      }
    } = this;
    return {
      status: {
        loading: c ?? !1,
        loadingFailed: d ?? !1,
        onLoadingRetry: h,
        emptyState: u
      },
      presentation: {
        headerWithBackground: !!t,
        stickyHeader: !!e,
        stickyFooter: !!n,
        hoverable: !!m
      },
      sorting: {
        sortable: !!o,
        sortableColumns: o?.sortableColumns,
        sortStatus: o?.sortStatus ?? null,
        onSortChange: o?.onSortChange ?? E
      },
      pagination: {
        paginated: !!r,
        selectedPage: r?.selectedPage ?? 1,
        pageCount: r?.pageCount ?? 1,
        onPageChange: r?.onPageChange ?? E,
        pageRangeDisplayed: r?.pageRangeDisplayed
      },
      rows: {
        expandableRows: l?.expandableRows ?? !1,
        expandedRows: this.state.expandedRows,
        onExpansionToggle: this.handleExpansionToggle,
        selectableRows: !!i,
        selectedRowIds: i?.selectedRowIds ?? [],
        onRowSelect: i?.onRowSelect ?? E,
        onAllRowsSelect: i?.onAllRowsSelect ?? E,
        allRowsSelected: i?.allRowsSelected ?? !1,
        allRowsSelectedIndeterminate: i?.allRowsSelectedIndeterminate ?? !1
      },
      loading: {
        loadingStrategy: p ?? "spinner"
      }
    };
  }
  render() {
    const {
      framed: t,
      className: e,
      children: n,
      wrapperProps: o,
      wrapperRef: r,
      innerWrapperClassName: i,
      nativeProps: l,
      tableRef: c
    } = this.props, d = Id(n), h = f(de.wrapper, o?.className, {
      [de.wrapperIsFramed]: t,
      [de.wrapperIsLoading]: this.props.loading,
      [de.wrapperIsDisabled]: this.props.loading && this.props.loadingStrategy && ["fade", "disabled"].includes(this.props.loadingStrategy)
    }), u = f(
      {
        [de.innerWrapper]: !0
      },
      i
    ), p = f(de.table, e), m = this.getContextValue();
    return /* @__PURE__ */ s.jsx(Bs, { fallback: $n.fallback, children: /* @__PURE__ */ s.jsx(Gn.Provider, { value: m, children: /* @__PURE__ */ s.jsxs("div", { ...o, className: h, children: [
      /* @__PURE__ */ s.jsx("div", { className: u, ref: r, children: /* @__PURE__ */ s.jsx("table", { ...l, ref: c, className: p, children: d.children }) }),
      m.pagination.paginated && /* @__PURE__ */ s.jsx(Rd, {}),
      !m.pagination.paginated && d.footers
    ] }) }) });
  }
}
const mt = Object.assign(
  $(
    function(t, e) {
      return /* @__PURE__ */ s.jsx($n, { ...t, tableRef: e });
    }
  ),
  {
    name: $n.name,
    Thead: wd,
    Tbody: Vd,
    Tfoot: yd,
    Tr: hh,
    Th: Ds,
    Td: se,
    Footer: Ws
  }
), xh = "h-helpIcon--helpIcon__infoIcon", yh = {
  infoIcon: xh
};
class Ms extends D {
  render() {
    const {
      side: t,
      text: e,
      title: n,
      disabled: o,
      requireClick: r,
      className: i,
      alwaysShow: l,
      tooltipClassName: c,
      ...d
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      gt,
      {
        head: n,
        content: e,
        disabled: o,
        side: t,
        requireClick: r,
        alwaysShow: l,
        className: c,
        wrap: "none",
        ...d,
        children: /* @__PURE__ */ s.jsx("span", { className: f(yh.infoIcon, i), children: /* @__PURE__ */ s.jsx(N, { name: "info" }) })
      }
    );
  }
}
const xr = ({
  columns: a
}) => /* @__PURE__ */ s.jsx(s.Fragment, { children: a.map(({ label: t, style: e, helpIcon: n, columnId: o }, r) => /* @__PURE__ */ s.jsxs(mt.Th, { columnId: o || t, style: e, children: [
  t,
  n?.title && n?.text && /* @__PURE__ */ s.jsx(Ms, { side: "bottom", ...n })
] }, t || r)) }), _h = ({
  columns: a,
  data: t
}) => /* @__PURE__ */ s.jsxs(mt, { headerWithBackground: !1, framed: !1, children: [
  /* @__PURE__ */ s.jsx(mt.Thead, { children: /* @__PURE__ */ s.jsx(mt.Tr, { children: /* @__PURE__ */ s.jsx(xr, { columns: a }) }) }),
  /* @__PURE__ */ s.jsx(mt.Tbody, { children: t.map((e, n) => /* @__PURE__ */ s.jsx(mt.Tr, { children: a.map(({ selector: o }, r) => /* @__PURE__ */ s.jsx(mt.Td, { children: o(e) }, r)) }, n)) })
] }), Ch = ({
  data: a,
  rowId: t,
  columns: e,
  subTableColumns: n,
  subTableDataSelector: o
}) => /* @__PURE__ */ s.jsx(
  mt.Tr,
  {
    expandableContent: !!(n && o) && /* @__PURE__ */ s.jsx(
      _h,
      {
        data: o(a),
        columns: n
      }
    ),
    rowId: t,
    children: e.map(({ selector: r }, i) => /* @__PURE__ */ s.jsx(mt.Td, { children: r(a) }, i))
  }
), ok = ({
  columns: a,
  subTableColumns: t,
  data: e,
  subTableDataSelector: n,
  tableWrapperProps: o,
  tableInnerWrapperClassName: r,
  paginationProps: i,
  sortingProps: l,
  selectableRowsProps: c,
  tableStyleProps: d,
  tableStatusProps: h,
  tableRowIdSelector: u,
  tableLoadingStrategy: p,
  tableWrapperRef: m
}) => {
  const g = a.filter((b) => b.sortable).reduce(
    (b, x) => x.columnId ? [...b, x.columnId] : b,
    []
  );
  return g.length && l && (l.sortableColumns = g), /* @__PURE__ */ s.jsxs(
    mt,
    {
      stickyHeader: !0,
      wrapperProps: o,
      innerWrapperClassName: r,
      expandableRowsProps: {
        expandableRows: !!(t && n)
      },
      sortingProps: l,
      selectableRowsProps: c,
      loadingStrategy: p,
      wrapperRef: m,
      ...d,
      ...h,
      children: [
        /* @__PURE__ */ s.jsx(mt.Thead, { children: /* @__PURE__ */ s.jsx(mt.Tr, { children: /* @__PURE__ */ s.jsx(xr, { columns: a }) }) }),
        /* @__PURE__ */ s.jsx(mt.Tbody, { children: e.map((b, x) => /* @__PURE__ */ s.jsx(
          Ch,
          {
            rowId: u ? u(b) : x,
            data: b,
            columns: a,
            subTableDataSelector: n,
            subTableColumns: t
          },
          x
        )) }),
        i && /* @__PURE__ */ s.jsx(mt.Footer, { children: /* @__PURE__ */ s.jsx(fd, { ...i }) })
      ]
    }
  );
}, wh = "h-datePickerOld--datePickerDay__root", vh = "h-datePickerOld--datePickerDay__rootActive", Sh = "h-datePickerOld--datePickerDay__rootDisabled", Ih = "h-datePickerOld--datePickerDay__rootDim", Dh = "h-datePickerOld--datePickerDay__label", Ae = {
  root: wh,
  rootActive: vh,
  rootDisabled: Sh,
  rootDim: Ih,
  label: Dh
};
class kh extends D {
  render() {
    const {
      className: t,
      dim: e,
      active: n,
      disabled: o,
      children: r,
      onClick: i,
      ...l
    } = this.props, c = f(
      {
        [Ae.root]: !0,
        [Ae.rootDim]: e,
        [Ae.rootActive]: n,
        [Ae.rootDisabled]: !n && o
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "button",
      {
        ...l,
        onClick: i,
        className: c,
        disabled: o,
        children: /* @__PURE__ */ s.jsx("span", { className: Ae.label, children: r })
      }
    );
  }
}
const Th = "h-datePickerOld--datePickerOld__grid", jh = "h-datePickerOld--datePickerOld__gridItem", Nh = "h-datePickerOld--datePickerOld__day", Ph = "h-datePickerOld--datePickerOld__month", Fh = "h-datePickerOld--datePickerOld__timeButtonContainerLeft", Rh = "h-datePickerOld--datePickerOld__timeButtonContainerRight", Eh = "h-datePickerOld--datePickerOld__arrowTime", Lh = "h-datePickerOld--datePickerOld__arrow", Ah = "h-datePickerOld--datePickerOld__dayNames", $h = "h-datePickerOld--datePickerOld__dayName", Bh = "h-datePickerOld--datePickerOld__time", Oh = "h-datePickerOld--datePickerOld__timeDisplay", G = {
  grid: Th,
  gridItem: jh,
  day: Nh,
  month: Ph,
  timeButtonContainerLeft: Fh,
  timeButtonContainerRight: Rh,
  arrowTime: Eh,
  arrow: Lh,
  dayNames: Ah,
  dayName: $h,
  time: Bh,
  timeDisplay: Oh
}, rk = (a) => [0, 6].indexOf(a.getDay()) !== -1;
class Qe extends D {
  static defaultProps;
  static getDateValue(t) {
    const e = t.value instanceof Date ? t.value : /* @__PURE__ */ new Date();
    return new Date(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes()
    );
  }
  constructor(t) {
    super(t);
    const e = Qe.getDateValue(t.input);
    this.state = {
      selectedDate: e,
      showDate: e
    };
  }
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(t) {
    const { input: e } = this.props;
    t.input !== e && this.setState({
      selectedDate: Qe.getDateValue(t.input)
    });
  }
  generateGrid() {
    const { selectedDate: t, showDate: e } = this.state, { input: n, disabled: o, minDate: r, maxDate: i } = this.props, l = [], c = new Date(
      e.getFullYear(),
      e.getMonth(),
      1,
      t.getHours(),
      t.getMinutes()
    ), d = c.getDay() || 7, h = new Date(
      c.getFullYear(),
      c.getMonth() + 1,
      1
    );
    d < 3 && c.setDate(c.getDate() - 7), c.setDate(c.getDate() - (d - 1));
    const u = Qe.getDateValue(n).getTime();
    let p = 0;
    for (; c < h || c.getDay() !== 1 || p < 6; ) {
      const m = c.getTime(), g = new Date(m);
      l.push({
        date: g,
        label: c.getDate().toString(),
        isThisMonth: c.getMonth() === e.getMonth(),
        selected: m === u,
        disabled: o(c) || !!(i && g > i) || !!(r && g < r)
      }), c.getDay() === 1 && (p += 1), c.setDate(c.getDate() + 1);
    }
    return l;
  }
  goToMonth(t) {
    const { showDate: e } = this.state, n = new Date(e.getTime());
    n.setMonth(e.getMonth() + t), this.setState({
      showDate: n
    });
  }
  nextMonth = (t) => {
    t.preventDefault(), this.goToMonth(1);
  };
  prevMonth = (t) => {
    t.preventDefault(), this.goToMonth(-1);
  };
  handleDateClick(t, e) {
    t.preventDefault();
    const {
      input: { onChange: n }
    } = this.props, { showDate: o } = this.state, r = {
      ...this.state,
      selectedDate: e
    };
    o.getMonth() !== e.getMonth() && (r.showDate = e), this.setState(r), n(e);
  }
  goToTime(t, e, n = "hours") {
    const o = n === "minutes" ? "setMinutes" : "setHours", r = n === "minutes" ? "getMinutes" : "getHours", {
      input: { onChange: i }
    } = this.props, { selectedDate: l } = this.state, c = new Date(l.getTime());
    c[o](c[r]() + e), this.setState({
      selectedDate: c
    }), i(c);
  }
  nextMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, 15, "minutes");
  };
  prevMinutes = (t) => {
    t.preventDefault(), this.goToTime(t, -15, "minutes");
  };
  nextHour = (t) => {
    t.preventDefault(), this.goToTime(t, 1);
  };
  prevHour = (t) => {
    t.preventDefault(), this.goToTime(t, -1);
  };
  canGoPrevMonth() {
    const { minDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth(),
      1
    );
    return t < n;
  }
  canGoNextMonth() {
    const { maxDate: t } = this.props, { showDate: e } = this.state;
    if (t === null) return !0;
    const n = new Date(
      e.getFullYear(),
      e.getMonth() + 1,
      1,
      0,
      0,
      0,
      -1
    );
    return t > n;
  }
  canGoDirection(t = "hours", e) {
    const n = t === "minutes" ? "setMinutes" : "setHours", o = t === "minutes" ? "getMinutes" : "getHours", { maxDate: r } = this.props, { selectedDate: i } = this.state, l = new Date(i.getTime());
    return l[n](l[o]() + e), !(l.getDate() !== i.getDate()) && (r === null || r >= l);
  }
  render() {
    const {
      className: t,
      input: e,
      hasTime: n,
      disabled: o,
      minDate: r,
      maxDate: i,
      ...l
    } = this.props, { selectedDate: c, showDate: d } = this.state, h = f({}, t), u = this.generateGrid(), p = {
      month: "long",
      year: "numeric"
    };
    let m = null;
    try {
      m = d.toLocaleDateString("en-US", p);
    } catch (g) {
      m = `${d.getMonth() + 1} / ${d.getFullYear()}`, console.warn("toLocaleDateString exception", g);
    }
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsxs("div", { className: G.month, children: [
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: G.arrow,
            disabled: !this.canGoPrevMonth(),
            onClick: this.prevMonth,
            "aria-label": "Previous month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
          }
        ),
        m,
        /* @__PURE__ */ s.jsx(
          "button",
          {
            className: G.arrow,
            disabled: !this.canGoNextMonth(),
            onClick: this.nextMonth,
            "aria-label": "Next month",
            children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { className: G.dayNames, children: [
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Mon" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Tue" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Wed" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Thu" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Fri" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Sat" }),
        /* @__PURE__ */ s.jsx("p", { className: G.dayName, children: "Sun" })
      ] }),
      /* @__PURE__ */ s.jsx("div", { className: G.grid, children: u.map((g) => /* @__PURE__ */ s.jsx("div", { className: G.gridItem, children: /* @__PURE__ */ s.jsx(
        kh,
        {
          onClick: (b) => this.handleDateClick(b, g.date),
          dim: !g.isThisMonth,
          active: g.selected,
          disabled: g.disabled,
          className: G.day,
          children: g.label
        }
      ) }, g.date.getTime())) }),
      n && /* @__PURE__ */ s.jsxs("div", { className: G.time, children: [
        /* @__PURE__ */ s.jsxs("div", { className: G.timeButtonContainerLeft, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("hours", -1),
              onClick: this.prevHour,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-left", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("minutes", -15),
              onClick: this.prevMinutes,
              "aria-label": "Previous hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-left", className: "icon-vertical-fix" })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx("div", { className: G.timeDisplay, children: `${to(
          c.getHours().toString(),
          2,
          "0"
        )}:${to(c.getMinutes().toString(), 2, "0")}` }),
        /* @__PURE__ */ s.jsxs("div", { className: G.timeButtonContainerRight, children: [
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("minutes", 15),
              onClick: this.nextMinutes,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-right", className: "icon-vertical-fix" })
            }
          ),
          /* @__PURE__ */ s.jsx(
            "button",
            {
              className: G.arrowTime,
              disabled: !this.canGoDirection("hours", 1),
              onClick: this.nextHour,
              "aria-label": "Next hour",
              children: /* @__PURE__ */ s.jsx(N, { name: "angle-double-right", className: "icon-vertical-fix" })
            }
          )
        ] })
      ] })
    ] });
  }
}
Qe.defaultProps = {
  /* eslint-disable react/default-props-match-prop-types */
  disabled: () => !1,
  minDate: null,
  maxDate: null,
  hasTime: !1
};
function Hh(a) {
  return Math.abs(a.diff(j())) < 25e3 ? "just now" : a.fromNow();
}
function ks(a) {
  return j(a, j.ISO_8601).isValid();
}
function Se(a) {
  return !!j.tz.zone(a ?? "");
}
const jt = "HH:mm", yr = ir(24), _r = ir(0, 60, 15), Cr = (a) => j("1995-12-25").format(a);
function wr(a) {
  if (a < 0 || a > 23)
    throw new Error("Hour must be between 0 and 23.");
}
function vr(a) {
  if (a < 0 || a > 59)
    throw new Error("Minute must be between 0 and 59.");
}
function Sr({
  hour: a,
  minute: t,
  timeFormat: e
}) {
  const n = j({ hour: a, minute: t });
  return {
    id: n.format(jt),
    name: n.format(e)
  };
}
function Wh(a, t) {
  return t?.map(({ hour: e, minute: n }) => (wr(e), vr(n), Sr({ hour: e, minute: n, timeFormat: a }))) || [];
}
function Ir({
  hours: a,
  minutes: t,
  overrides: e,
  timeFormat: n
}) {
  return da(
    a.reduce(
      (o, r, i) => [
        ...o,
        ...t.map((l, c) => (c === 0 && wr(r), i === 0 && vr(l), Sr({ hour: r, minute: l, timeFormat: n })))
      ],
      []
    ).concat(Wh(n, e)),
    ["id"]
  );
}
const Mh = "h-datePicker--datePicker__root", zh = "h-datePicker--datePicker__navigationButton", Vh = "h-datePicker--datePicker__nextMonthButton", Kh = "h-datePicker--datePicker__prevMonthButton", ve = {
  root: Mh,
  navigationButton: zh,
  nextMonthButton: Vh,
  prevMonthButton: Kh
}, Bn = {
  previousMonth({ ariaLabel: a, ...t }) {
    const e = f(
      ve.navigationButton,
      ve.prevMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": a, size: 24, name: "angle-left" }) });
  },
  nextMonth({ ariaLabel: a, ...t }) {
    const e = f(
      ve.navigationButton,
      ve.nextMonthButton
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(N, { ...t, "aria-label": a, size: 24, name: "angle-right" }) });
  }
}, Dr = (a) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx("span", { className: "date-number-container", children: a.date() }),
  /* @__PURE__ */ s.jsx("span", { className: "day-complimentary-highlight" })
] }), kr = ({ month: a }) => /* @__PURE__ */ s.jsx("span", { children: a.format("MMMM YYYY") }), Tr = (a) => {
  const { value: t, presets: e, onSelect: n } = a, o = P(
    (r) => {
      n(r.key === t ? null : r);
    },
    [n, t]
  );
  return /* @__PURE__ */ s.jsxs(Yt, { children: [
    /* @__PURE__ */ s.jsx(Vn, { orientation: "vertical" }),
    /* @__PURE__ */ s.jsx(oo, { children: e.map((r) => /* @__PURE__ */ s.jsx(
      oo.Item,
      {
        isSelected: r.key === t,
        onClick: () => o(r),
        children: r.label
      },
      r.key
    )) })
  ] });
}, Uh = "h-fieldLabel--fieldLabel__root", qh = "h-fieldLabel--fieldLabel__label", Gh = "h-fieldLabel--fieldLabel__labelChildren", Yh = "h-fieldLabel--fieldLabel__rootRequired", Qh = "h-fieldLabel--fieldLabel__helpIcon", $e = {
  root: Uh,
  label: qh,
  labelChildren: Gh,
  rootRequired: Yh,
  helpIcon: Qh
}, Xh = "fieldLabel";
class zs extends D {
  render() {
    const { required: t, helpIcon: e, className: n, children: o, ...r } = this.props, i = f($e.root, n, {
      [$e.rootRequired]: t
    });
    return /* @__PURE__ */ s.jsxs("div", { className: i, "data-testid": Xh, children: [
      /* @__PURE__ */ s.jsx("label", { className: $e.label, ...r, children: /* @__PURE__ */ s.jsx("div", { className: $e.labelChildren, children: o }) }),
      !!e?.text && /* @__PURE__ */ s.jsx(
        Ms,
        {
          ...e,
          className: f($e.helpIcon, e.className)
        }
      )
    ] });
  }
}
const Zh = "h-dropdownSelect--dropdownInfinite__item", Jh = "h-dropdownSelect--dropdownInfinite__list", tu = "h-dropdownSelect--dropdownInfinite__listEmpty", ds = {
  item: Zh,
  list: Jh,
  listEmpty: tu
};
class vo extends D {
  render() {
    const {
      item: t,
      itemComponent: e,
      tooltip: n,
      onSelect: o,
      onChange: r,
      onKeyDown: i,
      clearSearch: l,
      checked: c,
      disabled: d,
      isLoading: h,
      active: u,
      id: p
    } = this.props, m = /* @__PURE__ */ s.jsx(
      e,
      {
        item: t,
        onSelect: o,
        onChange: r,
        onKeyDown: i,
        clearSearch: l,
        checked: c,
        disabled: d,
        isLoading: h,
        active: u,
        tabIndex: -1,
        id: p,
        role: "option",
        "aria-disabled": d,
        "aria-selected": c
      }
    );
    return n ? /* @__PURE__ */ s.jsx(gt, { ...n, children: m }, t.id) : m;
  }
}
const eu = 6, nu = 48;
class Vs extends D {
  listRef;
  infiniteListRef;
  static defaultProps = {
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  constructor(t) {
    super(t), this.isItemLoaded = this.isItemLoaded.bind(this), this.listRef = B(), this.infiniteListRef = B();
  }
  isItemLoaded(t) {
    const { items: e } = this.props;
    return t < e.length;
  }
  isItemActive(t) {
    if (!t) return !1;
    const { activeItem: e } = this.props;
    return t === e || t.id === e;
  }
  isItemChecked(t) {
    if (!t) return !1;
    const { selectedItems: e } = this.props;
    return (e?.findIndex((o) => typeof o == "object" ? o.id === t.id : o === t.id) ?? -1) > -1;
  }
  isItemDisabled(t) {
    return t ? (this.props.disabledItems?.indexOf(t.id) ?? -1) >= 0 : !0;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !t || As(e?.[t.id]) ? null : e?.[t.id] ?? null;
  }
  goToTop() {
    this.infiniteListRef.current && this.infiniteListRef.current.scrollToItem(0), this.listRef.current && (this.listRef.current.scrollTop = 0);
  }
  getItemId(t) {
    const { id: e } = this.props;
    return e ? `${e}-option-${t}` : void 0;
  }
  /**
   * This attribute is supposed to be a React component. The FixedSizeList
   * component expects a component is a child.
   *
   * @see https://react-window.vercel.app/#/examples/list/fixed-size
   */
  ListItem = ({
    index: t,
    style: e
  }) => {
    const { items: n, itemComponent: o, onSelect: r, onChange: i, clearSearch: l } = this.props, c = this.isItemLoaded(t), d = t === n.length - 1, h = c ? n[t] : { id: tn(), name: "Loading..." }, u = this.props.pagination ? this.props.pagination.nextEnable : !1;
    return /* @__PURE__ */ s.jsxs("div", { style: e, className: ds.item, children: [
      /* @__PURE__ */ s.jsx(
        vo,
        {
          id: this.getItemId(t),
          checked: this.isItemChecked(h),
          clearSearch: l,
          disabled: this.isItemDisabled(h),
          isLoading: !c,
          item: h,
          itemComponent: o,
          onChange: i,
          onSelect: r,
          tooltip: this.getTooltip(h),
          active: this.isItemActive(h)
        }
      ),
      d && u && c && /* @__PURE__ */ s.jsx(ha, { onEnter: this.loadMoreItems })
    ] });
  };
  loadMoreItems = async () => {
    this.props.pagination && await this.props.pagination.onNext?.();
  };
  render() {
    const {
      items: t,
      pagination: e,
      itemComponent: n,
      onSelect: o,
      onChange: r,
      onKeyDown: i,
      clearSearch: l,
      itemsDisplayCount: c = eu,
      itemHeight: d = nu,
      id: h,
      ariaLabelledby: u
    } = this.props;
    if (!e || !e.infinite || !e.onNext)
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          style: { maxHeight: `${c * d}px` },
          className: f({
            [ds.list]: !0,
            [ds.listEmpty]: t.length === 0
          }),
          ref: this.listRef,
          role: "listbox",
          id: h,
          "aria-labelledby": u,
          children: t.map((w, y) => {
            const v = ua(w) ? w : w.id.toString() || w.name.toString() || w.toString();
            return /* @__PURE__ */ s.jsx(
              vo,
              {
                id: this.getItemId(y),
                checked: this.isItemChecked(w),
                clearSearch: l,
                disabled: this.isItemDisabled(w),
                item: w,
                itemComponent: n,
                onChange: r,
                onSelect: o,
                onKeyDown: i,
                tooltip: this.getTooltip(w),
                active: this.isItemActive(w)
              },
              v
            );
          })
        }
      );
    const { nextEnable: p, itemCount: m } = e, g = m || (p ? t.length + c : t.length), b = {
      items: t,
      selectedItems: this.props.selectedItems,
      disabledItems: this.props.disabledItems,
      tooltipItems: this.props.tooltipItems,
      activeItem: this.props.activeItem,
      pagination: this.props.pagination
    }, x = Math.min(
      g * d,
      c * d
    );
    return /* @__PURE__ */ s.jsx(pa, { disableHeight: !0, doNotBailOutOnEmptyChildren: !0, children: ({ width: w }) => /* @__PURE__ */ s.jsx(
      ma,
      {
        ...b,
        ref: this.infiniteListRef,
        width: w,
        height: x,
        itemCount: g,
        itemSize: d,
        "aria-labelledby": u,
        children: this.ListItem
      }
    ) });
  }
}
const su = "h-selectItems-checkableBaseItem--checkableBaseItem__root", ou = "h-selectItems-checkableBaseItem--checkableBaseItem__rootActive", ru = "h-selectItems-checkableBaseItem--checkableBaseItem__rootDisabled", au = "h-selectItems-checkableBaseItem--checkableBaseItem__checkbox", iu = "h-selectItems-checkableBaseItem--checkableBaseItem__content", Be = {
  root: su,
  rootActive: ou,
  rootDisabled: ru,
  checkbox: au,
  content: iu
};
class Ks extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  noop(t) {
    t.preventDefault();
  }
  render() {
    const {
      item: t,
      onChange: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: i,
      children: l,
      active: c,
      ...d
    } = this.props, h = f(Be.root, {
      [Be.rootDisabled]: r,
      [Be.rootActive]: c
    }), u = r ? E : this.handleChange;
    return /* @__PURE__ */ s.jsxs("label", { ...d, className: h, children: [
      /* @__PURE__ */ s.jsx(
        an,
        {
          id: t?.id,
          name: "",
          className: Be.checkbox,
          checked: o,
          onChange: u
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: Be.content, children: l })
    ] });
  }
}
const lu = "h-selectItems-emptySelectItem--emptySelectItem__root", cu = "h-selectItems-emptySelectItem--emptySelectItem__name", So = {
  root: lu,
  name: cu
};
class cn extends D {
  render() {
    const { label: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("div", { ...e, className: So.root, children: /* @__PURE__ */ s.jsx("div", { className: So.name, children: t }) });
  }
}
const du = "h-selectItems-selectItem--selectItem__root", hu = "h-selectItems-selectItem--selectItem__rootActive", uu = "h-selectItems-selectItem--selectItem__name", pu = "h-selectItems-selectItem--selectItem__nameBold", mu = "h-selectItems-selectItem--selectItem__nameWithDescription", gu = "h-selectItems-selectItem--selectItem__description", fu = "h-selectItems-selectItem--selectItem__icon", Jt = {
  root: du,
  rootActive: hu,
  name: uu,
  nameBold: pu,
  nameWithDescription: mu,
  description: gu,
  icon: fu
};
class jr extends _t {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      active: i,
      isLoading: l,
      ...c
    } = this.props, { description: d, name: h, icon: u, iconSize: p } = t, m = f(Jt.root, {
      [Jt.rootActive]: i
    }), g = f(Jt.name, {
      [Jt.nameBold]: o,
      [Jt.nameWithDescription]: !!d
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": i,
        className: m,
        disabled: r,
        onClick: () => {
          e(t);
        },
        children: [
          u ? /* @__PURE__ */ s.jsx(N, { className: Jt.icon, name: u, size: p ?? 16 }) : null,
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
            /* @__PURE__ */ s.jsx("span", { className: g, "data-testid": "name", children: h }),
            d && /* @__PURE__ */ s.jsx("span", { className: Jt.description, "data-testid": "description", children: d })
          ] }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
const bu = "h-selectItems-checkableSelectItem--checkableSelectItem__name", xu = {
  name: bu
};
class ak extends D {
  render() {
    const { item: t, isLoading: e } = this.props, { name: n } = e ? { name: "Loading..." } : t;
    return /* @__PURE__ */ s.jsx(Ks, { ...this.props, children: /* @__PURE__ */ s.jsx("span", { className: xu.name, children: n }) });
  }
}
const yu = "h-selectItems-tagSelectItem--tagSelectItem__root", _u = "h-selectItems-tagSelectItem--tagSelectItem__rootActive", Cu = "h-selectItems-tagSelectItem--tagSelectItem__name", wu = "h-selectItems-tagSelectItem--tagSelectItem__nameBold", vu = "h-selectItems-tagSelectItem--tagSelectItem__dotContainer", Su = "h-selectItems-tagSelectItem--tagSelectItem__dot", he = {
  root: yu,
  rootActive: _u,
  name: Cu,
  nameBold: wu,
  dotContainer: vu,
  dot: Su
};
class ik extends D {
  static defaultProps = {
    checked: !1
  };
  render() {
    const {
      item: t,
      onSelect: e,
      clearSearch: n,
      checked: o,
      disabled: r,
      isLoading: i,
      active: l,
      ...c
    } = this.props, { name: d, color: h = "#000" } = t, u = f(he.root, {
      [he.rootActive]: l
    }), p = f(he.name, {
      [he.nameBold]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...c,
        type: "button",
        "aria-current": l,
        className: u,
        onClick: () => {
          e(t), n();
        },
        tabIndex: 0,
        title: typeof d == "string" ? d : d.toString(),
        disabled: r,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: he.dotContainer, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: he.dot,
              style: { backgroundColor: h ?? void 0 }
            }
          ) }),
          /* @__PURE__ */ s.jsx("div", { className: p, children: d }),
          o && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" }),
          r && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ]
      }
    );
  }
}
const Iu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__name", Du = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dotContainer", ku = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__dot", Tu = "h-selectItems-checkableTagSelectItem--checkableTagSelectItem__nameContainer", mn = {
  name: Iu,
  dotContainer: Du,
  dot: ku,
  nameContainer: Tu
};
class lk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange() {
    const { onChange: t, item: e, checked: n } = this.props;
    typeof t == "function" && t(e, !n);
  }
  render() {
    const { item: t, isLoading: e, disabled: n } = this.props, { name: o, color: r } = e ? { name: "Loading...", color: "#000" } : t;
    return /* @__PURE__ */ s.jsx(
      Ks,
      {
        ...this.props,
        disabled: this.props.checked ? !1 : n,
        children: /* @__PURE__ */ s.jsxs("div", { className: mn.nameContainer, children: [
          r && /* @__PURE__ */ s.jsx("div", { className: mn.dotContainer, children: /* @__PURE__ */ s.jsx("div", { className: mn.dot, style: { backgroundColor: r } }) }),
          /* @__PURE__ */ s.jsx("span", { className: mn.name, children: o }),
          n && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" })
        ] })
      }
    );
  }
}
const ju = "h-selectItems-avatarSelectItem--avatarSelectItem__root", Nu = "h-selectItems-avatarSelectItem--avatarSelectItem__rootActive", Pu = "h-selectItems-avatarSelectItem--avatarSelectItem__secondaryName", Fu = "h-selectItems-avatarSelectItem--avatarSelectItem__primaryName", Ru = "h-selectItems-avatarSelectItem--avatarSelectItem__names", Eu = "h-selectItems-avatarSelectItem--avatarSelectItem__namesBold", Lu = "h-selectItems-avatarSelectItem--avatarSelectItem__container", Au = "h-selectItems-avatarSelectItem--avatarSelectItem__containerCheckable", Wt = {
  root: ju,
  rootActive: Nu,
  secondaryName: Pu,
  primaryName: Fu,
  names: Ru,
  namesBold: Eu,
  container: Lu,
  containerCheckable: Au
};
class $u extends D {
  static defaultProps = {
    checked: !1
  };
  getNames(t) {
    const e = /* @__PURE__ */ new Set();
    typeof t.name == "string" && e.add(t.name), typeof t.name != "string" && typeof t.display_name == "string" && e.add(t.display_name), typeof t.phone_number == "string" && e.add(t.phone_number), typeof t.email == "string" && e.add(t.email);
    const n = Array.from(e);
    return {
      primaryName: n.length > 0 ? n[0] : "No name",
      secondaryName: n.length > 1 ? n[1] : null
    };
  }
  getAvatar(t) {
    return typeof t.icon == "string" ? /* @__PURE__ */ s.jsx(N, { name: t.icon, size: 16 }) : /* @__PURE__ */ s.jsx(mr, { user: t });
  }
  renderContent() {
    const t = this.props.isLoading ? {
      id: "",
      name: "Loading..."
    } : this.props.item, e = this.getAvatar(t), n = this.getNames(t), o = f(Wt.container, {
      [Wt.containerCheckable]: this.props.checkable
    }), r = f(Wt.names, {
      [Wt.namesBold]: this.props.checked
    });
    return /* @__PURE__ */ s.jsxs("div", { className: o, children: [
      e,
      /* @__PURE__ */ s.jsxs("div", { className: r, children: [
        /* @__PURE__ */ s.jsx("div", { className: Wt.primaryName, children: n.primaryName }),
        n.secondaryName !== null && /* @__PURE__ */ s.jsx("div", { className: Wt.secondaryName, children: n.secondaryName })
      ] })
    ] });
  }
  render() {
    const t = this.renderContent(), { checkable: e, ...n } = this.props;
    if (e) {
      const m = n;
      return /* @__PURE__ */ s.jsx(Ks, { ...m, children: t });
    }
    const o = n, { item: r, disabled: i, onSelect: l, active: c, checked: d, isLoading: h, ...u } = o, p = f(Wt.root, {
      [Wt.rootActive]: c
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...u,
        type: "button",
        className: p,
        disabled: i,
        onClick: () => {
          l(r);
        },
        "aria-current": c,
        children: [
          t,
          d && /* @__PURE__ */ s.jsx(N, { name: "done", size: 20, color: "neutral.700" })
        ]
      }
    );
  }
}
class ck extends D {
  render() {
    return /* @__PURE__ */ s.jsx($u, { checkable: !0, ...this.props });
  }
}
const Bu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__root", Ou = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__rootActive", Hu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__suggestion", Wu = "h-selectItems-tagSelectSuggestion--tagSelectSuggestion__icon", gn = {
  root: Bu,
  rootActive: Ou,
  suggestion: Hu,
  icon: Wu
};
class dk extends _t {
  static defaultProps = {
    searchSuggestion: (t, e) => t.find((n) => n.name.toLowerCase() === e.toLowerCase()),
    renderSuggestion: (t) => `Add "${t}" tag`
  };
  constructor(t) {
    super(t), this.state = {}, this.onSuggest = this.onSuggest.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidUpdate(t) {
    const { searched: e, active: n } = this.props;
    e !== t.searched && this.searchItem(), n !== t.active && (n ? window.addEventListener("keydown", this.handleKeyDown) : window.removeEventListener("keydown", this.handleKeyDown));
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }
  searchItem() {
    const { items: t, searched: e, searchSuggestion: n } = this.props;
    this.setState({ searching: !0 }, async () => {
      try {
        const o = await n?.(t, e);
        this.setState({ item: o });
      } catch (o) {
        console.error(o);
      } finally {
        this.setState({ searching: !1 });
      }
    });
  }
  onSuggest() {
    const { searched: t, onSuggest: e, clearSearch: n, triggerClose: o } = this.props;
    o?.(), e?.(t), n();
  }
  handleKeyDown(t) {
    this.props.active && t.key === "Enter" && this.onSuggest();
  }
  render() {
    const {
      className: t,
      triggerClose: e,
      onSuggest: n,
      searched: o,
      items: r,
      active: i,
      renderSuggestion: l,
      searchSuggestion: c,
      clearSearch: d,
      ...h
    } = this.props, { item: u, searching: p } = this.state;
    if (!o || p || u)
      return null;
    const m = f(t, gn.root, {
      [gn.rootActive]: i
    });
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        ...h,
        type: "button",
        "aria-current": i,
        className: m,
        onClick: this.onSuggest,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ s.jsx("div", { className: gn.suggestion, children: l?.(o) }),
          /* @__PURE__ */ s.jsx("div", { className: gn.icon, children: /* @__PURE__ */ s.jsx(N, { name: "plus" }) })
        ]
      }
    );
  }
}
const Mu = "h-selectItems-deselectItem--deselectItem__root", zu = "h-selectItems-deselectItem--deselectItem__rootDisabled", Vu = "h-selectItems-deselectItem--deselectItem__name", Ku = "h-selectItems-deselectItem--deselectItem__icon", fn = {
  root: Mu,
  rootDisabled: zu,
  name: Vu,
  icon: Ku
};
class Uu extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, ...r } = this.props, { name: i } = t, l = f(fn.root, {
      [fn.rootDisabled]: o
    });
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: l, children: [
      /* @__PURE__ */ s.jsx("div", { className: fn.name, children: i }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: fn.icon,
          onClick: () => {
            e(t);
          },
          disabled: o,
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const qu = "h-selectItems-tagDeselectItem--tagDeselectItem__root", Gu = "h-selectItems-tagDeselectItem--tagDeselectItem__name", Yu = "h-selectItems-tagDeselectItem--tagDeselectItem__icon", Qu = "h-selectItems-tagDeselectItem--tagDeselectItem__dotContainer", Xu = "h-selectItems-tagDeselectItem--tagDeselectItem__dot", Oe = {
  root: qu,
  name: Gu,
  icon: Yu,
  dotContainer: Qu,
  dot: Xu
};
class hk extends D {
  render() {
    const { item: t, onSelect: e, clearSearch: n, disabled: o, isLoading: r, ...i } = this.props, { name: l, color: c } = t, d = f(Oe.root);
    return /* @__PURE__ */ s.jsxs("div", { ...i, className: d, children: [
      /* @__PURE__ */ s.jsx("div", { className: Oe.dotContainer, children: /* @__PURE__ */ s.jsx(
        "div",
        {
          className: Oe.dot,
          style: { backgroundColor: c ?? void 0 }
        }
      ) }),
      /* @__PURE__ */ s.jsx("div", { className: Oe.name, children: l }),
      o && /* @__PURE__ */ s.jsx("span", { children: "Deactivated" }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: Oe.icon,
          onClick: () => {
            e(t);
          },
          children: /* @__PURE__ */ s.jsx(N, { name: "close" })
        }
      )
    ] });
  }
}
const Zu = "h-chip--chip__root", Ju = "h-chip--chip__rootLight", tp = "h-chip--chip__rootNoBorder", ep = "h-chip--chip__rootDisabled", np = "h-chip--chip__rootInteractable", He = {
  root: Zu,
  rootLight: Ju,
  rootNoBorder: tp,
  rootDisabled: ep,
  rootInteractable: np
}, sp = ({
  className: a,
  children: t,
  onClick: e,
  light: n,
  noBorder: o,
  disabled: r,
  ...i
}) => {
  const l = f(
    {
      [He.root]: !0,
      [He.rootLight]: n,
      [He.rootNoBorder]: o,
      [He.rootDisabled]: r,
      [He.rootInteractable]: typeof e == "function" && !r
    },
    a
  ), c = typeof e == "function" ? "button" : "div";
  return /* @__PURE__ */ s.jsx(rt, { ...i, as: c, className: l, onClick: e, children: t });
}, op = "h-tag--tag__tagName", rp = "h-tag--tag__tagNameTruncated", ap = "h-tag--tag__icon", ip = "h-tag--tag__deleteButton", lp = "h-tag--tag__deleteButtonDisabled", cp = "h-tag--tag__deleteIcon", ue = {
  tagName: op,
  tagNameTruncated: rp,
  icon: ap,
  deleteButton: ip,
  deleteButtonDisabled: lp,
  deleteIcon: cp
}, Ie = ({
  className: a,
  tagNameClassName: t,
  children: e,
  onDelete: n,
  color: o,
  light: r,
  noBorder: i,
  noTruncation: l = !1,
  disabled: c,
  ...d
}) => {
  const h = f(
    {
      [ue.tagName]: !0,
      [ue.tagNameTruncated]: !l
    },
    t
  ), u = f(ue.deleteButton, {
    [ue.deleteButtonDisabled]: c
  });
  return /* @__PURE__ */ s.jsxs(
    sp,
    {
      ...d,
      className: a,
      light: r,
      noBorder: i,
      disabled: c,
      children: [
        o && /* @__PURE__ */ s.jsx(
          "span",
          {
            className: ue.icon,
            style: { backgroundColor: Ze(o) ?? void 0 }
          }
        ),
        /* @__PURE__ */ s.jsx("span", { className: h, children: e }),
        !!n && !c && /* @__PURE__ */ s.jsx("button", { className: u, type: "button", onClick: n, children: /* @__PURE__ */ s.jsx(N, { name: "close", className: ue.deleteIcon }) })
      ]
    }
  );
}, dp = "h-select--select__root", hp = "h-select--select__rootDisabled", up = "h-select--select__inputWrapper", pp = "h-select--select__control", mp = "h-select--select__rootHasIcon", gp = "h-select--select__selection", fp = "h-select--select__selectionItem", bp = "h-select--select__tag", xp = "h-select--select__tagName", yp = "h-select--select__tagLimiter", _p = "h-select--select__text", Cp = "h-select--select__rootSearchable", wp = "h-select--select__rootDropdownOpen", vp = "h-select--select__rootIsSearching", Sp = "h-select--select__search", Ip = "h-select--select__rootSingle", Dp = "h-select--select__indicators", kp = "h-select--select__spinner", Tp = "h-select--select__clearIndicator", jp = "h-select--select__dropdownIndicator", Np = "h-select--select__dropdown", Pp = "h-select--select__dropdownFixed", Fp = "h-select--select__pagination", q = {
  root: dp,
  rootDisabled: hp,
  inputWrapper: up,
  control: pp,
  rootHasIcon: mp,
  selection: gp,
  selectionItem: fp,
  tag: bp,
  tagName: xp,
  tagLimiter: yp,
  text: _p,
  rootSearchable: Cp,
  rootDropdownOpen: wp,
  rootIsSearching: vp,
  search: Sp,
  rootSingle: Ip,
  indicators: Dp,
  spinner: kp,
  clearIndicator: Tp,
  dropdownIndicator: jp,
  dropdown: Np,
  dropdownFixed: Pp,
  pagination: Fp
};
class De extends D {
  controlRef;
  searchRef;
  listRef;
  static defaultProps = {
    id: lr("select"),
    selectedItems: [],
    disabledItems: [],
    itemComponent: jr,
    emptyComponent: cn,
    emptyMessage: "No options",
    placeholder: "",
    disabled: !1,
    loading: !1,
    multiple: !1,
    searchable: !1,
    clearable: !1,
    keepOpen: !1,
    hideSelectedItems: !1,
    hasDropDownIndicator: !0
  };
  constructor(t) {
    super(t), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSearch = this.handleSearch.bind(this), this.handleDropdown = this.handleDropdown.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this), this.handleSelect = this.handleSelect.bind(this), this.handleChange = this.handleChange.bind(this), this.handleRemove = this.handleRemove.bind(this), this.handleClear = this.handleClear.bind(this), this.handleDropdownClick = this.handleDropdownClick.bind(this), this.resolveItem = this.resolveItem.bind(this), this.resetSearch = this.resetSearch.bind(this), this.controlRef = B(), this.searchRef = B(), this.listRef = B();
    const e = this.initSelectedItems(), n = this.initHighlightedIndex(e);
    this.state = {
      dropdownOpen: !1,
      search: "",
      selectedItems: e,
      highlightedIndex: n
    }, !De.isSuggestionComponentWarningShown && this.props.suggestionComponent && !this.props.searchable && (console.warn(
      "SuggestionComponent can only be shown on searchable select components. You should either remove suggestionComponent prop or add searchable prop"
    ), De.isSuggestionComponentWarningShown = !0);
  }
  componentDidUpdate(t, e) {
    const { dropdownOpen: n } = this.state;
    if (n !== e.dropdownOpen)
      if (window[n ? "addEventListener" : "removeEventListener"](
        "click",
        this.handleClickOutside
      ), n) {
        this.searchRef.current?.focus();
        const o = this.initHighlightedIndex();
        this.highlightIndex(o, "auto");
      } else
        this.searchRef.current?.blur();
    cr(t.selectedItems, this.props.selectedItems) || this.setState({ selectedItems: this.initSelectedItems() });
  }
  componentWillUnmount() {
    const { dropdownOpen: t } = this.state;
    t && window.removeEventListener("click", this.handleClickOutside);
  }
  static isSuggestionComponentWarningShown = !1;
  get a11y() {
    const { id: t } = this.props, { highlightedIndex: e } = this.state, n = `${t}-label`, o = `${t}-dropdown`, r = e !== null ? `${o}-option-${e}` : "";
    return { label: n, dropdown: o, option: r };
  }
  isItemIdType(t) {
    return typeof t == "string" || typeof t == "number";
  }
  initSelectedItems() {
    const { selectedItems: t = [] } = this.props;
    return t.map(this.resolveItem).filter(Boolean);
  }
  initHighlightedIndex(t = this.state.selectedItems) {
    const { multiple: e, items: n, hideSelectedItems: o } = this.props;
    if (!e && !o && t.length) {
      const r = this.resolveItem(t[0]);
      return n.indexOf(r);
    }
    return null;
  }
  resolveItem(t) {
    return this.isItemIdType(t) ? this.props.items.find((n) => n.id === t) : t;
  }
  resetSearch() {
    this.state.search && (this.setState({ search: "" }), this.searchRef.current?.focus());
  }
  handleSearch(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    this.setState({ search: n }, () => {
      e?.(n), n && (this.highlightIndex(this.hasSuggestionComponent() ? -1 : 0), this.listRef.current?.goToTop());
    });
  }
  handleDropdown(t = "toggle") {
    const { dropdownOpen: e } = this.state, { keepOpen: n, onToggle: o } = this.props;
    if (n)
      return this.setState({ dropdownOpen: !0 });
    if (t === "toggle")
      return o?.(!e), this.controlRef.current?.focus(), this.setState({ dropdownOpen: !e });
    if (t === "open")
      return o?.(!0), this.setState({ dropdownOpen: !0 });
    if (t === "close" && e)
      return o?.(!1), this.controlRef.current?.blur(), this.setState({
        dropdownOpen: !1,
        search: ""
      });
  }
  handleClickOutside(t) {
    if (!this.controlRef || !(t.target instanceof Node)) return;
    const e = this.controlRef.current, { target: n } = t;
    n && n !== e && !e?.contains(n) && this.handleDropdown("close");
  }
  highlightIndex(t, e = "smooth") {
    this.setState({ highlightedIndex: t }, () => {
      if (t === null || t === -1) return;
      (this.listRef.current?.listRef.current?.children ?? [])[t]?.scrollIntoView({
        behavior: e,
        block: "nearest",
        inline: "start"
      });
    });
  }
  handleKeyDown(t) {
    const { search: e, dropdownOpen: n, highlightedIndex: o, selectedItems: r } = this.state, { multiple: i, hideSelectedItems: l } = this.props, c = this.getAvailableItems(), d = t.key === "Escape", h = t.key === "Enter", u = t.key === "ArrowUp", p = t.key === "ArrowDown", m = t.key === "Backspace";
    if ((h || u || p) && t.preventDefault(), p && !n)
      return t.preventDefault(), this.handleDropdown("open");
    if (d && (n && t.stopPropagation(), this.handleDropdown("close")), m && i && !e) {
      const g = r[r.length - 1];
      g && this.handleRemove(g);
    }
    if (this.hasSuggestionComponent()) {
      if (p && (o === null || o === c.length - 1 || o === 0 && c.length === 0))
        return this.highlightIndex(-1);
      if (u && o === 0)
        return this.highlightIndex(-1);
      if (h && o === -1) {
        this.props.onSuggest?.(e), this.resetSearch();
        return;
      }
    }
    if (p && o === null)
      return this.highlightIndex(0);
    if (o !== null) {
      if (p && o === c.length - 1)
        return this.highlightIndex(0);
      if (p)
        return this.highlightIndex(o + 1);
      if (u && o > 0)
        return this.highlightIndex(o - 1);
      if (u && o <= 0)
        return this.highlightIndex(c.length - 1);
      if (h) {
        const g = c[o], b = g && this.isItemDisabled(g);
        if (g && !b) {
          this.handleSelect(g);
          const x = Math.min(
            l ? o : o + 1,
            c.length - 2
          );
          this.highlightIndex(x);
        }
      }
    }
  }
  handleSelect(t) {
    const { multiple: e, keepOpen: n, onSelect: o } = this.props;
    if (e) {
      const r = this.isItemSelected(t);
      this.handleChange(t, !r);
    } else
      this.setState({
        selectedItems: [t],
        dropdownOpen: n ?? !1
      }), this.resetSearch(), o?.(t);
  }
  handleChange(t, e) {
    const { onChange: n } = this.props, { selectedItems: o } = this.state;
    this.setState({
      selectedItems: e ? [...o, t] : o.filter((r) => r.id !== t.id)
    }), this.resetSearch(), n?.(t, e);
  }
  handleRemove(t, e) {
    e && (e.preventDefault(), e.stopPropagation()), this.handleChange(t, !1);
  }
  handleClear(t) {
    t.stopPropagation();
    const { onClear: e } = this.props;
    e?.(), this.setState({ selectedItems: [] });
  }
  handleDropdownClick(t) {
    t.stopPropagation();
  }
  getPlaceholder() {
    return this.state.selectedItems.length ? "" : this.props.placeholder;
  }
  getInputSize() {
    return this.state.search ? this.state.search.length : this.state.selectedItems?.length ? 5 : this.props.placeholder?.length || 5;
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  getAvailableItems() {
    const { search: t } = this.state, { items: e, hideSelectedItems: n, onSearch: o, searchBy: r } = this.props, i = new RegExp($s(t), "i");
    return e.filter((c) => {
      const d = [];
      return t && !o && (r && typeof r == "function" ? d.push(r(c, t)) : r && r instanceof Array ? d.push(
        r.some((h) => {
          const u = c[h];
          return (typeof u == "string" || typeof u == "number") && i.test(u.toString().trim());
        })
      ) : d.push(i.test(this.getItemName(c)))), n && d.push(!this.isItemSelected(c)), d.every((h) => h);
    });
  }
  isItemSelected(t) {
    return this.state.selectedItems.some(
      (e) => e.id === t.id
    );
  }
  isItemDisabled(t) {
    return this.props.disabledItems?.includes(t.id);
  }
  isEmpty() {
    return this.state.selectedItems.length === 0;
  }
  hasSuggestionComponent(t) {
    return !!this.state.search && typeof this.props.suggestionComponent == "function";
  }
  renderHiddenItems() {
    const { limit: t } = this.props, { selectedItems: e } = this.state;
    if (t && t > 0)
      return /* @__PURE__ */ s.jsx(O, { flexDirection: "column", children: e?.slice(t).map((n) => /* @__PURE__ */ s.jsxs(
        O,
        {
          alignItems: "center",
          justifyContent: "space-between",
          "data-testid": "select-hidden-item",
          children: [
            /* @__PURE__ */ s.jsx(rt, { margin: "0 400 0 0", children: this.getItemName(n) }),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "close",
                variant: "tertiary",
                onClick: (o) => this.handleRemove(n, o)
              }
            )
          ]
        },
        n.id
      )) });
  }
  renderSelection(t) {
    return this.props.renderSelection?.(t) ?? this.getItemName(t);
  }
  renderMultipleSelection() {
    const { selectedItems: t } = this.state, e = this.props.limit || t.length, n = e < t.length, o = t?.slice(0, e).map((r) => {
      const i = this.renderSelection(r);
      return /* @__PURE__ */ s.jsx(
        "div",
        {
          onClick: (l) => l.stopPropagation(),
          "data-testid": "select-selection",
          className: q.selectionItem,
          children: /* @__PURE__ */ s.jsx(
            Ie,
            {
              className: q.tag,
              tagNameClassName: q.tagName,
              onDelete: (l) => this.handleRemove(r, l),
              color: r.color,
              noTruncation: !0,
              "data-testid": "select-tag",
              children: i
            }
          )
        },
        r.id
      );
    });
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      n && /* @__PURE__ */ s.jsx("div", { onClick: (r) => r.stopPropagation(), children: /* @__PURE__ */ s.jsx(
        gt,
        {
          content: this.renderHiddenItems(),
          requireClick: !0,
          "data-testid": "select-limiter",
          light: !0,
          children: /* @__PURE__ */ s.jsxs(
            Ie,
            {
              className: f(q.tag, q.tagLimiter),
              noTruncation: !0,
              children: [
                "+",
                t.length - e
              ]
            }
          )
        }
      ) })
    ] });
  }
  renderSingleSelection() {
    const { search: t, selectedItems: e } = this.state, n = e[0], o = /* @__PURE__ */ s.jsx("span", { style: { width: 0 }, "data-testid": "select-selection-empty", children: " " });
    return n ? /* @__PURE__ */ s.jsx(
      "span",
      {
        className: q.text,
        "aria-hidden": !!t,
        "data-testid": "select-selection",
        children: this.renderSelection(n)
      }
    ) : o;
  }
  renderSearch() {
    const { searchable: t } = this.props;
    return !t && !this.isEmpty() ? null : /* @__PURE__ */ s.jsx(
      "input",
      {
        className: q.search,
        ref: this.searchRef,
        tabIndex: -1,
        onFocus: (e) => e.stopPropagation(),
        value: this.state.search,
        size: this.getInputSize(),
        onChange: this.handleSearch,
        placeholder: this.getPlaceholder(),
        autoComplete: "off",
        readOnly: !t,
        "aria-autocomplete": "list",
        "aria-controls": this.a11y.dropdown,
        "aria-labelledby": this.a11y.label,
        "data-testid": "select-input"
      }
    );
  }
  renderDropdown() {
    const { dropdownOpen: t, highlightedIndex: e, search: n } = this.state, {
      disabledItems: o,
      tooltipItems: r,
      emptyComponent: i,
      suggestionComponent: l,
      emptyMessage: c,
      pagination: d,
      dropdownProps: h,
      searchSuggestion: u,
      renderSuggestion: p,
      onSuggest: m,
      multiple: g
    } = this.props, b = f(
      {
        [q.dropdown]: !0,
        [q.dropdownFixed]: h?.fixed ?? !1
      },
      h?.className
    ), x = this.getAvailableItems(), w = x[e ?? -1] ?? null, y = !x.length;
    return /* @__PURE__ */ s.jsxs(
      Xt,
      {
        onClick: this.handleDropdownClick,
        ...h,
        className: b,
        isOpen: t,
        "data-testid": "select-dropdown",
        children: [
          y && typeof i == "function" && /* @__PURE__ */ s.jsx(
            i,
            {
              label: c ?? "No options",
              "data-testid": "select-dropdown-empty"
            }
          ),
          this.hasSuggestionComponent(l) && /* @__PURE__ */ s.jsx(
            l,
            {
              searched: n,
              onSuggest: m,
              triggerClose: g ? void 0 : () => this.handleDropdown("close"),
              items: x,
              active: e === -1,
              clearSearch: this.resetSearch,
              searchSuggestion: u,
              renderSuggestion: p
            }
          ),
          !y && /* @__PURE__ */ s.jsx(
            Vs,
            {
              id: this.a11y.dropdown,
              ariaLabelledby: this.a11y.label,
              ref: this.listRef,
              pagination: d,
              items: x,
              clearSearch: this.resetSearch,
              onSelect: this.handleSelect,
              onChange: this.handleChange,
              onKeyDown: this.handleKeyDown,
              selectedItems: this.state.selectedItems,
              disabledItems: o,
              tooltipItems: r,
              activeItem: w,
              itemComponent: this.props.itemComponent
            }
          ),
          !!d && !d.infinite && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: q.pagination,
              "data-testid": "select-dropdown-pagination",
              children: [
                /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: "secondary",
                    disabled: !d.previousEnable,
                    onClick: d.onPrevious,
                    children: "Prev page"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: "secondary",
                    disabled: !d.nextEnable,
                    onClick: d.onNext,
                    children: "Next page"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
  render() {
    const {
      className: t,
      disabled: e,
      hasDropDownIndicator: n,
      loading: o,
      multiple: r,
      searchable: i,
      clearable: l,
      prefix: c,
      suffix: d,
      icon: h,
      status: u
    } = this.props, { search: p, dropdownOpen: m } = this.state, g = f(
      {
        [q.root]: !0,
        [q.rootSingle]: !r,
        [q.rootDisabled]: e,
        [q.rootSearchable]: i,
        [q.rootDropdownOpen]: m,
        [q.rootIsSearching]: !!p,
        [q.rootHasIcon]: !!h
      },
      t
    ), b = p ? void 0 : () => this.handleDropdown("toggle");
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: g,
        role: "combobox",
        "aria-expanded": m,
        "aria-owns": this.a11y.dropdown,
        "aria-haspopup": "listbox",
        "data-testid": "select-root",
        children: [
          /* @__PURE__ */ s.jsx(
            Rt,
            {
              prefix: c,
              suffix: d,
              icon: h,
              status: u,
              active: m,
              disabled: e,
              className: q.inputWrapper,
              children: /* @__PURE__ */ s.jsxs(
                "div",
                {
                  className: q.control,
                  ref: this.controlRef,
                  onKeyDown: this.handleKeyDown,
                  onClick: b,
                  tabIndex: e ? -1 : 0,
                  "aria-activedescendant": this.a11y.option,
                  "data-testid": "select-control",
                  children: [
                    /* @__PURE__ */ s.jsxs("div", { className: q.selection, children: [
                      r ? this.renderMultipleSelection() : this.renderSingleSelection(),
                      this.renderSearch()
                    ] }),
                    /* @__PURE__ */ s.jsxs("div", { className: q.indicators, children: [
                      o && /* @__PURE__ */ s.jsx(
                        zn,
                        {
                          className: q.spinner,
                          size: 16,
                          "aria-label": "Loading",
                          "data-testid": "select-loading"
                        }
                      ),
                      !this.isEmpty() && l && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.clearIndicator,
                          icon: "close",
                          variant: "tertiary",
                          onClick: this.handleClear,
                          "aria-label": "Clear",
                          "data-testid": "select-clear"
                        }
                      ),
                      n && /* @__PURE__ */ s.jsx(
                        K,
                        {
                          tabIndex: -1,
                          className: q.dropdownIndicator,
                          icon: m ? "angle-up" : "angle-down",
                          variant: "tertiary",
                          onClick: (x) => {
                            x.stopPropagation(), this.handleDropdown("toggle");
                          },
                          "aria-label": m ? "Close" : "Open",
                          "data-testid": "select-toggle"
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          !e && m && this.renderDropdown()
        ]
      }
    );
  }
}
function Rp(a) {
  return /* @__PURE__ */ s.jsx(
    Bs,
    {
      fallback: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: "Something went wrong" }) }),
      children: /* @__PURE__ */ s.jsx(De, { ...a })
    }
  );
}
const Ep = "h-datePicker-timezoneSelector--timezoneSelector__root", Lp = "h-datePicker-timezoneSelector--timezoneSelector__label", Io = {
  root: Ep,
  label: Lp
}, Nr = ({
  disabled: a,
  tooltipProps: t,
  selectedTimezone: e,
  onChange: n
}) => {
  const o = j.tz.guess(!0), r = P((h, u) => {
    const [p, m] = j.tz(h).format("Z").split(":"), [g, b] = j.tz(u).format("Z").split(":");
    return +parseInt(p) * 60 + parseInt(m) - (+parseInt(g) * 60 + parseInt(b));
  }, []), i = (h) => `(GMT${j.tz(h).format("Z")})`, l = (h) => `${i(h)} ${h}`, c = U(() => {
    const h = j.tz.names().filter((m) => m !== o), u = {
      id: o,
      name: `Default ${i(o)}`
    }, p = h.sort(r).map((m) => ({ id: m, name: l(m) }));
    return [u, ...p];
  }, [r]), d = ({ id: h }) => {
    n(h);
  };
  return /* @__PURE__ */ s.jsxs("div", { className: Io.root, children: [
    /* @__PURE__ */ s.jsx(zs, { className: Io.label, children: "Time zone" }),
    /* @__PURE__ */ s.jsx(gt, { ...t, side: "top", children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
      Rp,
      {
        disabled: a,
        items: c,
        onSelect: d,
        selectedItems: [
          Se(e) ? e : o
        ],
        searchable: !0
      }
    ) }) })
  ] });
}, Ap = "h-fieldAlert--fieldAlert__root", $p = "h-fieldAlert--fieldAlert__alert", Bp = "h-fieldAlert--fieldAlert__icon", hs = {
  root: Ap,
  alert: $p,
  icon: Bp
}, Op = "h-fieldAlert-fieldAlertButton--fieldAlertButton__root", Hp = {
  root: Op
};
function Wp({
  className: a,
  variant: t = "tertiary",
  ...e
}) {
  return /* @__PURE__ */ s.jsx(
    Q,
    {
      ...e,
      variant: t,
      className: f(a, Hp.root)
    }
  );
}
const Mp = {
  error: "exclamation-circle-filled",
  warning: "exclamation-triangle-filled",
  success: "check-circle-filled",
  title: null
};
function Yn({
  children: a,
  className: t,
  ...e
}) {
  const n = e.variant || "title", o = f(hs.root, t), [r, i] = V(!1), l = Mp[n], c = P(
    (d) => {
      if (!d) return;
      const { offsetWidth: h, scrollWidth: u } = d;
      i(h < u);
    },
    [a]
  );
  return /* @__PURE__ */ s.jsxs(L.Input, { ...e, variant: n, className: o, children: [
    !!l && /* @__PURE__ */ s.jsx(N, { className: hs.icon, name: l }),
    /* @__PURE__ */ s.jsx("div", { className: hs.alert, ref: c, children: r ? /* @__PURE__ */ s.jsx(gt, { content: a, children: a }) : a })
  ] });
}
Yn.Button = Wp;
const bn = (a, t = 0) => {
  if (!a)
    return t;
  if (typeof a == "number")
    return a;
  const e = parseFloat(a);
  return isNaN(e) ? t : e;
}, zp = "h-inputText-inputNumberArrows--inputNumberArrows__root", Vp = "h-inputText-inputNumberArrows--inputNumberArrows__button", Kp = "h-inputText-inputNumberArrows--inputNumberArrows__buttonUp", Up = "h-inputText-inputNumberArrows--inputNumberArrows__buttonDown", qp = "h-inputText-inputNumberArrows--inputNumberArrows__spacer", pe = {
  root: zp,
  button: Vp,
  buttonUp: Kp,
  buttonDown: Up,
  spacer: qp
}, Gp = 50, Do = 300, Yp = "inputNumberArrowsTestId";
class Qp extends D {
  intervalId;
  timeoutId;
  constructor(t) {
    super(t), this.intervalId = null, this.timeoutId = null, this.increaseValue = this.increaseValue.bind(this), this.decreaseValue = this.decreaseValue.bind(this), this.startIncreaseValue = this.startIncreaseValue.bind(this), this.startDecreaseValue = this.startDecreaseValue.bind(this), this.stopChangeValue = this.stopChangeValue.bind(this);
  }
  componentDidMount() {
    window.addEventListener("mouseup", this.stopChangeValue);
  }
  componentWillUnmount() {
    window.removeEventListener("mouseup", this.stopChangeValue);
  }
  getNewValue(t) {
    const {
      step: e,
      min: n,
      max: o,
      inputRef: { current: r }
    } = this.props;
    if (!r)
      return 0;
    const i = bn(r.value), l = bn(e, 1), c = bn(n, Number.MIN_SAFE_INTEGER), d = bn(o, Number.MAX_SAFE_INTEGER);
    return t == "decrease" ? Math.max(i - l, c) : Math.min(i + l, d);
  }
  startIncreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("increase"),
      Do
    );
  }
  startDecreaseValue() {
    this.timeoutId = setTimeout(
      () => this.startChangeValue("decrease"),
      Do
    );
  }
  startChangeValue(t) {
    this.intervalId || (this.intervalId = setInterval(
      () => this.triggerInputChange(t),
      Gp
    ));
  }
  stopChangeValue() {
    this.timeoutId && (clearTimeout(this.timeoutId), this.timeoutId = null), this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
  }
  increaseValue(t) {
    t.preventDefault(), this.triggerInputChange("increase");
  }
  decreaseValue(t) {
    t.preventDefault(), this.triggerInputChange("decrease");
  }
  triggerInputChange(t) {
    const {
      inputRef: { current: e },
      readOnly: n
    } = this.props;
    if (!e || n)
      return;
    const o = this.getNewValue(t), r = new Event("input", { bubbles: !0 }), i = Object.getPrototypeOf(e);
    Object.getOwnPropertyDescriptor(
      i,
      "value"
    )?.set?.call(e, o), e.dispatchEvent(r), e.focus();
  }
  render() {
    return /* @__PURE__ */ s.jsxs("div", { className: pe.root, "data-testid": Yp, children: [
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(pe.button, pe.buttonUp),
          tabIndex: -1,
          onClick: this.increaseValue,
          onMouseDown: this.startIncreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-up" })
        }
      ),
      /* @__PURE__ */ s.jsx("span", { className: pe.spacer }),
      /* @__PURE__ */ s.jsx(
        "button",
        {
          className: f(pe.button, pe.buttonDown),
          tabIndex: -1,
          onClick: this.decreaseValue,
          onMouseDown: this.startDecreaseValue,
          children: /* @__PURE__ */ s.jsx(N, { name: "angle-down" })
        }
      )
    ] });
  }
}
const Xp = "h-inputText--inputText__rootReadOnly", Zp = "h-inputText--inputText__container", Jp = "h-inputText--inputText__rootHasIcon", tm = "h-inputText--inputText__rootTypeNumber", em = "h-inputText--inputText__input", We = {
  rootReadOnly: Xp,
  container: Zp,
  rootHasIcon: Jp,
  rootTypeNumber: tm,
  input: em
}, nm = "inputText", Ut = $(function(t, e) {
  const n = Y(null);
  ke(e, () => n.current);
  const {
    className: o,
    disabled: r,
    readOnly: i,
    type: l = "text",
    name: c,
    prefix: d,
    suffix: h,
    icon: u,
    status: p,
    min: m,
    max: g,
    step: b,
    hideNumberArrows: x = !1,
    active: w = !1,
    ...y
  } = t, v = f(o, {
    [We.rootTypeNumber]: l === "number",
    [We.rootHasIcon]: !!u,
    [We.rootReadOnly]: i
  });
  return /* @__PURE__ */ s.jsx(
    Rt,
    {
      className: v,
      status: p,
      disabled: r,
      active: w,
      prefix: d,
      suffix: h,
      icon: u,
      children: /* @__PURE__ */ s.jsxs("div", { className: We.container, children: [
        /* @__PURE__ */ s.jsx(
          "input",
          {
            "data-testid": nm,
            dir: "auto",
            id: c,
            name: c,
            ref: n,
            ...y,
            min: m,
            max: g,
            step: b,
            type: l,
            disabled: r,
            readOnly: i,
            className: We.input
          }
        ),
        l === "number" && !x && /* @__PURE__ */ s.jsx(
          Qp,
          {
            min: m,
            max: g,
            step: b,
            inputRef: n,
            readOnly: i
          }
        )
      ] })
    }
  );
}), sm = "hmm A", om = (a, t) => {
  const e = `${a}`.padStart(2, "0"), n = `${t}`.padStart(2, "0");
  return `${e}:${n}`;
}, ko = (a, t) => {
  const e = a.hours(), n = a.minutes();
  return {
    id: om(e, n),
    name: a.format(t)
  };
}, en = ({
  hasDropDownIndicator: a = !0,
  allowCustomTimeInput: t = !1,
  timeOptions: e,
  overrides: n,
  selectedItems: o,
  selectableHours: r = yr,
  selectableMinutes: i = _r,
  timeFormat: l = j.localeData().longDateFormat("LT"),
  onSelect: c,
  onIsCustomTimeValid: d,
  ...h
}) => {
  const [u] = o || [], [p, m] = V(
    () => typeof u == "object" ? u?.id : u || null
  ), [g, b] = V(""), x = U(
    () => e || Ir({
      hours: r,
      minutes: i,
      overrides: n,
      timeFormat: l
    }),
    [
      e,
      r,
      i,
      n,
      l
    ]
  ), w = U(() => {
    const _ = j(
      g || (typeof u == "object" ? u.id : u) || p,
      [l, sm]
    );
    if (!_.isValid())
      return null;
    const S = _.hours(), I = _.minutes();
    if (!d || d(S, I))
      return ko(_, l);
    const T = S <= 12, R = S + 12, A = d(R, I);
    return T && A ? ko(j({ hours: R, minutes: I }), l) : null;
  }, [u, g]), y = U(() => {
    if (!t)
      return x;
    const _ = p ? x.filter(({ name: S }) => S !== w?.name) : x.filter(
      ({ name: S }) => S.startsWith(g) && S !== w?.name
    );
    if (!w)
      return _;
    const C = p !== w.id ? 0 : _.findIndex(
      (S) => j(S.id, [l]) > j(w.id, [l])
    );
    return _.splice(
      // If it's -1 then there was no later time, so add it to the end.
      C === -1 ? _.length : C,
      0,
      w
    ), _;
  }, [w, g, p, x]), v = P(
    (_) => {
      _?.id !== w?.id && b(""), c(_?.id || null), m(_?.id || null);
    },
    [w]
  );
  return tt(() => {
    u ? (b(""), m(
      typeof u == "object" ? u.id : u
    )) : m(null);
  }, [u]), /* @__PURE__ */ s.jsx(
    De,
    {
      searchable: !0,
      placeholder: Cr(l),
      ...h,
      selectedItems: o,
      hasDropDownIndicator: a,
      items: t ? y : x,
      onChange: E,
      onClear: v,
      onSelect: v,
      ...t && { onSearch: b }
    }
  );
}, rm = "h-timePicker-range--timeRangePicker__root", am = "h-timePicker-range--timeRangePicker__timePickerFrom", im = "h-timePicker-range--timeRangePicker__timePickerTo", lm = "h-timePicker-range--timeRangePicker__arrowContainer", cm = "h-timePicker-range--timeRangePicker__arrowContainerHasError", dm = "h-timePicker-range--timeRangePicker__arrowContainerHasWarning", hm = "h-timePicker-range--timeRangePicker__arrowContainerHasSuccess", te = {
  root: rm,
  timePickerFrom: am,
  timePickerTo: im,
  arrowContainer: lm,
  arrowContainerHasError: cm,
  arrowContainerHasWarning: dm,
  arrowContainerHasSuccess: hm
}, um = ({
  className: a,
  disabled: t,
  endTime: e,
  onSelect: n,
  overrides: o,
  placeholder: r,
  selectableHours: i = yr,
  selectableMinutes: l = _r,
  status: c,
  startTime: d,
  allowCustomTimeInput: h = !1,
  timeFormat: u = j.localeData().longDateFormat("LT"),
  ...p
}) => {
  const [{ startTime: m, endTime: g }, b] = V({
    startTime: d || null,
    endTime: e || null
  }), x = U(
    () => Ir({
      hours: i,
      minutes: l,
      overrides: o,
      timeFormat: u
    }),
    [i, l, o, u]
  ), w = U(() => {
    const C = x.map(
      ({ id: T }) => j(T, [u])
    ), S = j(m, [u]), I = m && C.findIndex(
      (T) => T > S
    ) || 0;
    return x.slice(I);
  }, [x, m, u]);
  tt(() => {
    const C = typeof d == "string", S = typeof d == "string";
    (C && d !== m || S && e !== g) && b((I) => ({
      ...I,
      ...C && { startTime: d },
      ...S && { endTime: e }
    }));
  });
  const y = P(
    (C) => (S) => void b((I) => {
      const T = j(S, [u]), R = j(I.startTime, [u]), A = j(I.endTime, [u]), k = x.map(
        ({ id: nt }) => j(nt, [u])
      ), F = k.findIndex(
        (nt) => nt >= T
      ) || -1, H = C === "startTime" ? F : k.findIndex(
        (nt) => nt >= R
      ), et = C === "endTime" ? -1 : k.findIndex(
        (nt) => nt >= A
      ), at = {
        ...I,
        [C]: S,
        ...I.endTime !== null && C !== "endTime" && H >= et && {
          endTime: x[F + 1]?.id || null
        }
      };
      return n(at), at;
    }),
    [n]
  ), v = P(
    (C, S) => {
      const I = j(m, [u]);
      if (!I.isValid())
        return !0;
      const R = I.hours(), A = I.minutes();
      return R < C || R === C && A < S;
    },
    [m, u]
  ), _ = (C) => r?.[C] || r || Cr(u);
  return /* @__PURE__ */ s.jsxs(rt, { className: f(te.root, a), children: [
    /* @__PURE__ */ s.jsx(
      en,
      {
        className: te.timePickerFrom,
        searchable: !0,
        ...p,
        disabled: t,
        hasDropDownIndicator: !1,
        timeOptions: x,
        onSelect: y("startTime"),
        placeholder: _("startTime"),
        allowCustomTimeInput: h,
        selectedItems: m ? [m] : [],
        status: c
      }
    ),
    /* @__PURE__ */ s.jsx(
      rt,
      {
        className: f(te.arrowContainer, {
          [te.arrowContainerHasError]: c === "error",
          [te.arrowContainerHasWarning]: c === "warning",
          [te.arrowContainerHasSuccess]: c === "success"
        }),
        children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" })
      }
    ),
    /* @__PURE__ */ s.jsx(
      en,
      {
        className: te.timePickerTo,
        searchable: !0,
        disabled: t || !m,
        ...p,
        hasDropDownIndicator: !1,
        timeOptions: w,
        onSelect: y("endTime"),
        placeholder: _("endTime"),
        ...h && {
          allowCustomTimeInput: h,
          onIsCustomTimeValid: v
        },
        selectedItems: g ? [g] : [],
        status: c
      }
    )
  ] });
};
class Kt {
  constructor(t, e, n) {
    this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n, this.dateFormat = t, this.dateParser = e, this.dateRangeConstraint = n;
  }
  static validationOK = { isValid: !0, error: null };
  isValidDate(t) {
    try {
      return this.dateParser(t).isValid();
    } catch {
      return !1;
    }
  }
  isSingleDateValid(t) {
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "Date is not valid"
      };
    const { minDate: e, maxDate: n } = this.dateRangeConstraint, o = this.dateParser(t);
    return o.isBefore(e, "day") ? {
      isValid: !1,
      error: `Date must be after ${e.format(this.dateFormat)}`
    } : o.isAfter(n, "day") ? {
      isValid: !1,
      error: `Date must be before ${n.format(this.dateFormat)}`
    } : Kt.validationOK;
  }
  /**
   * Mind that this is dependant on end date as well because it's a range
   */
  isStartDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(t))
      return {
        isValid: !1,
        error: "From date is not valid"
      };
    const r = this.dateParser(t), i = this.dateParser(e);
    return r.isBefore(n, "day") ? {
      isValid: !1,
      error: `From date must be after ${n.format(this.dateFormat)}`
    } : e && this.isValidDate(e) && r.isAfter(i, "day") ? {
      isValid: !1,
      error: `From date must be before ${i.format(
        this.dateFormat
      )}`
    } : r.isAfter(o, "day") ? {
      isValid: !1,
      error: `From date must be before ${o.format(this.dateFormat)}`
    } : Kt.validationOK;
  }
  /**
   * Mind that this is dependant on start date as well because it's a range
   */
  isEndDateValid({
    startDateInputValue: t,
    endDateInputValue: e
  }) {
    const { minDate: n, maxDate: o } = this.dateRangeConstraint;
    if (!this.isValidDate(e))
      return {
        isValid: !1,
        error: "To date is not valid"
      };
    const r = this.dateParser(t), i = this.dateParser(e);
    return i.isAfter(o, "day") ? {
      isValid: !1,
      error: `To date must be before ${o.format(this.dateFormat)}`
    } : t && this.isValidDate(t) && i.isBefore(r, "day") ? {
      isValid: !1,
      error: `To date must be after ${r.format(
        this.dateFormat
      )}`
    } : i.isBefore(n, "day") ? {
      isValid: !1,
      error: `To date must be after ${n.format(this.dateFormat)}`
    } : Kt.validationOK;
  }
  isTimeOrderValid({
    startDate: t,
    endDate: e
  }) {
    return !t || !e ? Kt.validationOK : t.isAfter(e) ? {
      isValid: !1,
      error: "From time should be before to time"
    } : Kt.validationOK;
  }
}
const pm = "h-datePicker-range-inputFields--dateRangePickerInputFields__root", mm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTop", gm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementTopWithTimezoneSelector", fm = "h-datePicker-range-inputFields--dateRangePickerInputFields__rootPlacementBottom", bm = "h-datePicker-range-inputFields--dateRangePickerInputFields__fields", xm = "h-datePicker-range-inputFields--dateRangePickerInputFields__input", ym = "h-datePicker-range-inputFields--dateRangePickerInputFields__alert", Mt = {
  root: pm,
  rootPlacementTop: mm,
  rootPlacementTopWithTimezoneSelector: gm,
  rootPlacementBottom: fm,
  fields: bm,
  input: xm,
  alert: ym
};
Array(24).fill(0).map((a, t) => t);
class Us extends D {
  dateRangeValidators;
  timeOptions;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      startDateInputValue: this.props.startDate?.format(e) ?? "",
      startDateError: null,
      endDateInputValue: this.props.endDate?.format(e) ?? "",
      endDateError: null,
      timeOrderError: null
    }, this.timeOptions = [], this.instanceId = Us.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateStartDateChangeEvent = this.propagateStartDateChangeEvent.bind(this), this.propagateEndDateChangeEvent = this.propagateEndDateChangeEvent.bind(this), this.dateRangeValidators = new Kt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncStartDateWithProps(t), this.syncEndDateWithProps(t), this.validateTimesOrder();
  }
  static instanceCount = 0;
  validateTimesOrder() {
    const { startDate: t, endDate: e } = this.props, { isValid: n, error: o } = this.dateRangeValidators.isTimeOrderValid({
      startDate: t,
      endDate: e
    });
    n ? this.setState({ timeOrderError: null }) : this.setState({
      timeOrderError: o
    });
  }
  syncEndDateWithProps(t) {
    const { endDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.endDate || e?.isSame(t.endDate, n)))
      return this.props.endDate ? this.setState({
        endDateError: null,
        endDateInputValue: this.props.endDate.format(this.props.dateFormat)
      }) : this.setState({
        endDateError: null,
        endDateInputValue: ""
      });
  }
  syncStartDateWithProps(t) {
    const { startDate: e, timeRoundingStrategy: n } = this.props;
    if (!(e === t.startDate || e?.isSame(t.startDate, n)))
      return this.props.startDate ? this.setState({
        startDateError: null,
        startDateInputValue: this.props.startDate.format(this.props.dateFormat)
      }) : this.setState({
        startDateError: null,
        startDateInputValue: ""
      });
  }
  handleInputValueChange(t, e) {
    const n = t.target.value;
    switch (e) {
      case "startDate":
        this.setState(
          { startDateInputValue: this.ensureValidChars(n) },
          this.propagateStartDateChangeEvent
        );
        break;
      case "endDate":
        this.setState(
          { endDateInputValue: this.ensureValidChars(n) },
          this.propagateEndDateChangeEvent
        );
        break;
    }
  }
  propagateStartDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (t === "") {
      this.props.onStartDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ startDateError: o });
      return;
    }
    const { isValid: r, error: i } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = e !== "" && !r ? i : null;
    this.setState(
      {
        startDateError: null,
        endDateError: l
      },
      () => this.props.onStartDateChange(this.parseDateString(t))
    );
  }
  propagateEndDateChangeEvent() {
    const { startDateInputValue: t, endDateInputValue: e } = this.state;
    if (e === "") {
      this.props.onEndDateChange(null);
      return;
    }
    const { isValid: n, error: o } = this.dateRangeValidators.isEndDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    });
    if (!n) {
      this.setState({ endDateError: o });
      return;
    }
    const { isValid: r, error: i } = this.dateRangeValidators.isStartDateValid({
      startDateInputValue: t,
      endDateInputValue: e
    }), l = t !== "" && !r ? i : null;
    this.setState(
      {
        endDateError: null,
        startDateError: l
      },
      () => this.props.onEndDateChange(this.parseDateString(e))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  getOverrides(t) {
    if (t !== "startTime")
      return [
        {
          hour: 23,
          minute: 59
        }
      ];
  }
  renderFields(t, e, n, o, r, i, l) {
    const {
      dateFormat: c,
      disabled: d,
      focusedInput: h,
      onFocusChange: u,
      onTimeChange: p,
      timeFormat: m,
      withTimePicker: g,
      withDateInput: b
    } = this.props, { timeOrderError: x } = this.state;
    return /* @__PURE__ */ s.jsxs("div", { children: [
      /* @__PURE__ */ s.jsx(zs, { children: t === "startDate" ? "From" : "To" }),
      b && /* @__PURE__ */ s.jsx(
        Ut,
        {
          className: Mt.input,
          placeholder: c.toLowerCase(),
          name: `input__${t}__${this.instanceId}`,
          value: r,
          onChange: (w) => this.handleInputValueChange(w, t),
          onFocus: () => u(t),
          autoComplete: "off",
          status: i ? "error" : void 0,
          disabled: d,
          active: h === t
        }
      ),
      g && /* @__PURE__ */ s.jsx("div", { className: Mt.input, children: /* @__PURE__ */ s.jsx(
        gt,
        {
          content: "Please select a date first.",
          disabled: !!n || d,
          side: "right",
          children: /* @__PURE__ */ s.jsx("div", { children: /* @__PURE__ */ s.jsx(
            en,
            {
              disabled: !n,
              overrides: this.getOverrides(e),
              selectedItems: o ? [o] : void 0,
              status: x ? "error" : void 0,
              ...l,
              timeFormat: m,
              onSelect: (w) => p(e, w)
            }
          ) })
        }
      ) })
    ] });
  }
  getError() {
    const { startDateError: t, endDateError: e, timeOrderError: n } = this.state;
    return t || e || n || null;
  }
  renderErrors() {
    const t = this.getError();
    return /* @__PURE__ */ s.jsx(
      Yn,
      {
        className: Mt.alert,
        variant: t ? "error" : void 0,
        children: t
      }
    );
  }
  render() {
    const {
      startDate: t,
      startTime: e,
      endDate: n,
      endTime: o,
      timePickerProps: r = { start: {}, end: {} },
      hasTimezoneSelector: i
    } = this.props, {
      startDateInputValue: l,
      startDateError: c,
      endDateInputValue: d,
      endDateError: h
    } = this.state, { placement: u } = this.props, p = f(Mt.root, {
      [Mt.rootPlacementTop]: u === "top",
      [Mt.rootPlacementTopWithTimezoneSelector]: u === "top" && i,
      [Mt.rootPlacementBottom]: u === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: p, children: [
      /* @__PURE__ */ s.jsxs("div", { className: Mt.fields, children: [
        this.renderFields(
          "startDate",
          "startTime",
          t,
          e,
          l,
          c,
          r.start
        ),
        this.renderFields(
          "endDate",
          "endTime",
          n,
          o,
          d,
          h,
          r.end
        )
      ] }),
      this.renderErrors()
    ] });
  }
}
const _m = "dateRangePickerTestId";
class Cm extends D {
  static defaultProps = {
    withDateInput: !0,
    withTimePicker: !1,
    timePickerProps: { start: {}, end: {} },
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const {
      startDate: e,
      endDate: n,
      timezone: o,
      presetKey: r,
      presets: i,
      focusedInput: l = "startDate"
    } = t;
    this.state = {
      startTime: e ? j(e).format(jt) : null,
      endTime: n ? j(n).format(jt) : null,
      timezone: Se(o) ? o : j.tz.guess(!0),
      presetKey: i?.find(({ key: c }) => c === r)?.key ?? null,
      focusedInput: l,
      dateRangePickerKey: 0
    }, this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onDatesChange = this.onDatesChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.handleFocusChange = this.handleFocusChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onStartDateChange = this.onStartDateChange.bind(this), this.onEndDateChange = this.onEndDateChange.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey(t), this.updateTimezoneFromProps(t), this.updatePresetKey(t);
  }
  visibleCalendarMonthRef = B();
  updatePresetKey(t) {
    const { presetKey: e } = this.props;
    t.presetKey !== e && this.setState({
      presetKey: this.props.presets?.find(({ key: n }) => n === e)?.key ?? null
    });
  }
  updateTimezoneFromProps(t) {
    const { timezone: e } = this.props;
    t.timezone !== e && Se(e) && this.setState({ timezone: e });
  }
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props, n = this.dateFormat;
    return {
      minDate: e ? j(e, n) : j("0001-01-01"),
      maxDate: t ? j(t, n) : j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { startDate: e, endDate: n } = this.props, { presetKey: o } = this.state;
    this.setState(
      { timezone: t },
      () => this.onDatesChange({ startDate: e, endDate: n }, o)
    );
  }
  onStartDateChange(t) {
    this.onDatesChange({ startDate: t, endDate: this.props.endDate });
  }
  onEndDateChange(t) {
    this.onDatesChange({ endDate: t, startDate: this.props.startDate });
  }
  onDatesChange(t, e = null) {
    const { startTime: n, endTime: o, timezone: r } = this.state, { timeRoundingStrategy: i } = this.props, l = this.addTimezoneToDate(
      t.startDate,
      r
    ), c = this.addTimezoneToDate(
      t.endDate,
      r
    );
    let d = l?.clone().startOf(i) || null, h = c?.clone().endOf(i) || null, u = t.startDate?.clone().startOf(i) || null, p = t.endDate?.clone().endOf(i) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          startTime: t.startDate?.clone().startOf(i).format(jt) ?? null,
          endTime: t.endDate?.clone().startOf(i).format(jt) ?? null
        },
        () => {
          this.props.onChange({
            startDate: d,
            localStartDate: u,
            endDate: h,
            localEndDate: p,
            timezone: r,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (d = this.addTimeToDate(
      l,
      n,
      "startDate"
    ), u = this.addTimeToDate(
      t.startDate,
      n,
      "startDate"
    )), o && (h = this.addTimeToDate(c, o, "endDate"), p = this.addTimeToDate(t.endDate, o, "endDate")), this.props.onChange({
      startDate: d,
      localStartDate: u,
      endDate: h,
      localEndDate: p,
      timezone: r,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    if (!t)
      this.onDatesChange({ startDate: null, endDate: null });
    else {
      const { startDate: e, endDate: n, key: o } = t;
      this.onDatesChange({ startDate: e, endDate: n }, o);
    }
    this.handleFocusChange("startDate");
  }
  handleTimeChange(t, e) {
    const { startDate: n, endDate: o } = this.props;
    this.setState(
      (r) => ({
        ...r,
        [t]: e
      }),
      () => this.onDatesChange({ startDate: n, endDate: o })
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Se(e) ? t.clone().tz(e, !0) : t.clone().startOf(n);
  }
  handleFocusChange(t) {
    this.setState({ focusedInput: t ?? "startDate" });
  }
  addTimeToDate(t, e, n) {
    if (!t)
      return null;
    const { timeRoundingStrategy: o } = this.props, [r, i] = e.split(":");
    return !r || !i ? n === "startDate" ? t.clone().startOf(o) : t.clone().endOf(o) : t.clone().set({
      hours: parseInt(r, 10),
      minutes: parseInt(i, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    if (this.props.disabled)
      return !0;
    const { timeRoundingStrategy: e } = this.props, { minDate: n, maxDate: o } = this.getDateConstraints();
    return !t.isBetween(n, o, e);
  }
  updateTimeOnDateChange({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    n?.isSame(t) || this.setState({
      startTime: n ? j(n).format(jt) : null
    }), o?.isSame(e) || this.setState({
      endTime: o ? j(o).format(jt) : null
    });
  }
  recalculateDatePickerKey({
    startDate: t,
    endDate: e
  }) {
    const { startDate: n, endDate: o } = this.props;
    if (e && t && !n && !o)
      return this.setState({ dateRangePickerKey: this.generateRandomKey() });
    if (!(!o && !e) && !(!o && e)) {
      if (o && !e) {
        const r = this.visibleCalendarMonthRef.current?.state.currentMonth;
        if (this.visibleCalendarMonthRef.current && o.isSame(r, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
      if (o && e) {
        if (o.isSame(e, "month"))
          return;
        this.setState({ dateRangePickerKey: this.generateRandomKey() });
      }
    }
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderTimezoneSelector() {
    const {
      startDate: t,
      endDate: e,
      disabled: n,
      withTimezoneSelector: o,
      timezoneSelectorProps: r
    } = this.props, { timezone: i } = this.state;
    if (!o)
      return null;
    const l = !!t || !!e, c = !l && !n, d = !l || n || r?.disabled;
    return /* @__PURE__ */ s.jsx(
      Nr,
      {
        disabled: d,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !c,
          ...r?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: i
      }
    );
  }
  renderInputFields(t) {
    const {
      withDateInput: e,
      withTimePicker: n,
      withTimezoneSelector: o,
      timePickerProps: r,
      disabled: i,
      startDate: l,
      endDate: c,
      selectableMinutes: d,
      selectableHours: h,
      inputsPlacement: u,
      timeFormat: p,
      timeRoundingStrategy: m
    } = this.props;
    if (u !== t || !e && !n)
      return null;
    const { startTime: g, endTime: b, focusedInput: x } = this.state, { minDate: w, maxDate: y } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      Us,
      {
        dateFormat: this.dateFormat,
        timeFormat: p,
        onStartDateChange: this.onStartDateChange,
        onEndDateChange: this.onEndDateChange,
        onTimeChange: this.handleTimeChange,
        onFocusChange: this.handleFocusChange,
        startDate: l,
        endDate: c,
        startTime: g,
        endTime: b,
        minDate: w,
        maxDate: y,
        disabled: i,
        withDateInput: e,
        withTimePicker: n,
        hasTimezoneSelector: o,
        timePickerProps: r,
        selectableMinutes: d,
        selectableHours: h,
        placement: t,
        timeRoundingStrategy: m,
        focusedInput: x
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Tr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, startDate: o, endDate: r } = this.props, i = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": _m,
        className: f(ve.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              dr.DayPickerRangeController,
              {
                ref: this.visibleCalendarMonthRef,
                startDate: o,
                endDate: r,
                onDatesChange: this.onDatesChange,
                onFocusChange: this.handleFocusChange,
                focusedInput: this.state.focusedInput,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Dr,
                daySize: 32,
                minimumNights: 0,
                disabled: n,
                renderNavPrevButton: i,
                renderNavNextButton: l,
                renderMonthElement: kr,
                initialVisibleMonth: () => o || r || j(),
                transitionDuration: 0,
                ...e
              },
              this.state.dateRangePickerKey
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const wm = "h-datePicker-single-inputFields--datePickerInputFields__root", vm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTop", Sm = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementTopWithTimezoneSelector", Im = "h-datePicker-single-inputFields--datePickerInputFields__rootPlacementBottom", Dm = "h-datePicker-single-inputFields--datePickerInputFields__input", km = "h-datePicker-single-inputFields--datePickerInputFields__alert", ee = {
  root: wm,
  rootPlacementTop: vm,
  rootPlacementTopWithTimezoneSelector: Sm,
  rootPlacementBottom: Im,
  input: Dm,
  alert: km
};
class qs extends D {
  dateValidators;
  instanceId;
  constructor(t) {
    super(t);
    const { dateFormat: e } = t;
    this.state = {
      dateInputValue: this.props.date?.format(e) ?? "",
      dateError: null
    }, this.instanceId = qs.instanceCount++, this.handleInputValueChange = this.handleInputValueChange.bind(this), this.parseDateString = this.parseDateString.bind(this), this.propagateDateChangeEvent = this.propagateDateChangeEvent.bind(this), this.dateValidators = new Kt(
      t.dateFormat,
      this.parseDateString,
      { maxDate: t.maxDate, minDate: t.minDate }
    );
  }
  componentDidUpdate(t) {
    this.syncDateWithProps(t);
  }
  static instanceCount = 0;
  syncDateWithProps(t) {
    const { date: e, timeRoundingStrategy: n } = this.props, o = j(e);
    if (!(e === t.date || o?.isSame(j(t.date), n)))
      return this.props.date ? this.setState({
        dateError: null,
        dateInputValue: o.format(this.props.dateFormat)
      }) : this.setState({
        dateError: null,
        dateInputValue: ""
      });
  }
  handleInputValueChange(t) {
    const e = this.ensureValidChars(t.target.value);
    this.setState({ dateInputValue: e }, this.propagateDateChangeEvent);
  }
  propagateDateChangeEvent() {
    const { dateInputValue: t } = this.state;
    if (t === "") {
      this.props.onDateChange(null);
      return;
    }
    const { isValid: e, error: n } = this.dateValidators.isSingleDateValid(t);
    if (!e) {
      this.setState({ dateError: n });
      return;
    }
    this.setState(
      {
        dateError: null
      },
      () => this.props.onDateChange(this.parseDateString(t))
    );
  }
  parseDateString(t) {
    return j(t, this.props.dateFormat, !0);
  }
  ensureValidChars(t) {
    return t.replace(/[^0-9/]/g, "");
  }
  renderDateInput() {
    const { disabled: t, dateFormat: e, withDateInput: n } = this.props, { dateInputValue: o, dateError: r } = this.state;
    return n ? /* @__PURE__ */ s.jsx(
      Ut,
      {
        className: ee.input,
        required: !0,
        name: `date__input__${this.instanceId}`,
        value: o,
        onChange: this.handleInputValueChange,
        autoComplete: "off",
        placeholder: e.toLowerCase(),
        disabled: t,
        status: r ? "error" : void 0
      }
    ) : null;
  }
  renderTimeInput() {
    const {
      date: t,
      time: e,
      withTimePicker: n,
      timePickerProps: o = {},
      disabled: r,
      onTimeChange: i,
      timeFormat: l
    } = this.props;
    if (!n)
      return null;
    const c = !t && !r, d = !t || r;
    return /* @__PURE__ */ s.jsx(
      gt,
      {
        content: "Please select a date first.",
        disabled: !c,
        side: "right",
        children: /* @__PURE__ */ s.jsx("div", { className: ee.input, children: /* @__PURE__ */ s.jsx(
          en,
          {
            disabled: d,
            onSelect: i,
            selectedItems: e ? [e] : void 0,
            ...o,
            timeFormat: l
          }
        ) })
      }
    );
  }
  renderErrors() {
    const { dateError: t } = this.state;
    return /* @__PURE__ */ s.jsx(
      Yn,
      {
        className: ee.alert,
        variant: t ? "error" : void 0,
        children: this.state.dateError
      }
    );
  }
  render() {
    const { hasTimezoneSelector: t, placement: e } = this.props, n = f(ee.root, {
      [ee.rootPlacementTop]: e === "top",
      [ee.rootPlacementTopWithTimezoneSelector]: e === "top" && t,
      [ee.rootPlacementBottom]: e === "bottom"
    });
    return /* @__PURE__ */ s.jsxs("div", { className: n, children: [
      this.renderDateInput(),
      this.renderTimeInput(),
      this.renderErrors()
    ] });
  }
}
const Tm = "datePickerTestId";
class jm extends D {
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    withDateInput: !1,
    withTimePicker: !1,
    timePickerProps: {},
    inputsPlacement: "bottom",
    timeRoundingStrategy: "day"
  };
  constructor(t) {
    super(t);
    const { date: e, timezone: n, presets: o, presetKey: r } = t;
    this.state = {
      time: e ? j(e).format(jt) : null,
      timezone: Se(n) ? n : j.tz.guess(!0),
      presetKey: o?.find(({ key: i }) => i === r)?.key ?? null,
      datePickerKey: 0
    }, this.onDateChange = this.onDateChange.bind(this), this.handleTimeChange = this.handleTimeChange.bind(this), this.onTimezoneChange = this.onTimezoneChange.bind(this), this.onPresetSelect = this.onPresetSelect.bind(this), this.isDateOutsideOfSelectableRange = this.isDateOutsideOfSelectableRange.bind(this);
  }
  componentDidUpdate(t) {
    this.updateTimeOnDateChange(t), this.recalculateDatePickerKey();
  }
  visibleCalendarMonthRef = B();
  getDateConstraints() {
    const { maxDate: t, minDate: e } = this.props;
    return {
      minDate: e || j("0001-01-01"),
      maxDate: t || j("9999-12-31")
    };
  }
  onTimezoneChange(t) {
    const { date: e } = this.props, { presetKey: n } = this.state;
    this.setState({ timezone: t }, () => this.onDateChange(e, n));
  }
  onDateChange(t, e = null) {
    const { time: n, timezone: o } = this.state, { timeRoundingStrategy: r } = this.props, i = this.addTimezoneToDate(t, o);
    let l = i?.clone().startOf(r) || null, c = t?.clone().startOf(r) || null;
    if (this.setState({ presetKey: e }), e) {
      this.setState(
        {
          time: t?.clone().startOf(r).format(jt) ?? null
        },
        () => {
          this.props.onChange({
            date: l,
            localDate: c,
            timezone: o,
            localTimezone: j.tz.guess(!0),
            presetKey: e
          });
        }
      );
      return;
    }
    n && (l = this.addTimeToDate(i, n), c = this.addTimeToDate(t, n)), this.props.onChange({
      date: l,
      localDate: c,
      timezone: o,
      localTimezone: j.tz.guess(!0)
    });
  }
  onPresetSelect(t) {
    t ? this.onDateChange(t.date, t.key) : this.onDateChange(null);
  }
  handleTimeChange(t) {
    const { date: e } = this.props;
    this.setState(
      (n) => ({
        ...n,
        time: t
      }),
      () => this.onDateChange(e)
    );
  }
  addTimezoneToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props;
    return Se(e) ? j(t).clone().tz(e, !0) : t.clone().startOf(n);
  }
  addTimeToDate(t, e) {
    if (!t) return null;
    const { timeRoundingStrategy: n } = this.props, [o, r] = e.split(":");
    return !o || !r ? t.clone().startOf(n) : t.clone().set({
      hours: parseInt(o, 10),
      minutes: parseInt(r, 10),
      seconds: 0,
      milliseconds: 0
    });
  }
  isDateOutsideOfSelectableRange(t) {
    const { disabled: e, timeRoundingStrategy: n } = this.props;
    if (e)
      return !0;
    const { minDate: o, maxDate: r } = this.getDateConstraints();
    return !t.isBetween(o, r, n);
  }
  updateTimeOnDateChange(t) {
    const { date: e } = this.props;
    t.date?.isSame(e) || this.setState({
      time: e ? j(e).format(jt) : null
    });
  }
  recalculateDatePickerKey() {
    const { date: t } = this.props, e = this.visibleCalendarMonthRef.current?.state.currentMonth;
    if (e && t && !t.isSame(e, "month"))
      return this.setState({ datePickerKey: this.generateRandomKey() });
  }
  generateRandomKey() {
    return Math.floor(Math.random() * 1e8);
  }
  renderTimezoneSelector() {
    const { date: t, disabled: e, withTimezoneSelector: n, timezoneSelectorProps: o } = this.props, { timezone: r } = this.state;
    if (!n)
      return null;
    const i = !!t, l = !i && !e, c = !i || e || o?.disabled;
    return /* @__PURE__ */ s.jsx(
      Nr,
      {
        disabled: c,
        tooltipProps: {
          content: "Please select a date first",
          disabled: !l,
          ...o?.tooltipProps
        },
        onChange: this.onTimezoneChange,
        selectedTimezone: r,
        ...o
      }
    );
  }
  renderInputFields(t) {
    const {
      dateFormat: e,
      timeFormat: n,
      withDateInput: o,
      withTimePicker: r,
      withTimezoneSelector: i,
      timePickerProps: l,
      selectableMinutes: c,
      selectableHours: d,
      disabled: h,
      date: u,
      inputsPlacement: p,
      timeRoundingStrategy: m
    } = this.props;
    if (p !== t || !o && !r)
      return null;
    const { time: g } = this.state, { minDate: b, maxDate: x } = this.getDateConstraints();
    return /* @__PURE__ */ s.jsx(
      qs,
      {
        dateFormat: e,
        timeFormat: n,
        onDateChange: this.onDateChange,
        onTimeChange: this.handleTimeChange,
        time: g,
        date: u,
        minDate: b,
        maxDate: x,
        disabled: h,
        withDateInput: o,
        withTimePicker: r,
        hasTimezoneSelector: i,
        timePickerProps: l,
        selectableMinutes: c,
        selectableHours: d,
        placement: t,
        timeRoundingStrategy: m
      }
    );
  }
  renderPresets() {
    const { presets: t } = this.props, { presetKey: e } = this.state;
    return t?.length ? /* @__PURE__ */ s.jsx(
      Tr,
      {
        value: e,
        presets: t,
        onSelect: this.onPresetSelect
      }
    ) : null;
  }
  render() {
    const { className: t, calendarProps: e, disabled: n, date: o } = this.props, { datePickerKey: r } = this.state, i = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.previousMonth, l = n ? () => /* @__PURE__ */ s.jsx("span", {}) : Bn.nextMonth;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Tm,
        className: f(ve.root, t),
        children: [
          /* @__PURE__ */ s.jsxs(O, { flexDirection: "column", alignItems: "center", children: [
            this.renderTimezoneSelector(),
            this.renderInputFields("top"),
            /* @__PURE__ */ s.jsx(
              dr.DayPickerSingleDateController,
              {
                ref: this.visibleCalendarMonthRef,
                date: o,
                onDateChange: this.onDateChange,
                isOutsideRange: this.isDateOutsideOfSelectableRange,
                numberOfMonths: 1,
                hideKeyboardShortcutsPanel: !0,
                noBorder: !0,
                renderDayContents: Dr,
                daySize: 32,
                renderNavPrevButton: i,
                renderNavNextButton: l,
                renderMonthElement: kr,
                initialVisibleMonth: () => o || j(),
                onFocusChange: E,
                focused: !0,
                transitionDuration: 0,
                ...e
              },
              r
            ),
            this.renderInputFields("bottom")
          ] }),
          this.renderPresets()
        ]
      }
    );
  }
}
const Nm = "h-dialer--dialer__dialer", Pm = "h-dialer--dialer__number", Fm = "h-dialer--dialer__letters", Rm = "h-dialer--dialer__asterisk", Rn = {
  dialer: Nm,
  number: Pm,
  letters: Fm,
  asterisk: Rm
}, Em = [
  { value: "1", letters: " " },
  { value: "2", letters: "abc" },
  { value: "3", letters: "def" },
  { value: "4", letters: "ghi" },
  { value: "5", letters: "jkl" },
  { value: "6", letters: "mno" },
  { value: "7", letters: "pqrs" },
  { value: "8", letters: "tuv" },
  { value: "9", letters: "wxyz" },
  { value: "*", letters: null, classNames: Rn.asterisk },
  { value: "0", letters: null },
  { value: "#", letters: null }
];
class uk extends D {
  render() {
    const { className: t, onInput: e, ...n } = this.props, o = f(Rn.dialer, t);
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: Em.map((r) => /* @__PURE__ */ va(
      "div",
      {
        className: f(Rn.number),
        ...Kn(() => e(r.value)),
        key: r.value
      },
      /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-1", color: "neutral.700", children: /* @__PURE__ */ s.jsx("span", { className: r.classNames ?? "", children: r.value }) }),
      /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", color: "neutral.700", children: !!r.letters && /* @__PURE__ */ s.jsx("span", { className: Rn.letters, children: r.letters }) })
    )) });
  }
}
const Lm = "h-fieldWrapper--fieldWrapper__root", Am = "h-fieldWrapper--fieldWrapper__rootDisabled", $m = "h-fieldWrapper--fieldWrapper__label", Bm = "h-fieldWrapper--fieldWrapper__alert", xn = {
  root: Lm,
  rootDisabled: Am,
  label: $m,
  alert: Bm
}, Om = "fieldWrapper";
class z extends D {
  static hasStatus(t, e) {
    return t?.[e] ? t?.touched === void 0 || t.touched === !0 : !1;
  }
  static getStatusMessage(t, e) {
    if (this.hasStatus(t, e))
      return t?.[e];
  }
  static getStatus(t) {
    return z.hasStatus(t, "error") ? "error" : z.hasStatus(t, "warning") ? "warning" : z.hasStatus(t, "success") ? "success" : void 0;
  }
  renderAlerts() {
    const { meta: t, description: e } = this.props;
    let n = e, o;
    return z.hasStatus(t, "error") ? (n = z.getStatusMessage(t, "error"), o = "error") : z.hasStatus(t, "warning") ? (n = z.getStatusMessage(t, "warning"), o = "warning") : z.hasStatus(t, "success") && (n = z.getStatusMessage(t, "success"), o = "success"), /* @__PURE__ */ s.jsx(Yn, { variant: o, className: xn.alert, children: n });
  }
  render() {
    const {
      className: t,
      labelFor: e,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      noAlert: c,
      noLabel: d,
      children: h,
      ...u
    } = this.props, p = f(
      xn.root,
      {
        [xn.rootDisabled]: i
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": Om,
        ...u,
        className: p,
        children: [
          !d && /* @__PURE__ */ s.jsx(
            zs,
            {
              required: r,
              htmlFor: e,
              helpIcon: l,
              className: xn.label,
              children: n
            }
          ),
          h,
          !c && this.renderAlerts()
        ]
      }
    );
  }
}
class Ts extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noLabel: d,
      noAlert: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noLabel: d,
        noAlert: h,
        children: /* @__PURE__ */ s.jsx(
          Ut,
          {
            status: z.getStatus(o),
            disabled: i,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const Hm = "h-dropdownSelect--dropdownSelectContainer__search", Wm = "h-dropdownSelect--dropdownSelectContainer__pagination", Mm = "h-dropdownSelect--dropdownSelectContainer__selectionActions", zm = "h-dropdownSelect--dropdownSelectContainer__extra", yn = {
  search: Hm,
  pagination: Wm,
  selectionActions: Mm,
  extra: zm
}, Vm = "DROP_SEARCH_INPUT";
class Pr extends _t {
  listRef;
  searchRef;
  static getDerivedStateFromProps(t, e) {
    const { dropdownOpen: n } = t, o = { ...e };
    return n || (o.searchValue = ""), o;
  }
  constructor(t) {
    super(t), this.state = {
      searchValue: ""
    }, this.search = this.search.bind(this), this.searchKeyDown = this.searchKeyDown.bind(this), this.onSelect = this.onSelect.bind(this), this.onChange = this.onChange.bind(this), this.listRef = B(), this.searchRef = B();
  }
  componentDidMount() {
    this.onOpen();
  }
  componentDidUpdate(t) {
    const { dropdownOpen: e } = this.props;
    !t.dropdownOpen && e && this.onOpen();
  }
  getInput() {
    const { searchValue: t } = this.state;
    return {
      name: Vm,
      value: t,
      onChange: this.search,
      onKeyDown: this.searchKeyDown,
      autoComplete: "off",
      "aria-label": "Search"
    };
  }
  searchKeyDown(t) {
    const { keyCode: e } = t, { searchValue: n } = this.state, { triggerClose: o } = this.props;
    e === 27 && n === "" ? o() : e === 27 ? this.clearSearch() : e === 13 && t.preventDefault();
  }
  search(t) {
    const { onSearch: e } = this.props, { value: n } = t.target;
    typeof e == "function" && e(n), n && this.listRef.current && this.listRef.current.goToTop(), this.setState({
      searchValue: n
    });
  }
  onSelect(t) {
    const { onSelect: e, keepOpen: n, triggerClose: o } = this.props;
    typeof e == "function" && e(t), n && this.focusSearch(), !n && typeof o == "function" && o();
  }
  onChange(t, e) {
    const { onChange: n, keepOpen: o, triggerClose: r } = this.props;
    typeof n == "function" && n(t, e), o && this.focusSearch(), !o && typeof r == "function" && r();
  }
  onOpen() {
    this.focusSearch();
  }
  focusSearch() {
    const { hasSearch: t } = this.props;
    if (t && this.searchRef.current) {
      const e = this.searchRef.current.querySelector("input");
      e && e.focus();
    }
  }
  clearSearch = () => {
    const { onSearch: t } = this.props, { searchValue: e } = this.state;
    e && (typeof t == "function" && t(""), this.setState({ searchValue: "" }));
  };
  render() {
    const {
      className: t,
      itemComponent: e,
      emptyComponent: n,
      suggestionComponent: o,
      optionComponent: r,
      items: i,
      hasSearch: l,
      searchPlaceholder: c,
      pagination: d,
      keepOpen: h,
      onSelect: u,
      onSearch: p,
      onSuggest: m,
      onChange: g,
      onClear: b,
      onClearText: x,
      triggerClose: w,
      dropdownOpen: y,
      emptyMessage: v,
      selectedItems: _,
      disabledItems: C,
      tooltipItems: S,
      activeItem: I,
      itemsDisplayCount: T,
      itemHeight: R,
      renderSuggestion: A,
      searchSuggestion: k,
      ...F
    } = this.props;
    if (!y)
      return null;
    const { searchValue: H } = this.state, et = i.length === 0, at = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...F, className: at, children: [
      l && /* @__PURE__ */ s.jsx("div", { className: yn.search, ref: this.searchRef, children: /* @__PURE__ */ s.jsx(
        Ts,
        {
          input: this.getInput(),
          meta: { error: null, touched: !0 },
          icon: "search",
          noAlert: !0,
          noLabel: !0,
          placeholder: c
        }
      ) }),
      !!(l && o || r) && /* @__PURE__ */ s.jsxs("div", { className: yn.extra, children: [
        r,
        l && typeof o == "function" && /* @__PURE__ */ s.jsx(
          o,
          {
            searched: H,
            onSuggest: m,
            triggerClose: h ? void 0 : w,
            clearSearch: this.clearSearch,
            items: i,
            searchSuggestion: k,
            renderSuggestion: A
          }
        )
      ] }),
      /* @__PURE__ */ s.jsxs("div", { children: [
        !et && /* @__PURE__ */ s.jsx(
          Vs,
          {
            ref: this.listRef,
            pagination: d,
            items: i,
            onSelect: this.onSelect,
            onChange: this.onChange,
            clearSearch: this.clearSearch,
            selectedItems: _,
            disabledItems: C,
            itemComponent: e,
            tooltipItems: S,
            itemsDisplayCount: T,
            itemHeight: R,
            activeItem: I
          }
        ),
        et && typeof n == "function" && /* @__PURE__ */ s.jsx(n, { label: v || "" })
      ] }),
      typeof b == "function" && /* @__PURE__ */ s.jsx("div", { className: yn.selectionActions, children: /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "secondary",
          disabled: _?.length === 0,
          onClick: b,
          children: x || "Clear"
        }
      ) }),
      !!d && !d.infinite && /* @__PURE__ */ s.jsxs("div", { className: yn.pagination, children: [
        /* @__PURE__ */ s.jsx(
          Q,
          {
            variant: "secondary",
            disabled: !d.previousEnable,
            onClick: d.onPrevious,
            children: "Prev page"
          }
        ),
        /* @__PURE__ */ s.jsx(
          Q,
          {
            variant: "secondary",
            disabled: !d.nextEnable,
            onClick: d.onNext,
            children: "Next page"
          }
        )
      ] })
    ] });
  }
}
class Gs extends D {
  static defaultProps = {
    className: "",
    buttonProps: {},
    dropdownProps: {},
    containerProps: {},
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    pagination: !1,
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    onToggle: () => {
    },
    onKeyDown: () => {
    },
    emptyComponent: cn,
    emptyMessage: "No items found",
    selectedItems: [],
    disabledItems: [],
    tooltipItems: {},
    activeItem: null
  };
  render() {
    const {
      className: t,
      items: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: i,
      onClearText: l,
      onKeyDown: c,
      hasSearch: d,
      searchPlaceholder: h = "Search...",
      onSuggest: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      children: b,
      buttonProps: x,
      dropdownProps: w,
      containerProps: y,
      pagination: v,
      emptyComponent: _,
      emptyMessage: C,
      selectedItems: S,
      disabledItems: I,
      tooltipItems: T,
      activeItem: R,
      itemsDisplayCount: A,
      itemHeight: k,
      optionComponent: F,
      renderSuggestion: H,
      searchSuggestion: et,
      ...at
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      re,
      {
        ...at,
        className: t,
        buttonProps: { variant: "secondary", ...x },
        dropdownProps: w,
        dropdown: /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ toggleDropdown: nt, dropdownOpen: M }) => /* @__PURE__ */ s.jsx(
          Pr,
          {
            ...y,
            items: e,
            itemComponent: m,
            hasSearch: d,
            searchPlaceholder: h,
            suggestionComponent: g,
            onSuggest: u,
            keepOpen: p,
            onSearch: r,
            onSelect: n,
            onChange: o,
            onClear: i,
            onClearText: l,
            onKeyDown: c,
            triggerClose: nt,
            dropdownOpen: M,
            pagination: v,
            emptyComponent: _,
            emptyMessage: C,
            selectedItems: S,
            disabledItems: I,
            tooltipItems: T,
            activeItem: R,
            itemsDisplayCount: A,
            itemHeight: k,
            optionComponent: F,
            renderSuggestion: H,
            searchSuggestion: et
          }
        ) }),
        children: b
      }
    );
  }
}
const Km = "h-dropdownSelectMultiple--dropdownSelectMultiple__items", Um = "h-dropdownSelectMultiple--dropdownSelectMultiple__moreItemsDropdown", qm = "h-dropdownSelectMultiple--dropdownSelectMultiple__tagName", us = {
  items: Km,
  moreItemsDropdown: Um,
  tagName: qm
};
class Gm extends _t {
  static defaultProps = {
    noArrow: !0,
    hasSearch: !1,
    searchPlaceholder: "Search...",
    keepOpen: !1,
    onSearch: () => {
    },
    onSuggest: () => {
    },
    onChange: () => {
    },
    onSelect: () => {
    },
    emptyComponent: cn,
    emptyMessage: "No items found",
    buttonText: "+Select item",
    selectedItems: []
  };
  getItems() {
    const { items: t } = this.props;
    return t;
  }
  render() {
    const {
      items: t,
      itemComponent: e,
      onSelect: n,
      onChange: o,
      onSearch: r,
      onClear: i,
      hasSearch: l,
      searchPlaceholder: c,
      onSuggest: d,
      suggestionComponent: h,
      emptyComponent: u,
      emptyMessage: p,
      keepOpen: m,
      containerProps: g,
      buttonText: b,
      selectedItems: x,
      optionComponent: w,
      ...y
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Gs,
      {
        ...y,
        containerProps: g,
        items: this.getItems(),
        itemComponent: e,
        hasSearch: l,
        searchPlaceholder: c,
        suggestionComponent: h,
        onSuggest: d,
        keepOpen: m,
        onSearch: r,
        onSelect: n,
        onChange: o,
        onClear: i,
        emptyComponent: u,
        emptyMessage: p,
        selectedItems: x,
        optionComponent: w,
        children: b
      }
    );
  }
}
class pk extends _t {
  static defaultProps = {
    MoreItemsItemComponent: Uu,
    hideSelectedItems: !1,
    disabledItems: [],
    tooltipItems: {}
  };
  constructor(t) {
    super(t), this.getListItem = this.getListItem.bind(this), this.getListMoreItem = this.getListMoreItem.bind(this);
  }
  resolveItem(t) {
    if (typeof t == "object")
      return t;
    const e = this.props.items.find((n) => n.id === t);
    return e || { id: lr(), name: "Unknown" };
  }
  getItemName(t) {
    return t.name.toString().trim();
  }
  isItemDisabled(t) {
    return this.props.disabledItems ? this.props.disabledItems.indexOf(t.id) >= 0 : !1;
  }
  getTooltip(t) {
    const { tooltipItems: e } = this.props;
    return !e || As(e[t.id]) ? null : e[t.id];
  }
  getListItem(t, e) {
    const { onRemove: n } = this.props, o = this.resolveItem(t), r = this.getItemName(o), i = this.getTooltip(o), l = /* @__PURE__ */ s.jsx(
      Ie,
      {
        className: us.tagName,
        onDelete: () => n(o),
        color: o.color,
        disabled: this.isItemDisabled(o),
        children: r
      },
      o.id
    );
    return i ? /* @__PURE__ */ s.jsx(gt, { ...i, children: l }, e) : l;
  }
  getListMoreItem(t) {
    const { MoreItemsItemComponent: e, onRemove: n } = this.props, o = this.resolveItem(t), r = this.getTooltip(o), i = /* @__PURE__ */ s.jsx(
      e,
      {
        item: o,
        onSelect: n,
        disabled: this.isItemDisabled(o),
        clearSearch: E,
        isLoading: !1,
        checked: !1
      },
      o.id
    );
    return r ? /* @__PURE__ */ s.jsx(gt, { ...r, children: i }, o.id) : i;
  }
  getPreviewItems() {
    const {
      selectedItems: t,
      previewItemsNumber: e,
      moreItemsDropdownProps: n = {}
    } = this.props;
    let o = [], r = [], i = "";
    if (e && t) {
      if (t.length > 0 && t.length < e)
        o = t.map(this.getListItem);
      else if (t.length >= e) {
        const h = t.slice(0, e), u = t.slice(
          e,
          t.length
        );
        o = h.map(this.getListItem), r = u.map(this.getListMoreItem), i = u.length.toString();
      }
    } else
      o = t.map(this.getListItem);
    const { className: l, ...c } = n, d = /* @__PURE__ */ s.jsx(
      "div",
      {
        ...c,
        className: f(us.moreItemsDropdown, l),
        children: r
      }
    );
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      o,
      e && t.length > e ? /* @__PURE__ */ s.jsxs(
        re,
        {
          noArrow: !0,
          buttonProps: { variant: "tertiary" },
          dropdown: d,
          children: [
            "+ ",
            i,
            /* @__PURE__ */ s.jsx("span", { children: " selected" })
          ]
        }
      ) : null
    ] });
  }
  render() {
    const {
      items: t,
      selectedItems: e,
      previewItemsNumber: n,
      className: o,
      onSelect: r,
      onChange: i,
      onSearch: l,
      hasSearch: c,
      searchPlaceholder: d,
      onSuggest: h,
      onRemove: u,
      keepOpen: p,
      itemComponent: m,
      suggestionComponent: g,
      pagination: b,
      emptyComponent: x,
      emptyMessage: w,
      containerProps: y,
      moreItemsDropdownProps: v,
      MoreItemsItemComponent: _,
      hideSelectedItems: C,
      disabledItems: S,
      tooltipItems: I,
      optionComponent: T,
      ...R
    } = this.props, A = f(
      {
        [us.items]: !0
      },
      o
    );
    return /* @__PURE__ */ s.jsxs("div", { className: A, children: [
      /* @__PURE__ */ s.jsx(
        Gm,
        {
          items: t,
          itemComponent: m,
          hasSearch: c,
          searchPlaceholder: d,
          suggestionComponent: g,
          onSuggest: h,
          keepOpen: p,
          onSearch: l,
          onSelect: r,
          onChange: i,
          pagination: b,
          emptyComponent: x,
          emptyMessage: w,
          containerProps: y,
          selectedItems: e,
          disabledItems: S,
          tooltipItems: I,
          optionComponent: T,
          ...R
        }
      ),
      !C && this.getPreviewItems()
    ] });
  }
}
const Ym = "h-fieldButton--fieldButton__button", Qm = {
  button: Ym
}, mk = $(
  function({
    className: t,
    buttonClassName: e,
    label: n,
    meta: o,
    disabled: r,
    helpIcon: i,
    description: l,
    noAlert: c,
    noLabel: d,
    children: h,
    ...u
  }, p) {
    const m = f(e, Qm.button);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        meta: o,
        disabled: r,
        helpIcon: i,
        description: l,
        noAlert: c,
        noLabel: d,
        children: /* @__PURE__ */ s.jsx(
          Q,
          {
            ref: p,
            disabled: r,
            ...u,
            className: m,
            children: h
          }
        )
      }
    );
  }
), Xm = "h-inputDatePicker--inputDatePicker__root", Zm = "h-inputDatePicker--inputDatePicker__inputContainer", Jm = "h-inputDatePicker--inputDatePicker__input", tg = "h-inputDatePicker--inputDatePicker__rootReadOnly", eg = "h-inputDatePicker--inputDatePicker__iconsContainer", ng = "h-inputDatePicker--inputDatePicker__rootHasClearIcon", sg = "h-inputDatePicker--inputDatePicker__rootHasWrapperIcon", og = "h-inputDatePicker--inputDatePicker__calendarIcon", rg = "h-inputDatePicker--inputDatePicker__clearIcon", Lt = {
  root: Xm,
  inputContainer: Zm,
  input: Jm,
  rootReadOnly: tg,
  iconsContainer: eg,
  rootHasClearIcon: ng,
  rootHasWrapperIcon: sg,
  calendarIcon: og,
  clearIcon: rg
}, ag = "inputDatePickerTestId";
class ig extends D {
  inputRef;
  rootRef;
  datePickerContainerRef;
  static defaultProps = {
    dateFormat: j.localeData().longDateFormat("L"),
    name: Math.floor(Math.random() * 1e8).toString()
  };
  constructor(t) {
    super(t), this.inputRef = B(), this.rootRef = B(), this.datePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      shouldRerenderDatePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDateChange = this.handleDateChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown)), n && this.focusDatePickerInput());
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDatePickerInput() {
    this.datePickerContainerRef.current?.querySelector('input[type="text"]')?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    je(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDateChange(t) {
    const { onChange: e, value: n } = this.props;
    typeof e == "function" && e(t), (n ?? t !== null) && this.inputRef.current?.focus();
  }
  handleClearIconClick() {
    this.handleDateChange({
      date: null,
      localDate: null,
      timezone: null,
      localTimezone: null
    });
  }
  showDropdown() {
    this.setState({
      isDropdownOpen: !0,
      shouldRerenderDatePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus() {
    const { readOnly: t } = this.props;
    t || this.showDropdown();
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  handleInputKeydown({ key: t }) {
    Un(t) && this.showDropdown();
  }
  handleCalendarIconClick(t) {
    const { readOnly: e } = this.props;
    e || (t.stopPropagation(), this.showDropdown());
  }
  renderInputAndIcons() {
    const {
      className: t,
      name: e,
      value: n,
      onChange: o,
      dateFormat: r,
      dropdownProps: i,
      prefix: l,
      suffix: c,
      icon: d,
      status: h,
      placeholder: u,
      disabled: p,
      datePickerProps: m,
      clearable: g,
      minDate: b,
      maxDate: x,
      readOnly: w,
      ...y
    } = this.props, { isDropdownOpen: v } = this.state;
    return /* @__PURE__ */ s.jsx(
      Rt,
      {
        prefix: l,
        suffix: c,
        disabled: p,
        icon: d,
        active: v,
        status: h,
        children: /* @__PURE__ */ s.jsxs("div", { className: Lt.inputContainer, children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              ...y,
              id: e,
              name: e,
              className: Lt.input,
              ref: this.inputRef,
              onClick: this.handleInputClick,
              onFocus: this.handleInputFocus,
              onBlur: this.handleInputBlur,
              onKeyDown: this.handleInputKeydown,
              disabled: p,
              placeholder: u || r?.toLowerCase(),
              autoComplete: "off",
              value: Ln(n) ? void 0 : n?.format(r) ?? "",
              onChange: Ln(n) ? void 0 : E,
              readOnly: !0
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: Lt.iconsContainer, children: [
            this.renderClearIcon(),
            this.renderCalendarIcon()
          ] })
        ] })
      }
    );
  }
  renderCalendarIcon() {
    const { disabled: t } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: Lt.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: this.handleCalendarIconClick,
        tabIndex: -1,
        disabled: t
      }
    );
  }
  renderClearIcon() {
    const { clearable: t, value: e, disabled: n } = this.props;
    return !t || !e ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: Lt.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: n,
        onClick: this.handleClearIconClick
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      datePickerProps: r,
      disabled: i,
      dropdownProps: l,
      dateFormat: c
    } = this.props, { isDropdownOpen: d, shouldRerenderDatePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Xt, { ...l, isOpen: d, children: /* @__PURE__ */ s.jsx("div", { ref: this.datePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      jm,
      {
        disabled: i,
        ...r,
        dateFormat: c,
        date: t ?? null,
        timezone: o,
        onChange: this.handleDateChange,
        minDate: e,
        maxDate: n
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, i = f(Lt.root, t, {
      [Lt.rootHasClearIcon]: n && e,
      [Lt.rootHasWrapperIcon]: !!r,
      [Lt.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": ag,
        ref: this.rootRef,
        className: i,
        children: [
          this.renderInputAndIcons(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class gk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      date: t?.date ? t.date.toISOString() : "",
      localDate: t?.localDate ? t.localDate.toISOString() : "",
      timezone: t?.timezone || "",
      localTimezone: t?.localTimezone || ""
    });
  }
  render() {
    const {
      className: t,
      input: { value: e, name: n, onChange: o, ...r },
      label: i,
      meta: l,
      required: c,
      disabled: d,
      helpIcon: h,
      description: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: i,
        labelFor: n,
        meta: l,
        required: c,
        disabled: d,
        helpIcon: h,
        description: u,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          ig,
          {
            name: n,
            value: ks(e?.localDate) ? j(e.localDate, j.ISO_8601) : null,
            timezone: e?.timezone,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const lg = "h-inputDateRangePicker--inputDateRangePicker__root", cg = "h-inputDateRangePicker--inputDateRangePicker__inputsContainer", dg = "h-inputDateRangePicker--inputDateRangePicker__arrowContainer", hg = "h-inputDateRangePicker--inputDateRangePicker__inputContainer", ug = "h-inputDateRangePicker--inputDateRangePicker__input", pg = "h-inputDateRangePicker--inputDateRangePicker__rootReadOnly", mg = "h-inputDateRangePicker--inputDateRangePicker__iconsContainer", gg = "h-inputDateRangePicker--inputDateRangePicker__rootStartDateHasClearIcon", fg = "h-inputDateRangePicker--inputDateRangePicker__startDateIconsContainer", bg = "h-inputDateRangePicker--inputDateRangePicker__rootEndDateHasClearIcon", xg = "h-inputDateRangePicker--inputDateRangePicker__endDateIconsContainer", yg = "h-inputDateRangePicker--inputDateRangePicker__rootHasWrapperIcon", _g = "h-inputDateRangePicker--inputDateRangePicker__calendarIcon", Cg = "h-inputDateRangePicker--inputDateRangePicker__clearIcon", ht = {
  root: lg,
  inputsContainer: cg,
  arrowContainer: dg,
  inputContainer: hg,
  input: ug,
  rootReadOnly: pg,
  iconsContainer: mg,
  rootStartDateHasClearIcon: gg,
  startDateIconsContainer: fg,
  rootEndDateHasClearIcon: bg,
  endDateIconsContainer: xg,
  rootHasWrapperIcon: yg,
  calendarIcon: _g,
  clearIcon: Cg
}, wg = "inputDateRangePickerTestId";
class nn extends D {
  inputsRef;
  rootRef;
  dateRangePickerContainerRef;
  static getInputName(t, e) {
    return t[e] || `${t}__${e}`;
  }
  static defaultProps = {
    name: {
      startDate: Math.floor(Math.random() * 1e8).toString(),
      endDate: Math.floor(Math.random() * 1e8).toString()
    }
  };
  constructor(t) {
    super(t), this.inputsRef = {
      startDate: B(),
      endDate: B()
    }, this.rootRef = B(), this.dateRangePickerContainerRef = B(), this.state = {
      isDropdownOpen: !1,
      focusedInput: "startDate",
      shouldRerenderDateRangePicker: !0
    }, this.handleWindowClick = this.handleWindowClick.bind(this), this.handleWindowKeyDown = this.handleWindowKeyDown.bind(this), this.handleDatesChange = this.handleDatesChange.bind(this), this.handleCalendarIconClick = this.handleCalendarIconClick.bind(this), this.handleInputClick = this.handleInputClick.bind(this), this.handleInputFocus = this.handleInputFocus.bind(this), this.handleInputBlur = this.handleInputBlur.bind(this), this.handleInputKeydown = this.handleInputKeydown.bind(this), this.handleClearIconClick = this.handleClearIconClick.bind(this);
  }
  componentDidUpdate(t, e) {
    const { isDropdownOpen: n, focusedInput: o } = this.state;
    n !== e.isDropdownOpen && (n ? (window.addEventListener("click", this.handleWindowClick), window.addEventListener("keydown", this.handleWindowKeyDown)) : (window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown))), (n !== e.isDropdownOpen || o !== e.focusedInput) && this.focusDateRangePickerInput();
  }
  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick), window.removeEventListener("keydown", this.handleWindowKeyDown);
  }
  focusDateRangePickerInput() {
    const { focusedInput: t } = this.state, e = this.dateRangePickerContainerRef.current?.querySelectorAll(
      'input[type="text"]'
    );
    t === "startDate" ? e?.[0]?.focus() : e?.[1]?.focus();
  }
  handleWindowClick(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleWindowKeyDown(t) {
    je(t.key) && this.state.isDropdownOpen && (t.stopPropagation(), this.hideDropdown());
  }
  handleDatesChange(t) {
    const { onChange: e, value: n } = this.props, { focusedInput: o } = this.state;
    typeof e == "function" && e(t), (n?.[o] ?? t[o] !== null) && this.inputsRef[o].current?.focus();
  }
  handleClearIconClick(t, e) {
    const { value: n, timezone: o, localTimezone: r } = this.props, i = {
      startDate: e === "startDate" ? null : n?.startDate ?? null,
      localStartDate: e === "startDate" ? null : n?.localStartDate ?? null,
      endDate: e === "endDate" ? null : n?.endDate ?? null,
      localEndDate: e === "endDate" ? null : n?.localEndDate ?? null,
      timezone: o || null,
      localTimezone: r || null
    };
    this.handleDatesChange(i);
  }
  showDropdown(t) {
    this.setState({
      isDropdownOpen: !0,
      focusedInput: t,
      shouldRerenderDateRangePicker: !1
    });
  }
  hideDropdown() {
    this.setState({ isDropdownOpen: !1 });
  }
  handleInputFocus(t, e) {
    const { readOnly: n } = this.props;
    n || this.showDropdown(e);
  }
  handleInputBlur(t) {
    this.rootRef.current?.contains(t.target) || this.hideDropdown();
  }
  handleInputKeydown({ key: t }, e) {
    Un(t) && this.showDropdown(e);
  }
  handleInputClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  handleCalendarIconClick(t, e) {
    const { readOnly: n } = this.props;
    n || (t.stopPropagation(), this.showDropdown(e));
  }
  get dateFormat() {
    const { dateFormat: t } = this.props;
    return t || j.localeData().longDateFormat("L");
  }
  renderInputLayout() {
    const { prefix: t, suffix: e, icon: n, status: o, disabled: r } = this.props, { isDropdownOpen: i } = this.state;
    return /* @__PURE__ */ s.jsx(
      Rt,
      {
        prefix: t,
        suffix: e,
        disabled: r,
        icon: n,
        active: i,
        status: o,
        children: /* @__PURE__ */ s.jsxs("div", { className: ht.inputsContainer, children: [
          this.renderInputAndIcons("startDate"),
          /* @__PURE__ */ s.jsx("div", { className: ht.arrowContainer, children: /* @__PURE__ */ s.jsx(N, { name: "arrow-right" }) }),
          this.renderInputAndIcons("endDate", -1)
        ] })
      }
    );
  }
  renderInputAndIcons(t, e) {
    const {
      className: n,
      clearable: o,
      dateFormat: r,
      dateRangePickerProps: i,
      disabled: l,
      dropdownProps: c,
      icon: d,
      localTimezone: h,
      maxDate: u,
      minDate: p,
      name: m,
      onChange: g,
      placeholder: b,
      prefix: x,
      readOnly: w,
      status: y,
      suffix: v,
      tabIndex: _,
      timezone: C,
      value: S,
      ...I
    } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: ht.inputContainer, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...I,
          id: nn.getInputName(m, t),
          name: nn.getInputName(m, t),
          className: ht.input,
          ref: this.inputsRef[t],
          onClick: (T) => this.handleInputClick(T, t),
          onFocus: (T) => this.handleInputFocus(T, t),
          onBlur: (T) => this.handleInputBlur(T),
          onKeyDown: (T) => this.handleInputKeydown(T, t),
          disabled: l,
          placeholder: b?.[t] || b || this.dateFormat?.toLowerCase(),
          autoComplete: "off",
          value: S && j(S[t]).isValid() ? j(S[t]).format(this.dateFormat) : "",
          onChange: Ln(S) ? void 0 : E,
          tabIndex: e ?? _,
          readOnly: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: f(ht.iconsContainer, {
            [ht.startDateIconsContainer]: t === "startDate",
            [ht.endDateIconsContainer]: t === "endDate"
          }),
          children: [
            this.renderClearIcon(t),
            this.renderCalendarIcon(t)
          ]
        }
      )
    ] });
  }
  renderCalendarIcon(t) {
    const { disabled: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      K,
      {
        className: ht.calendarIcon,
        icon: "calendar",
        variant: "tertiary",
        onClick: (n) => this.handleCalendarIconClick(n, t),
        tabIndex: -1,
        disabled: e
      }
    );
  }
  renderClearIcon(t) {
    const { clearable: e, value: n, disabled: o } = this.props;
    return !e || !n?.[t] ? null : /* @__PURE__ */ s.jsx(
      K,
      {
        className: ht.clearIcon,
        variant: "tertiary",
        icon: "close",
        disabled: o,
        onClick: (r) => this.handleClearIconClick(r, t)
      }
    );
  }
  renderDropdown() {
    const {
      value: t,
      minDate: e,
      maxDate: n,
      timezone: o,
      dateRangePickerProps: r,
      disabled: i,
      dropdownProps: l
    } = this.props, { isDropdownOpen: c, focusedInput: d, shouldRerenderDateRangePicker: h } = this.state;
    return /* @__PURE__ */ s.jsx(Xt, { ...l, isOpen: c, children: /* @__PURE__ */ s.jsx("div", { ref: this.dateRangePickerContainerRef, children: /* @__PURE__ */ s.jsx(
      Cm,
      {
        disabled: i,
        ...r,
        dateFormat: this.dateFormat,
        onChange: this.handleDatesChange,
        startDate: t?.startDate ?? null,
        endDate: t?.endDate ?? null,
        timezone: o ?? null,
        minDate: e,
        maxDate: n,
        focusedInput: d
      },
      h.toString()
    ) }) });
  }
  render() {
    const { className: t, value: e, clearable: n, readOnly: o, icon: r } = this.props, i = f(ht.root, t, {
      [ht.rootStartDateHasClearIcon]: n && e?.startDate,
      [ht.rootEndDateHasClearIcon]: n && e?.endDate,
      [ht.rootHasWrapperIcon]: !!r,
      [ht.rootReadOnly]: o
    });
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        "data-testid": wg,
        ref: this.rootRef,
        className: i,
        children: [
          this.renderInputLayout(),
          this.renderDropdown()
        ]
      }
    );
  }
}
class fk extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this);
  }
  handleChange(t) {
    const {
      input: { onChange: e }
    } = this.props;
    e?.({
      startDate: t?.startDate ? t.startDate.toISOString() : "",
      localStartDate: t?.localStartDate ? t.localStartDate.toISOString() : "",
      endDate: t?.endDate ? t.endDate.toISOString() : "",
      localEndDate: t?.localEndDate ? t.localEndDate.toISOString() : "",
      timezone: t?.timezone ?? "",
      localTimezone: t?.localTimezone ?? ""
    });
  }
  getDateRange({
    localStartDate: t,
    localEndDate: e
  }) {
    const n = ks(t) ? j(t, j.ISO_8601) : null, o = ks(e) ? j(e, j.ISO_8601) : null;
    return {
      startDate: n,
      endDate: o
    };
  }
  render() {
    const {
      className: t,
      input: { name: e, value: n, onChange: o, ...r },
      label: i,
      meta: l,
      required: c,
      disabled: d,
      description: h,
      helpIcon: u,
      noLabel: p,
      noAlert: m,
      ...g
    } = this.props, { timezone: b, localTimezone: x } = n;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: i,
        labelFor: nn.getInputName(e, "startDate"),
        meta: l,
        required: c,
        disabled: d,
        helpIcon: u,
        description: h,
        noLabel: p,
        noAlert: m,
        children: /* @__PURE__ */ s.jsx(
          nn,
          {
            name: e,
            value: this.getDateRange(n),
            timezone: b,
            localTimezone: x,
            onChange: this.handleChange,
            ...r,
            status: z.getStatus(l),
            disabled: d,
            required: c,
            ...g
          }
        )
      }
    );
  }
}
const vg = [
  "link",
  "bold",
  "italic",
  "unorderedList",
  "orderedList",
  "format"
], oe = /(Mac|iPhone|iPod|iPad)/i.test(
  navigator.userAgent
), On = (a) => ga(a), Ys = (a, t = window) => t.getComputedStyle(a).display === "block";
function ps(a, t) {
  const e = {
    ctrlKey: [
      "Control",
      ...oe ? ["$controlOrAlt"] : ["$metaOrCtrl"]
    ],
    shiftKey: ["Shift"],
    altKey: ["Alt", ...oe ? [] : ["$controlOrAlt"]],
    metaKey: ["Meta", "OS", ...oe ? ["$metaOrCtrl"] : []]
  };
  return a.some((n) => {
    if (t.code !== n[1])
      return !1;
    const o = n[0] ?? [];
    return Object.entries(e).every(
      ([r, i]) => {
        const l = fa(
          i,
          o
        ).length;
        return t[r] ? l > 0 : l === 0;
      }
    );
  });
}
const Sg = (a, t, e) => {
  if (!a || t < 0 || e < 0) return !1;
  const n = a?.textContent?.length ?? 0;
  return !(t > n || e > n);
}, Ig = (a, t) => a.document.queryCommandState(t), Dg = (a) => a.document.queryCommandValue("formatBlock"), kg = (a) => a.type.indexOf("image/") === 0, To = (a, t) => {
  const e = tn();
  return {
    src: (a.URL || a.webkitURL).createObjectURL(t),
    uid: e
  };
}, Tg = (a) => {
  a && a.querySelectorAll("td").forEach((t) => {
    t.style.border = "1px solid currentColor";
  });
}, js = (a) => {
  a.setAttribute("dir", "auto");
  const t = window.getComputedStyle(a).direction;
  a.setAttribute("dir", t);
}, jo = (a) => {
  a && a.childNodes.forEach((t) => {
    t.nodeType !== Node.ELEMENT_NODE && t.nodeType !== Node.TEXT_NODE || On(t) && Ys(t) && js(t);
  });
}, Qs = (a, t = !0) => {
  const e = document.createElement("div");
  return e.style.display = "none", e.innerHTML = a, document.body.appendChild(e), e.childNodes.forEach((n) => {
    if (!(n.nodeType !== Node.ELEMENT_NODE && n.nodeType !== Node.TEXT_NODE)) {
      if (On(n) && Ys(n))
        n.innerHTML = Qs(n.innerHTML, !1), js(n);
      else if (t) {
        const o = document.createElement("div");
        o.appendChild(n.cloneNode(!0)), n.replaceWith(o), js(o);
      }
    }
  }), document.body.removeChild(e), e.innerHTML;
}, No = (a, t = { side: "both" }) => {
  const { side: e } = t, n = a.split(""), o = " ", r = "&nbsp;";
  let i = 0, l = n.length - 1;
  if (e === "both" || e === "start")
    for (; n[i] === o; )
      n[i++] = r;
  if (e === "both" || e === "end")
    for (; n[l] === o; )
      n[l--] = r;
  return n.join("");
}, Hn = (a, t) => a.split(/\r\n|\r|\n/g).map((e, n) => e ? t.inline && n === 0 ? No(e, { side: "end" }) : `<div>${No(e)}</div>` : "<br />").join("");
function jg(a) {
  const t = "&nbsp;", e = " ", n = " ", o = Ng(a.anchorNode), r = Pg(a.anchorNode);
  if (a.anchorNode?.nodeType === Node.TEXT_NODE && o.endsWith(t)) {
    const { focusOffset: i, anchorOffset: l } = a, c = Array.prototype.indexOf.call(
      a.anchorNode.parentElement?.childNodes,
      a.anchorNode
    ), d = r.replaceAll(t, n).replace(/.$/, e), h = document.createTextNode(d);
    if (a.anchorNode.parentElement?.childNodes[c].replaceWith(h), a?.rangeCount && a?.rangeCount > 0 && Sg(h, i, l)) {
      const u = a.getRangeAt(0);
      u.setStart(h, i), u.setEnd(h, l);
    }
  }
}
function Ng(a) {
  if (!a)
    return "";
  if (a instanceof Element)
    return a.innerHTML;
  const t = document.createElement("span");
  return t.appendChild(a.cloneNode()), t.innerHTML;
}
function Pg(a) {
  return !a || !a.textContent ? "" : a.textContent;
}
const Fg = "h-inputRichText-addonTrigger--addonTrigger__root", Rg = {
  root: Fg
};
function Eg(a) {
  if (!a)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = a;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t) || null;
}
const _n = (a, t) => {
  const e = Fr(a, t);
  return e && a.triggers.isAddonTrigger(e.matchedTrigger) ? e.matchedTrigger : null;
}, Cn = (a, t) => {
  const e = Fr(a, t);
  return e ? e.match : null;
}, Fr = (a, t) => t ? a.triggers.test(t) : null, Po = "input-rich-text-addon-trigger", Lg = (a, t) => {
  const e = a.selection.recreate();
  if (!e || !t) return null;
  const n = e.getRangeAt(0).getBoundingClientRect();
  return a.ref.current && n && e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0).getBoundingClientRect() : null;
}, Ag = (a, t) => {
  if (a.ref.current && t) {
    const e = a.ref.current.getBoundingClientRect();
    return {
      left: `${t.x - e.x}px`,
      top: `${t.y - e.y}px`,
      height: "0",
      width: t.width,
      position: "absolute"
    };
  }
  return {};
}, zt = (a) => Eg(a.selection.recreate()) || "", ms = (a, t) => !!t && a.triggers.isAddonTrigger(t), gs = (a) => a?.nodeType === Node.ELEMENT_NODE, Ns = (a, t) => a.dataset.testid === t ? a : a.parentElement ? Ns(a.parentElement, t) : null, me = {};
class $g extends EventTarget {
  /**
   * A map of event listeners for each event type.
   *
   * Since it can be tricky to register/unregister event listeners as data
   * changes in the consumer, we store the event listeners in a map to be able
   * to clear them easily, in order to avoid memory leaks.
   */
  callbacks = {
    focus: [],
    insert: [],
    up: [],
    down: []
  };
  addEventListener(t, e, n) {
    super.addEventListener(t, e, n), e && this.callbacks[t].push(e);
  }
  /** Clear all event listeners for a given event type. */
  clearEventListeners(t) {
    this.callbacks[t].forEach((e) => {
      this.removeEventListener(t, e);
    }), this.callbacks[t] = [];
  }
}
const Ce = new $g(), Bg = Bt({
  matchText: "",
  insertContent: () => {
  },
  eventEmitter: Ce
});
var Og = /* @__PURE__ */ ((a) => (a.FOCUS = "focus", a.INSERT = "insert", a.UP = "up", a.DOWN = "down", a))(Og || {});
const Hg = (a) => {
  const { editor: t } = a, [e, n] = V(null), [o, r] = V(null), [i, l] = V(null), [c, d] = V(!1), h = Ag(t, i), [u] = V(tn()), { dismissText: p } = me[u] ?? { dismissText: "" }, m = e?.[0] ?? "", g = p && /**
  * Replaces trailing spaces with regular spaces. If a text was dismissed
  * with trailing space, editor uses non-breaking space (U+00A0) instead of
  * regular ` ` space, which results in isDismissed being `false` where it
  * should be `true`.
  */
  m?.replace(/\s+$/, " ").startsWith(p.replace(/\s+$/, " ")) || !1, b = P(() => {
    const S = _n(t, zt(t)), I = Cn(t, zt(t)), T = Lg(t, S);
    ms(t, S) && S?.shouldHandleSelectionChange?.() !== !1 ? (r(S), n(I), l(T)) : (r(null), n(null), l(null)), d(!0);
  }, [t]), x = P(() => {
    const S = _n(t, zt(t)), I = Cn(t, zt(t))?.[0];
    return ms(t, S) && !!I;
  }, [t]), w = P(() => {
    const S = _n(t, zt(t)), I = Cn(t, zt(t))?.[0], T = me[u]?.dismissText || "", R = T ? I?.startsWith(T) : !1;
    return ms(t, S) && !!I && !R;
  }, [t, u]), y = P(() => {
    t.hotkeys.add([
      {
        keybindings: [[[], "Tab"]],
        condition: w,
        callback: () => {
          Ce.dispatchEvent(new Event(
            "focus"
            /* FOCUS */
          ));
        }
      },
      {
        keybindings: [[[], "Enter"]],
        condition: w,
        callback: () => {
          Ce.dispatchEvent(new Event(
            "insert"
            /* INSERT */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowUp"]],
        condition: w,
        callback: () => {
          Ce.dispatchEvent(new Event(
            "up"
            /* UP */
          ));
        }
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: w,
        callback: () => {
          Ce.dispatchEvent(new Event(
            "down"
            /* DOWN */
          ));
        }
      },
      {
        keybindings: [[[], "Escape"]],
        condition: w,
        callback: (S, I) => {
          const T = Cn(t, zt(t))?.[0];
          if (!T) {
            me[u] = {
              dismissText: ""
            };
            return;
          }
          _n(t, zt(t))?.persistOnEsc === !1 && (I.stopPropagation(), r(null), n(null), l(null)), me[u] = {
            dismissText: (T.trim().length === 1 ? "" : T) ?? ""
          };
        }
      }
    ]);
  }, [t, w, u]);
  tt(() => {
    x() && p !== m && // If persistOnEsc is non-false - preserve existing behavior and reset trigger if the match text changes.
    (g && o?.persistOnEsc !== !1 || // If trigger has been dismissed with Esc and persistOnEsc is false
    // reset dismissText when text is being removed, but preserve dismissText when characters are only added.
    !g && o?.persistOnEsc === !1) && (me[u] = {
      dismissText: ""
    });
  }, [p, g, x, m, u, o]);
  const v = P((S) => {
    const I = S.nativeEvent.relatedTarget, T = gs(I) && Ns(I, $r), R = gs(I) && Ns(I, Po);
    (!gs(I) || !T && !R) && d(!1);
  }, []), _ = P(
    (S, { inline: I } = {}) => {
      const T = t.selection.recreate();
      if (!T || !o)
        return;
      const A = !!T.anchorNode?.textContent?.match(
        `^${o?.trigger.source}`
      ) && !I ? (
        // Adjust each lines direction if it's been added to a new line
        Qs(
          Hn(S, { inline: !1 })
        )
      ) : (
        // Or concatenate to the end of the current line without changing direction
        Hn(S, { inline: !0 })
      );
      T?.rangeCount && T?.rangeCount > 0 && t.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        T.getRangeAt(0).createContextualFragment(A),
        {
          getSelection: () => {
            const k = t.selection.recreate();
            if (!k)
              return null;
            const { focusOffset: F } = k, at = o.trigger.exec(m)?.[1]?.length ?? 0, nt = m.length - at;
            return k?.anchorNode && k.extend(
              k.anchorNode,
              F - nt
            ), k;
          }
        }
      );
    },
    [t, m, o]
  );
  if (Te(() => {
    y(), t.selection.onUpdate(b), t.events.onBlur(v);
  }), Qt(() => {
    delete me[u];
  }), !o || !c || !m || g)
    return null;
  const C = o.customContainer?.current || window.document.body;
  return /* @__PURE__ */ s.jsx("div", { style: h, children: /* @__PURE__ */ s.jsxs(ba, { open: !0, children: [
    /* @__PURE__ */ s.jsx(xa, {}),
    /* @__PURE__ */ s.jsx(ya, { container: C, children: /* @__PURE__ */ s.jsx(
      _a,
      {
        onOpenAutoFocus: (S) => S.preventDefault(),
        "data-testid": Po,
        className: Rg.root,
        side: o.popoverContent?.side ?? "top",
        align: o.popoverContent?.align ?? void 0,
        children: /* @__PURE__ */ s.jsx(
          Bg.Provider,
          {
            value: { matchText: m, insertContent: _, eventEmitter: Ce },
            children: o.component
          }
        )
      }
    ) })
  ] }) });
}, Wg = "h-inputRichText-toolbarButton--toolbarButton__root", Mg = "h-inputRichText-toolbarButton--toolbarButton__rootDisabled", zg = "h-inputRichText-toolbarButton--toolbarButton__rootActive", Vg = "h-inputRichText-toolbarButton--toolbarButton__rootWithBadge", Kg = "h-inputRichText-toolbarButton--toolbarButton__rootWithText", ge = {
  root: Wg,
  rootDisabled: Mg,
  rootActive: zg,
  rootWithBadge: Vg,
  rootWithText: Kg
};
function Nt({
  className: a,
  isActive: t,
  icon: e,
  disabled: n,
  showBadge: o,
  text: r,
  ...i
}) {
  const l = f(
    {
      [ge.root]: ge.root,
      [ge.rootActive]: t,
      [ge.rootDisabled]: n,
      [ge.rootWithBadge]: o,
      [ge.rootWithText]: r
    },
    a
  );
  return /* @__PURE__ */ s.jsx(
    "button",
    {
      tabIndex: -1,
      type: "button",
      ...i,
      className: l,
      disabled: n,
      children: /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(N, { name: e }) }),
        r && /* @__PURE__ */ s.jsx("span", { children: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "3", wrap: "nowrap", color: "inherit", children: r }) })
      ] })
    }
  );
}
const Ug = "h-inputRichText-attachmentButton--attachmentButton__dropzone", qg = "h-inputRichText-attachmentButton--attachmentButton__fileInput", Gg = "h-inputRichText-attachmentButton--attachmentButton__dropdown", Yg = "h-inputRichText-attachmentButton--attachmentButton__dropzoneIcon", wn = {
  dropzone: Ug,
  fileInput: qg,
  dropdown: Gg,
  dropzoneIcon: Yg
};
let Qg = class extends D {
  static displayName = "AttachmentButtonDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowAttachments: e } = this.props;
    e && this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && e(t.dataTransfer.files), this.setState({
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      isAttachmentsUploading: n,
      allowAttachments: o,
      allowInline: r,
      onAddAttachment: i,
      ...l
    } = this.props, { fileHover: c } = this.state, d = f(t), h = c || n;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...l,
        className: d,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragEnter,
        onDragLeave: this.handleDragLeave,
        onDrop: this.handleAttachmentDrop,
        children: [
          e,
          h && /* @__PURE__ */ s.jsx(Yt, { children: n ? "Uploading..." : "Drop to add an attachment" }),
          !h && "Drop the file or click to upload"
        ]
      }
    );
  }
};
const Xg = [
  {
    name: "addAttachment",
    label: "Add attachment",
    keybindings: [[["$metaOrCtrl"], "KeyU"]]
  }
];
class Zg extends D {
  unsubscribeAddAttachment;
  fileInputRef;
  constructor(t) {
    super(t), this.fileInputRef = B(), this.unsubscribeAddAttachment = Fa;
  }
  componentDidMount() {
    this.unsubscribeAddAttachment = this.props.editor.events.subscribe(
      "addAttachment",
      () => {
        this.fileInputRef.current?.click();
      }
    );
  }
  componentWillUnmount() {
    this.unsubscribeAddAttachment?.();
  }
  openFileBrowser = (t) => {
    t.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  handleFileChanged = (t) => {
    const { onAttachFiles: e, editorWindow: n } = this.props, o = t.target;
    o !== null && o instanceof n.HTMLInputElement && (e(o.files), o.value = "");
  };
  renderDropdown() {
    const { isAttachmentsUploading: t, attachments: e, onAttachFiles: n, children: o } = this.props;
    return /* @__PURE__ */ s.jsxs("div", { className: wn.dropdown, children: [
      /* @__PURE__ */ s.jsx(
        Qg,
        {
          className: wn.dropzone,
          onAddAttachment: n,
          attachments: e,
          isAttachmentsUploading: t,
          allowInline: !1,
          onClick: this.openFileBrowser,
          allowAttachments: !0,
          children: /* @__PURE__ */ s.jsx(N, { name: "paperclip", className: wn.dropzoneIcon })
        }
      ),
      o
    ] });
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  render() {
    const {
      className: t,
      attachments: e,
      onAttachFiles: n,
      onDetachFile: o,
      isAttachmentsUploading: r,
      dropdownRef: i,
      editorWindow: l,
      ...c
    } = this.props;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ref: this.fileInputRef,
          type: "file",
          className: wn.fileInput,
          onChange: this.handleFileChanged,
          multiple: !0
        }
      ),
      /* @__PURE__ */ s.jsx(
        re,
        {
          ...c,
          className: t,
          noStyle: !0,
          ref: i,
          dropdown: this.renderDropdown(),
          children: /* @__PURE__ */ s.jsx(
            Nt,
            {
              onMouseDown: this.preventDefault,
              icon: "paperclip",
              showBadge: e.length > 0
            }
          )
        }
      )
    ] });
  }
}
const Jg = "h-inputRichText-dropzone--dropzone__root", tf = "h-inputRichText-dropzone--dropzone__inlineDropzone", ef = "h-inputRichText-dropzone--dropzone__attachmentDropzone", nf = "h-inputRichText-dropzone--dropzone__rootDual", sf = "h-inputRichText-dropzone--dropzone__icon", fe = {
  root: Jg,
  inlineDropzone: tf,
  attachmentDropzone: ef,
  rootDual: nf,
  icon: sf
};
class of extends D {
  static displayName = "InputRichTextDropzone";
  constructor(t) {
    super(t), this.state = {
      fileHover: !1,
      overDropzone: !1
    };
  }
  handleDragEnter = (t) => {
    t.preventDefault();
    const { allowInlineAttachments: e, allowAttachments: n } = this.props;
    !e && !n || this.setState({
      fileHover: !0
    });
  };
  handleDragLeave = (t) => {
    t.preventDefault(), this.setState({
      fileHover: !1
    });
  };
  handleEnterDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !0
    });
  };
  handleLeaveDropzone = (t) => {
    t.preventDefault(), this.setState({
      overDropzone: !1
    });
  };
  handleInlineDrop = (t) => {
    t.preventDefault();
    const { onAddInline: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  handleAttachmentDrop = (t) => {
    t.preventDefault();
    const { onAddAttachment: e } = this.props;
    t.dataTransfer && typeof e == "function" && e(t.dataTransfer.files), this.setState({
      overDropzone: !1,
      fileHover: !1
    });
  };
  render() {
    const {
      className: t,
      children: e,
      allowInlineAttachments: n,
      allowAttachments: o,
      onAddInline: r,
      onMouseDown: i,
      attachments: l,
      onAddAttachment: c,
      ...d
    } = this.props, { fileHover: h, overDropzone: u } = this.state, p = f(
      {
        [fe.root]: !0,
        [fe.rootDual]: n && o
      },
      t
    ), m = n || o, g = {};
    return i && (g.onClick = i), m && (g.onDragEnter = this.handleDragEnter, g.onDragOver = this.handleDragEnter, g.onDragLeave = this.handleDragLeave), /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...d,
        tabIndex: -1,
        className: p,
        ...g,
        children: [
          e,
          (h || u) && /* @__PURE__ */ s.jsxs(Yt, { children: [
            n && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleInlineDrop,
                className: fe.inlineDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "upload", size: 24, className: fe.icon }),
                  "Drop to add inline"
                ]
              }
            ),
            o && /* @__PURE__ */ s.jsxs(
              "div",
              {
                onDragEnter: this.handleEnterDropzone,
                onDragLeave: this.handleLeaveDropzone,
                onDrop: this.handleAttachmentDrop,
                className: fe.attachmentDropzone,
                children: [
                  /* @__PURE__ */ s.jsx(N, { name: "paperclip", size: 24, className: fe.icon }),
                  "Drop to add an attachment"
                ]
              }
            )
          ] })
        ]
      }
    );
  }
}
const Rr = (a, t) => a.split(new RegExp(`(${$s(t)})`, "gi")).map(
  (e, n) => e.toLowerCase() === t.toLowerCase() ? /* @__PURE__ */ s.jsx("span", { children: e }, n) : e
), rf = "h-inputRichText-emoji--emoji__root", af = "h-inputRichText-emoji--emoji__decorator", lf = "h-inputRichText-emoji--emoji__suggestion", cf = "h-inputRichText-emoji--emoji__suggestionActive", df = "h-inputRichText-emoji--emoji__suggestionName", Xe = {
  root: rf,
  decorator: af,
  suggestion: lf,
  suggestionActive: cf,
  suggestionName: df
}, hf = Sa(
  () => import("./emoji-D9B2480I.js").then((a) => a.g).then((a) => ({
    default: a.EmojiPicker
  }))
), Wn = {};
Ta.emojis.forEach((a) => {
  a.forEach(
    (t) => {
      t.shortNames && t.shortNames.forEach((e) => {
        Wn[e.replace(/:/g, "")] = t.emoji;
      });
    }
  );
});
const uf = (a) => {
  const { active: t, item: e, match: n, onSelect: o } = a, r = n ? Rr(e, n) : e;
  return /* @__PURE__ */ s.jsxs(
    "button",
    {
      onClick: () => o(e),
      type: "button",
      "aria-current": t,
      className: f(Xe.suggestion, {
        [Xe.suggestionActive]: t
      }),
      children: [
        Wn[e],
        /* @__PURE__ */ s.jsx("span", { className: Xe.suggestionName, children: r })
      ]
    }
  );
};
class pf extends D {
  constructor(t) {
    super(t), this.insertEmoji = this.insertEmoji.bind(this), this.insertContent = this.insertContent.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: /(^|\s):/,
      minChars: 2,
      allowSpaces: !1,
      getSuggestions: this.getSuggestions,
      suggestionComponent: uf,
      insertContent: this.insertContent
    });
  }
  insertContent(t, e = "", n) {
    this.insertEmoji(Wn[t], e, n);
  }
  insertEmoji(t, e, n) {
    const { editor: o } = this.props, r = document.createElement("span");
    r.classList.add(Xe.decorator), r.innerHTML = t, o.content.insert(r, {
      getSelection: () => {
        const i = o.selection.recreate();
        return e && i?.anchorNode && i.extend(i.anchorNode, n), i;
      }
    });
  }
  getSuggestions = (t) => Object.keys(Wn).filter((n) => n.indexOf(t) !== -1);
  // eslint-disable-next-line no-undef
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown = () => /* @__PURE__ */ s.jsx(Ia, { fallback: /* @__PURE__ */ s.jsx("div", { children: "Loading..." }), children: /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ toggleDropdown: t }) => /* @__PURE__ */ s.jsx(
    hf,
    {
      onSelect: (e) => {
        this.insertEmoji(e), t();
      }
    }
  ) }) });
  render() {
    const { className: t } = this.props, e = f(
      {
        [Xe.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { className: e, children: /* @__PURE__ */ s.jsx(re, { icon: "smile", dropdown: this.renderDropdown(), noStyle: !0, children: /* @__PURE__ */ s.jsx(
      Nt,
      {
        icon: "smile",
        title: "Emojis",
        onMouseDown: this.preventDefault
      }
    ) }) });
  }
}
const mf = "h-inputRichText--inputRichText__inputWrapper", gf = "h-inputRichText--inputRichText__root", ff = "h-inputRichText--inputRichText__toolbar", bf = "h-inputRichText--inputRichText__toolbarHint", xf = "h-inputRichText--inputRichText__toolbarHintVisible", yf = "h-inputRichText--inputRichText__toolbarHintHidden", _f = "h-inputRichText--inputRichText__editorWrap", Cf = "h-inputRichText--inputRichText__placeholder", wf = "h-inputRichText--inputRichText__editor", vf = "h-inputRichText--inputRichText__fileInput", Sf = "h-inputRichText--inputRichText__uiBlocker", xt = {
  inputWrapper: mf,
  root: gf,
  toolbar: ff,
  toolbarHint: bf,
  toolbarHintVisible: xf,
  toolbarHintHidden: yf,
  editorWrap: _f,
  placeholder: Cf,
  editor: wf,
  fileInput: vf,
  uiBlocker: Sf
}, If = "h-inputRichText-linkButton--linkButton__linkOpener", Df = "h-inputRichText-linkButton--linkButton__dropdownContainer", Fo = {
  linkOpener: If,
  dropdownContainer: Df
}, kf = "h-inputRichText-linkButton--linkMenu__root", Tf = "h-inputRichText-linkButton--linkMenu__field", fs = {
  root: kf,
  field: Tf
};
class jf extends D {
  constructor(t) {
    super(t);
    const { initialText: e, initialUrl: n } = t;
    this.state = {
      textValue: e,
      urlValue: n
    };
  }
  componentDidUpdate(t) {
    const { initialText: e, initialUrl: n } = this.props;
    (e !== t.initialText || n !== t.initialUrl) && this.setState({
      textValue: e,
      urlValue: n
    });
  }
  handleTextChange = (t) => {
    t && this.setState({
      textValue: t.target.value
    });
  };
  handleUrlChange = (t) => {
    t && this.setState({
      urlValue: t.target.value
    });
  };
  handleAddLink = (t) => {
    t?.preventDefault();
    const { onAddLink: e, toggleDropdown: n } = this.props, { textValue: o, urlValue: r } = this.state;
    o && r && (e(o, r), n());
  };
  handleUnlink = (t) => {
    t.preventDefault();
    const { onUnlink: e, toggleDropdown: n } = this.props;
    e(), n();
  };
  handleKeyDown = (t) => {
    t.key === "Enter" && (t.preventDefault(), this.handleAddLink());
  };
  render() {
    const {
      className: t,
      initialText: e,
      initialUrl: n,
      onAddLink: o,
      toggleDropdown: r,
      onUnlink: i,
      ...l
    } = this.props, { textValue: c, urlValue: d } = this.state, h = f({ [fs.root]: !0 }, t);
    return /* @__PURE__ */ s.jsxs("div", { ...l, className: h, children: [
      /* @__PURE__ */ s.jsx(
        Ts,
        {
          label: "Link title",
          noAlert: !0,
          className: fs.field,
          input: {
            value: c,
            name: "pleasedontautofillthis",
            onChange: this.handleTextChange
          },
          onKeyDown: this.handleKeyDown
        }
      ),
      /* @__PURE__ */ s.jsx(
        Ts,
        {
          label: "Link URL",
          noAlert: !0,
          className: fs.field,
          input: {
            value: d,
            name: "link_url",
            onChange: this.handleUrlChange
          },
          onKeyDown: this.handleKeyDown,
          autoFocus: !0
        }
      ),
      /* @__PURE__ */ s.jsxs(O, { gap: "200", children: [
        /* @__PURE__ */ s.jsx(Q, { variant: "primary", onClick: this.handleAddLink, children: "Add" }),
        !!d && /* @__PURE__ */ s.jsx(Q, { variant: "secondary", onClick: this.handleUnlink, children: "Remove link" })
      ] })
    ] });
  }
}
const Nf = [
  {
    name: "hyperlink",
    label: "Link: insert",
    keybindings: oe ? [[["Control", "Meta"], "KeyK"]] : [[["Control", "Alt"], "KeyK"]]
  },
  {
    name: "removeHyperlink",
    label: "Link: remove",
    keybindings: [],
    callback: (a) => a.command.run("unlink")
  }
], Pf = ({ editor: a }) => {
  const [t, e] = Da((y) => y + 1, 0), [n, o] = ja(!1), r = Y(null), i = Y(), [
    { hoverLinkBounds: l, hoverLinkHref: c, selectedLink: d, selectedText: h },
    u
  ] = Na({
    selectedLink: "",
    selectedText: "",
    hoverLinkHref: null,
    hoverLinkBounds: null
  });
  Te(() => {
    a.events.onMouseOver((y) => {
      m(y);
    }), i.current = a.events.subscribe("hyperlink", () => {
      o(!0);
    }), a.selection.onUpdate(() => {
      p();
    });
  }), Qt(() => {
    i.current?.();
  });
  const p = () => {
    const y = a.selection.recreate();
    if (!y)
      return;
    const { anchorNode: v, focusNode: _ } = y;
    if (v && _ === v && v.parentElement?.nodeName === "A") {
      const { href: C, innerText: S } = v.parentElement;
      u({
        selectedLink: C,
        selectedText: S
      });
    } else
      u({
        selectedLink: "",
        selectedText: y.toString()
      });
  }, m = P(
    (y) => {
      const { target: v } = y, { current: _ } = a.ref;
      if (_ && v && v instanceof HTMLAnchorElement) {
        const C = _.getBoundingClientRect(), S = v.getBoundingClientRect();
        u({
          hoverLinkHref: v.getAttribute("href"),
          hoverLinkBounds: {
            top: S.top - C.top,
            left: S.left - C.left,
            width: S.width
          }
        });
      } else
        u({
          hoverLinkHref: null,
          hoverLinkBounds: null
        });
    },
    [a.ref, u]
  ), g = P(() => {
    const y = a.selection.recreate();
    if (!y)
      return;
    const { anchorNode: v, focusNode: _ } = y;
    if (v && v === _ && v.parentElement?.nodeName === "A") {
      const C = document.createRange();
      C.selectNodeContents(v.parentElement), y.removeAllRanges(), y.addRange(C);
    }
  }, [a.selection]), b = P(
    (y, v) => {
      v && (g(), a.command.run("insertHTML", `<a href="${v}">${y || v}</a>`), e());
    },
    [a.command, g]
  ), x = P(() => {
    g(), a.command.run("unlink");
  }, [a.command, g]), w = P((y) => {
    y.preventDefault();
  }, []);
  return pr(r, () => {
    o(!1);
  }), ur("Escape", () => {
    o(!1), g();
  }), /* @__PURE__ */ s.jsxs(Yt, { children: [
    /* @__PURE__ */ s.jsxs("div", { ref: r, className: Fo.dropdownContainer, children: [
      /* @__PURE__ */ s.jsx(
        Nt,
        {
          isActive: !!d,
          icon: "link",
          onMouseDown: w,
          onClick: () => o()
        }
      ),
      n && /* @__PURE__ */ s.jsx(Xt, { isOpen: n, children: /* @__PURE__ */ s.jsx(
        jf,
        {
          onAddLink: b,
          toggleDropdown: o,
          initialUrl: d,
          initialText: h,
          onUnlink: x
        }
      ) })
    ] }),
    !!l && !!c && /* @__PURE__ */ s.jsx(
      "a",
      {
        className: Fo.linkOpener,
        href: c,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          top: `${l.top}px`,
          left: `${l.left + l.width}px`
        },
        children: /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "external-link" })
      }
    )
  ] });
}, Ff = "h-tabs--tabs__root", Rf = "h-tabs--tabs__tabs", Ef = "h-tabs--tabs__tab", Lf = "h-tabs--tabs__tabTop", Af = "h-tabs--tabs__tabTopActive", $f = "h-tabs--tabs__tabTopSelected", Bf = "h-tabs--tabs__tabLeft", Of = "h-tabs--tabs__tabLeftActive", Hf = "h-tabs--tabs__tabLeftSelected", Wf = "h-tabs--tabs__tabBottom", Mf = "h-tabs--tabs__tabBottomActive", zf = "h-tabs--tabs__tabBottomSelected", Vf = "h-tabs--tabs__tabRight", Kf = "h-tabs--tabs__tabRightActive", Uf = "h-tabs--tabs__tabRightSelected", qf = "h-tabs--tabs__tabDisabled", ot = {
  root: Ff,
  tabs: Rf,
  tab: Ef,
  tabTop: Lf,
  tabTopActive: Af,
  tabTopSelected: $f,
  tabLeft: Bf,
  tabLeftActive: Of,
  tabLeftSelected: Hf,
  tabBottom: Wf,
  tabBottomActive: Mf,
  tabBottomSelected: zf,
  tabRight: Vf,
  tabRightActive: Kf,
  tabRightSelected: Uf,
  tabDisabled: qf
}, Gf = 13;
class Yf extends D {
  constructor(t) {
    super(t), this.handleOnClick = this.handleOnClick.bind(this), this.handleOnKeyDown = this.handleOnKeyDown.bind(this);
  }
  handleOnClick() {
    const { id: t, onChange: e, disabled: n } = this.props;
    n || e(t);
  }
  handleOnKeyDown(t) {
    t.keyCode === Gf && this.handleOnClick();
  }
  getClassName() {
    const {
      selected: t,
      placement: e,
      className: n,
      disabled: o,
      active: r,
      selectedClassName: i
    } = this.props;
    let l = f(ot.tab, n, {
      [ot.tabDisabled]: o,
      [ot.tabTop]: e === "top",
      [ot.tabRight]: e === "right",
      [ot.tabLeft]: e === "left",
      [ot.tabBottom]: e === "bottom",
      [ot.tabTopSelected]: e === "top" && t,
      [ot.tabRightSelected]: e === "right" && t,
      [ot.tabLeftSelected]: e === "left" && t,
      [ot.tabBottomSelected]: e === "bottom" && t,
      [ot.tabTopActive]: e === "top" && r,
      [ot.tabRightActive]: e === "right" && r,
      [ot.tabLeftActive]: e === "left" && r,
      [ot.tabBottomActive]: e === "bottom" && r
    });
    return i && (l = f(l, { [i]: t })), l;
  }
  render() {
    const { id: t, label: e, icon: n, disabled: o, slotEnd: r, slotStart: i } = this.props;
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        role: "tab",
        className: this.getClassName(),
        onClick: this.handleOnClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: o ? -1 : 0,
        children: [
          i || !!n && /* @__PURE__ */ s.jsx(N, { name: n, className: "icon-vertical-fix" }),
          e,
          r
        ]
      },
      t
    );
  }
}
class Xs extends D {
  containerRef;
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.containerRef = B(), this.renderTab = this.renderTab.bind(this), this.renderTabs = this.renderTabs.bind(this);
  }
  renderTab({
    id: t,
    label: e,
    icon: n,
    disabled: o,
    slotEnd: r,
    slotStart: i
  }) {
    const {
      selectedId: l,
      activeId: c,
      onChange: d,
      tabsPlacement: h,
      tabClassName: u,
      tabSelectedClassName: p
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      Yf,
      {
        selected: t === l,
        className: u,
        selectedClassName: p,
        id: t,
        label: e,
        icon: n,
        onChange: d,
        placement: h,
        disabled: o,
        active: t === c,
        slotEnd: r,
        slotStart: i
      },
      t
    );
  }
  renderTabs() {
    const { tabs: t } = this.props;
    return t.map(this.renderTab);
  }
  render() {
    const {
      className: t,
      tabClassName: e,
      tabSelectedClassName: n,
      tabs: o,
      selectedId: r,
      onChange: i,
      tabsPlacement: l,
      activeId: c,
      ...d
    } = this.props, h = f(ot.root, t);
    return /* @__PURE__ */ s.jsx("div", { ref: this.containerRef, ...d, className: h, children: /* @__PURE__ */ s.jsx("div", { className: ot.tabs, children: this.renderTabs() }) });
  }
}
const Qf = on(Xs, {
  fallback: null
}), Xf = "h-inputRichText-quickResponseSelector--quickResponseItem__root", Zf = "h-inputRichText-quickResponseSelector--quickResponseItem__rootActive", Jf = "h-inputRichText-quickResponseSelector--quickResponseItem__name", Me = {
  root: Xf,
  rootActive: Zf,
  name: Jf
};
class bs extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this);
  }
  handleSelect() {
    const { isLoading: t, onSelect: e, item: n } = this.props;
    t || e(n);
  }
  render() {
    const {
      className: t,
      item: e,
      isLoading: n,
      onSelect: o,
      active: r,
      searchValue: i,
      clearSearch: l,
      ...c
    } = this.props, { name: d, content: h, matched: u } = !n && e ? e : {
      name: "Loading...",
      content: "",
      matched: ""
    }, p = f(
      {
        [Me.root]: Me.root,
        [Me.rootActive]: r
      },
      t
    ), m = u ? Rr(d, u) : d;
    return /* @__PURE__ */ s.jsxs(
      "button",
      {
        type: "button",
        "aria-current": r,
        ...c,
        className: p,
        onClick: this.handleSelect,
        title: d,
        children: [
          /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-3", className: Me.name, children: m }),
          /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "4", className: Me.name, subdued: !0, children: h })
        ]
      }
    );
  }
}
const tb = "h-inputRichText-quickResponseSelector--quickResponseSelector__container", eb = "h-inputRichText-quickResponseSelector--quickResponseSelector__dropdownButtonContainer", nb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdown", sb = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabs", ob = "h-inputRichText-quickResponseSelector--quickResponseSelector__tabbedDropdownTabsContent", rb = "h-inputRichText-quickResponseSelector--quickResponseSelector__regularDropdown", be = {
  container: tb,
  dropdownButtonContainer: eb,
  tabbedDropdown: nb,
  tabbedDropdownTabs: sb,
  tabbedDropdownTabsContent: ob,
  regularDropdown: rb
}, Ro = /(^|\s)=/, Eo = "Quick responses";
class ab extends _t {
  constructor(t) {
    super(t), this.state = {
      searchTerm: "",
      selectedTab: t.languages[0]?.code
    }, this.handleToggle = this.handleToggle.bind(this), this.handleNextPage = this.handleNextPage.bind(this), this.getPagination = this.getPagination.bind(this), this.normalizeSuggestion = this.normalizeSuggestion.bind(this), this.handleSearchChange = this.handleSearchChange.bind(this), this.handleTabChange = this.handleTabChange.bind(this), this.handleTabbedSearchChange = this.handleTabbedSearchChange.bind(this), this.getTabDefinitions = this.getTabDefinitions.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.triggers.add({
      trigger: Ro,
      minChars: 0,
      allowSpaces: !0,
      getSuggestions: this.handleSearchChange,
      suggestionComponent: bs,
      getPagination: this.getPagination,
      getTabs: this.getTabDefinitions,
      insertContent: this.insertContent
    });
  }
  normalizeSuggestion(t) {
    const { quickResponsesApi: e } = this.props;
    return {
      id: t.name,
      matched: e.params.search ?? "",
      ...t
    };
  }
  getTabDefinitions() {
    const { languages: t } = this.props;
    return t.map((e) => ({
      id: e.code,
      label: e.label
    }));
  }
  handleNextPage() {
    const { quickResponsesApi: t } = this.props;
    return new Promise((e) => t.getItemsAsyncStatus === "loading" ? e(t.items.map(this.normalizeSuggestion)) : e(
      t.nextPage().then((n) => n.map(this.normalizeSuggestion)).catch((n) => {
        console.error(n);
      })
    ));
  }
  preventDefault = (t) => {
    t.preventDefault();
  };
  handleSelect = (t, e) => {
    this.insertContent(t)?.then(() => {
      e && e();
    });
  };
  insertContent = (t, e, n) => {
    const { renderQuickResponse: o, sanitize: r, editor: i } = this.props;
    return o(t).then((l) => {
      const c = i.selection.recreate();
      if (!c)
        return;
      const d = !!e, h = d && !!c.anchorNode?.textContent?.match(
        `^${Ro.source}`
      ) || !d && !c.anchorNode?.textContent;
      let u;
      h ? u = Qs(
        Hn(r(l), { inline: !1 })
      ) : u = Hn(r(l), { inline: !0 }), c?.rangeCount && c?.rangeCount > 0 && i.content.insert(
        // template is sanitized
        // eslint-disable-next-line no-unsanitized/method
        c.getRangeAt(0).createContextualFragment(u),
        {
          getSelection: () => {
            const p = i.selection.recreate();
            return d && p?.anchorNode && p.extend(p.anchorNode, n), p;
          }
        }
      );
    });
  };
  handleToggle(t) {
    const { quickResponsesApi: e, languages: n } = this.props;
    t && (e.params.search !== "" || e.params.locale !== n[0]?.code) && this.setState({ searchTerm: "", selectedTab: n[0]?.code }, () => {
      const { searchTerm: o, selectedTab: r } = this.state;
      this.handleSearchChange(o, r, 0);
    });
  }
  getPagination() {
    const { quickResponsesApi: t } = this.props;
    return {
      nextEnable: t.hasNextPage,
      previousEnable: !1,
      infinite: !0,
      onNext: this.handleNextPage
    };
  }
  handleSearchChange(t, e, n) {
    const { quickResponsesApi: o } = this.props;
    return o.paramsChange({ search: t, locale: e }, n).then((r) => r.map(this.normalizeSuggestion));
  }
  handleTabbedSearchChange(t) {
    this.setState({ searchTerm: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n);
    });
  }
  handleTabChange(t) {
    this.setState({ selectedTab: t }, () => {
      const { searchTerm: e, selectedTab: n } = this.state;
      this.handleSearchChange(e, n, 0);
    });
  }
  renderIcon() {
    return /* @__PURE__ */ s.jsx(
      Nt,
      {
        icon: this.props.iconName ?? "bolt",
        title: Eo,
        onMouseDown: this.preventDefault
      }
    );
  }
  renderItemsWithoutTabs() {
    const { className: t, quickResponsesApi: e } = this.props;
    return /* @__PURE__ */ s.jsx(
      Gs,
      {
        className: t,
        dropdownProps: {
          className: be.regularDropdown
        },
        containerProps: { className: be.container },
        items: e.items.map(this.normalizeSuggestion),
        pagination: this.getPagination(),
        itemComponent: bs,
        hasSearch: !0,
        noStyle: !0,
        onSearch: this.handleSearchChange,
        onSelect: this.handleSelect,
        onToggle: this.handleToggle,
        emptyMessage: e.getItemsAsyncStatus === "loading" ? "Loading..." : void 0,
        children: this.renderIcon()
      }
    );
  }
  renderItemsWithTabs() {
    const { className: t } = this.props, { selectedTab: e } = this.state;
    return /* @__PURE__ */ s.jsx("div", { className: be.dropdownButtonContainer, children: /* @__PURE__ */ s.jsx(
      re,
      {
        className: t,
        noStyle: !0,
        onToggle: this.handleToggle,
        buttonProps: { title: Eo },
        dropdown: /* @__PURE__ */ s.jsxs("div", { className: be.tabbedDropdown, children: [
          /* @__PURE__ */ s.jsx(
            Xs,
            {
              className: be.tabbedDropdownTabs,
              tabs: this.getTabDefinitions(),
              tabsPlacement: "left",
              selectedId: e,
              onChange: this.handleTabChange
            }
          ),
          /* @__PURE__ */ s.jsx("div", { className: be.tabbedDropdownTabsContent, children: this.renderTabItems() })
        ] }),
        children: this.renderIcon()
      }
    ) });
  }
  renderTabItems() {
    const { quickResponsesApi: t } = this.props;
    return /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ dropdownOpen: e, closeDropdown: n }) => /* @__PURE__ */ s.jsx(
      Pr,
      {
        dropdownOpen: e,
        triggerClose: n,
        hasSearch: !0,
        pagination: this.getPagination(),
        items: t.items.map(this.normalizeSuggestion),
        itemComponent: bs,
        onSearch: this.handleTabbedSearchChange,
        onSelect: (o) => this.handleSelect(o, n),
        emptyComponent: cn,
        emptyMessage: t.getItemsAsyncStatus === "loading" ? "Loading..." : "No items found."
      }
    ) });
  }
  render() {
    const { languages: t } = this.props;
    return t?.length ? this.renderItemsWithTabs() : this.renderItemsWithoutTabs();
  }
}
const ib = "h-inputRichText-formatSelector--formatSelector__root", lb = "h-inputRichText-formatSelector--formatSelector__list", cb = "h-inputRichText-formatSelector--formatSelector__selector", db = "h-inputRichText-formatSelector--formatSelector__option", hb = "h-inputRichText-formatSelector--formatSelector__optionActive", ub = "h-inputRichText-formatSelector--formatSelector__button", xe = {
  root: ib,
  list: lb,
  selector: cb,
  option: db,
  optionActive: hb,
  button: ub
}, Ps = [
  {
    name: "noHeading",
    label: "Normal",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "div"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h1",
    label: "Headline 1",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H1>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h2",
    label: "Headline 2",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H2>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h3",
    label: "Headline 3",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H3>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h4",
    label: "Headline 4",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H4>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "h5",
    label: "Headline 5",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<H5>"),
    condition: (a) => a.allowFormatting.includes("format")
  },
  {
    name: "quote",
    label: "Blockquote",
    keybindings: [],
    callback: (a) => a.command.run("formatBlock", "<BLOCKQUOTE>"),
    condition: (a) => a.allowFormatting.includes("format")
  }
], Lo = {
  h1: { tag: "<H1>" },
  h2: { tag: "<H2>" },
  h3: { tag: "<H3>" },
  h4: { tag: "<H4>" },
  h5: { tag: "<H5>" },
  noHeading: { default: !0, tag: "div" },
  quote: { tag: "<BLOCKQUOTE>" }
};
class pb extends D {
  preventDefault = (t) => {
    t.preventDefault();
  };
  renderDropdown() {
    const { editor: t } = this.props;
    return /* @__PURE__ */ s.jsx(ln.Consumer, { children: ({ closeDropdown: e }) => /* @__PURE__ */ s.jsx("ul", { className: xe.list, children: Ps.map((n) => {
      const o = "condition" in n;
      if (!(!o || o && n.condition(t)))
        return;
      const i = Lo[n.name];
      return /* @__PURE__ */ s.jsx(
        "li",
        {
          className: f(xe.option, {
            [xe.optionActive]: this.isActiveFormat(i)
          }),
          children: /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              className: xe.button,
              onClick: () => {
                n.callback?.(t), e();
              },
              children: n.label
            }
          )
        },
        n.name
      );
    }).filter(Boolean) }) });
  }
  isActiveFormat(t) {
    const { formatBlock: e } = this.props;
    return !!(!e && t.default || t.tag === e || t.tag === `<${e.toUpperCase()}>`);
  }
  getCurrentFormatName() {
    return Ps.find(
      (t) => this.isActiveFormat(Lo[t.name])
    )?.label ?? "Normal";
  }
  render() {
    const { className: t, editor: e, formatBlock: n, ...o } = this.props, r = f(xe.root, t);
    return /* @__PURE__ */ s.jsx(
      re,
      {
        className: r,
        ...o,
        dropdown: this.renderDropdown(),
        noStyle: !0,
        children: /* @__PURE__ */ s.jsxs("div", { className: xe.selector, children: [
          this.getCurrentFormatName(),
          /* @__PURE__ */ s.jsx(N, { className: "icon-vertical-fix", name: "angle-down" })
        ] })
      }
    );
  }
}
const mb = "h-inputRichText-stylingMenu--stylingMenu__menu", gb = "h-inputRichText-stylingMenu--stylingMenu__buttonsContainer", Ao = {
  menu: mb,
  buttonsContainer: gb
}, Er = [
  {
    name: "bold",
    label: "Bold",
    icon: "bold",
    keybindings: [[["$metaOrCtrl"], "KeyB"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyB"]],
    callback: (a) => a.command.run("bold"),
    condition: (a) => a.allowFormatting.includes("bold")
  },
  {
    name: "italic",
    label: "Italic",
    icon: "italic",
    keybindings: [[["$metaOrCtrl"], "KeyI"]],
    preventDefaultKeybinding: [[["$metaOrCtrl"], "KeyI"]],
    callback: (a) => a.command.run("italic"),
    condition: (a) => a.allowFormatting.includes("italic")
  },
  {
    name: "orderedList",
    label: "List: ordered",
    icon: "list-ol",
    keybindings: oe ? [[["Control", "Meta"], "Digit7"]] : [[["Control", "Alt"], "Digit7"]],
    callback: (a) => a.command.run("insertOrderedList"),
    condition: (a) => a.allowFormatting.includes("orderedList")
  },
  {
    name: "unorderedList",
    label: "List: unordered",
    icon: "list-ul",
    keybindings: oe ? [[["Control", "Meta"], "Digit8"]] : [[["Control", "Alt"], "Digit8"]],
    callback: (a) => a.command.run("insertUnorderedList"),
    condition: (a) => a.allowFormatting.includes("unorderedList")
  },
  {
    name: "noFormat",
    label: "Clear formatting",
    icon: "pen-slash",
    keybindings: [],
    callback: (a) => a.command.run("removeFormat")
  }
], Lr = [...Ps, ...Er];
class fb extends D {
  domRef;
  constructor(t) {
    super(t), this.state = {
      isOpen: !1,
      currentFormat: ""
    }, this.domRef = B(), this.handleToolbarButtonClick = this.handleToolbarButtonClick.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(() => {
      this.updateCurrentFormat();
    });
  }
  componentDidUpdate(t, e) {
    const { isOpen: n } = this.state, { editorWindow: o } = this.props;
    n !== e.isOpen && o[n ? "addEventListener" : "removeEventListener"](
      "click",
      this.handleClickOutside,
      !0
    );
  }
  componentWillUnmount() {
    const { isOpen: t } = this.state, { editorWindow: e } = this.props;
    t && e.removeEventListener("click", this.handleClickOutside, !0);
  }
  updateCurrentFormat() {
    const { editorWindow: t } = this.props;
    this.setState({
      currentFormat: Dg(t)
    });
  }
  handleClickOutside = (t) => {
    const { current: e } = this.domRef;
    e && t.target instanceof Element && t.target !== e && !e.contains(t.target) && this.setState({
      isOpen: !1
    });
  };
  handleClick = (t) => {
    t.preventDefault();
    const { isOpen: e } = this.state;
    this.setState({
      isOpen: !e
    });
  };
  handleToolbarButtonClick(t) {
    return (e) => {
      const { editor: n } = this.props;
      e.preventDefault(), t && (Lr.find(
        (r) => r.name === t
      )?.callback(n), this.forceUpdate());
    };
  }
  styleActive(t) {
    const { editor: e } = this.props;
    return e.command.active(t);
  }
  render() {
    const { className: t, isActive: e, editor: n, editorWindow: o, ...r } = this.props, { isOpen: i, currentFormat: l } = this.state, c = f(t);
    return /* @__PURE__ */ s.jsxs("div", { ...r, className: c, ref: this.domRef, children: [
      i && /* @__PURE__ */ s.jsxs("div", { className: Ao.menu, children: [
        n.allowFormatting.includes("format") && /* @__PURE__ */ s.jsx(
          pb,
          {
            formatBlock: l,
            editor: this.props.editor
          }
        ),
        /* @__PURE__ */ s.jsx("div", { className: Ao.buttonsContainer, children: Er.map((d) => {
          const h = "condition" in d;
          if (!h || h && d.condition(n))
            return /* @__PURE__ */ s.jsx(
              Nt,
              {
                isActive: this.styleActive(d.name),
                onMouseDown: this.handleToolbarButtonClick(d.name),
                icon: d.icon
              },
              d.name
            );
        }).filter(Boolean) })
      ] }),
      /* @__PURE__ */ s.jsx(
        Nt,
        {
          isActive: e,
          icon: "format",
          onClick: this.handleClick
        }
      )
    ] });
  }
}
const bb = "h-inputRichText-suggestions--suggestions__dropdown", xb = "h-inputRichText-suggestions--suggestions__dropdownWithTabs", yb = "h-inputRichText-suggestions--suggestions__dropdownWithoutTabs", _b = "h-inputRichText-suggestions--suggestions__dropdownTabs", Cb = "h-inputRichText-suggestions--suggestions__dropdownTabsContent", ze = {
  dropdown: bb,
  dropdownWithTabs: xb,
  dropdownWithoutTabs: yb,
  dropdownTabs: _b,
  dropdownTabsContent: Cb
};
function wb(a) {
  if (!a)
    return null;
  const { focusOffset: t, anchorOffset: e, anchorNode: n } = a;
  return t !== e || !n || n.nodeName !== "#text" ? null : n?.textContent?.slice(0, t);
}
class vb extends D {
  dropdownRef;
  tabsRef;
  constructor(t) {
    super(t), this.state = {
      listenForSelectionChange: !0,
      suggestions: null,
      suggestionPosition: null,
      suggestionIndex: 0,
      suggestionExtendBy: 0,
      suggestionTrigger: null,
      suggestionMatchedString: "",
      selectedTab: null,
      selectionMode: "suggestion",
      tabIndex: 0
    }, this.dropdownRef = B(), this.tabsRef = B(), this.handleSuggestionClick = this.handleSuggestionClick.bind(this), this.handleSelectionChange = this.handleSelectionChange.bind(this), this.getPagination = this.getPagination.bind(this), this.handleBlur = this.handleBlur.bind(this), this.handleTabChange = this.handleTabChange.bind(this);
  }
  componentDidMount() {
    const { editor: t } = this.props;
    t.selection.onUpdate(this.handleSelectionChange), t.events.onBlur(this.handleBlur), t.hotkeys.add([
      {
        keybindings: [[[], "ArrowUp"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(-1)
      },
      {
        keybindings: [[[], "ArrowDown"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleArrowKey(1)
      },
      {
        keybindings: [[[], "Escape"]],
        condition: () => this.hasSuggestions() || this.hasTabs(),
        callback: (e, n) => this.handleEscapeKey(n)
      },
      {
        keybindings: [[[], "Enter"]],
        condition: () => this.shouldHandleKey(),
        callback: () => this.handleEnterKey()
      }
    ]);
  }
  componentDidUpdate(t, e) {
    const { suggestionIndex: n, tabIndex: o } = this.state;
    n !== e.suggestionIndex && this.updateSuggestionScroll(), o !== e.tabIndex && this.updateTabScroll();
  }
  shouldHandleKey() {
    const { selectionMode: t } = this.state;
    return t === "suggestion" && this.hasSuggestions() || t === "tab" && this.hasTabs();
  }
  handleArrowKey(t) {
    const { selectionMode: e } = this.state;
    e === "suggestion" && this.hasSuggestions() ? this.suggestionsNavigate(t) : e === "tab" && this.hasTabs() && this.tabsNavigate(t);
  }
  handleEscapeKey(t) {
    const { selectionMode: e } = this.state;
    this.shouldRenderDropdown() && t.stopPropagation(), e === "suggestion" && this.hasTabs() ? this.setState({
      selectionMode: "tab",
      tabIndex: this.getSelectedTabIndex()
    }) : this.clearSuggestions();
  }
  handleEnterKey() {
    const { selectionMode: t, tabIndex: e, suggestionTrigger: n } = this.state;
    if (t === "suggestion" && this.hasSuggestions())
      this.expandSuggestion();
    else if (t === "tab" && this.hasTabs()) {
      const o = n?.getTabs?.()[e];
      o && this.handleTabChange(o.id);
    }
  }
  handleBlur(t) {
    const {
      nativeEvent: { relatedTarget: e }
    } = t;
    e === null && this.clearSuggestions();
  }
  hasSuggestions() {
    const { suggestions: t } = this.state;
    return !!t?.length;
  }
  hasTabs() {
    return !!this.state.suggestionTrigger?.getTabs?.().length;
  }
  getSelectedTabIndex() {
    const { suggestionTrigger: t, selectedTab: e } = this.state;
    return this.hasTabs() ? t?.getTabs?.().findIndex((n) => n.id === e) : -1;
  }
  clearSuggestions() {
    this.setState({
      suggestions: null,
      suggestionPosition: null,
      selectedTab: null,
      selectionMode: "suggestion"
    });
  }
  suggestionsNavigate(t) {
    this.setState(({ suggestionIndex: e, suggestions: n }) => {
      if (n && n.length) {
        let o;
        return t < 0 ? o = e > 0 ? e - 1 : n.length - 1 : o = (e + 1) % n.length, {
          suggestionIndex: o
        };
      }
      return null;
    });
  }
  tabsNavigate(t) {
    this.setState(({ tabIndex: e, suggestionTrigger: n }) => {
      const o = n?.getTabs?.();
      if (o?.length) {
        let r;
        return t < 0 ? r = e > 0 ? e - 1 : o.length - 1 : r = (e + 1) % o.length, {
          tabIndex: r
        };
      }
      return null;
    });
  }
  lookForTriggers(t, e) {
    const { editor: n } = this.props, { selectedTab: o, selectionMode: r } = this.state, i = wb(n.selection.recreate());
    if (i) {
      const l = n.triggers.test(i);
      if (l && n.triggers.isSuggestionTrigger(l.matchedTrigger)) {
        const { match: c, matchedTrigger: d } = l, h = d?.getTabs?.();
        if (h?.length) {
          let p = null;
          if (t ? p = {
            selectionMode: "suggestion",
            selectedTab: t,
            tabIndex: -1
          } : o ? t = o : p = {
            selectionMode: "tab",
            selectedTab: h[0].id,
            tabIndex: 0
          }, p && this.setState(p, () => {
            t || this.lookForTriggers();
          }), !t)
            return;
        } else r !== "suggestion" && this.setState({ selectionMode: "suggestion" });
        Promise.resolve(
          d.getSuggestions(c[1], t, e)
        ).then((p) => {
          this.updateSuggestions(c, d, p);
        });
        return;
      }
    }
    this.clearSuggestions();
  }
  findTriggerPosition(t, e) {
    this.setState(
      {
        listenForSelectionChange: !1
      },
      () => {
        const { onError: n, editor: o } = this.props, r = o.selection.recreate();
        if (r) {
          const { focusOffset: i, anchorNode: l } = r;
          if (l) {
            if (i - t >= 0)
              try {
                r.extend(l, i - t);
              } catch (c) {
                n?.(c);
              }
            if (r?.rangeCount && r?.rangeCount > 0) {
              const c = r.getRangeAt(0).getBoundingClientRect();
              r.collapseToEnd(), setTimeout(() => {
                e(c), this.setState({
                  listenForSelectionChange: !0
                });
              });
            }
          }
        }
      }
    );
  }
  updateSuggestions(t, e, n) {
    const { editor: o } = this.props;
    this.findTriggerPosition(t[0].length, (r) => {
      const i = o.selection.recreate();
      if (!i)
        return;
      const { focusOffset: l } = i, h = new RegExp(e.trigger).exec(t[0])?.[1]?.length ?? 0, u = t[0].length - h;
      this.setState({
        suggestions: n,
        suggestionTrigger: e,
        suggestionPosition: r,
        suggestionIndex: 0,
        suggestionMatchedString: t[1],
        suggestionExtendBy: l - u,
        listenForSelectionChange: !0
      });
    });
  }
  updateSuggestionScroll() {
    const { suggestionIndex: t } = this.state, { current: e } = this.dropdownRef;
    if (e) {
      if (e.infiniteListRef.current)
        e.infiniteListRef.current.scrollToItem(t);
      else if (e.listRef.current) {
        const n = e.listRef.current, r = e.listRef.current.children[t].getBoundingClientRect(), i = n.getBoundingClientRect();
        i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
      }
    }
  }
  updateTabScroll() {
    const { tabIndex: t } = this.state, { current: e } = this.tabsRef;
    if (!(t < 0 || !e) && e.containerRef.current) {
      const n = e.containerRef.current, r = e.containerRef.current.children[0].children[t].getBoundingClientRect(), i = n.getBoundingClientRect();
      i.bottom < r.bottom ? n.scrollTop += r.bottom - i.bottom : i.top > r.top && (n.scrollTop -= i.top - r.top);
    }
  }
  expandSuggestion() {
    const {
      suggestions: t,
      suggestionIndex: e,
      suggestionExtendBy: n,
      suggestionTrigger: o
    } = this.state;
    if (!(!t || !t[e] || !o))
      return o.insertContent(
        t[e],
        o.trigger,
        n
      );
  }
  handleSelectionChange() {
    const { listenForSelectionChange: t } = this.state;
    t && this.lookForTriggers();
  }
  handleSuggestionClick(t) {
    this.setState(
      (e) => ({
        suggestionIndex: e.suggestions ? e.suggestions.indexOf(t) : 0
      }),
      () => {
        this.expandSuggestion();
      }
    );
  }
  calculateSuggestionBoxPosition() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        bottom: n.bottom - t.bottom + t.height,
        left: t.x - n.x + t.width
      };
    }
    return {};
  }
  suggestionBoxStyle() {
    const { suggestionPosition: t } = this.state, { editor: e } = this.props;
    if (e.ref.current && t) {
      const n = e.ref.current.getBoundingClientRect();
      return {
        left: `${t.x - n.x}px`,
        top: `${t.y - n.y + t.height / 2}px`,
        //`${suggestionPosition.x}px`,
        height: 1,
        width: t.width,
        position: "absolute"
      };
    }
    return {};
  }
  getPagination() {
    const { suggestionTrigger: t } = this.state;
    if (!t || !t.getPagination)
      return !1;
    const e = t.getPagination();
    return !e || !e.onNext ? !1 : {
      ...e,
      onNext: () => e.onNext?.().then((n) => {
        this.setState({ suggestions: n });
      }) ?? Promise.resolve(void 0)
    };
  }
  handleTabChange(t) {
    this.lookForTriggers(t, 0);
  }
  renderEmptyState() {
    return /* @__PURE__ */ s.jsx(cn, { label: "No suggestions found" });
  }
  renderTabs() {
    const { suggestions: t, suggestionTrigger: e, selectedTab: n, tabIndex: o } = this.state, r = e?.getTabs?.() ?? [], i = !!t?.length;
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        Xs,
        {
          ref: this.tabsRef,
          className: ze.dropdownTabs,
          tabs: r,
          tabsPlacement: "left",
          selectedId: n,
          activeId: r?.[o]?.id,
          onChange: this.handleTabChange
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: ze.dropdownTabsContent, children: i ? this.renderItems() : this.renderEmptyState() })
    ] });
  }
  renderItems() {
    const { suggestions: t, suggestionIndex: e, suggestionTrigger: n, selectionMode: o } = this.state, r = n ? n.suggestionComponent : null;
    return /* @__PURE__ */ s.jsx(
      Vs,
      {
        ref: this.dropdownRef,
        pagination: this.getPagination(),
        items: t || void 0,
        onSelect: this.handleSuggestionClick,
        itemComponent: r,
        activeItem: o === "suggestion" ? t?.[e] : void 0
      }
    );
  }
  shouldRenderDropdown() {
    const { suggestionPosition: t, selectedTab: e, suggestions: n } = this.state;
    return !(!t || !this.hasTabs() && !n?.length || this.hasTabs() && !e);
  }
  render() {
    const { editor: t, onError: e, ...n } = this.props;
    if (!this.shouldRenderDropdown())
      return null;
    const o = f(ze.dropdown, {
      [ze.dropdownWithTabs]: this.hasTabs(),
      [ze.dropdownWithoutTabs]: !this.hasTabs()
    });
    return /* @__PURE__ */ s.jsx("div", { ...n, children: /* @__PURE__ */ s.jsx("div", { style: this.suggestionBoxStyle(), children: /* @__PURE__ */ s.jsx(Xt, { className: o, isOpen: !0, children: this.hasTabs() ? this.renderTabs() : this.renderItems() }) }) });
  }
}
function $o(a) {
  return a instanceof RegExp ? a.source : a;
}
function Sb(a) {
  return a.replace(/\(/g, "(?:");
}
class Ar {
  storedTriggers;
  constructor() {
    this.storedTriggers = [];
  }
  get excludeTriggersRegex() {
    return this.storedTriggers.map(
      (t) => `(?!${$o(t.trigger)})`
    ).join("");
  }
  add(t) {
    this.storedTriggers.push(t);
  }
  update(t) {
    const e = this.storedTriggers.findIndex(
      (n) => this.isAddonTrigger(n) && n.id === t.id
    );
    e !== -1 && (this.storedTriggers[e] = t);
  }
  test(t) {
    let e;
    for (let n = 0; n < this.storedTriggers.length; n += 1) {
      const o = this.storedTriggers[n], { trigger: r, allowSpaces: i, minChars: l } = o, c = Sb(
        $o(r)
      ), d = this.excludeTriggersRegex, h = i ? "." : "\\S";
      if (e = new RegExp(`${c}((?:${d}${h})*)$`, "g").exec(t), e && (!l || e[1].length >= l))
        return {
          match: e,
          matchedTrigger: o
        };
    }
    return null;
  }
  isSuggestionTrigger(t) {
    return "getSuggestions" in t;
  }
  isAddonTrigger(t) {
    return !this.isSuggestionTrigger(t);
  }
}
const $r = "input-rich-text-editor", Ib = [
  {
    name: "insertInlineAttachment",
    label: "Insert inline image",
    keybindings: oe ? [[["Control", "Meta"], "KeyM"]] : [[["Control"], "KeyM"]]
  }
], Bo = [
  ...Ib,
  ...Lr,
  ...Nf,
  ...Xg
], Db = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/\S*)?$/i, kb = Bt({
  command: {
    run: E,
    active: () => !1
  },
  content: {
    insert: E,
    setUiBlocker: E
  },
  hotkeys: {
    add: E,
    updateKeybindings: E
  },
  selection: {
    recreate: () => null,
    getRange: () => null,
    isWithinEditor: () => !1,
    onUpdate: E
  },
  events: {
    subscribe: () => E,
    publish: E,
    onMouseOver: E,
    onBlur: E
  },
  allowFormatting: [],
  triggers: new Ar(),
  ref: B(),
  window,
  history: {
    canUndo: () => !1,
    undo: E,
    takeSnapshot: E,
    reset: E
  }
});
class Zs extends D {
  editor;
  editorRef;
  currentSuggestionRef;
  fileInputRef;
  attachmentDropdownButtonRef;
  unsubscribeInlineAttachment;
  isInserting;
  contentInsertionQueue;
  /**
   * Button that can be used in `toolbarAddons` to have same styles as the
   * buitlin buttons.
   */
  static ToolbarButton = Nt;
  /** Context containing props and methods to interact with the editor. */
  static Context = kb;
  static defaultProps = {
    allowAttachments: !1,
    allowInlineAttachments: !1,
    allowEmoji: !0,
    languages: [],
    onTriggerSend() {
      console.warn("InputRichText: onTriggerSend callback missing in props");
    },
    onToggleSendOnEnter: E,
    sendOnEnter: !1,
    editorWindow: window,
    onMount: E,
    onUnmount: E,
    disabled: !1,
    hasAutocompleteSuggestionsFeature: !1
  };
  constructor(t) {
    super(t), this.editorRef = B(), this.currentSuggestionRef = B(), this.fileInputRef = B(), this.attachmentDropdownButtonRef = B(), this.unsubscribeInlineAttachment = E, this.isInserting = !1, this.contentInsertionQueue = [], this.state = {
      keyDownHandled: !1,
      keyCommands: Bo,
      selectionUpdateListeners: [],
      mouseOverListeners: [],
      blurListeners: [],
      htmlOld: "",
      lastSelection: null,
      hasFocus: !1,
      selectedText: "",
      selectedLink: "",
      showHint: !1,
      pubsub: {},
      uiBlocker: t.uiBlocker,
      undoStack: []
    }, this.editor = {
      command: {
        run: this.commandRun.bind(this),
        active: this.commandActive.bind(this)
      },
      content: {
        insert: this.insertContent.bind(this),
        setUiBlocker: this.setUiBlocker.bind(this)
      },
      hotkeys: {
        add: this.addKeyCommands.bind(this),
        updateKeybindings: this.updateKeyCommandsKeybindings.bind(this)
      },
      selection: {
        onUpdate: this.addSelectionUpdateListener.bind(this),
        recreate: this.recreateSelection.bind(this),
        getRange: this.getSelectionRange.bind(this),
        isWithinEditor: this.isSelectionWithinEditor.bind(this)
      },
      events: {
        onMouseOver: this.addMouseOverListener.bind(this),
        onBlur: this.addBlurListener.bind(this),
        subscribe: this.subscribe.bind(this),
        publish: this.publish.bind(this)
      },
      allowFormatting: this.getAllowedFormattingOptions(),
      triggers: new Ar(),
      ref: this.editorRef,
      window: this.props.editorWindow ?? window,
      history: {
        undo: this.undo,
        canUndo: this.canUndo,
        reset: this.resetUndoStack,
        takeSnapshot: this.addCurrentContentToUndoStack
      }
    };
  }
  componentDidMount() {
    const { editorWindow: t = window, onMount: e } = this.props;
    t.document.execCommand(
      "defaultParagraphSeparator",
      !1,
      "div"
    );
    const { value: n } = this.props;
    n && !n.startsWith("<") ? this.setHtml(`<div>${n}</div>`) : n ? this.setHtml(n) : this.setHtml(""), this.unsubscribeInlineAttachment = this.editor.events.subscribe(
      "insertInlineAttachment",
      () => {
        this.props.allowInlineAttachments && this.openFileBrowser();
      }
    ), e(), this.updateKeyCommandsKeybindings(this.props.keybindings);
  }
  componentDidUpdate(t) {
    const { fileUploadStatuses: e, autocomplete: n, keybindings: o, uiBlocker: r } = this.props, { current: i } = this.editorRef;
    e && e !== t.fileUploadStatuses && i && (Object.keys(e).forEach((l) => {
      this.updateFileLoader(l, e[l]);
    }), this.handleSelectionChange()), n && n.showAutocompleteSuggestions !== t.autocomplete?.showAutocompleteSuggestions && this.setState({ showHint: !0 }, () => {
      setTimeout(() => {
        this.setState({ showHint: !1 });
      }, 1e3);
    }), cr(t.keybindings, o) || this.updateKeyCommandsKeybindings(o), t.uiBlocker !== r && this.setUiBlocker(r);
  }
  componentWillUnmount() {
    const { onUnmount: t } = this.props;
    this.unsubscribeInlineAttachment?.(), t(this.getSanitizedHtml());
  }
  getCommandsWithInputKeybindings() {
    const { keybindings: t } = this.props;
    return Bo.map((e) => ({
      ...e,
      keybindings: t && e.name ? t[e.name] ?? [] : e.keybindings
    }));
  }
  subscribe(t, e) {
    return this.setState((n) => ({
      pubsub: {
        ...n.pubsub,
        [t]: [...n.pubsub[t] ?? [], e]
      }
    })), () => {
      this.setState((n) => hr(n, t));
    };
  }
  publish(t) {
    this.state.pubsub[t]?.forEach((e) => e(this.editor));
  }
  /**
   * The core update function, that triggers every time the selection is
   * changed, which will also trigger when the contents change.
   *
   * This method handles calling onChange prop.
   *
   * @returns {void | undefined} Description
   * @todo Test if onInput would be a better way of triggering onChange
   */
  handleSelectionChange = () => {
    const { onChange: t, onSelectionChange: e } = this.props, { htmlOld: n, selectionUpdateListeners: o } = this.state, { current: r } = this.editorRef;
    if (r) {
      this.forceUpdate();
      const i = this.extractEditorContent();
      i !== n && (this.setState({
        htmlOld: i
      }), t(i));
    }
    o.forEach((i) => {
      i();
    }), e && e();
  };
  /** Handle any mouse over events on the editor */
  handleMouseOver = (t) => {
    const { mouseOverListeners: e } = this.state;
    e.forEach((n) => {
      n(t);
    });
  };
  /** Handle click events on the editor to select images */
  handleEditorClick = (t) => {
    const e = t.target, { editorWindow: n = window } = this.props;
    if (On(e) && e.tagName === "IMG") {
      t.preventDefault();
      const o = n.getSelection();
      if (o) {
        const r = n.document.createRange();
        r.selectNode(e), o.removeAllRanges(), o.addRange(r), this.handleSelectionChange();
      }
    }
  };
  /** Handle blur events on the editor */
  handleBlurListeners = (t) => {
    const { blurListeners: e } = this.state;
    e.forEach(
      (n) => {
        n(t);
      }
    );
  };
  handleKeyDown = (t) => {
    if (t.getModifierState(t.key))
      return;
    const { keyCommands: e } = this.state, { sendOnEnter: n, onKeyDown: o } = this.props;
    if (o?.(t), e.some(
      ({ preventDefaultKeybinding: i }) => i && ps(i, t)
    ) && t.preventDefault(), e.some(
      ({ name: i, keybindings: l, condition: c, callback: d }) => {
        if (ps(l, t) && (c === void 0 || c(this.editor)))
          return d?.(this.editor, t), i && this.editor.events.publish(i), !0;
      }
    )) {
      this.setKeyDownHandled(t);
      return;
    }
    if (ps([[["$metaOrCtrl"], "Enter"]], t)) {
      const { onTriggerSend: i } = this.props;
      this.setKeyDownHandled(t), i();
    } else if (t.key === "Enter" && n && !t.shiftKey) {
      const { onTriggerSend: i } = this.props;
      this.setKeyDownHandled(t), i();
    }
    return null;
  };
  getBlockLevelParent = (t) => {
    const { editorWindow: e = window } = this.props;
    let n = On(t) ? t : t.parentElement;
    for (; !Ys(n, e); )
      n = n.parentElement;
    return n;
  };
  // Insert actual text direction into the html
  onInput = (t) => {
    const { current: e } = this.editorRef, n = t?.nativeEvent;
    if (!n)
      return;
    this.resetUndoStack();
    const { inputType: o } = n;
    if (o === "insertFromPaste" || !o) {
      jo(e), Tg(e);
      return;
    }
    const i = document.getSelection()?.anchorNode;
    if (o === "insertText" && i && i.textContent?.length === 1) {
      const l = this.getBlockLevelParent(i);
      if (
        // if the parent element is `ol` or `ul`, and if it has direction, do not change it
        (l.tagName === "UL" || l.tagName === "OL") && l.hasAttribute("dir")
      )
        return;
      l.setAttribute("dir", "auto");
      const c = window.getComputedStyle(l).direction;
      l.setAttribute("dir", c), l.style.textAlign = "";
    }
  };
  handleKeyUp = () => {
    const { keyDownHandled: t } = this.state;
    t || this.handleSelectionChange(), this.setState({
      keyDownHandled: !1
    });
  };
  setKeyDownHandled = (t) => {
    t.preventDefault(), this.setState({
      keyDownHandled: !0
    });
  };
  addKeyCommands = (t) => {
    this.setState(({ keyCommands: e }) => ({
      keyCommands: [...e, ...t]
    }));
  };
  updateKeyCommandsKeybindings = (t) => {
    if (!t)
      return;
    const { keyCommands: e } = this.state;
    Object.entries(t).forEach(([n, o]) => {
      const r = e.findIndex(
        ({ name: i }) => i === n
      );
      r > -1 && o && (e[r].keybindings = o);
    });
  };
  addSelectionUpdateListener(t) {
    this.setState(({ selectionUpdateListeners: e }) => ({
      selectionUpdateListeners: [...e, t]
    }));
  }
  addMouseOverListener(t) {
    this.setState(({ mouseOverListeners: e }) => ({
      mouseOverListeners: [...e, t]
    }));
  }
  addBlurListener(t) {
    this.setState(({ blurListeners: e }) => ({
      blurListeners: [...e, t]
    }));
  }
  handlePaste = (t) => {
    const {
      onFileDropped: e,
      allowInlineAttachments: n,
      editorWindow: o = window,
      sanitize: r
    } = this.props, { clipboardData: i } = t;
    if (!i)
      return;
    let l = i.getData("text/html");
    const c = i.getData("text/plain"), d = i.files.item(0);
    if (l) {
      t.preventDefault(), this.commandRun("insertHTML", r?.(l));
      return;
    }
    if (c && Db.test(c)) {
      t.preventDefault(), l = `<a href="${c}">${c}</a>`, this.commandRun("insertHTML", l);
      return;
    }
    if (d) {
      if (n && e) {
        const { src: h, uid: u } = To(o, d);
        this.insertImageLoader(h, u), e(d, u);
      }
      t.preventDefault();
    }
  };
  commandRun(t, e = null) {
    setTimeout(() => {
      const { hasFocus: n } = this.state, { current: o } = this.editorRef, { editorWindow: r = window } = this.props;
      o && (n || this.recreateSelection(), r.document.execCommand(
        t,
        !1,
        // execCommand 3rd expects string | null, TS thinks it needs string | undefined
        e
      ));
    });
  }
  commandActive(t) {
    const { hasFocus: e } = this.state, { editorWindow: n = window } = this.props;
    return !!(e && Ig(n, t));
  }
  getText = () => {
    const { current: t } = this.editorRef;
    return t && this.hasContent(this.extractEditorContent()) ? this.extractEditorContent() : "";
  };
  getSanitizedHtml = () => this.props.sanitize?.(this.getText());
  getPlainText = () => {
    const { current: t } = this.editorRef, e = (
      // innerHTML of <div></div> should count as empty
      t && this.hasContent(this.extractEditorContent()) ? t.innerText : ""
    );
    return e ? e.replace(/\n\n/g, `
`).trim() : "";
  };
  setHtml(t) {
    const { current: e } = this.editorRef, n = this.props.sanitize?.(t);
    e && (e.innerHTML = n || "", jo(e)), this.setState({
      htmlOld: n
    }), this.handleSelectionChange();
  }
  handleInlineUpload = (t) => {
    if (t === null) return;
    const { onFileDropped: e, editorWindow: n = window } = this.props;
    t && e && Array.from(t).forEach((r) => {
      if (kg(r)) {
        const { src: i, uid: l } = To(n, r);
        this.insertImageLoader(i, l), e(r, l);
      } else {
        const i = tn();
        this.insertFileLoader(r.name, i), e(r, i);
      }
    });
  };
  handleAttachmentUpload = (t) => {
    const { onAttachmentsFile: e } = this.props, { current: n } = this.attachmentDropdownButtonRef;
    n && n.open(), t && typeof e == "function" && Array.from(t).forEach((r) => {
      const i = tn();
      e(r, i);
    });
  };
  handleDetachAttachmentFile = (t) => {
    const { onDetachAttacmentFile: e } = this.props;
    typeof e == "function" && e(t);
  };
  handleFileSelect = (t) => {
    const e = t.target;
    e?.ownerDocument?.defaultView && e instanceof e.ownerDocument.defaultView.HTMLInputElement && (this.handleInlineUpload(e.files), e.value = "");
  };
  openFileBrowser = (t) => {
    t?.preventDefault();
    const { current: e } = this.fileInputRef;
    e && e.click();
  };
  insertImageLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("img");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("src", t), this.insertContent(o);
  }
  insertFileLoader(t, e) {
    const { editorWindow: n = window } = this.props, o = n.document.createElement("a");
    o.setAttribute("class", "async-loading"), o.setAttribute("data-uid", e), o.setAttribute("href", "#"), o.innerText = t, this.insertContent(o);
  }
  updateFileLoader(t, { link: e, status: n, filename: o }) {
    const { current: r } = this.editorRef;
    if (r) {
      const i = r.querySelector(`[data-uid="${t}"]`);
      i && (n === "failed" && i.parentElement ? i.parentElement.removeChild(i) : (i.classList.remove(
        "async-loading",
        "async-succeeded",
        "async-failed"
      ), i.classList.add(`async-${n}`), e && i.tagName === "IMG" && (i.src = e, o && (i.title = o)), e && i.tagName === "A" && (i.href = e)));
    }
  }
  handleToggleSendOnEnter = (t) => {
    t.preventDefault();
    const { onToggleSendOnEnter: e } = this.props;
    e();
  };
  handleToggleAutocompleteSuggestions = (t) => {
    t.preventDefault();
    const { autocomplete: e } = this.props;
    e && e.onToggleShowAutocompleteSuggestions();
  };
  isSelectionWithinEditor(t) {
    const { anchorNode: e } = t;
    let { parentElement: n = null } = e || {};
    const o = `.${xt.editor}`;
    let r = e !== null && e.nodeType === Node.ELEMENT_NODE ? e.matches(o) : !1;
    for (; !r && n !== null; ) {
      if (n.matches(o)) {
        r = !0;
        break;
      }
      n = n.parentElement;
    }
    return r;
  }
  insertContent = (t, e) => {
    this.contentInsertionQueue.push(t), e?.getSelection ? this.processContentInsertionQueue(e.getSelection()) : this.isInserting || (this.isInserting = !0, this.editor.window.requestAnimationFrame(() => {
      this.processContentInsertionQueue(this.recreateSelection()), this.isInserting = !1;
    }));
  };
  processContentInsertionQueue = (t) => {
    if (!(!t || !this.isSelectionWithinEditor(t))) {
      if (jg(t), t?.rangeCount && t?.rangeCount > 0) {
        const e = t.getRangeAt(0);
        if (t.isCollapsed || e.deleteContents(), this.contentInsertionQueue.length === 1)
          e.insertNode(this.contentInsertionQueue[0]);
        else if (this.contentInsertionQueue.length > 1) {
          const n = document.createElement("span");
          this.contentInsertionQueue.forEach((o) => {
            n.appendChild(o);
          }), e.insertNode(n);
        }
      }
      this.contentInsertionQueue = [], this.editor.window.requestAnimationFrame(() => {
        t.collapseToEnd();
      }), this.handleSelectionChange();
    }
  };
  setUiBlocker(t) {
    this.setState({ uiBlocker: t });
  }
  getSelectionRange() {
    const { editorWindow: t = window } = this.props;
    if (t.document.activeElement === this.editorRef.current) {
      const e = t.document.getSelection();
      return e?.rangeCount && e?.rangeCount > 0 ? e.getRangeAt(0) : null;
    }
    return this.state.lastSelection;
  }
  recreateSelection() {
    const { current: t } = this.editorRef, { hasFocus: e, lastSelection: n } = this.state, { editorWindow: o = window } = this.props, r = o.getSelection();
    return t && !e && (t.focus(), n && r && (r.removeAllRanges(), r.addRange(n))), r;
  }
  handleFocus = () => {
    const { editorWindow: t = window } = this.props;
    this.setState({
      hasFocus: !0
    }), t.document.addEventListener(
      "selectionchange",
      this.handleSelectionChange
    );
  };
  handleBlur = (t) => {
    const { editorWindow: e = window } = this.props, n = e.getSelection(), o = () => n?.rangeCount && n?.rangeCount > 0 ? n.getRangeAt(0) : null;
    this.setState({
      lastSelection: o(),
      hasFocus: !1
    }), e.document.removeEventListener(
      "selectionchange",
      this.handleSelectionChange
    ), this.handleBlurListeners(t);
  };
  focus = () => {
    const { current: t } = this.editorRef, { hasFocus: e } = this.state;
    t && (e || t.focus());
  };
  hasContent(t) {
    return t?.length ? !t.match(
      /^\s*<br>\s*$|^<[A-z\s="0-9]*>\s*(<br>\s*)?<\/[A-z\s="0-9]*>$/
    ) : !1;
  }
  isStylingActive() {
    return this.commandActive("bold") || this.commandActive("italic") || this.commandActive("insertUnorderedList") || this.commandActive("insertOrderedList");
  }
  getAllowedFormattingOptions() {
    const { allowFormatting: t } = this.props;
    return Array.isArray(t) ? t : t ? vg : [];
  }
  lastExtractedContent = B();
  extractEditorContent() {
    const { editorContentExtractor: t, sanitize: e } = this.props, { current: n } = this.editorRef, o = n?.innerHTML ?? "";
    if (!t)
      return o;
    if (o === this.lastExtractedContent.current)
      return this.lastExtractedContent.current;
    const r = t(n);
    return this.lastExtractedContent.current = e?.(r) ?? r, this.lastExtractedContent.current;
  }
  canUndo = () => this.state.undoStack.length > 0;
  undo = () => {
    const { undoStack: t } = this.state;
    if (t.length > 0) {
      const e = t[t.length - 1];
      this.setHtml(e), this.setState({
        undoStack: t.slice(0, -1)
      });
    }
  };
  resetUndoStack = () => {
    this.setState({
      undoStack: []
    });
  };
  addCurrentContentToUndoStack = () => {
    this.setState({
      // To prevent undo stack from growing indefinitely, we only keep a finite amount
      undoStack: [...this.state.undoStack.slice(-50), this.getText()]
    });
  };
  render() {
    const {
      className: t,
      wrapperClassName: e,
      renderQuickResponse: n,
      quickResponsesApi: o,
      sendOnEnter: r,
      placeholder: i,
      allowInlineAttachments: l,
      allowAttachments: c,
      allowEmoji: d,
      attachmentsFields: h,
      attachments: u,
      isAttachmentsUploading: p,
      hideSendOnEnterToggle: m,
      editorWindow: g = window,
      languages: b,
      disabled: x,
      status: w,
      onError: y,
      icon: v,
      prefix: _,
      suffix: C,
      id: S,
      autocomplete: I,
      toolbarAddons: T
    } = this.props, { htmlOld: R, uiBlocker: A } = this.state, k = f(xt.root, t);
    return /* @__PURE__ */ s.jsx(Zs.Context.Provider, { value: this.editor, children: /* @__PURE__ */ s.jsx(
      Rt,
      {
        status: w,
        icon: v,
        prefix: _,
        suffix: C,
        disabled: x,
        className: f(xt.inputWrapper, e),
        children: /* @__PURE__ */ s.jsxs("div", { className: k, children: [
          /* @__PURE__ */ s.jsxs(
            of,
            {
              className: xt.editorWrap,
              onAddInline: this.handleInlineUpload,
              onAddAttachment: this.handleAttachmentUpload,
              attachments: Array.isArray(u) ? u : [],
              allowInlineAttachments: l,
              allowAttachments: c,
              children: [
                /* @__PURE__ */ s.jsx(
                  "div",
                  {
                    id: S,
                    ref: this.editorRef,
                    onPaste: this.handlePaste,
                    onKeyDown: this.handleKeyDown,
                    onInput: this.onInput,
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    onMouseOver: this.handleMouseOver,
                    onClick: this.handleEditorClick,
                    className: xt.editor,
                    "data-testid": $r,
                    contentEditable: !0
                  }
                ),
                !this.hasContent(R) && !!i && /* @__PURE__ */ s.jsx("span", { role: "presentation", className: xt.placeholder, children: i })
              ]
            }
          ),
          /* @__PURE__ */ s.jsxs("div", { className: xt.toolbar, children: [
            this.editor.allowFormatting.length > 0 && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              /* @__PURE__ */ s.jsx(
                fb,
                {
                  isActive: this.isStylingActive(),
                  editor: this.editor,
                  editorWindow: g
                }
              ),
              this.editor.allowFormatting.includes("link") && /* @__PURE__ */ s.jsx(Pf, { editor: this.editor })
            ] }),
            l && /* @__PURE__ */ s.jsx(
              Nt,
              {
                icon: "upload",
                onMouseDown: this.openFileBrowser
              }
            ),
            c && /* @__PURE__ */ s.jsx(
              Zg,
              {
                dropdownRef: this.attachmentDropdownButtonRef,
                onAttachFiles: this.handleAttachmentUpload,
                attachments: Array.isArray(u) ? u : [],
                isAttachmentsUploading: p,
                onDetachFile: this.handleDetachAttachmentFile,
                editorWindow: g,
                editor: this.editor,
                children: h
              }
            ),
            d && /* @__PURE__ */ s.jsx(pf, { "data-tip": "Emojis", editor: this.editor }),
            !!o && !!n && /* @__PURE__ */ s.jsx(
              ab,
              {
                languages: b,
                renderQuickResponse: n,
                quickResponsesApi: o,
                editor: this.editor,
                sanitize: this.props.sanitize,
                iconName: this.props.quickResponseIcon
              }
            ),
            I && I.hasAutocompleteSuggestionsFeature && /* @__PURE__ */ s.jsx(
              Nt,
              {
                isActive: I.showAutocompleteSuggestions,
                onMouseDown: this.handleToggleAutocompleteSuggestions,
                icon: "autocomplete"
              }
            ),
            T,
            !m && /* @__PURE__ */ s.jsx(
              Nt,
              {
                isActive: r,
                onMouseDown: this.handleToggleSendOnEnter,
                icon: "enter"
              }
            ),
            I ? /* @__PURE__ */ s.jsxs(
              "span",
              {
                className: f(xt.toolbarHint, {
                  [xt.toolbarHintVisible]: this.state.showHint,
                  [xt.toolbarHintHidden]: !this.state.showHint
                }),
                children: [
                  "Autocomplete",
                  " ",
                  I.showAutocompleteSuggestions ? "ON" : "OFF"
                ]
              }
            ) : null
          ] }),
          /* @__PURE__ */ s.jsx(
            "input",
            {
              tabIndex: -1,
              ref: this.fileInputRef,
              type: "file",
              className: xt.fileInput,
              onChange: this.handleFileSelect,
              multiple: !0
            }
          ),
          /* @__PURE__ */ s.jsx(vb, { editor: this.editor, onError: y }),
          /* @__PURE__ */ s.jsx(Hg, { editor: this.editor }),
          A && /* @__PURE__ */ s.jsx("div", { className: xt.uiBlocker, children: A })
        ] })
      }
    ) });
  }
}
const Tb = "h-textarea--textarea__inputWrapper", jb = "h-textarea--textarea__input", Oo = {
  inputWrapper: Tb,
  input: jb
}, Nb = "textarea", Br = $(function(t, e) {
  const n = Y(null), {
    className: o,
    disabled: r,
    readOnly: i,
    name: l,
    prefix: c,
    suffix: d,
    icon: h,
    status: u,
    height: p,
    style: m,
    ...g
  } = t, b = { ...m, height: p };
  return /* @__PURE__ */ s.jsx(
    Rt,
    {
      className: Oo.inputWrapper,
      status: u,
      disabled: r,
      prefix: c,
      suffix: d,
      icon: h,
      children: /* @__PURE__ */ s.jsx(
        "textarea",
        {
          "data-testid": Nb,
          className: Oo.input,
          dir: "auto",
          id: l,
          ...g,
          ref: n,
          style: b,
          name: l,
          disabled: r,
          readOnly: i
        }
      )
    }
  );
}), Pb = "h-fieldRichText--fieldRichText__editorContainer", Fb = "h-fieldRichText--fieldRichText__fallbackTextArea", Ho = {
  editorContainer: Pb,
  fallbackTextArea: Fb
};
class xk extends D {
  static defaultProps = {
    allowFormatting: !0
  };
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        helpIcon: l,
        disabled: i,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Bs,
          {
            fallback: /* @__PURE__ */ s.jsx(
              Br,
              {
                ...e,
                className: Ho.fallbackTextArea,
                disabled: i,
                value: e.value,
                onChange: (p) => e.onChange(p.target.value)
              }
            ),
            children: /* @__PURE__ */ s.jsx("div", { className: Ho.editorContainer, children: /* @__PURE__ */ s.jsx(
              Zs,
              {
                disabled: i,
                status: z.getStatus(o),
                ...e,
                ...u,
                hideSendOnEnterToggle: !0,
                onTriggerSend: E
              }
            ) })
          }
        )
      }
    );
  }
}
class yk extends D {
  constructor(t) {
    super(t), this.handleSelect = this.handleSelect.bind(this), this.handleClear = this.handleClear.bind(this);
  }
  getSelectedItems() {
    const {
      input: { value: t },
      items: e
    } = this.props;
    return typeof t == "string" && e?.some((n) => n.id === t) ? [t] : Array.isArray(t) && t.length && e?.some((n) => t.some((o) => o === n.id)) ? t : [];
  }
  handleSelect(t) {
    const {
      input: { onChange: e }
    } = this.props;
    typeof e == "function" && e(t === null ? "" : t.id.toString());
  }
  handleClear() {
    const {
      input: { value: t },
      onClear: e
    } = this.props;
    typeof t == "string" && this.handleSelect(null), typeof e == "function" && e();
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: i,
      description: l,
      helpIcon: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: o,
        labelFor: e.name,
        meta: n,
        required: r,
        disabled: i,
        helpIcon: c,
        description: l,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          De,
          {
            ...u,
            id: e.name,
            disabled: i,
            selectedItems: this.getSelectedItems(),
            onSelect: this.handleSelect,
            onClear: this.handleClear,
            status: z.getStatus(n)
          }
        )
      }
    );
  }
}
function Or(a, t = "") {
  return Ft.toArray(a).reduce((e, n) => Pt(n) ? n.type === Yt ? [
    ...e,
    ...Or(n.props.children, n.key)
  ] : [...e, { ...n, key: `${t}${n.key}` }] : e, []);
}
const Qn = (a) => U(() => Or(a), [a]), Rb = "h-selectionList--selectionList__root", Eb = "h-selectionList--selectionList__disabled", Wo = {
  root: Rb,
  disabled: Eb
}, Pe = Ca(
  () => Bt({
    list: {
      isMultiple: !1,
      isActive: !1,
      isFocused: !1,
      isDisabled: !1
    },
    item: {
      isActive: !1,
      setActive: E,
      register: E,
      isSelected: () => !1,
      onSelect: E,
      isOnlyVisibleItem: !1
    }
  })
), Js = ({ defaultActiveItemIndex: a = 0 } = {
  defaultActiveItemIndex: 0
}) => {
  const [t, e] = V(!1), [n, o] = V(-1), [r, i] = V([]), [l, c] = V({}), d = P(
    ({
      isActivatable: g,
      isLastChild: b,
      isOnlyVisibleItem: x,
      keysTakenOverHandlingFromParent: w
    }, y) => {
      g !== void 0 && i((v) => {
        const _ = g ? [...v, y].sort((C, S) => C - S) : v.filter((C) => C !== y);
        return b && o((C) => (_.includes(y) && !v.includes(y) || y !== C) && _.includes(C) && y !== _[a] ? C : _[a] ?? _[0] ?? C), _;
      }), x !== void 0 && e(x), w !== void 0 && c((v) => ({
        ...v,
        [y]: w
      }));
    },
    [a]
  ), h = P(
    (g) => "index" in g ? g.index : g.step === "first" ? r[0] : g.step === "last" ? r[r.length - 1] : r[(r.findIndex(
      (b) => b === n
    ) + g.step + r.length) % r.length],
    [r, n]
  ), u = P(
    (g) => {
      o(h(g));
    },
    [h]
  );
  tt(() => {
    (n < 0 || n === void 0) && o(r[a]);
  }, [n, r, a]);
  const p = U(
    () => l[n] ?? [],
    [n, l]
  );
  return U(
    () => ({
      activeItemIndex: n,
      getActiveItemIndex: h,
      activatableItemIndices: r,
      setActiveItem: u,
      handleItemRegister: d,
      isOnlyActiveItemVisible: t,
      keysDelegatedHandlingToItem: p
    }),
    [
      r,
      n,
      h,
      d,
      t,
      p,
      u
    ]
  );
}, Mo = ({
  className: a,
  selectedValues: t = [],
  isActive: e,
  isDisabled: n,
  isMultiple: o = !1,
  onChange: r = E,
  equalityFn: i = Object.is,
  tabIndex: l = 0,
  defaultActiveItemIndex: c,
  children: d,
  ...h
}, u) => {
  const [p, m] = V(!1), [g, b] = V({ isActive: !!e, source: "parent" }), x = Pe(), {
    activeItemIndex: w,
    setActiveItem: y,
    handleItemRegister: v,
    isOnlyActiveItemVisible: _,
    keysDelegatedHandlingToItem: C
  } = Js({ defaultActiveItemIndex: c }), S = Qn(d), I = P(
    (k) => k !== void 0 && (t || []).some(
      (F) => i(F, k)
    ),
    [i, t]
  ), T = P(
    ({ value: k, meta: F }, H) => {
      y({ index: H }), k !== void 0 && r(o ? {
        selectedValues: I(k) ? t.filter(
          (et) => !i(et, k)
        ) : [...t, k],
        selectedItem: {
          isNode: F?.isNode,
          isSelected: !I(k),
          value: k
        },
        event: F?.event
      } : {
        selectedValues: [k],
        selectedItem: {
          isNode: F?.isNode,
          isSelected: !0,
          value: k
        },
        event: F?.event
      });
    },
    [
      i,
      I,
      o,
      r,
      t,
      y
    ]
  ), R = U(
    () => !n && (g.isActive || p),
    [n, g.isActive, p]
  ), A = (k) => {
    !R || C.includes(k.key) || (k.key === "Enter" ? k.preventDefault() : k.key === "Home" ? (y({ step: "first" }), k.preventDefault()) : k.key === "End" ? (y({ step: "last" }), k.preventDefault()) : k.key === "ArrowDown" ? (y({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && (y({ step: -1 }), k.preventDefault()));
  };
  return tt(() => {
    b({ isActive: !!e, source: "parent" });
  }, [e]), rn("keydown", A), /* @__PURE__ */ s.jsx(
    "ul",
    {
      ref: u,
      role: "listbox",
      tabIndex: n || e ? -1 : l,
      ...h,
      className: f(a, Wo.root, {
        [Wo.disabled]: n
      }),
      onFocus: () => m(!0),
      onBlur: () => m(!1),
      onMouseLeave: () => {
        g.source === "child" && b({ isActive: !1, source: "self" });
      },
      children: S.map(
        (k, F) => Pt(k) && (!_ || F === w) && /* @__PURE__ */ s.jsx(
          x.Provider,
          {
            value: {
              list: {
                isFocused: p,
                isMultiple: o,
                isActive: g.isActive,
                isDisabled: n
              },
              item: {
                isActive: R && F === w,
                setActive: () => {
                  b({ isActive: !0, source: "child" }), y({ index: F });
                },
                register: (H) => v(H, F),
                isSelected: I,
                onSelect: (H) => T(H, F),
                isOnlyVisibleItem: _,
                isLastChild: F === S.length - 1
              }
            },
            children: k
          },
          F
        )
      )
    }
  );
}, zo = ({ className: a, label: t, ...e }, n) => {
  const {
    item: { register: o, isLastChild: r }
  } = qt(Pe());
  return Te(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), Qt(() => {
    o({ isActivatable: !1, isLastChild: r });
  }), /* @__PURE__ */ s.jsx(
    Vn,
    {
      ref: n,
      as: "li",
      color: "tertiary",
      padding: "200 250",
      ...e,
      children: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "4", color: "secondary", children: t })
    }
  );
}, Hr = Object.assign($(zo), {
  name: zo.name
}), Lb = "h-selectionList-subComponents-item--selectionListItem__root", Ab = "h-selectionList-subComponents-item--selectionListItem__rootDisabled", $b = "h-selectionList-subComponents-item--selectionListItem__rootActive", Bb = "h-selectionList-subComponents-item--selectionListItem__selectionState", Ob = "h-selectionList-subComponents-item--selectionListItem__fixedSize", Hb = "h-selectionList-subComponents-item--selectionListItem__content", Wb = "h-selectionList-subComponents-item--selectionListItem__contentDisabled", ne = {
  root: Lb,
  rootDisabled: Ab,
  rootActive: $b,
  selectionState: Bb,
  fixedSize: Ob,
  content: Hb,
  contentDisabled: Wb
}, Vo = ({
  value: a,
  isDisabled: t = !1,
  isIndeterminate: e = !1,
  className: n,
  contentClassName: o,
  noFixedSelectionStateSpace: r,
  onActiveStateChange: i,
  onSelectedStateChange: l,
  onSelect: c,
  children: d,
  ...h
}, u) => {
  const {
    list: {
      isMultiple: p,
      isDisabled: m,
      isActive: g,
      isFocused: b
    },
    item: {
      register: x,
      isSelected: w,
      onSelect: y,
      isActive: v,
      isNode: _ = !1,
      isLastChild: C = !1,
      setActive: S
    }
  } = qt(Pe()), I = w(a), T = U(
    () => !m && (g || b),
    [g, m, b]
  ), R = U(
    () => !t && v && T,
    [v, t, T]
  ), A = Y(null);
  ke(
    u,
    () => A.current
  );
  const k = P(
    (M) => {
      !t && !m && (c?.({ value: a, meta: { target: M?.target } }), y({
        value: a,
        meta: {
          target: M?.target,
          event: M || void 0
        }
      }));
    },
    [t, m, c, y, a]
  ), F = P(
    (M) => {
      R && M.key === "Enter" && k(M);
    },
    [R, k]
  );
  tt(() => {
    v && T && A.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [v]);
  const H = P(
    () => ({
      isActive: v,
      isSelected: I,
      isLastChild: C,
      isNode: _,
      value: a
    }),
    [v, C, _, I, a]
  ), et = Je(v), at = Je(I);
  Gt(() => {
    v !== et && i?.(H()), I !== at && l?.(H());
  }, [
    H,
    v,
    I,
    i,
    l,
    et,
    at
  ]), rn("keydown", F), tt(() => (x({ isActivatable: !t, isLastChild: C }), () => x({ isActivatable: !1, isLastChild: C })), [t]);
  const nt = !p && I || p && a !== void 0 || !r;
  return /* @__PURE__ */ s.jsxs(
    "li",
    {
      ref: A,
      role: "option",
      "aria-selected": I,
      "aria-disabled": t,
      onClick: k,
      onMouseMove: S,
      className: f(ne.root, n, {
        [ne.rootActive]: R,
        [ne.rootDisabled]: t
      }),
      ...h,
      children: [
        nt && /* @__PURE__ */ s.jsxs(
          O,
          {
            className: f(ne.selectionState, {
              [ne.fixedSize]: !r
            }),
            children: [
              !p && I && /* @__PURE__ */ s.jsx(N, { name: "done" }),
              p && a !== void 0 && /* @__PURE__ */ s.jsx(
                an,
                {
                  checked: I,
                  indeterminate: !I && e,
                  disabled: t,
                  onChange: E,
                  tabIndex: -1
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ s.jsx(
          rt,
          {
            className: f(ne.content, o, {
              [ne.contentDisabled]: t
            }),
            children: d
          }
        ),
        _ && /* @__PURE__ */ s.jsx(N, { name: "angle-right" })
      ]
    }
  );
}, Mb = Object.assign($(Vo), {
  name: Vo.name
}), zb = "h-selectionList-subComponents-list-backItem--selectionListBackItem__root", Vb = "h-selectionList-subComponents-list-backItem--selectionListBackItem__rootActive", Ko = {
  root: zb,
  rootActive: Vb
}, Uo = ({
  className: a,
  content: t,
  onActiveStateChange: e,
  onSelected: n,
  ...o
}, r) => {
  const {
    list: {
      isDisabled: i,
      isActive: l,
      isFocused: c
    },
    item: { register: d, isActive: h, onSelect: u, setActive: p }
  } = qt(Pe()), m = U(
    () => !i && (l || c),
    [l, i, c]
  ), g = U(
    () => h && m,
    [h, m]
  ), b = Y(null);
  ke(
    r,
    () => b.current
  );
  const x = P(() => {
    u({}), n?.();
  }, [u, n]), w = P(
    (v) => {
      !g || i || v.key === "Enter" && x();
    },
    [x, g, i]
  );
  tt(() => {
    h && m && b.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, [h]);
  const y = Je(h);
  return Gt(() => {
    h !== y && e?.({ isActive: h });
  }, [h, e, y]), rn("keydown", w), Te(() => {
    d({ isActivatable: !0 });
  }), Qt(() => {
    d({ isActivatable: !1 });
  }), /* @__PURE__ */ s.jsx(
    "li",
    {
      ref: b,
      role: "navigation",
      className: f(Ko.root, a, {
        [Ko.rootActive]: g
      }),
      onClick: x,
      onMouseMove: p,
      ...o,
      children: t || /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(N, { name: "angle-left" }),
        /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "1", children: "Back" })
      ] })
    }
  );
}, Wr = Object.assign(
  $(Uo),
  {
    name: Uo.name
  }
), Kb = "h-selectionList-subComponents-list--selectionListList__list", Ub = {
  list: Kb
}, qo = ({
  parentItem: a,
  children: t,
  backItemProps: e = {},
  listProps: { className: n, ...o } = {},
  onActiveStateChange: r,
  ...i
}, l) => {
  const c = Pe(), d = qt(c), {
    list: {
      isFocused: h,
      isActive: u,
      isDisabled: p
    },
    item: {
      isActive: m,
      onSelect: g,
      isOnlyVisibleItem: b,
      register: x,
      setActive: w,
      isLastChild: y = !1
    }
  } = d, v = U(
    () => !p && (u || h),
    [u, p, h]
  ), _ = Qn(t), {
    activeItemIndex: C,
    setActiveItem: S,
    handleItemRegister: I,
    isOnlyActiveItemVisible: T,
    keysDelegatedHandlingToItem: R
  } = Js({ defaultActiveItemIndex: 1 }), A = P(
    (M, st) => {
      S({ index: st }), g(M);
    },
    [g, S]
  ), k = (M) => {
    !v || !b || R.includes(M.key) || (M.key === "Home" ? (S({ step: "first" }), M.preventDefault()) : M.key === "End" ? (S({ step: "last" }), M.preventDefault()) : M.key === "ArrowDown" ? (S({ step: 1 }), M.preventDefault()) : M.key === "ArrowUp" && (S({ step: -1 }), M.preventDefault()));
  }, F = Je(
    b
  );
  Gt(() => {
    b !== F && r?.({
      isActive: b,
      isLastChild: y
    });
  }, [
    b,
    r,
    F
  ]), tt(() => {
    x(b ? {
      keysTakenOverHandlingFromParent: [
        "Home",
        "End",
        "ArrowDown",
        "ArrowUp"
      ]
    } : { keysTakenOverHandlingFromParent: [] });
  }, [b]), rn("keydown", k);
  const H = P(
    ({ value: M, meta: st }) => {
      st?.target instanceof HTMLInputElement && st.target.type === "checkbox" ? g({ value: M, meta: { isNode: !0 } }) : x({ isOnlyVisibleItem: !0 });
    },
    // excluding `register` to avoid infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), et = P(() => {
    x({ isOnlyVisibleItem: !1 });
  }, []);
  tt(() => {
    b || S({ index: -1 });
  }, [b, S]);
  const at = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: H,
        isNode: !0
      }
    }),
    [H, d]
  ), nt = U(
    () => ({
      ...d,
      item: {
        ...d.item,
        onSelect: et,
        isActive: C === 0,
        setActive: () => {
          w(), S({ index: 0 });
        },
        register: (M) => I(M, 0)
      }
    }),
    [
      C,
      et,
      I,
      d,
      w,
      S
    ]
  );
  return b ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    !T && /* @__PURE__ */ s.jsx(c.Provider, { value: nt, children: /* @__PURE__ */ s.jsx(Wr, { ...e }) }),
    /* @__PURE__ */ s.jsx("li", { ref: l, ...i, children: /* @__PURE__ */ s.jsx(
      "ul",
      {
        role: "listbox",
        className: f(Ub.list, n),
        ...o,
        children: _.map((M, st) => {
          const It = st + 1;
          return Pt(M) && (!T || It === C) && /* @__PURE__ */ s.jsx(
            c.Provider,
            {
              value: {
                ...d,
                item: {
                  ...d.item,
                  isActive: m && It === C,
                  setActive: () => {
                    w(), S({ index: It });
                  },
                  register: (ae) => I(ae, It),
                  onSelect: (ae) => A(ae, It),
                  isOnlyVisibleItem: T,
                  isLastChild: st === _.length - 1
                }
              },
              children: M
            },
            st
          );
        })
      }
    ) })
  ] }) : /* @__PURE__ */ s.jsx(c.Provider, { value: at, children: a });
}, qb = Object.assign($(qo), {
  name: qo.name
}), Gb = "h-selectionList-subComponents-section--selectionListSection__section", Yb = {
  section: Gb
}, Go = ({
  title: a,
  children: t,
  listProps: { className: e, ...n } = {},
  onActiveStateChange: o,
  ...r
}, i) => {
  const l = Pe(), c = qt(l), {
    list: {
      isFocused: d,
      isActive: h,
      isDisabled: u
    },
    item: {
      isActive: p,
      setActive: m,
      onSelect: g,
      register: b,
      isLastChild: x = !1
    }
  } = c, w = U(
    () => !u && (h || d),
    [h, u, d]
  ), y = Qn(t), {
    activatableItemIndices: v,
    activeItemIndex: _,
    setActiveItem: C,
    handleItemRegister: S,
    keysDelegatedHandlingToItem: I
  } = Js(), T = P(
    (k, F) => {
      C({ index: F }), g(k);
    },
    [g, C]
  ), R = (k) => {
    !w || I.includes(k.key) || (k.key === "Home" ? C({ step: "first" }) : k.key === "End" && C({ step: "last" }), p ? k.key === "ArrowDown" && _ !== v[v.length - 1] ? (C({ step: 1 }), k.preventDefault()) : k.key === "ArrowUp" && _ !== v[0] && (C({ step: -1 }), k.preventDefault()) : k.key === "ArrowDown" ? C({ step: "first" }) : k.key === "ArrowUp" && C({ step: "last" }));
  }, A = Je(p);
  return Gt(() => {
    p !== A && o?.({
      isActive: p,
      isLastChild: x
    });
  }, [p, o, A]), tt(() => {
    const k = [];
    p && (_ !== v[v.length - 1] && k.push("ArrowDown"), _ !== v[0] && k.push("ArrowUp")), b({ keysTakenOverHandlingFromParent: k });
  }, [v, _, p]), Te(() => b({ isActivatable: !0 })), Qt(() => b({ isActivatable: !1 })), rn("keydown", R), /* @__PURE__ */ s.jsx("li", { ref: i, ...r, children: /* @__PURE__ */ s.jsxs(
    "ul",
    {
      role: "group",
      className: f(Yb.section, e),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(Hr, { label: a }),
        y.map(
          (k, F) => Pt(k) && /* @__PURE__ */ s.jsx(
            l.Provider,
            {
              value: {
                ...c,
                item: {
                  ...c.item,
                  isActive: p && F === _,
                  setActive: () => {
                    m(), C({ index: F });
                  },
                  register: (H) => S(H, F),
                  onSelect: (H) => T(H, F),
                  isLastChild: x && F === y.length - 1
                }
              },
              children: k
            },
            F
          )
        )
      ]
    }
  ) });
}, Qb = Object.assign($(Go), {
  name: Go.name
}), Xb = Object.assign($(Mo), {
  name: Mo.name,
  Item: Mb,
  BackItem: Wr,
  Divider: Hr,
  Section: Qb,
  List: qb
}), Zb = "h-inputSelectionList-chip--inputSelectionListChip__root", Jb = "h-inputSelectionList-chip--inputSelectionListChip__name", Yo = {
  root: Zb,
  name: Jb
}, xs = ({
  onDelete: a,
  className: t,
  disabled: e,
  readOnly: n,
  ...o
}) => {
  const r = U(() => {
    if (!(!a || e || n))
      return (i) => {
        i.stopPropagation(), a();
      };
  }, [e, a, n]);
  return /* @__PURE__ */ s.jsx(
    Ie,
    {
      ...o,
      onDelete: r,
      className: f(Yo.root, t),
      tagNameClassName: Yo.name
    }
  );
}, tx = "h-inputSelectionList--inputSelectionList__root", ex = "h-inputSelectionList--inputSelectionList__inputWrapper", nx = "h-inputSelectionList--inputSelectionList__inputWrapperChild", sx = "h-inputSelectionList--inputSelectionList__rootHasWrapperIcon", ox = "h-inputSelectionList--inputSelectionList__rootReadOnly", rx = "h-inputSelectionList--inputSelectionList__titleContainer", ax = "h-inputSelectionList--inputSelectionList__filterInput", ix = "h-inputSelectionList--inputSelectionList__placeholder", lx = "h-inputSelectionList--inputSelectionList__titleBox", cx = "h-inputSelectionList--inputSelectionList__iconContainer", dx = "h-inputSelectionList--inputSelectionList__iconButton", hx = "h-inputSelectionList--inputSelectionList__dropdown", ux = "h-inputSelectionList--inputSelectionList__hiddenItemsTooltip", px = "h-inputSelectionList--inputSelectionList__hiddenItemsChip", lt = {
  root: tx,
  inputWrapper: ex,
  inputWrapperChild: nx,
  rootHasWrapperIcon: sx,
  rootReadOnly: ox,
  titleContainer: rx,
  filterInput: ax,
  placeholder: ix,
  titleBox: lx,
  iconContainer: cx,
  iconButton: dx,
  dropdown: hx,
  hiddenItemsTooltip: ux,
  hiddenItemsChip: px
}, mx = "inputSelectionListTestId", Qo = ({
  className: a,
  name: t,
  value: e,
  onChange: n,
  prefix: o,
  suffix: r,
  icon: i,
  status: l,
  placeholder: c,
  disabled: d,
  readOnly: h,
  children: u,
  filter: p,
  multiple: m,
  getItemTitleByValue: g,
  tabIndex: b,
  keepOpen: x,
  onToggleDropdown: w,
  onClick: y,
  onBlur: v,
  onKeyDown: _,
  limit: C = Number.POSITIVE_INFINITY,
  clearable: S = !1,
  equalityFn: I = Object.is,
  defaultActiveItemIndex: T,
  valueArrayToStringFn: R = JSON.stringify,
  rootClassName: A,
  dropdownProps: k,
  selectionListProps: F,
  slotBeforeList: H,
  slotAfterList: et,
  ...at
}, nt) => {
  const M = Y(null), st = Y(null), It = Y(null), ae = Y(null), [X, zr] = V(!1);
  ke(
    nt,
    () => st.current
  );
  const Zn = U(
    () => p?.value !== void 0 && p.onChange !== void 0 && X,
    [p, X]
  ), Vr = U(() => {
    if (!e?.length)
      return c;
    if (!m) {
      const W = g(e[0]);
      return typeof W == "object" ? "" : W?.toString();
    }
    return "";
  }, [m, c, g, e]), Kr = U(() => Zn ? m && !!e?.length : !0, [m, Zn, e?.length]), Jn = P(
    (W) => {
      !h && !d && n?.({
        selectedItem: {
          isSelected: !1,
          value: W
        },
        selectedValues: e?.filter((Ee) => !I(Ee, W)) ?? []
      });
    },
    [d, I, n, h, e]
  ), Ur = U(() => {
    if (!e?.length)
      return /* @__PURE__ */ s.jsx(O, { alignItems: "center", className: lt.placeholder, children: c });
    if (m) {
      const W = C < e.length ? e.slice(0, C) : e, Ee = C < e.length ? e.slice(C) : [];
      return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        W?.map((Le, ts) => /* @__PURE__ */ s.jsx(
          xs,
          {
            onDelete: () => {
              Jn(Le);
            },
            disabled: d,
            readOnly: h,
            children: g(Le)
          },
          ts
        )),
        !!Ee.length && /* @__PURE__ */ s.jsx(
          gt,
          {
            disabled: d,
            requireClick: !0,
            content: /* @__PURE__ */ s.jsx(
              O,
              {
                className: lt.hiddenItemsTooltip,
                gap: "100",
                flexWrap: "wrap",
                children: Ee?.map((Le, ts) => /* @__PURE__ */ s.jsx(
                  xs,
                  {
                    onDelete: () => {
                      Jn(Le);
                    },
                    disabled: d,
                    readOnly: h,
                    children: g(Le)
                  },
                  ts
                ))
              }
            ),
            light: !0,
            children: /* @__PURE__ */ s.jsxs(
              xs,
              {
                className: lt.hiddenItemsChip,
                disabled: d,
                children: [
                  "+ ",
                  Ee.length
                ]
              }
            )
          }
        )
      ] });
    }
    return /* @__PURE__ */ s.jsx(rt, { className: lt.titleBox, children: g(e[0]) });
  }, [
    e,
    m,
    g,
    c,
    C,
    d,
    h,
    Jn
  ]), dt = P(
    (W) => {
      (h || d) && W || (W !== X && w?.(W), zr(W));
    },
    [d, X, w, h]
  ), Fe = P(
    ({ target: W }) => {
      ae.current?.contains(W) || (M.current?.contains(W) && st.current?.focus(), dt(!1));
    },
    [dt]
  ), Re = P(
    (W) => {
      je(W.key) && X && (dt(!1), st.current?.focus());
    },
    [X, dt]
  ), qr = P(
    (W) => {
      W.relatedTarget && M.current?.contains(W.relatedTarget) || (dt(!1), v?.(W));
    },
    [v, dt]
  ), Gr = P(
    (W) => {
      X || W.stopPropagation(), dt(!0), y?.(W);
    },
    [X, y, dt]
  ), Yr = P(
    (W) => {
      Un(W.key) && dt(!0), _?.(W);
    },
    [_, dt]
  ), Qr = P(
    (W) => {
      W.stopPropagation(), dt(!X), st.current?.focus();
    },
    [X, dt]
  ), Xr = P(
    (W) => {
      W.stopPropagation(), st.current?.focus(), !d && !h && n?.({ selectedValues: [] });
    },
    [d, n, h]
  ), Zr = P(
    (W) => {
      n?.(W), st.current?.focus(), !x && !m ? dt(!1) : It.current?.focus();
    },
    [m, x, n, dt]
  );
  return tt(() => (X ? (window.addEventListener("click", Fe), window.addEventListener("keydown", Re)) : (window.removeEventListener("click", Fe), window.removeEventListener("keydown", Re)), () => {
    window.removeEventListener("click", Fe), window.removeEventListener("keydown", Re);
  }), [Fe, Re, X]), tt(() => {
    X && It.current?.focus();
  }, [X]), Qt(() => {
    window.removeEventListener("click", Fe), window.removeEventListener("keydown", Re);
  }), /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": mx,
      ref: M,
      className: f(lt.root, A, {
        [lt.rootHasWrapperIcon]: !!i,
        [lt.rootReadOnly]: h
      }),
      "aria-expanded": X,
      "aria-haspopup": "listbox",
      role: "combobox",
      children: [
        /* @__PURE__ */ s.jsx(
          Rt,
          {
            ...at,
            ref: st,
            className: f(a, lt.inputWrapper),
            prefix: o,
            suffix: r,
            disabled: d,
            icon: i,
            active: X,
            status: l,
            onClick: Gr,
            onBlur: qr,
            onKeyDown: Yr,
            tabIndex: d ? -1 : b ?? 0,
            children: /* @__PURE__ */ s.jsxs(O, { className: lt.inputWrapperChild, children: [
              /* @__PURE__ */ s.jsxs(O, { gap: "100", flexWrap: "wrap", className: lt.titleContainer, children: [
                Kr && Ur,
                Zn && /* @__PURE__ */ s.jsx(
                  "input",
                  {
                    ...p,
                    ref: It,
                    className: f(lt.filterInput, p?.className),
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    placeholder: Vr,
                    disabled: d || p?.disabled
                  }
                )
              ] }),
              /* @__PURE__ */ s.jsxs(O, { alignItems: "center", className: lt.iconContainer, children: [
                S && !d && !h && !!e?.length && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: "close",
                    disabled: d,
                    onClick: Xr,
                    "aria-label": "Clear"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  K,
                  {
                    className: lt.iconButton,
                    variant: "tertiary",
                    icon: X ? "angle-up" : "angle-down",
                    disabled: d,
                    onClick: Qr,
                    "aria-label": X ? "Close" : "Open"
                  }
                )
              ] })
            ] })
          }
        ),
        t && /* @__PURE__ */ s.jsx(
          "input",
          {
            type: "hidden",
            disabled: d,
            name: t,
            value: R(e)
          }
        ),
        /* @__PURE__ */ s.jsx(
          Xt,
          {
            isOpen: X,
            ...k,
            className: f(k?.className, lt.dropdown),
            children: /* @__PURE__ */ s.jsx("div", { ref: ae, style: { width: "100%" }, children: X && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
              H,
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              /* @__PURE__ */ s.jsx(
                Xb,
                {
                  ...F,
                  equalityFn: I,
                  defaultActiveItemIndex: T,
                  isActive: X,
                  isMultiple: m,
                  selectedValues: e,
                  onChange: Zr,
                  children: u
                }
              ),
              et
            ] }) })
          }
        )
      ]
    }
  );
}, gx = Object.assign($(Qo), {
  name: Qo.name
}), _k = ({
  className: a,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: a,
    label: r,
    labelFor: e,
    meta: i,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      gx,
      {
        name: e,
        value: t || [],
        onChange: (g) => {
          n(g.selectedValues);
        },
        ...o,
        status: z.getStatus(i),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), fx = "h-slider--slider__rootWrapper", bx = "h-slider--slider__rootWrapperNoAnnotations", xx = "h-slider--slider__root", yx = "h-slider--slider__rootDark", _x = "h-slider--slider__rootDisabled", Cx = "h-slider--slider__handle", wx = "h-slider--slider__trackWrapper", vx = "h-slider--slider__track", Sx = "h-slider--slider__highlight", Ix = "h-slider--slider__minValueIndicator", Dx = "h-slider--slider__maxValueIndicator", ft = {
  rootWrapper: fx,
  rootWrapperNoAnnotations: bx,
  root: xx,
  rootDark: yx,
  rootDisabled: _x,
  handle: Cx,
  trackWrapper: wx,
  track: vx,
  highlight: Sx,
  minValueIndicator: Ix,
  maxValueIndicator: Dx
};
var Tt = /* @__PURE__ */ ((a) => (a.LowBoundIndicator = "input-slider-low-indicator", a.HighBoundIndicator = "input-slider-high-indicator", a.Handle = "input-slider-handle", a.Value = "input-slider-value", a.TrackBackground = "input-slider-tack-background", a.Track = "input-slider-track", a.Highlight = "input-slider-highlight", a))(Tt || {});
const kx = (a) => {
  a.preventDefault();
}, Tx = (a, t, e) => typeof a != "number" && !Array.isArray(a) ? "" : typeof a == "number" ? /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "3", children: [
  t,
  a,
  e
] }) : /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "3", children: [
  t,
  a[0],
  e,
  " - ",
  t,
  a[1],
  e
] });
class jx extends D {
  static defaultProps = {
    min: 0,
    max: 100,
    dark: !1,
    highlightRange: null,
    formatValue: Tx,
    hideAnnotations: !1
  };
  constructor(t) {
    super(t), this.state = {
      startX: 0,
      startVal: 0,
      sliderWidth: 0,
      currentIndex: null
    }, this.handleHandleGrab = this.handleHandleGrab.bind(this), this.handleHandleMove = this.handleHandleMove.bind(this), this.handleHandleDrop = this.handleHandleDrop.bind(this), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleSliderMouseDown = this.handleSliderMouseDown.bind(this), this.relativeValueToAbsoluteValue = this.relativeValueToAbsoluteValue.bind(this), this.absoluteValueToRelativeValue = this.absoluteValueToRelativeValue.bind(this);
  }
  sliderRef = B();
  isInterval(t) {
    return Array.isArray(t);
  }
  handleChange(t) {
    typeof t == "number" ? this.props.onChange?.(Math.round(t)) : this.props.onChange?.(
      t.map((e) => Math.round(e))
    );
  }
  /*
    This method handles grab on handle, and saves the index of the handle, so that
    when the event bubbles to the slider, the handler will know that we chose a specific handle
   */
  handleHandleGrab(t) {
    t.target instanceof Element && this.setState({
      currentIndex: parseInt(
        t.target.getAttribute("data-index") || "",
        10
      )
    });
  }
  handleHandleMove(t) {
    t.preventDefault();
    const { startVal: e, startX: n, sliderWidth: o, currentIndex: r } = this.state, i = e + (t.clientX - n) / o, l = this.getAbsoluteValue(i, r);
    this.handleChange(l);
  }
  handleHandleDrop() {
    window.removeEventListener("mousemove", this.handleHandleMove), window.removeEventListener("mouseup", this.handleHandleDrop), this.setState({ currentIndex: null });
  }
  handleKeyDown(t) {
    const { step: e = 1, value: n } = this.props;
    t.preventDefault();
    const o = this.isInterval(n) && t.target instanceof Element ? parseInt(t.target.getAttribute("data-index") || "", 10) : null;
    switch (t.key) {
      case "ArrowRight":
      case "ArrowUp":
        this.increment(e, o);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        this.increment(-e, o);
        break;
    }
  }
  /*
    This method handles mouse down on the slider (both handles and track)
    this will move the handle to the click position and start a drag.
    If the slider is an interval slider it will move and grab the closest handle
   */
  handleSliderMouseDown(t) {
    if (!this.sliderRef.current) return;
    const { value: e } = this.props, { currentIndex: n } = this.state, o = this.sliderRef.current.getBoundingClientRect(), r = (t.clientX - o.left) / o.width;
    this.setState({
      startX: t.clientX,
      // save the current mouse x
      startVal: r,
      // save the current percentage
      sliderWidth: o.width
      // save the slider width
    });
    let i;
    if (this.isInterval(e)) {
      const l = n ?? this.findTheNearestHandle(r, e);
      this.setState({
        currentIndex: l
      }), i = this.getAbsoluteValue(r, l);
    } else
      i = this.getAbsoluteValue(r);
    this.handleChange(i), window.addEventListener("mousemove", this.handleHandleMove), window.addEventListener("mouseup", this.handleHandleDrop);
  }
  findTheNearestHandle(t, e) {
    const [n, o] = e.map(
      this.absoluteValueToRelativeValue
    );
    return t > o && t > n ? 1 : t < o && t < n ? 0 : Math.abs(n - t) > Math.abs(o - t) ? 1 : 0;
  }
  getAdjustedStep(t) {
    const { min: e, max: n } = this.props;
    return t / (n - e);
  }
  getAbsoluteValue(t, e) {
    const { value: n, step: o } = this.props;
    let r = Nn(t, 0, 1);
    if (o) {
      const h = this.getAdjustedStep(o);
      r = Math.round(r / h) * h;
    }
    if (!this.isInterval(n))
      return this.relativeValueToAbsoluteValue(r);
    const [i, l] = n;
    let c = this.relativeValueToAbsoluteValue(r);
    e === 0 && c > l ? c = l : e === 1 && c < i && (c = i);
    const d = [i, l];
    return typeof e == "number" && (d[e] = c), d;
  }
  /**
   * @param ratio Is a number between 0 and 1 and it represents the **relative**
   *   placement of the handle within the slider track.
   */
  relativeValueToAbsoluteValue(t) {
    const { min: e, max: n } = this.props, o = e + (n - e) * t;
    return Nn(o, e, n);
  }
  /**
   * @param value Is a number between 'min' and 'max' and it represents the
   *   **absolute** value that is derived from the relative placement of the
   *   handle.
   */
  absoluteValueToRelativeValue(t) {
    const { min: e, max: n } = this.props, o = (t - e) / (n - e);
    return Nn(o, 0, 1);
  }
  increment(t, e) {
    const { value: n } = this.props;
    let o;
    if (this.isInterval(n)) {
      const r = [...n];
      r[e ?? 0] = r[e ?? 0] + t, o = r;
    } else
      o = n + t;
    this.handleChange(o);
  }
  getTrackStyles() {
    const { value: t, min: e } = this.props, n = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[1]) - this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(t), o = this.isInterval(t) ? this.absoluteValueToRelativeValue(t[0]) : this.absoluteValueToRelativeValue(e);
    return {
      width: `${n * 100}%`,
      left: `${o * 100}%`
    };
  }
  getHandleStyles(t) {
    const { value: e } = this.props;
    return {
      left: `${(this.isInterval(e) ? this.absoluteValueToRelativeValue(e[t ?? 0]) : this.absoluteValueToRelativeValue(e)) * 100}%`
    };
  }
  getHighlightStyles() {
    const { highlightRange: t } = this.props;
    if (yt(t)) return {};
    const [e, n] = t.map(this.absoluteValueToRelativeValue);
    return {
      left: `${e * 100}%`,
      width: `${(n - e) * 100}%`
    };
  }
  render() {
    const {
      className: t,
      value: e,
      step: n,
      highlightRange: o,
      min: r,
      max: i,
      dark: l,
      disabled: c,
      onChange: d,
      formatValue: h,
      hideAnnotations: u,
      valuePrefix: p,
      valueSuffix: m,
      onBlur: g,
      onFocus: b,
      children: x,
      ...w
    } = this.props, y = f(
      ft.root,
      { [ft.rootDark]: l },
      { [ft.rootDisabled]: c },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        className: f(ft.rootWrapper, {
          [ft.rootWrapperNoAnnotations]: u
        }),
        children: [
          /* @__PURE__ */ s.jsxs(
            "div",
            {
              ...w,
              className: y,
              ref: this.sliderRef,
              onMouseDown: this.handleSliderMouseDown,
              children: [
                /* @__PURE__ */ s.jsxs(
                  "div",
                  {
                    className: ft.trackWrapper,
                    "data-testid": Tt.TrackBackground,
                    children: [
                      !yt(o) && /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: ft.highlight,
                          style: this.getHighlightStyles(),
                          "data-testid": Tt.Highlight
                        }
                      ),
                      /* @__PURE__ */ s.jsx(
                        "div",
                        {
                          className: ft.track,
                          style: this.getTrackStyles(),
                          "data-testid": Tt.Track
                        }
                      )
                    ]
                  }
                ),
                !this.isInterval(e) && /* @__PURE__ */ s.jsx(
                  "button",
                  {
                    tabIndex: 0,
                    role: "slider",
                    type: "button",
                    "aria-valuemin": r,
                    "aria-valuemax": i,
                    "aria-valuenow": e,
                    className: ft.handle,
                    onClick: kx,
                    onKeyDown: this.handleKeyDown,
                    style: this.getHandleStyles(),
                    "data-testid": Tt.Handle
                  }
                ),
                this.isInterval(e) && /* @__PURE__ */ s.jsxs(Yt, { children: [
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "0",
                      className: ft.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(0),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Tt.Handle
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "button",
                    {
                      tabIndex: 0,
                      type: "button",
                      "data-index": "1",
                      className: ft.handle,
                      onKeyDown: this.handleKeyDown,
                      style: this.getHandleStyles(1),
                      onMouseDown: this.handleHandleGrab,
                      "data-testid": Tt.Handle
                    }
                  )
                ] }),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    "data-testid": Tt.LowBoundIndicator,
                    className: ft.minValueIndicator,
                    children: /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      r,
                      m
                    ] })
                  }
                ),
                !u && /* @__PURE__ */ s.jsx(
                  "span",
                  {
                    className: ft.maxValueIndicator,
                    "data-testid": Tt.HighBoundIndicator,
                    children: /* @__PURE__ */ s.jsxs(L.Paragraph, { variant: "4", as: "span", subdued: !0, children: [
                      p,
                      i,
                      m
                    ] })
                  }
                )
              ]
            }
          ),
          !u && /* @__PURE__ */ s.jsx("div", { "data-testid": Tt.Value, children: h(e, p, m) })
        ]
      }
    );
  }
}
const Fs = on(jx, {
  fallback: null
}), Nx = "h-fieldSlider--fieldSlider__root", Px = {
  root: Nx
};
class Ck extends D {
  constructor(t) {
    super(t), this.handleChange = this.handleChange.bind(this), this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange(t) {
    const e = new Event("change");
    Object.defineProperty(e, "target", {
      writable: !0,
      value: { value: t, name: this.props.input.name }
    }), this.props.input.onChange(e);
  }
  /**
   * Redux form performs a value check when `blur` happens, so we need to make
   * sure the value is attached to the blur event otherwise it will be set to
   * null
   *
   * @see https://github.com/redux-form/redux-form/issues/2768
   */
  handleBlur(t) {
    const { input: e } = this.props, n = new FocusEvent(
      "blur",
      t
    );
    Object.defineProperty(n, "target", {
      writable: !0,
      value: { value: e.value, name: e.name }
    }), e.onBlur?.(n);
  }
  render() {
    const {
      className: t,
      input: e,
      meta: n,
      label: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props, p = f(Px.root, t);
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: p,
        label: o,
        meta: n,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Fs,
          {
            ...e,
            onChange: this.handleChange,
            disabled: i,
            ...u
          }
        )
      }
    );
  }
}
const Fx = "h-switch--switch__root", Rx = "h-switch--switch__input", Ex = "h-switch--switch__inner", Lx = "h-switch--switch__pending", Ax = "h-switch--switch__active", Ve = {
  root: Fx,
  input: Rx,
  inner: Ex,
  pending: Lx,
  active: Ax
}, Xo = {
  input: "Switch-input",
  label: "Switch-label"
};
class $x extends D {
  render() {
    const { id: t, className: e, variant: n, ...o } = this.props, r = t || `switch_${Math.random()}`;
    return /* @__PURE__ */ s.jsxs("div", { className: f(e, Ve.root), "data-testid": t, children: [
      /* @__PURE__ */ s.jsx(
        "input",
        {
          ...o,
          id: r,
          type: "checkbox",
          className: Ve.input,
          "data-testid": Xo.input
        }
      ),
      /* @__PURE__ */ s.jsx(
        "label",
        {
          htmlFor: r,
          className: f(Ve.inner, {
            [Ve.active]: n === "active",
            [Ve.pending]: n === "pending"
          }),
          "data-testid": Xo.label
        }
      )
    ] });
  }
}
class wk extends D {
  render() {
    const { input: t, ...e } = this.props, { ref: n, ...o } = t;
    return /* @__PURE__ */ s.jsx($x, { ...o, ...e });
  }
}
class vk extends D {
  render() {
    const {
      className: t,
      input: e,
      label: n,
      meta: o,
      required: r,
      disabled: i,
      helpIcon: l,
      description: c,
      noAlert: d,
      noLabel: h,
      ...u
    } = this.props;
    return /* @__PURE__ */ s.jsx(
      z,
      {
        className: t,
        label: n,
        labelFor: e.name,
        meta: o,
        required: r,
        disabled: i,
        helpIcon: l,
        description: c,
        noAlert: d,
        noLabel: h,
        children: /* @__PURE__ */ s.jsx(
          Br,
          {
            status: z.getStatus(o),
            disabled: i,
            required: r,
            ...e,
            ...u
          }
        )
      }
    );
  }
}
const Sk = ({
  className: a,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => void n(b ?? ""),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: a,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: i,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        en,
        {
          selectedItems: e ? [e] : [],
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(i)
        }
      )
    }
  );
}, Ik = ({
  className: a,
  input: { name: t, value: e, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  description: d,
  helpIcon: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => {
  const g = P(
    (b) => void n({
      startTime: b.startTime ?? "",
      endTime: b.endTime ?? ""
    }),
    []
  );
  return /* @__PURE__ */ s.jsx(
    z,
    {
      className: a,
      description: d,
      disabled: c,
      helpIcon: h,
      label: r,
      labelFor: t,
      meta: i,
      noAlert: p,
      noLabel: u,
      required: l,
      children: /* @__PURE__ */ s.jsx(
        um,
        {
          endTime: e.endTime,
          startTime: e.startTime,
          ...o,
          ...m,
          disabled: c,
          id: t,
          onSelect: g,
          status: z.getStatus(i)
        }
      )
    }
  );
}, Bx = "h-inputColorPicker-indicator--inputColorPickerIndicator__root", Ox = "h-inputColorPicker-indicator--inputColorPickerIndicator__rootAlpha", Hx = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicator", Wx = "h-inputColorPicker-indicator--inputColorPickerIndicator__indicatorNoColor", vn = {
  root: Bx,
  rootAlpha: Ox,
  indicator: Hx,
  indicatorNoColor: Wx
}, Mx = ({
  color: a,
  alpha: t,
  className: e,
  ...n
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    ...n,
    className: f(vn.root, e, {
      [vn.rootAlpha]: t
    }),
    children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(vn.indicator, {
          [vn.indicatorNoColor]: !a
        }),
        style: { backgroundColor: a }
      }
    )
  }
), zx = "h-inputColorPicker--inputColorPicker__root", Vx = "h-inputColorPicker--inputColorPicker__inputContainer", Kx = "h-inputColorPicker--inputColorPicker__input", Ux = "h-inputColorPicker--inputColorPicker__rootReadOnly", qx = "h-inputColorPicker--inputColorPicker__iconContainer", Gx = "h-inputColorPicker--inputColorPicker__rootHasWrapperIcon", Yx = "h-inputColorPicker--inputColorPicker__clearIcon", Qx = "h-inputColorPicker--inputColorPicker__colorIndicator", Vt = {
  root: zx,
  inputContainer: Vx,
  input: Kx,
  rootReadOnly: Ux,
  iconContainer: qx,
  rootHasWrapperIcon: Gx,
  clearIcon: Yx,
  colorIndicator: Qx
}, Xx = "inputColorPickerTestId", Zx = ({
  className: a,
  name: t = Math.floor(Math.random() * 1e8).toString(),
  value: e,
  onChange: n,
  dropdownProps: o,
  prefix: r,
  suffix: i,
  icon: l,
  status: c,
  placeholder: d,
  disabled: h,
  colorPickerProps: u,
  clearable: p,
  readOnly: m,
  children: g,
  ...b
}) => {
  const x = Y(null), w = Y(null), y = Y(null), [v, _] = V(!1);
  tt(() => {
    v ? (window.addEventListener("click", S), window.addEventListener("keydown", I)) : (window.removeEventListener("click", S), window.removeEventListener("keydown", I)), v && C();
  }, [v]), Qt(() => {
    window.removeEventListener("click", S), window.removeEventListener("keydown", I);
  });
  const C = () => {
    y.current?.querySelector("input")?.focus();
  }, S = ({ target: F }) => {
    w.current?.contains(F) || _(!1);
  }, I = (F) => {
    je(F.key) && v && (F.stopPropagation(), _(!1));
  }, T = () => {
    m || _(!0);
  }, R = ({ target: F }) => {
    w.current?.contains(F) || _(!1);
  }, A = () => {
    m || _(!0);
  }, k = ({ key: F }) => {
    Un(F) && _(!0);
  };
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      "data-testid": Xx,
      ref: w,
      className: f(Vt.root, a, {
        [Vt.rootHasWrapperIcon]: !!l,
        [Vt.rootReadOnly]: m
      }),
      children: [
        /* @__PURE__ */ s.jsx(
          Rt,
          {
            prefix: r,
            suffix: i,
            disabled: h,
            icon: l,
            active: v,
            status: c,
            children: /* @__PURE__ */ s.jsxs("div", { className: Vt.inputContainer, children: [
              /* @__PURE__ */ s.jsx(
                "input",
                {
                  ...b,
                  id: t,
                  name: t,
                  className: Vt.input,
                  ref: x,
                  onClick: A,
                  onFocus: T,
                  onBlur: R,
                  onKeyDown: k,
                  disabled: h,
                  placeholder: d,
                  autoComplete: "off",
                  value: e,
                  onChange: Ln(e) ? void 0 : E,
                  readOnly: !0
                }
              ),
              /* @__PURE__ */ s.jsx("div", { className: Vt.iconContainer, children: p && e && /* @__PURE__ */ s.jsx(
                K,
                {
                  className: Vt.clearIcon,
                  variant: "tertiary",
                  icon: "close",
                  disabled: h,
                  onClick: () => n?.("")
                }
              ) }),
              /* @__PURE__ */ s.jsx(
                Mx,
                {
                  className: Vt.colorIndicator,
                  onClick: A,
                  color: e,
                  alpha: u?.alpha
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ s.jsx(Xt, { ...o, isOpen: v, children: /* @__PURE__ */ s.jsx("div", { ref: y, children: /* @__PURE__ */ s.jsx(
          qn,
          {
            margin: "300",
            ...u,
            color: e,
            onChange: n ?? E,
            children: g
          }
        ) }) })
      ]
    }
  );
}, Dk = ({
  className: a,
  input: { value: t, name: e, onChange: n, ...o },
  label: r,
  meta: i,
  required: l,
  disabled: c,
  helpIcon: d,
  description: h,
  noLabel: u,
  noAlert: p,
  ...m
}) => /* @__PURE__ */ s.jsx(
  z,
  {
    className: a,
    label: r,
    labelFor: e,
    meta: i,
    required: l,
    disabled: c,
    helpIcon: d,
    description: h,
    noLabel: u,
    noAlert: p,
    children: /* @__PURE__ */ s.jsx(
      Zx,
      {
        name: e,
        value: t,
        onChange: n,
        ...o,
        status: z.getStatus(i),
        disabled: c,
        required: l,
        ...m
      }
    )
  }
), Jx = "h-fieldAddonDropdown--fieldAddonDropdown__root", ty = "h-fieldAddonDropdown--fieldAddonDropdown__prefix", ey = "h-fieldAddonDropdown--fieldAddonDropdown__suffix", ny = "h-fieldAddonDropdown--fieldAddonDropdown__angleDown", Sn = {
  root: Jx,
  prefix: ty,
  suffix: ey,
  angleDown: ny
}, kk = ({
  className: a,
  noArrow: t,
  ...e
}) => As(e) ? null : /* @__PURE__ */ s.jsx(Is.Consumer, { children: ({ position: n, disabled: o }) => /* @__PURE__ */ s.jsx(
  Gs,
  {
    ...hr(e, "meta"),
    noStyle: !0,
    itemComponent: jr,
    children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: f(
          Sn.root,
          {
            [Sn.prefix]: n === "prefix",
            [Sn.suffix]: n === "suffix"
          },
          a
        ),
        disabled: o || e.meta.disabled,
        type: "button",
        children: [
          /* @__PURE__ */ s.jsx("span", { children: e.meta.selectedValue }),
          !t && /* @__PURE__ */ s.jsx(
            N,
            {
              name: "angle-down",
              className: f("icon-vertical-fix", Sn.angleDown)
            }
          )
        ]
      }
    )
  }
) }), sy = "h-countryFlag--countryFlag__flag", oy = "h-countryFlag--countryFlag__ad", ry = "h-countryFlag--countryFlag__ae", ay = "h-countryFlag--countryFlag__af", iy = "h-countryFlag--countryFlag__ag", ly = "h-countryFlag--countryFlag__ai", cy = "h-countryFlag--countryFlag__al", dy = "h-countryFlag--countryFlag__am", hy = "h-countryFlag--countryFlag__ao", uy = "h-countryFlag--countryFlag__aq", py = "h-countryFlag--countryFlag__ar", my = "h-countryFlag--countryFlag__as", gy = "h-countryFlag--countryFlag__at", fy = "h-countryFlag--countryFlag__au", by = "h-countryFlag--countryFlag__aw", xy = "h-countryFlag--countryFlag__ax", yy = "h-countryFlag--countryFlag__az", _y = "h-countryFlag--countryFlag__ba", Cy = "h-countryFlag--countryFlag__bb", wy = "h-countryFlag--countryFlag__bd", vy = "h-countryFlag--countryFlag__be", Sy = "h-countryFlag--countryFlag__bf", Iy = "h-countryFlag--countryFlag__bg", Dy = "h-countryFlag--countryFlag__bh", ky = "h-countryFlag--countryFlag__bi", Ty = "h-countryFlag--countryFlag__bj", jy = "h-countryFlag--countryFlag__bl", Ny = "h-countryFlag--countryFlag__bm", Py = "h-countryFlag--countryFlag__bn", Fy = "h-countryFlag--countryFlag__bo", Ry = "h-countryFlag--countryFlag__bq", Ey = "h-countryFlag--countryFlag__br", Ly = "h-countryFlag--countryFlag__bs", Ay = "h-countryFlag--countryFlag__bt", $y = "h-countryFlag--countryFlag__bv", By = "h-countryFlag--countryFlag__bw", Oy = "h-countryFlag--countryFlag__by", Hy = "h-countryFlag--countryFlag__bz", Wy = "h-countryFlag--countryFlag__ca", My = "h-countryFlag--countryFlag__cd", zy = "h-countryFlag--countryFlag__cf", Vy = "h-countryFlag--countryFlag__cg", Ky = "h-countryFlag--countryFlag__ch", Uy = "h-countryFlag--countryFlag__ci", qy = "h-countryFlag--countryFlag__ck", Gy = "h-countryFlag--countryFlag__cl", Yy = "h-countryFlag--countryFlag__cm", Qy = "h-countryFlag--countryFlag__cn", Xy = "h-countryFlag--countryFlag__co", Zy = "h-countryFlag--countryFlag__cp", Jy = "h-countryFlag--countryFlag__cr", t_ = "h-countryFlag--countryFlag__cu", e_ = "h-countryFlag--countryFlag__cv", n_ = "h-countryFlag--countryFlag__cw", s_ = "h-countryFlag--countryFlag__cy", o_ = "h-countryFlag--countryFlag__cz", r_ = "h-countryFlag--countryFlag__de", a_ = "h-countryFlag--countryFlag__dj", i_ = "h-countryFlag--countryFlag__dk", l_ = "h-countryFlag--countryFlag__dm", c_ = "h-countryFlag--countryFlag__dz", d_ = "h-countryFlag--countryFlag__ec", h_ = "h-countryFlag--countryFlag__ee", u_ = "h-countryFlag--countryFlag__eg", p_ = "h-countryFlag--countryFlag__eh", m_ = "h-countryFlag--countryFlag__er", g_ = "h-countryFlag--countryFlag__es", f_ = "h-countryFlag--countryFlag__et", b_ = "h-countryFlag--countryFlag__eu", x_ = "h-countryFlag--countryFlag__fi", y_ = "h-countryFlag--countryFlag__fj", __ = "h-countryFlag--countryFlag__fm", C_ = "h-countryFlag--countryFlag__fo", w_ = "h-countryFlag--countryFlag__fr", v_ = "h-countryFlag--countryFlag__ga", S_ = "h-countryFlag--countryFlag__gb", I_ = "h-countryFlag--countryFlag__gd", D_ = "h-countryFlag--countryFlag__ge", k_ = "h-countryFlag--countryFlag__gg", T_ = "h-countryFlag--countryFlag__gh", j_ = "h-countryFlag--countryFlag__gi", N_ = "h-countryFlag--countryFlag__gl", P_ = "h-countryFlag--countryFlag__gm", F_ = "h-countryFlag--countryFlag__gn", R_ = "h-countryFlag--countryFlag__gp", E_ = "h-countryFlag--countryFlag__gq", L_ = "h-countryFlag--countryFlag__gr", A_ = "h-countryFlag--countryFlag__gt", $_ = "h-countryFlag--countryFlag__gu", B_ = "h-countryFlag--countryFlag__gw", O_ = "h-countryFlag--countryFlag__gy", H_ = "h-countryFlag--countryFlag__hk", W_ = "h-countryFlag--countryFlag__hn", M_ = "h-countryFlag--countryFlag__hr", z_ = "h-countryFlag--countryFlag__ht", V_ = "h-countryFlag--countryFlag__hu", K_ = "h-countryFlag--countryFlag__id", U_ = "h-countryFlag--countryFlag__ie", q_ = "h-countryFlag--countryFlag__il", G_ = "h-countryFlag--countryFlag__im", Y_ = "h-countryFlag--countryFlag__iq", Q_ = "h-countryFlag--countryFlag__ir", X_ = "h-countryFlag--countryFlag__is", Z_ = "h-countryFlag--countryFlag__it", J_ = "h-countryFlag--countryFlag__je", tC = "h-countryFlag--countryFlag__jm", eC = "h-countryFlag--countryFlag__jo", nC = "h-countryFlag--countryFlag__jp", sC = "h-countryFlag--countryFlag__ke", oC = "h-countryFlag--countryFlag__kg", rC = "h-countryFlag--countryFlag__kh", aC = "h-countryFlag--countryFlag__ki", iC = "h-countryFlag--countryFlag__km", lC = "h-countryFlag--countryFlag__kn", cC = "h-countryFlag--countryFlag__kp", dC = "h-countryFlag--countryFlag__kr", hC = "h-countryFlag--countryFlag__kw", uC = "h-countryFlag--countryFlag__ky", pC = "h-countryFlag--countryFlag__kz", mC = "h-countryFlag--countryFlag__la", gC = "h-countryFlag--countryFlag__lb", fC = "h-countryFlag--countryFlag__lc", bC = "h-countryFlag--countryFlag__li", xC = "h-countryFlag--countryFlag__lk", yC = "h-countryFlag--countryFlag__lr", _C = "h-countryFlag--countryFlag__ls", CC = "h-countryFlag--countryFlag__lt", wC = "h-countryFlag--countryFlag__lu", vC = "h-countryFlag--countryFlag__lv", SC = "h-countryFlag--countryFlag__ly", IC = "h-countryFlag--countryFlag__ma", DC = "h-countryFlag--countryFlag__mc", kC = "h-countryFlag--countryFlag__md", TC = "h-countryFlag--countryFlag__me", jC = "h-countryFlag--countryFlag__mf", NC = "h-countryFlag--countryFlag__mg", PC = "h-countryFlag--countryFlag__mh", FC = "h-countryFlag--countryFlag__mk", RC = "h-countryFlag--countryFlag__ml", EC = "h-countryFlag--countryFlag__mm", LC = "h-countryFlag--countryFlag__mn", AC = "h-countryFlag--countryFlag__mo", $C = "h-countryFlag--countryFlag__mq", BC = "h-countryFlag--countryFlag__mr", OC = "h-countryFlag--countryFlag__ms", HC = "h-countryFlag--countryFlag__mt", WC = "h-countryFlag--countryFlag__mu", MC = "h-countryFlag--countryFlag__mv", zC = "h-countryFlag--countryFlag__mw", VC = "h-countryFlag--countryFlag__mx", KC = "h-countryFlag--countryFlag__my", UC = "h-countryFlag--countryFlag__mz", qC = "h-countryFlag--countryFlag__na", GC = "h-countryFlag--countryFlag__nc", YC = "h-countryFlag--countryFlag__ne", QC = "h-countryFlag--countryFlag__ng", XC = "h-countryFlag--countryFlag__ni", ZC = "h-countryFlag--countryFlag__nl", JC = "h-countryFlag--countryFlag__no", tw = "h-countryFlag--countryFlag__np", ew = "h-countryFlag--countryFlag__nq", nw = "h-countryFlag--countryFlag__nr", sw = "h-countryFlag--countryFlag__nu", ow = "h-countryFlag--countryFlag__nz", rw = "h-countryFlag--countryFlag__om", aw = "h-countryFlag--countryFlag__pa", iw = "h-countryFlag--countryFlag__pe", lw = "h-countryFlag--countryFlag__pf", cw = "h-countryFlag--countryFlag__pg", dw = "h-countryFlag--countryFlag__ph", hw = "h-countryFlag--countryFlag__pk", uw = "h-countryFlag--countryFlag__pl", pw = "h-countryFlag--countryFlag__pr", mw = "h-countryFlag--countryFlag__ps", gw = "h-countryFlag--countryFlag__pt", fw = "h-countryFlag--countryFlag__pw", bw = "h-countryFlag--countryFlag__py", xw = "h-countryFlag--countryFlag__qa", yw = "h-countryFlag--countryFlag__re", _w = "h-countryFlag--countryFlag__ro", Cw = "h-countryFlag--countryFlag__rs", ww = "h-countryFlag--countryFlag__ru", vw = "h-countryFlag--countryFlag__rw", Sw = "h-countryFlag--countryFlag__sa", Iw = "h-countryFlag--countryFlag__sb", Dw = "h-countryFlag--countryFlag__sc", kw = "h-countryFlag--countryFlag__sd", Tw = "h-countryFlag--countryFlag__se", jw = "h-countryFlag--countryFlag__sg", Nw = "h-countryFlag--countryFlag__sh", Pw = "h-countryFlag--countryFlag__si", Fw = "h-countryFlag--countryFlag__sj", Rw = "h-countryFlag--countryFlag__sk", Ew = "h-countryFlag--countryFlag__sl", Lw = "h-countryFlag--countryFlag__sm", Aw = "h-countryFlag--countryFlag__sn", $w = "h-countryFlag--countryFlag__so", Bw = "h-countryFlag--countryFlag__sr", Ow = "h-countryFlag--countryFlag__ss", Hw = "h-countryFlag--countryFlag__st", Ww = "h-countryFlag--countryFlag__sv", Mw = "h-countryFlag--countryFlag__sx", zw = "h-countryFlag--countryFlag__sy", Vw = "h-countryFlag--countryFlag__sz", Kw = "h-countryFlag--countryFlag__tc", Uw = "h-countryFlag--countryFlag__td", qw = "h-countryFlag--countryFlag__tg", Gw = "h-countryFlag--countryFlag__th", Yw = "h-countryFlag--countryFlag__tj", Qw = "h-countryFlag--countryFlag__tl", Xw = "h-countryFlag--countryFlag__tm", Zw = "h-countryFlag--countryFlag__tn", Jw = "h-countryFlag--countryFlag__to", tv = "h-countryFlag--countryFlag__tr", ev = "h-countryFlag--countryFlag__tt", nv = "h-countryFlag--countryFlag__tv", sv = "h-countryFlag--countryFlag__tw", ov = "h-countryFlag--countryFlag__tz", rv = "h-countryFlag--countryFlag__ua", av = "h-countryFlag--countryFlag__ug", iv = "h-countryFlag--countryFlag__us", lv = "h-countryFlag--countryFlag__uy", cv = "h-countryFlag--countryFlag__uz", dv = "h-countryFlag--countryFlag__va", hv = "h-countryFlag--countryFlag__vc", uv = "h-countryFlag--countryFlag__ve", pv = "h-countryFlag--countryFlag__vg", mv = "h-countryFlag--countryFlag__vi", gv = "h-countryFlag--countryFlag__vn", fv = "h-countryFlag--countryFlag__vu", bv = "h-countryFlag--countryFlag__ws", xv = "h-countryFlag--countryFlag__ye", yv = "h-countryFlag--countryFlag__yt", _v = "h-countryFlag--countryFlag__za", Cv = "h-countryFlag--countryFlag__zm", wv = "h-countryFlag--countryFlag__zw", Zo = {
  flag: sy,
  ad: oy,
  ae: ry,
  af: ay,
  ag: iy,
  ai: ly,
  al: cy,
  am: dy,
  ao: hy,
  aq: uy,
  ar: py,
  as: my,
  at: gy,
  au: fy,
  aw: by,
  ax: xy,
  az: yy,
  ba: _y,
  bb: Cy,
  bd: wy,
  be: vy,
  bf: Sy,
  bg: Iy,
  bh: Dy,
  bi: ky,
  bj: Ty,
  bl: jy,
  bm: Ny,
  bn: Py,
  bo: Fy,
  bq: Ry,
  br: Ey,
  bs: Ly,
  bt: Ay,
  bv: $y,
  bw: By,
  by: Oy,
  bz: Hy,
  ca: Wy,
  cd: My,
  cf: zy,
  cg: Vy,
  ch: Ky,
  ci: Uy,
  ck: qy,
  cl: Gy,
  cm: Yy,
  cn: Qy,
  co: Xy,
  cp: Zy,
  cr: Jy,
  cu: t_,
  cv: e_,
  cw: n_,
  cy: s_,
  cz: o_,
  de: r_,
  dj: a_,
  dk: i_,
  dm: l_,
  do: "h-countryFlag--countryFlag__do",
  dz: c_,
  ec: d_,
  ee: h_,
  eg: u_,
  eh: p_,
  er: m_,
  es: g_,
  et: f_,
  eu: b_,
  fi: x_,
  fj: y_,
  fm: __,
  fo: C_,
  fr: w_,
  ga: v_,
  gb: S_,
  gd: I_,
  ge: D_,
  gg: k_,
  gh: T_,
  gi: j_,
  gl: N_,
  gm: P_,
  gn: F_,
  gp: R_,
  gq: E_,
  gr: L_,
  gt: A_,
  gu: $_,
  gw: B_,
  gy: O_,
  hk: H_,
  hn: W_,
  hr: M_,
  ht: z_,
  hu: V_,
  id: K_,
  ie: U_,
  il: q_,
  im: G_,
  in: "h-countryFlag--countryFlag__in",
  iq: Y_,
  ir: Q_,
  is: X_,
  it: Z_,
  je: J_,
  jm: tC,
  jo: eC,
  jp: nC,
  ke: sC,
  kg: oC,
  kh: rC,
  ki: aC,
  km: iC,
  kn: lC,
  kp: cC,
  kr: dC,
  kw: hC,
  ky: uC,
  kz: pC,
  la: mC,
  lb: gC,
  lc: fC,
  li: bC,
  lk: xC,
  lr: yC,
  ls: _C,
  lt: CC,
  lu: wC,
  lv: vC,
  ly: SC,
  ma: IC,
  mc: DC,
  md: kC,
  me: TC,
  mf: jC,
  mg: NC,
  mh: PC,
  mk: FC,
  ml: RC,
  mm: EC,
  mn: LC,
  mo: AC,
  mq: $C,
  mr: BC,
  ms: OC,
  mt: HC,
  mu: WC,
  mv: MC,
  mw: zC,
  mx: VC,
  my: KC,
  mz: UC,
  na: qC,
  nc: GC,
  ne: YC,
  ng: QC,
  ni: XC,
  nl: ZC,
  no: JC,
  np: tw,
  nq: ew,
  nr: nw,
  nu: sw,
  nz: ow,
  om: rw,
  pa: aw,
  pe: iw,
  pf: lw,
  pg: cw,
  ph: dw,
  pk: hw,
  pl: uw,
  pr: pw,
  ps: mw,
  pt: gw,
  pw: fw,
  py: bw,
  qa: xw,
  re: yw,
  ro: _w,
  rs: Cw,
  ru: ww,
  rw: vw,
  sa: Sw,
  sb: Iw,
  sc: Dw,
  sd: kw,
  se: Tw,
  sg: jw,
  sh: Nw,
  si: Pw,
  sj: Fw,
  sk: Rw,
  sl: Ew,
  sm: Lw,
  sn: Aw,
  so: $w,
  sr: Bw,
  ss: Ow,
  st: Hw,
  sv: Ww,
  sx: Mw,
  sy: zw,
  sz: Vw,
  tc: Kw,
  td: Uw,
  tg: qw,
  th: Gw,
  tj: Yw,
  tl: Qw,
  tm: Xw,
  tn: Zw,
  to: Jw,
  tr: tv,
  tt: ev,
  tv: nv,
  tw: sv,
  tz: ov,
  ua: rv,
  ug: av,
  us: iv,
  uy: lv,
  uz: cv,
  va: dv,
  vc: hv,
  ve: uv,
  vg: pv,
  vi: mv,
  vn: gv,
  vu: fv,
  ws: bv,
  ye: xv,
  yt: yv,
  za: _v,
  zm: Cv,
  zw: wv
}, vv = 127365, Sv = /^[a-z]{2}$/, Iv = (a) => Sv.test(a) ? String.fromCodePoint(
  ...a.split("").map((t) => vv + t.charCodeAt(0))
) : "", Tk = ({
  className: a,
  countryCode: t,
  size: e = 16
}) => navigator.userAgent.includes("Windows") ? /* @__PURE__ */ s.jsx(rt, { style: { width: e, height: e }, children: /* @__PURE__ */ s.jsx(
  rt,
  {
    className: f(Zo.flag, Zo[t], a),
    style: {
      width: 32,
      height: 32,
      transform: `scale(calc(${e} / 32))`
    }
  }
) }) : /* @__PURE__ */ s.jsx("span", { className: a, style: { fontSize: e }, children: Iv(t) }), jk = [
  "ad",
  "ae",
  "af",
  "ag",
  "ai",
  "al",
  "am",
  "ao",
  "ar",
  "as",
  "at",
  "au",
  "aw",
  "az",
  "ba",
  "bb",
  "bd",
  "be",
  "bf",
  "bg",
  "bh",
  "bi",
  "bj",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "bt",
  "bw",
  "by",
  "bz",
  "ca",
  "cd",
  "cf",
  "cg",
  "ch",
  "ci",
  "ck",
  "cl",
  "cm",
  "cn",
  "co",
  "cr",
  "cu",
  "cv",
  "cw",
  "cy",
  "cz",
  "de",
  "dj",
  "dk",
  "dm",
  "do",
  "dz",
  "ec",
  "ee",
  "eg",
  "er",
  "es",
  "et",
  "fi",
  "fj",
  "fk",
  "fm",
  "fo",
  "fr",
  "bl",
  "mf",
  "ga",
  "gb",
  "gd",
  "ge",
  "gf",
  "gh",
  "gi",
  "gl",
  "gm",
  "gn",
  "gp",
  "gq",
  "gr",
  "gt",
  "gu",
  "gw",
  "gy",
  "hk",
  "hn",
  "hr",
  "ht",
  "hu",
  "id",
  "ie",
  "il",
  "in",
  "io",
  "iq",
  "ir",
  "is",
  "it",
  "jm",
  "jo",
  "jp",
  "ke",
  "kg",
  "kh",
  "ki",
  "km",
  "kn",
  "kp",
  "kr",
  "kw",
  "ky",
  "kz",
  "la",
  "lb",
  "lc",
  "li",
  "lk",
  "lr",
  "ls",
  "lt",
  "lu",
  "lv",
  "ly",
  "ma",
  "mc",
  "md",
  "me",
  "mg",
  "mh",
  "mk",
  "ml",
  "mm",
  "mn",
  "mo",
  "mp",
  "mq",
  "mr",
  "ms",
  "mt",
  "mu",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nc",
  "ne",
  "nf",
  "ng",
  "ni",
  "nl",
  "bq",
  "no",
  "np",
  "nr",
  "nu",
  "nz",
  "om",
  "pa",
  "pe",
  "pf",
  "pg",
  "ph",
  "pk",
  "pl",
  "pm",
  "pr",
  "ps",
  "pt",
  "pw",
  "py",
  "qa",
  "re",
  "ro",
  "rs",
  "ru",
  "rw",
  "sa",
  "sb",
  "sc",
  "sd",
  "se",
  "sg",
  "sh",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sr",
  "ss",
  "st",
  "sv",
  "sx",
  "sy",
  "sz",
  "tc",
  "td",
  "tg",
  "th",
  "tj",
  "tk",
  "tl",
  "tm",
  "tn",
  "to",
  "tr",
  "tt",
  "tv",
  "tw",
  "tz",
  "ua",
  "ug",
  "us",
  "uy",
  "uz",
  "va",
  "vc",
  "ve",
  "vg",
  "vi",
  "vn",
  "vu",
  "wf",
  "ws",
  "ye",
  "za",
  "zm",
  "zw"
], Dv = "h-formGrid--formGrid__root", kv = {
  root: Dv
}, Tv = "formGridTestId", Nk = $(function({ className: t, children: e, ...n }, o) {
  const r = f(kv.root, t);
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-testid": Tv,
      className: r,
      ...n,
      ref: o,
      children: e
    }
  );
}), jv = "h-formGrid-field--formField__root", Nv = "h-formGrid-field--formField__rootSpan5", Pv = "h-formGrid-field--formField__rootSpan4", Fv = "h-formGrid-field--formField__rootSpan3", Rv = "h-formGrid-field--formField__rootSpan2", Ev = "h-formGrid-field--formField__rootSpan1", we = {
  root: jv,
  rootSpan5: Nv,
  rootSpan4: Pv,
  rootSpan3: Fv,
  rootSpan2: Rv,
  rootSpan1: Ev
}, Lv = "formFieldTestId", Av = {
  1: we.rootSpan1,
  2: we.rootSpan2,
  3: we.rootSpan3,
  4: we.rootSpan4,
  5: we.rootSpan5,
  6: void 0
};
class Pk extends D {
  static defaultProps = {
    span: 6
  };
  render() {
    const { span: t, className: e, children: n, ...o } = this.props, r = f(
      we.root,
      e,
      Av[t]
    );
    return /* @__PURE__ */ s.jsx("div", { "data-testid": Lv, className: r, ...o, children: n });
  }
}
const $v = "h-helperField--helperField__root", Bv = "h-helperField--helperField__label", Ov = "h-helperField--helperField__helpIcon", Hv = "h-helperField--helperField__error", Wv = "h-helperField--helperField__rootRequired", Ke = {
  root: $v,
  label: Bv,
  helpIcon: Ov,
  error: Hv,
  rootRequired: Wv
};
class Fk extends D {
  render() {
    const {
      className: t,
      label: e,
      required: n,
      disabled: o,
      errorMessage: r,
      fieldId: i,
      children: l,
      helpIcon: c,
      ...d
    } = this.props, h = f(
      {
        [Ke.root]: !0,
        [Ke.rootRequired]: n
      },
      t
    );
    return /* @__PURE__ */ s.jsxs("div", { ...d, className: h, children: [
      !!e && /* @__PURE__ */ s.jsx(
        "label",
        {
          className: Ke.label,
          htmlFor: i,
          id: `${i}-label`,
          children: e
        }
      ),
      !!c?.text && /* @__PURE__ */ s.jsx(
        Ms,
        {
          ...c,
          className: f(Ke.helpIcon, c?.className ?? "")
        }
      ),
      !!r && /* @__PURE__ */ s.jsx("p", { className: Ke.error, children: r }),
      l
    ] });
  }
}
const Mv = "h-inputDuration--inputDuration__root", zv = {
  root: Mv
}, ys = (a, t = [
  "hours",
  "minutes",
  "seconds"
]) => {
  const e = Math.floor(a / 1e3), n = {};
  let o = e;
  return t.includes("days") && (n.days = Math.floor(e / (24 * 3600)), o = e % (24 * 3600)), t.includes("hours") && (n.hours = Math.floor(o / 3600), o %= 3600), t.includes("minutes") && (n.minutes = Math.floor(o / 60), o %= 60), t.includes("seconds") && (n.seconds = o), n;
}, _s = (a) => ((a.days ?? 0) * 86400 + (a.hours ?? 0) * 3600 + (a.minutes ?? 0) * 60 + (a.seconds ?? 0)) * 1e3, Vv = [
  "hours",
  "minutes",
  "seconds"
], Rk = $(
  function(t, e) {
    const n = Y(null);
    ke(e, () => n.current);
    const {
      className: o,
      name: r = "input-duration",
      value: i = 0,
      required: l = !1,
      disabled: c = !1,
      readOnly: d = !1,
      inputParts: h = Vv,
      status: u,
      onChange: p,
      onBlur: m
    } = t, [g, b] = V(
      () => ys(i, h)
    );
    tt(() => {
      const _ = _s(g);
      if (i !== _) {
        const C = ys(i, h);
        b(C);
      }
    }, [i, h]);
    const x = P(
      (_, C) => {
        const S = Math.max(0, parseInt(C) || 0);
        if ((_ === "minutes" || _ === "seconds") && S > 60)
          return;
        const I = { ...g, [_]: S };
        b(I);
        const T = _s(I);
        p?.(T);
      },
      [g, p]
    ), w = P(() => {
      const _ = _s(g), C = ys(
        _,
        h
      );
      b(C), m?.();
    }, [g, h, m]), y = (_) => {
      const C = g[_] ?? 0, S = C === 0;
      return {
        type: "number",
        id: `${r}-${_}`,
        name: `${r}-${_}`,
        value: S ? "" : C,
        placeholder: S ? "0" : void 0,
        suffix: {
          type: "custom",
          value: _.charAt(0).toUpperCase() + _.slice(1)
        },
        min: 0,
        step: 1,
        required: l,
        disabled: c,
        readOnly: d,
        status: u,
        "aria-required": l,
        "aria-disabled": c,
        "aria-readonly": d,
        onBlur: w,
        onChange: (I) => x(_, I.target.value)
      };
    }, v = f(o, zv.root);
    return /* @__PURE__ */ s.jsxs("div", { ref: n, className: v, children: [
      h.includes("days") && /* @__PURE__ */ s.jsx(Ut, { ...y("days") }),
      h.includes("hours") && /* @__PURE__ */ s.jsx(Ut, { ...y("hours") }),
      h.includes("minutes") && /* @__PURE__ */ s.jsx(Ut, { ...y("minutes"), max: 60 }),
      h.includes("seconds") && /* @__PURE__ */ s.jsx(Ut, { ...y("seconds"), max: 60 })
    ] });
  }
), Ue = /* @__PURE__ */ new Map();
function Kv({
  containerId: a,
  children: t
}) {
  const [e, n] = V(null), o = (i) => {
    const l = Ue.get(a);
    l !== void 0 && Ue.set(a, l + i);
  }, r = () => {
    const i = document.createElement("div");
    return i.id = a, i;
  };
  return tt(() => {
    let i = document.getElementById(a);
    return i || (i = r(), document.body.appendChild(i), Ue.set(a, 0)), n(i), o(1), () => {
      o(-1), Ue.get(a) === 0 && i && (Ue.delete(a), i.remove());
    };
  }, [a]), e ? Ra.createPortal(t, e) : null;
}
const Uv = "h-modal--modal__root", qv = "h-modal--modal__modalContainer", Gv = "h-modal--modal__rootDisplayed", Yv = "h-modal--modal__rootOpened", Qv = "h-modal--modal__modalContent", Xv = "h-modal--modal__modal", ye = {
  root: Uv,
  modalContainer: qv,
  rootDisplayed: Gv,
  rootOpened: Yv,
  modalContent: Qv,
  modal: Xv
};
class Zv extends D {
  rootRef;
  haskeydownEventListner;
  closeTimer;
  static defaultProps = {
    allowEscClose: !0,
    restoreFocus: !0,
    bringInFocusOnTab: !0
  };
  constructor(t) {
    super(t), this.rootRef = B(), this.closeTimer = null, this.state = {
      opened: !1,
      displayed: !1
    }, this.haskeydownEventListner = !1, this.animateOpening = this.animateOpening.bind(this), this.animateClosing = this.animateClosing.bind(this), this.onTransitionEnd = this.onTransitionEnd.bind(this), this.handleKey = this.handleKey.bind(this);
  }
  componentDidMount() {
    const { isOpen: t } = this.props;
    t && this.animateOpening();
  }
  componentDidUpdate(t) {
    const { isOpen: e, allowEscClose: n } = this.props, { isOpen: o } = t;
    n && !this.haskeydownEventListner && (window.addEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !0), e !== o && (e ? this.animateOpening() : this.animateClosing());
  }
  componentWillUnmount() {
    this.cancelAnimation(), this.removeKeyDownEventListener();
  }
  handleKey(t) {
    const { isOpen: e, onClose: n } = this.props;
    e && je(t.key) && (this.rootRef.current?.querySelector(
      '[role="menu"][aria-expanded="true"]'
    ) || (t.preventDefault(), t.stopPropagation(), this.animateClosing(), n(t)));
  }
  removeKeyDownEventListener = () => {
    window.removeEventListener("keydown", this.handleKey, !0), this.haskeydownEventListner = !1;
  };
  cancelAnimation() {
    const { current: t } = this.rootRef;
    t && t.removeEventListener("transitionend", this.onTransitionEnd), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null);
  }
  animateOpening() {
    this.setState({ displayed: !0 }), setTimeout(() => this.setState({ opened: !0 }));
  }
  animateClosing() {
    this.rootRef.current && this.rootRef.current.addEventListener(
      "transitionend",
      this.onTransitionEnd
    ), this.removeKeyDownEventListener(), this.setState({ opened: !1 }), this.closeIfNoTransitionOccurred();
  }
  closeIfNoTransitionOccurred() {
    this.closeTimer = setTimeout(() => {
      this.closeTimer && this.onTransitionEnd();
    }, 400);
  }
  onTransitionEnd() {
    this.setState({ displayed: !1 }), this.closeTimer && (clearTimeout(this.closeTimer), this.closeTimer = null), this.rootRef.current && this.rootRef.current.removeEventListener(
      "transitionend",
      this.onTransitionEnd
    );
  }
  render() {
    const {
      className: t,
      isOpen: e,
      children: n,
      onClose: o,
      allowClickOutside: r,
      allowEscClose: i,
      // Stops allowEscClose from being passed in with otherProps
      wrapProps: l,
      autoFocus: c,
      restoreFocus: d,
      bringInFocusOnTab: h,
      ...u
    } = this.props, { displayed: p, opened: m } = this.state, g = f(ye.root, l?.className, {
      [ye.rootDisplayed]: p,
      [ye.rootOpened]: m
    }), b = f(ye.modal, t);
    return /* @__PURE__ */ s.jsx(Kv, { containerId: "modal-container", children: /* @__PURE__ */ s.jsx("div", { ...l, className: g, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: ye.modalContainer,
        ref: this.rootRef,
        ...r ? { onClick: o } : {},
        ...u,
        children: m && // fixes an issue with child-components that need to measure boundingClientRect
        /* @__PURE__ */ s.jsx(
          gr,
          {
            containerRef: this.rootRef,
            autoFocus: c,
            restoreFocus: d,
            bringInFocusOnTab: h,
            children: /* @__PURE__ */ s.jsx("div", { className: ye.modalContent, children: /* @__PURE__ */ s.jsx(
              "div",
              {
                className: b,
                onClick: (x) => r && x.stopPropagation(),
                children: n
              }
            ) })
          }
        )
      }
    ) }) });
  }
}
const Jv = "h-lightbox--lightbox__lightSource", tS = "h-lightbox--lightbox__closeButton", eS = "h-lightbox--lightbox__downloadButton", nS = "h-lightbox--lightbox__image", sS = "h-lightbox--lightbox__loadingContainer", oS = "h-lightbox--lightbox__navButton", rS = "h-lightbox--lightbox__navButtonPrevious", aS = "h-lightbox--lightbox__navButtonNext", iS = "h-lightbox--lightbox__counter", Dt = {
  lightSource: Jv,
  closeButton: tS,
  downloadButton: eS,
  image: nS,
  loadingContainer: sS,
  navButton: oS,
  navButtonPrevious: rS,
  navButtonNext: aS,
  counter: iS
};
class Ek extends D {
  render() {
    const {
      className: t,
      src: e,
      alt: n,
      isOpen: o,
      onClose: r,
      showNavigation: i = !1,
      currentIndex: l = 0,
      totalImages: c = 1,
      onPrevious: d,
      onNext: h,
      isLoading: u = !1
    } = this.props, p = c > 1;
    return /* @__PURE__ */ s.jsx(
      Zv,
      {
        className: t,
        isOpen: o,
        allowClickOutside: !0,
        onClose: r,
        children: /* @__PURE__ */ s.jsxs("div", { className: Dt.lightSource, children: [
          u ? /* @__PURE__ */ s.jsx("div", { className: Dt.loadingContainer, children: /* @__PURE__ */ s.jsx(zn, { size: 64 }) }) : e && /* @__PURE__ */ s.jsx(Os, { className: Dt.image, alt: n, src: e }),
          r && /* @__PURE__ */ s.jsx(
            K,
            {
              onClick: r,
              icon: "close",
              variant: "secondary",
              className: Dt.closeButton
            }
          ),
          e && typeof e == "string" && /* @__PURE__ */ s.jsx(
            "a",
            {
              href: e,
              target: "_blank",
              download: !0,
              className: Dt.downloadButton,
              rel: "noreferrer",
              children: /* @__PURE__ */ s.jsx(
                N,
                {
                  name: "cloud-download",
                  className: f("icon-vertical-fix")
                }
              )
            }
          ),
          i && p && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-left",
                variant: "primary",
                size: "large",
                onClick: d,
                className: `${Dt.navButton} ${Dt.navButtonPrevious}`
              }
            ),
            /* @__PURE__ */ s.jsx(
              K,
              {
                icon: "arrow-right",
                variant: "primary",
                size: "large",
                onClick: h,
                className: `${Dt.navButton} ${Dt.navButtonNext}`
              }
            ),
            /* @__PURE__ */ s.jsxs("div", { className: Dt.counter, children: [
              l + 1,
              " / ",
              c
            ] })
          ] })
        ] })
      }
    );
  }
}
const lS = "h-list-items--item__root", cS = "h-list-items--item__rootWithHoverEffect", dS = "h-list-items--item__rootDense", hS = "h-list-items--item__rootLarge", uS = "h-list-items--item__contentLeft", pS = "h-list-items--item__contentRight", mS = "h-list-items--item__titles", gS = "h-list-items--item__title", fS = "h-list-items--item__titleSecondary", bS = "h-list-items--item__arrow", kt = {
  root: lS,
  rootWithHoverEffect: cS,
  rootDense: dS,
  rootLarge: hS,
  contentLeft: uS,
  contentRight: pS,
  titles: mS,
  title: gS,
  titleSecondary: fS,
  arrow: bS
};
class Xn extends D {
  static defaultProps = {
    variant: "dense",
    withHoverEffect: !0
  };
  renderTitle() {
    const { title: t, titleSecondary: e } = this.props;
    return t || e ? /* @__PURE__ */ s.jsxs("div", { className: kt.titles, children: [
      !!t && /* @__PURE__ */ s.jsx(L.Paragraph, { as: "div", variant: "2", className: kt.title, children: t }),
      !!e && /* @__PURE__ */ s.jsx(
        L.Paragraph,
        {
          as: "div",
          variant: "4",
          subdued: !0,
          className: kt.titleSecondary,
          children: e
        }
      )
    ] }) : null;
  }
  renderContentLeft() {
    const { contentLeft: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: kt.contentLeft, children: t }) : null;
  }
  renderContentRight() {
    const { contentRight: t } = this.props;
    return t ? /* @__PURE__ */ s.jsx("div", { className: kt.contentRight, children: t }) : null;
  }
  renderIcon() {
    const { isLink: t, contentRight: e } = this.props;
    return t && !e ? /* @__PURE__ */ s.jsx(
      N,
      {
        className: f(kt.arrow, "icon-vertical-fix"),
        name: "angle-right",
        size: 24
      }
    ) : null;
  }
  renderContent() {
    return /* @__PURE__ */ s.jsxs(Yt, { children: [
      this.renderContentLeft(),
      this.renderTitle(),
      this.renderContentRight(),
      this.renderIcon()
    ] });
  }
  getChildrenWithFallback() {
    return this.props.children ?? this.renderContent();
  }
  render() {
    const {
      className: t,
      children: e,
      contentLeft: n,
      contentRight: o,
      title: r,
      titleSecondary: i,
      secondaryTitleBelow: l,
      isLink: c,
      variant: d,
      withHoverEffect: h,
      ...u
    } = this.props, p = f(kt.root, t, {
      [kt.rootDense]: d === "dense",
      [kt.rootLarge]: d === "large",
      [kt.rootWithHoverEffect]: h
    });
    return /* @__PURE__ */ s.jsx("li", { ...u, className: p, children: this.getChildrenWithFallback() });
  }
}
const xS = "h-list-items--keyValue__root", yS = {
  root: xS
};
class _S extends D {
  static defaultProps = {
    hideIfValueIsEmpty: !0
  };
  isValueEmpty() {
    return !this.props.pair.value;
  }
  render() {
    const { hideIfValueIsEmpty: t, className: e, pair: n, ...o } = this.props, r = f(yS.root, e);
    return t && this.isValueEmpty() ? null : /* @__PURE__ */ s.jsx(
      Xn,
      {
        ...o,
        className: r,
        title: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "4", subdued: !0, children: n.key }),
        titleSecondary: /* @__PURE__ */ s.jsx(L.Paragraph, { as: "span", variant: "2", children: n.value }),
        "data-testid": "List-KeyValue"
      }
    );
  }
}
const CS = "h-list-items--text__root", wS = {
  root: CS
};
class vS extends D {
  render() {
    const { children: t, className: e, ...n } = this.props, o = f(wS.root, e);
    return /* @__PURE__ */ s.jsx(
      Xn,
      {
        ...n,
        className: o,
        "data-testid": "List-Text",
        children: /* @__PURE__ */ s.jsx(L.Paragraph, { variant: "2", children: t })
      }
    );
  }
}
const SS = "h-list-items--user__root", IS = "h-list-items--user__avatarWrapper", Jo = {
  root: SS,
  avatarWrapper: IS
};
class DS extends D {
  getTitle() {
    const { user: t, title: e } = this.props;
    return e || t.display_name || t.name || t.phone_number || t.id;
  }
  getSubTitle() {
    const { user: t, titleSecondary: e } = this.props;
    return e || t.email;
  }
  render() {
    const { className: t, user: e, title: n, titleSecondary: o, ...r } = this.props, i = f(t, Jo.root);
    return /* @__PURE__ */ s.jsx(
      Xn,
      {
        className: i,
        contentLeft: /* @__PURE__ */ s.jsx("div", { className: Jo.avatarWrapper, children: /* @__PURE__ */ s.jsx(mr, { user: e }) }),
        title: this.getTitle(),
        titleSecondary: this.getSubTitle(),
        "data-testid": "<List.User>",
        ...r
      }
    );
  }
}
const kS = "h-list--list__root", TS = {
  root: kS
};
class jS extends D {
  static Item = Xn;
  static Text = vS;
  static User = DS;
  static KeyValue = _S;
  render() {
    const { className: t, ...e } = this.props;
    return /* @__PURE__ */ s.jsx("ul", { ...e, className: f(TS.root, t) });
  }
}
const Lk = on(jS, {
  fallback: null
}), NS = () => {
  document.exitFullscreen && document.exitFullscreen();
}, PS = (a) => {
  a.requestFullscreen ? a.requestFullscreen() : a.mozRequestFullScreen ? a.mozRequestFullScreen() : a.webkitRequestFullscreen ? a.webkitRequestFullscreen() : a.msRequestFullscreen && a.msRequestFullscreen();
}, FS = (a) => document.fullscreenElement === a;
class RS extends Error {
  status;
  url;
  response;
  constructor(t) {
    super(`NetworkError ${t.status} ${t.url}`), this.status = t.status, this.url = t.url, this.response = t;
  }
}
const ES = {
  fetch: (a, ...t) => fetch(a, ...t).then((e) => {
    if (!(e.status >= 200 && e.status < 300))
      throw new RS(e);
    return e;
  })
}, LS = "h-mediaPlayer--mediaPlayer__root", AS = "h-mediaPlayer--mediaPlayer__controls", $S = "h-mediaPlayer--mediaPlayer__unstyled", BS = "h-mediaPlayer--mediaPlayer__rootFullScreen", OS = "h-mediaPlayer--mediaPlayer__rootHideControls", HS = "h-mediaPlayer--mediaPlayer__control", WS = "h-mediaPlayer--mediaPlayer__progress", MS = "h-mediaPlayer--mediaPlayer__progressSlider", zS = "h-mediaPlayer--mediaPlayer__volumeSlider", VS = "h-mediaPlayer--mediaPlayer__timestamp", KS = "h-mediaPlayer--mediaPlayer__videoWrapper", US = "h-mediaPlayer--mediaPlayer__rootWaiting", qS = "h-mediaPlayer--mediaPlayer__rootAudio", GS = "h-mediaPlayer--mediaPlayer__video", YS = "h-mediaPlayer--mediaPlayer__volume", QS = "h-mediaPlayer--mediaPlayer__volumeMuteControl", XS = "h-mediaPlayer--mediaPlayer__downloadLink", Z = {
  root: LS,
  controls: AS,
  unstyled: $S,
  rootFullScreen: BS,
  rootHideControls: OS,
  control: HS,
  progress: WS,
  progressSlider: MS,
  volumeSlider: zS,
  timestamp: VS,
  videoWrapper: KS,
  rootWaiting: US,
  rootAudio: qS,
  video: GS,
  volume: YS,
  volumeMuteControl: QS,
  downloadLink: XS
};
function ZS(a) {
  const t = a >= 3600 ? 8 : 5;
  return Number.isNaN(a) || !Number.isFinite(a) ? "00:00" : new Date(a * 1e3).toISOString().substr(19 - t, t);
}
class Ak extends D {
  intersectionObserver;
  static defaultProps = {
    headers: {}
  };
  constructor(t) {
    super(t), this.state = {
      src: void 0,
      playing: !1,
      actuallyPlaying: !1,
      duration: 0,
      time: 0,
      prevVolume: 1,
      volume: 100,
      isFullScreen: !1,
      hideControls: !1,
      isWaiting: !1,
      buffer: null,
      asyncStatus: null
    }, this.updateBuffer = this.updateBuffer.bind(this), this.updateProgress = this.updateProgress.bind(this), this.handleMute = this.handleMute.bind(this), this.handlePlaying = this.handlePlaying.bind(this), this.handleWaiting = this.handleWaiting.bind(this), this.handleEnded = this.handleEnded.bind(this), this.handleError = this.handleError.bind(this), this.seek = this.seek.bind(this), this.handleIntersection = this.handleIntersection.bind(this), this.handleTogglePlayClick = this.handleTogglePlayClick.bind(this), this.handleFullscreenToggle = this.handleFullscreenToggle.bind(this), this.handleFullscreenChange = this.handleFullscreenChange.bind(this), this.startHideControlCountdown = this.startHideControlCountdown.bind(this);
  }
  componentDidMount() {
    const { lazy: t } = this.props, { current: e } = this.playerRef;
    e && e.addEventListener("fullscreenchange", this.handleFullscreenChange), t ? this.createIntersectionObserver() : this.loadSrc();
  }
  componentDidUpdate(t, e) {
    const {
      mediaFile: { src: n }
    } = t, {
      lazy: o,
      mediaFile: { src: r }
    } = this.props;
    n !== r && (o ? this.setSrc() : this.loadSrc()), this.tryReloadPlayer(e);
  }
  componentWillUnmount() {
    const { current: t } = this.playerRef;
    t && t.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    ), window.removeEventListener("mousemove", this.startHideControlCountdown), this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.controller.abort();
  }
  videoRef = B();
  playerRef = B();
  hideControlsTimeout = void 0;
  controller = new AbortController();
  loadSrc() {
    const {
      mediaFile: { src: t },
      isPrivateFile: e
    } = this.props;
    this.tryStopPlayer(), e ? this.fetchFile() : this.setSrc(t);
  }
  setSrc(t) {
    this.setState({
      src: t
    });
  }
  handleIntersection([t]) {
    const { src: e, asyncStatus: n } = this.state;
    !e && !(n === "loading") && t.isIntersecting && (this.loadSrc(), this.intersectionObserver?.disconnect());
  }
  createIntersectionObserver() {
    const { current: t } = this.playerRef;
    t && (this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection,
      { threshold: 1 }
    ), this.intersectionObserver.observe(t));
  }
  tryStopPlayer() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    t.currentTime = 0;
    const { playing: e, actuallyPlaying: n } = this.state;
    e && n && (t.pause(), this.setState({ playing: !1, actuallyPlaying: !1 }));
  }
  tryReloadPlayer(t) {
    const { current: e } = this.videoRef;
    if (!e)
      return;
    const { src: n } = this.state;
    n !== t.src && e.load();
  }
  fetchFile(t) {
    const {
      mediaFile: { src: e },
      headers: n,
      filename: o
    } = this.props;
    this.setState({ asyncStatus: "loading" });
    const r = new Headers(n);
    ES.fetch(e, {
      headers: r,
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      signal: this.controller.signal
    }).then((i) => i.blob()).then((i) => {
      const l = window.URL.createObjectURL(i);
      t ? wa.saveAs(
        i,
        o || decodeURIComponent(e.split("/").pop())
      ) : this.setSrc(l), this.setState({ asyncStatus: "succeeded" });
    }).catch((i) => {
      i && i.name === "AbortError" || (console.error("[MediaPlayer] fetchFile", i), this.setState({ asyncStatus: "failed" }));
    });
  }
  updateProgress() {
    const { current: t } = this.videoRef;
    t && this.setState({
      time: t.currentTime,
      duration: t.duration
    });
  }
  updateBuffer() {
    const { current: t } = this.videoRef, { time: e, duration: n } = this.state;
    if (t) {
      let o = null;
      const r = t.buffered;
      for (let i = 0; i < r.length; i += 1) {
        const l = r.start(i), c = r.end(i);
        l <= e && e <= c && (o = [l / n, c / n]);
      }
      this.setState({
        buffer: o
      });
    }
  }
  handleWaiting() {
    this.setState({
      isWaiting: !0
    });
  }
  handlePlaying() {
    this.setState({
      isWaiting: !1
    });
  }
  handleTogglePlayClick() {
    const { playing: t, actuallyPlaying: e } = this.state, { current: n } = this.videoRef;
    n && (t && e ? (n.pause(), this.setState({
      isWaiting: !1,
      playing: !1,
      actuallyPlaying: !1
    })) : t || (this.setState({
      isWaiting: !0,
      playing: !0,
      actuallyPlaying: !1
    }), n.play().then(() => {
      this.setState({ actuallyPlaying: !0 });
    })));
  }
  startHideControlCountdown() {
    this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), this.setState({
      hideControls: !1
    }), this.hideControlsTimeout = setTimeout(() => {
      this.setState({
        hideControls: !0
      });
    }, 2e3);
  }
  handleFullscreenChange() {
    const { current: t } = this.playerRef, e = FS(t);
    this.setState({
      isFullScreen: e
    }), e ? (this.startHideControlCountdown(), window.addEventListener("mousemove", this.startHideControlCountdown)) : (this.hideControlsTimeout && clearTimeout(this.hideControlsTimeout), window.removeEventListener("mousemove", this.startHideControlCountdown));
  }
  handleFullscreenToggle() {
    const { current: t } = this.playerRef, { isFullScreen: e } = this.state;
    t && (e ? NS() : PS(t));
  }
  handleEnded() {
    this.setState({
      playing: !1
    });
  }
  handleError() {
    this.props.onError && this.props.onError();
  }
  seek(t) {
    const { current: e } = this.videoRef, { duration: n } = this.state;
    e && t && !Number.isNaN(t) && (e.currentTime = n * t);
  }
  handleVolume = (t) => {
    const { current: e } = this.videoRef;
    !e || typeof t > "u" || !Number.isFinite(t) || this.setState({ volume: t }, () => {
      this.setPlayerVolume(t);
    });
  };
  handleMute() {
    const { current: t } = this.videoRef;
    if (!t)
      return;
    const { volume: e, prevVolume: n } = this.state, o = e === 0, r = o ? n : 0;
    this.setState(
      {
        volume: r,
        prevVolume: o ? n : e
      },
      () => {
        this.setPlayerVolume(r);
      }
    );
  }
  setPlayerVolume(t) {
    const { current: e } = this.videoRef;
    e && (e.volume = t / 100);
  }
  render() {
    const {
      className: t,
      mediaFile: { type: e },
      headers: n,
      isPrivateFile: o,
      width: r,
      controls: i,
      noControlsStyle: l,
      ...c
    } = this.props, {
      src: d,
      playing: h,
      duration: u,
      time: p,
      volume: m,
      hideControls: g,
      isFullScreen: b,
      isWaiting: x,
      buffer: w,
      asyncStatus: y
    } = this.state, v = i?.play ?? !0, _ = i?.download ?? !0, C = i?.progress ?? !0, S = i?.volume ?? !0, I = i?.maximize ?? !0, T = v || _ || C || S || I, R = typeof e == "string" && e.startsWith("audio"), A = !d || y === "loading", k = b ? "primary" : "secondary", F = f(
      Z.root,
      {
        [Z.rootFullScreen]: b,
        [Z.rootHideControls]: g,
        [Z.rootWaiting]: h && x,
        [Z.rootAudio]: R
      },
      t
    );
    return /* @__PURE__ */ s.jsxs(
      "div",
      {
        ...c,
        className: F,
        ref: this.playerRef,
        style: { width: r },
        children: [
          /* @__PURE__ */ s.jsx("div", { className: Z.videoWrapper, children: !!d && /* @__PURE__ */ s.jsx(
            "video",
            {
              className: Z.video,
              ref: this.videoRef,
              onDurationChange: this.updateProgress,
              onTimeUpdate: this.updateProgress,
              onWaiting: this.handleWaiting,
              onPlaying: this.handlePlaying,
              onProgress: this.updateBuffer,
              onEnded: this.handleEnded,
              onError: this.handleError,
              children: /* @__PURE__ */ s.jsx("source", { src: d })
            }
          ) }),
          T && /* @__PURE__ */ s.jsxs(
            "div",
            {
              className: f(Z.controls, {
                [Z.unstyled]: l
              }),
              children: [
                v && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    onClick: this.handleTogglePlayClick,
                    className: Z.control,
                    disabled: A,
                    icon: h ? "pause" : "play",
                    variant: k
                  }
                ),
                _ && (o ? /* @__PURE__ */ s.jsx(
                  Q,
                  {
                    variant: k,
                    className: Z.control,
                    disabled: A,
                    children: /* @__PURE__ */ s.jsx(
                      "a",
                      {
                        href: d,
                        download: !0,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: Z.downloadLink,
                        children: /* @__PURE__ */ s.jsx(N, { name: "download" })
                      }
                    )
                  }
                ) : /* @__PURE__ */ s.jsx(
                  K,
                  {
                    icon: "download",
                    variant: k,
                    className: Z.control,
                    disabled: A,
                    onClick: () => this.fetchFile(!0)
                  }
                )),
                C && /* @__PURE__ */ s.jsxs("div", { className: Z.progress, children: [
                  /* @__PURE__ */ s.jsx(
                    Fs,
                    {
                      hideAnnotations: !0,
                      className: Z.progressSlider,
                      min: 0,
                      max: u,
                      value: p,
                      onChange: (H) => !Array.isArray(H) && this.seek(H / u),
                      dark: b,
                      highlightRange: w?.map((H) => H * u)
                    }
                  ),
                  /* @__PURE__ */ s.jsx("span", { className: Z.timestamp, children: ZS(u) })
                ] }),
                S && /* @__PURE__ */ s.jsxs("div", { className: Z.volume, children: [
                  /* @__PURE__ */ s.jsx(
                    N,
                    {
                      className: Z.volumeMuteControl,
                      name: m === 0 ? "volume-off" : "volume-up",
                      onClick: this.handleMute
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    Fs,
                    {
                      hideAnnotations: !0,
                      className: Z.volumeSlider,
                      value: m,
                      onChange: (H) => !Array.isArray(H) && this.handleVolume(H),
                      dark: b
                    }
                  )
                ] }),
                I && !R && /* @__PURE__ */ s.jsx(
                  K,
                  {
                    variant: k,
                    onClick: this.handleFullscreenToggle,
                    className: Z.control,
                    icon: "expand"
                  }
                )
              ]
            }
          )
        ]
      }
    );
  }
}
const JS = "h-modalBody--modalBody__root", tI = {
  root: JS
};
class $k extends D {
  render() {
    const { className: t, children: e, ...n } = this.props, o = f(
      {
        [tI.root]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx("div", { ...n, className: o, children: e });
  }
}
const eI = "h-modalFoot--modalFoot__root", nI = "h-modalFoot--modalFoot__confirm", sI = "h-modalFoot--modalFoot__confirmSecondary", oI = "h-modalFoot--modalFoot__cancel", In = {
  root: eI,
  confirm: nI,
  confirmSecondary: sI,
  cancel: oI
};
class rI extends D {
  static defaultProps;
  render() {
    const {
      className: t,
      confirmOnClick: e,
      confirmSecondaryOnClick: n,
      cancelOnClick: o,
      confirmName: r,
      confirmSecondaryName: i,
      cancelName: l,
      confirmProps: c,
      confirmSecondaryProps: d,
      cancelProps: h,
      children: u,
      ...p
    } = this.props, m = f(
      {
        [In.root]: !0
      },
      t
    ), g = f(
      {
        [In.cancel]: !0
      },
      h?.className
    ), b = f(
      {
        [In.confirm]: !0
      },
      c?.className
    ), x = f(
      {
        [In.confirmSecondary]: !0
      },
      d?.className
    );
    return /* @__PURE__ */ s.jsxs("div", { ...p, className: m, children: [
      u,
      n && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "secondary",
          ...d,
          className: x,
          onClick: n,
          children: i
        }
      ),
      o && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "tertiary",
          ...h,
          className: g,
          onClick: o,
          children: l
        }
      ),
      e && /* @__PURE__ */ s.jsx(
        Q,
        {
          variant: "primary",
          ...c,
          className: b,
          onClick: e,
          children: r
        }
      )
    ] });
  }
}
rI.defaultProps = {
  confirmName: "Save",
  cancelName: "Cancel",
  // eslint-disable-next-line react/default-props-match-prop-types
  confirmProps: {},
  // eslint-disable-next-line react/default-props-match-prop-types
  cancelProps: {}
};
const aI = "h-modalHead--modalHead__root", iI = "h-modalHead--modalHead__top", lI = "h-modalHead--modalHead__title", cI = "h-modalHead--modalHead__buttons", dI = "h-modalHead--modalHead__caption", qe = {
  root: aI,
  top: iI,
  title: lI,
  buttons: cI,
  caption: dI
}, Bk = ({
  className: a,
  title: t,
  children: e,
  onClose: n,
  secondaryButton: o,
  buttonsClassName: r,
  ...i
}) => {
  const l = f(
    {
      [qe.root]: !0
    },
    a
  );
  return /* @__PURE__ */ s.jsxs("div", { ...i, className: l, children: [
    /* @__PURE__ */ s.jsxs("div", { className: qe.top, children: [
      /* @__PURE__ */ s.jsx(L.Heading, { className: qe.title, children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: f(qe.buttons, r), children: [
        typeof o?.onClick == "function" && /* @__PURE__ */ s.jsx(gt, { content: o?.tooltipContent, children: /* @__PURE__ */ s.jsx(
          K,
          {
            icon: o?.icon,
            variant: "tertiary",
            onClick: o?.onClick
          }
        ) }),
        typeof n == "function" && /* @__PURE__ */ s.jsx(
          K,
          {
            icon: "close",
            iconSize: 24,
            variant: "tertiary",
            onClick: n
          }
        )
      ] })
    ] }),
    !!e && /* @__PURE__ */ s.jsx(
      L.Paragraph,
      {
        variant: "2",
        color: "secondary",
        className: qe.caption,
        children: e
      }
    )
  ] });
}, hI = "h-page-body--pageBody__root", uI = {
  root: hI
}, pI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pt.Row,
    {
      ...n,
      ref: o,
      className: f(uI.root, e),
      scrollable: !0,
      noMinHeight: !0,
      noHorizontalPadding: !0,
      noVerticalPadding: !0,
      children: t
    }
  );
}), mI = "h-page-head--pageHead__root", gI = {
  root: mI
}, fI = $(function({ className: t, title: e, controls: n, ...o }, r) {
  return /* @__PURE__ */ s.jsxs(
    pt.Row,
    {
      ...o,
      ref: r,
      as: "header",
      className: f(gI.root, t),
      slottable: !0,
      borderBottom: !0,
      children: [
        /* @__PURE__ */ s.jsx(pt.Slot, { placement: "start", children: /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-2", as: "h1", children: e }) }),
        n && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "end", children: /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: n }) })
      ]
    }
  );
}), bI = "h-page-section--pageSection__root", xI = "h-page-section--pageSection__head", yI = "h-page-section--pageSection__callout", _I = "h-page-section--pageSection__content", Dn = {
  root: bI,
  head: xI,
  callout: yI,
  content: _I
}, CI = $(function({
  children: t,
  className: e,
  title: n,
  titleMeta: o,
  controls: r,
  callout: i,
  ...l
}, c) {
  const d = !!(n || o || r);
  return /* @__PURE__ */ s.jsxs(
    pt.Row,
    {
      ...l,
      ref: c,
      as: "section",
      className: f(Dn.root, e),
      noMinHeight: !0,
      children: [
        d && /* @__PURE__ */ s.jsxs(
          pt.Row,
          {
            className: Dn.head,
            slottable: !0,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: [
              (n || o) && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "start", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsxs(O, { alignItems: "center", gap: "200", children: [
                n && /* @__PURE__ */ s.jsx(L.Heading, { variant: "heading-3", as: "h2", children: n }),
                o && /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: o })
              ] }) }),
              r && /* @__PURE__ */ s.jsx(pt.Slot, { placement: "end", noVerticalPadding: !0, children: /* @__PURE__ */ s.jsx(O, { alignItems: "center", gap: "200", children: r }) })
            ]
          }
        ),
        i && /* @__PURE__ */ s.jsx(
          pt.Row,
          {
            className: Dn.callout,
            noMinHeight: !0,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: i
          }
        ),
        /* @__PURE__ */ s.jsx(
          pt.Row,
          {
            className: Dn.content,
            size: 1,
            noVerticalPadding: !0,
            noHorizontalPadding: !0,
            children: t
          }
        )
      ]
    }
  );
}), wI = $(function({ children: t, className: e, ...n }, o) {
  return /* @__PURE__ */ s.jsx(
    pt.Row,
    {
      ...n,
      ref: o,
      className: e,
      borderBottom: !0,
      noVerticalPadding: !0,
      noMinHeight: !0,
      children: t
    }
  );
}), tr = ({ children: a, className: t, ...e }, n) => /* @__PURE__ */ s.jsx(Yc, { ...e, ref: n, as: "article", className: t, children: /* @__PURE__ */ s.jsx(pt, { children: a }) }), Ok = Object.assign($(tr), {
  name: tr.name,
  Head: fI,
  Body: pI,
  Section: CI,
  Tabs: wI
}), vI = "h-radio--radio__radio", SI = "h-radio--radio__radioDisabled", II = "h-radio--radio__radioChecked", DI = "h-radio--radio__input", kn = {
  radio: vI,
  radioDisabled: SI,
  radioChecked: II,
  input: DI
}, Hk = $(function(t, e) {
  const { id: n, checked: o, disabled: r, className: i, labelProps: l, ...c } = t, d = f(
    kn.radio,
    { [kn.radioChecked]: o },
    { [kn.radioDisabled]: r },
    i
  ), h = n || `radio_${Math.random()}`;
  return /* @__PURE__ */ s.jsx(
    "label",
    {
      ...l,
      className: d,
      htmlFor: h,
      "data-testid": "radio",
      children: /* @__PURE__ */ s.jsx(
        "input",
        {
          ...c,
          ref: e,
          id: h,
          onChange: c.onChange || E,
          checked: o,
          disabled: r,
          type: "radio",
          className: kn.input,
          "data-testid": "input"
        }
      )
    }
  );
}), kI = "h-reverseScroll--reverseScroll__root", TI = "h-reverseScroll--reverseScroll__column", jI = "h-reverseScroll--reverseScroll__row", NI = "h-reverseScroll--reverseScroll__scrollHandle", Ge = {
  root: kI,
  column: TI,
  row: jI,
  scrollHandle: NI
}, PI = "reverse-scroll", Wk = $(function({
  children: t,
  className: e,
  direction: n = "column",
  ...o
}, r) {
  const i = Y(null), l = Y(null), c = Y(null), d = Qn(t), h = U(
    () => d.reverse(),
    [d]
  ), u = (b) => c.current?.scrollIntoView(b), p = (b) => l.current?.scrollIntoView(b), m = (b) => i.current?.children[1]?.scrollIntoView(b), g = (b) => i.current?.children[i.current.children.length - 2]?.scrollIntoView(b);
  return ke(r, () => ({
    rootElem: i.current,
    scrollToEnd: u,
    scrollToStart: p,
    scrollToFirstChild: g,
    scrollToLastChild: m
  })), /* @__PURE__ */ s.jsxs(
    "div",
    {
      ...o,
      "data-testid": PI,
      ref: i,
      className: f(e, Ge.root, {
        [Ge.row]: n === "row",
        [Ge.column]: n === "column"
      }),
      children: [
        /* @__PURE__ */ s.jsx("div", { ref: c, className: Ge.scrollHandle }),
        h,
        /* @__PURE__ */ s.jsx("div", { ref: l, className: Ge.scrollHandle })
      ]
    }
  );
}), FI = "h-removableCard--removableCard__root", RI = "h-removableCard--removableCard__close", EI = "h-removableCard--removableCard__title", LI = "h-removableCard--removableCard__titleIcon", Ye = {
  root: FI,
  close: RI,
  title: EI,
  titleIcon: LI
};
class Mk extends D {
  render() {
    const { icon: t, title: e, children: n, onRemove: o, className: r, ...i } = this.props, l = f(
      {
        [Ye.root]: Ye.root
      },
      r
    );
    return /* @__PURE__ */ s.jsxs(
      rt,
      {
        padding: "300",
        background: "neutral.100",
        borderRadius: !0,
        ...i,
        className: l,
        children: [
          /* @__PURE__ */ s.jsx(
            rt,
            {
              as: "button",
              "aria-label": "Remove",
              className: Ye.close,
              onClick: o,
              children: /* @__PURE__ */ s.jsx(N, { name: "close" })
            }
          ),
          /* @__PURE__ */ s.jsxs(
            O,
            {
              alignItems: "flex-start",
              justifyContent: "flex-start",
              className: Ye.title,
              children: [
                t && /* @__PURE__ */ s.jsx(N, { name: t, className: Ye.titleIcon }),
                e
              ]
            }
          ),
          /* @__PURE__ */ s.jsx(rt, { margin: "300 0 0 0" }),
          n
        ]
      }
    );
  }
}
const er = ({
  colorMode: a = "light"
}) => `<script>
  (function() {
    let lastHeight = null;

    function measureHeight() {
      const currentHeight = document.body.offsetHeight;
      if (currentHeight === lastHeight) return;
      lastHeight = currentHeight;
      window.parent.postMessage(
        {
          event: 'heightChange',
          value: currentHeight,
        },
        '*',
      );
    };

    function setColorMode() {
      const rootElement = document.documentElement;
      if (rootElement) {
        rootElement.setAttribute('data-color-mode', '${a}');
      }

      const style = document.createElement('style');
      style.innerHTML = 'html {color-scheme: ${a};}';
      document.head.appendChild(style);
    }

    document.body.style.padding = '0px';
    document.body.style.margin = '0px';
    document.body.style.display = 'inline-block';
    document.body.style.width = '100%';
    document.addEventListener('click', measureHeight);

    document.querySelectorAll('a').forEach(link => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });

    document.addEventListener('load', measureHeight, true);
    document.addEventListener('transitionend', measureHeight, true);

    new ResizeObserver(measureHeight).observe(document.body);

    measureHeight();
    setColorMode();
  })();
<\/script>`, AI = "h-sandboxIframe--sandboxIframe__frame", $I = {
  frame: AI
};
class Mr extends D {
  frameRef;
  static defaultProps;
  constructor(t) {
    super(t), this.state = {
      iframeHeight: 0
    }, this.frameRef = B(), this.handlePostMessage = this.handlePostMessage.bind(this);
  }
  componentDidMount() {
    this.buildSandbox(), window.addEventListener("message", this.handlePostMessage);
  }
  componentDidUpdate(t) {
    const { content: e, headContent: n, colorMode: o } = this.props;
    (t.content !== e || t.headContent !== n || t.colorMode !== o) && this.buildSandbox();
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.handlePostMessage);
  }
  static defaultSandboxParams = "allow-scripts allow-popups allow-forms";
  buildSandbox() {
    const { content: t, headContent: e = "", colorMode: n = "light" } = this.props, { current: o } = this.frameRef;
    if (o) {
      let r = "";
      t.indexOf("</body>") !== -1 ? r = t.replace(
        "</body>",
        `${er({ colorMode: n })}</body>`
      ) : r = `<html><head><meta charset="utf-8" /><base target="_parent" />${e}</head><body>${t}${er(
        { colorMode: n }
      )}</body></html>`, o.src = `data:text/html;base64,${window.btoa(
        unescape(encodeURIComponent(r))
      )}`;
    }
  }
  handlePostMessage(t) {
    const { current: e } = this.frameRef;
    if (e && t.source === e.contentWindow) {
      const { data: n } = t;
      typeof n == "object" && n !== null && n.event === "heightChange" && typeof n.value == "number" && this.setState({
        iframeHeight: n.value
      });
    }
  }
  render() {
    const {
      className: t,
      content: e,
      headContent: n,
      sandbox: o,
      colorMode: r,
      ...i
    } = this.props, { iframeHeight: l } = this.state, c = f({}, t);
    return /* @__PURE__ */ s.jsx("div", { ...i, className: c, children: /* @__PURE__ */ s.jsx(
      "iframe",
      {
        title: "message",
        sandbox: o ?? Mr.defaultSandboxParams,
        allowFullScreen: !0,
        scrolling: "no",
        frameBorder: "no",
        style: { height: `${l}px` },
        className: $I.frame,
        ref: this.frameRef
      }
    ) });
  }
}
const BI = "h-scrollbar--scrollbar__track", OI = "h-scrollbar--scrollbar__handle", nr = {
  track: BI,
  handle: OI
};
class zk extends D {
  constructor(t) {
    super(t), this.state = {
      size: 0,
      progress: 0,
      offset: 0
    }, this.handleTrackClick = this.handleTrackClick.bind(this), this.handleHandleClick = this.handleHandleClick.bind(this), this.handleDrag = this.handleDrag.bind(this), this.handleDrop = this.handleDrop.bind(this);
  }
  componentDidMount() {
    const { container: t } = this.props;
    t.current && t.current.addEventListener("scroll", this.updateSize), window.addEventListener("resize", this.updateSize), this.updateSize();
  }
  componentWillUnmount() {
    const { container: t } = this.props;
    t.current && t.current.removeEventListener("scroll", this.updateSize), window.removeEventListener("resize", this.updateSize);
  }
  updateSize = () => {
    const { container: t } = this.props;
    if (t.current) {
      const { current: e } = t;
      this.setState({
        size: e.offsetHeight / e.scrollHeight,
        progress: e.scrollTop / e.scrollHeight
      });
    }
  };
  handleTrackClick(t) {
    const { container: e } = this.props, { size: n } = this.state;
    if (this.setState({
      offset: n / 2
    }), e.current) {
      const o = e.current.getBoundingClientRect();
      let r = (t.clientY - o.top) / e.current.offsetHeight - n / 2;
      r < 0 && (r = 0), r + n > 1 && (r = 1 - n), e.current.scrollTop = r * e.current.scrollHeight, window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
    }
  }
  handleHandleClick(t) {
    const { size: e } = this.state;
    if (t.stopPropagation(), !(t.target instanceof Element)) return;
    const n = t.target.getBoundingClientRect();
    this.setState({
      offset: (t.clientY - n.top) / n.height * e
    }), window.addEventListener("mousemove", this.handleDrag), window.addEventListener("mouseup", this.handleDrop);
  }
  handleDrag(t) {
    t.preventDefault();
    const { container: e } = this.props, { size: n, offset: o } = this.state;
    if (e.current) {
      const r = e.current.getBoundingClientRect();
      let i = (t.clientY - r.top) / e.current.offsetHeight - o;
      i < 0 && (i = 0), i + n > 1 && (i = 1 - n), e.current.scrollTop = i * e.current.scrollHeight;
    }
  }
  handleDrop() {
    window.removeEventListener("mousemove", this.handleDrag), window.removeEventListener("mouseup", this.handleDrop);
  }
  render() {
    const { className: t, thumbClassName: e, trackClassName: n, ...o } = this.props, { size: r, progress: i } = this.state, l = f(t);
    return /* @__PURE__ */ s.jsx("div", { ...o, className: l, children: /* @__PURE__ */ s.jsx(
      "div",
      {
        className: f(nr.track, n),
        onMouseDown: this.handleTrackClick,
        children: /* @__PURE__ */ s.jsx(
          "div",
          {
            className: f(nr.handle, e),
            onMouseDown: this.handleHandleClick,
            style: {
              height: `${r * 100}%`,
              top: `${i * 100}%`
            }
          }
        )
      }
    ) });
  }
}
const HI = "h-scrollShadow--scrollShadow__wrapper", WI = "h-scrollShadow--scrollShadow__content", sr = {
  wrapper: HI,
  content: WI
}, Vk = ({
  className: a,
  children: t,
  ...e
}) => {
  const n = f(sr.wrapper, a);
  return /* @__PURE__ */ s.jsx("div", { className: n, ...e, children: /* @__PURE__ */ s.jsx("div", { className: sr.content, children: t }) });
}, MI = "h-searchInput--searchInput__root", zI = "h-searchInput--searchInput__input", VI = "h-searchInput--searchInput__inputButton", Tn = {
  root: MI,
  input: zI,
  inputButton: VI
}, KI = 275, or = 300, Kk = ({
  className: a,
  initialSearch: t,
  maxWidth: e = KI,
  placeholder: n,
  onChange: o,
  onSubmit: r,
  onToggle: i,
  ...l
}) => {
  const c = Y(null), [d, h] = V(!!t), [u, p] = V(!1), [m, g] = V(t ?? "");
  Pa(
    () => {
      u && (h(!1), p(!1), g(""));
    },
    or,
    [u]
  ), Gt(() => {
    i?.(d), d && requestAnimationFrame(() => c.current?.focus());
  }, [d]);
  const b = P(() => {
    h(!0);
  }, []), x = P(() => {
    p(!0);
  }, []), w = P(
    (C) => {
      C.preventDefault(), r(m);
    },
    [r, m]
  ), y = P(
    (C) => {
      const {
        target: { value: S }
      } = C;
      g(S), o?.(S);
    },
    [o]
  ), v = P(
    ({ key: C }) => {
      C === "Enter" && b();
    },
    [b]
  ), _ = P(
    ({ key: C }) => {
      (C === "Esc" || C === "Escape") && x();
    },
    [x]
  );
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      className: f(Tn.root, a),
      style: {
        "--max-width": `${d && !u ? e : 32}px`,
        "--transition-delay": `${or}ms`
      },
      ...l,
      children: d ? /* @__PURE__ */ s.jsx("form", { onSubmit: w, children: /* @__PURE__ */ s.jsx(
        Ut,
        {
          className: Tn.input,
          ref: c,
          onChange: y,
          placeholder: n ?? "Search...",
          type: "search",
          value: m,
          prefix: {
            type: "button",
            button: {
              icon: "search",
              onClick: w,
              className: Tn.inputButton
            }
          },
          suffix: {
            type: "button",
            button: {
              icon: "close",
              onClick: x,
              className: Tn.inputButton
            }
          },
          onKeyDown: _
        }
      ) }) : /* @__PURE__ */ s.jsx(
        K,
        {
          icon: "search",
          variant: "secondary",
          onClick: b,
          onKeyDown: v,
          "data-testid": "search-input-button"
        }
      )
    }
  );
}, UI = "h-selectOption--selectOption__root", qI = "h-selectOption--selectOption__checkbox", GI = "h-selectOption--selectOption__content", Cs = {
  root: UI,
  checkbox: qI,
  content: GI
}, Uk = (a) => {
  const t = f(Cs.root);
  return /* @__PURE__ */ s.jsxs("label", { className: t, children: [
    /* @__PURE__ */ s.jsx(
      an,
      {
        ...a,
        className: f(Cs.checkbox, a.className)
      }
    ),
    /* @__PURE__ */ s.jsx("div", { className: Cs.content, children: a.name })
  ] });
}, YI = "h-simpleProgressBar--simpleProgressBar__container", QI = "h-simpleProgressBar--simpleProgressBar__progressBar", XI = "h-simpleProgressBar--simpleProgressBar__progressBarFill", ws = {
  container: YI,
  progressBar: QI,
  progressBarFill: XI
}, ZI = "simpleProgressBarId";
function qk({
  progress: a,
  base: t = 100,
  progressColor: e = "purple.500",
  backgroundColor: n = "neutral.200",
  tooltipContent: o,
  tooltipProps: r,
  ...i
}) {
  const [l, c] = V(0), d = 4;
  tt(() => c(a), [a]);
  const h = t >= l ? l / t : 1, u = () => d / h, p = {
    backgroundColor: Ze(n)
  }, m = {
    transform: `scaleX(${h})`,
    borderTopRightRadius: `${u()}px ${d}px`,
    borderBottomRightRadius: `${u()}px ${d}px`,
    backgroundColor: Ze(e)
  };
  return /* @__PURE__ */ s.jsx(
    O,
    {
      "test-id": ZI,
      "align-items": "center",
      "justify-content": "center",
      className: ws.container,
      ...i,
      children: /* @__PURE__ */ s.jsx(
        gt,
        {
          disabled: !o,
          content: o,
          wrap: "none",
          ...r,
          children: /* @__PURE__ */ s.jsx("div", { className: ws.progressBar, style: p, children: /* @__PURE__ */ s.jsx(
            "div",
            {
              className: ws.progressBarFill,
              style: m
            }
          ) })
        }
      )
    }
  );
}
const JI = "h-tabsWithContent--tabsWithContent__container", tD = "h-tabsWithContent--tabsWithContent__containerTop", eD = "h-tabsWithContent--tabsWithContent__containerLeft", nD = "h-tabsWithContent--tabsWithContent__containerRight", sD = "h-tabsWithContent--tabsWithContent__containerBottom", oD = "h-tabsWithContent--tabsWithContent__childrenContainer", _e = {
  container: JI,
  containerTop: tD,
  containerLeft: eD,
  containerRight: nD,
  containerBottom: sD,
  childrenContainer: oD
};
class Rs extends _t {
  static defaultProps = {
    tabsPlacement: "top"
  };
  constructor(t) {
    super(t), this.state = { activeTab: t.initiallySelectedTabId }, this.handleTabChange = this.handleTabChange.bind(this);
  }
  handleTabChange(t) {
    this.ensureTabIsValid(t) && (this.setState({ activeTab: t }), this.props.onChange?.(t));
  }
  ensureTabIsValid(t) {
    return this.props.tabs.some((e) => e.id === t);
  }
  getActiveChildIndex() {
    return this.props.tabs.findIndex(({ id: t }) => t === this.state.activeTab);
  }
  render() {
    const {
      className: t,
      tabsClassName: e,
      tabClassName: n,
      tabSelectedClassName: o,
      childrenWrapperClassName: r,
      tabs: i,
      children: l,
      tabsPlacement: c
    } = this.props, { activeTab: d } = this.state, h = Ft.toArray(l);
    if (h.length !== i.length) {
      const g = `${Rs.name}: Number of tabs don't match the number of children.`;
      console.warn(g);
    }
    const u = this.getActiveChildIndex();
    if (u === -1) {
      const g = `${Rs.name}: The selected tab does not exist in tabs array!`;
      console.warn(g);
    }
    const p = f(t, _e.container, {
      [_e.containerTop]: c === "top",
      [_e.containerLeft]: c === "left",
      [_e.containerBottom]: c === "bottom",
      [_e.containerRight]: c === "right"
    }), m = f(
      r,
      _e.childrenContainer
    );
    return /* @__PURE__ */ s.jsxs("section", { className: p, children: [
      /* @__PURE__ */ s.jsx(
        Qf,
        {
          className: e,
          tabClassName: n,
          tabSelectedClassName: o,
          tabs: i,
          onChange: this.handleTabChange,
          selectedId: d,
          tabsPlacement: c
        }
      ),
      /* @__PURE__ */ s.jsx("div", { className: m, children: h[u] })
    ] });
  }
}
const rD = "h-tagsInput--tagsInput__root", aD = "h-tagsInput--tagsInput__wrapper", iD = "h-tagsInput--tagsInput__input", lD = "h-tagsInput--tagsInput__inputIsHidden", cD = "h-tagsInput--tagsInput__placeholder", dD = "h-tagsInput--tagsInput__placeholderText", hD = "h-tagsInput--tagsInput__iconBox", uD = "h-tagsInput--tagsInput__iconText", pD = "h-tagsInput--tagsInput__tag", mD = "h-tagsInput--tagsInput__tagIsActive", gD = "h-tagsInput--tagsInput__tagButton", fD = "h-tagsInput--tagsInput__divider", ut = {
  root: rD,
  wrapper: aD,
  input: iD,
  inputIsHidden: lD,
  placeholder: cD,
  placeholderText: dD,
  iconBox: hD,
  iconText: uD,
  tag: pD,
  tagIsActive: mD,
  tagButton: gD,
  divider: fD
};
function rr(a = [], t) {
  switch (t) {
    case "asc":
      return a.sort();
    case "desc":
      return a.sort().reverse();
    default:
      return a;
  }
}
const bD = 255, Gk = ({
  className: a,
  disabled: t,
  limit: e,
  placeholder: n,
  selectedTags: o,
  sortDirection: r,
  onChange: i
}) => {
  const l = Y(null), c = Y(null), [d, h] = V(""), [u, p] = V(
    rr(o, r)
  ), [m, g] = V(""), [b, x] = V(!1);
  pr(l, () => x(!1)), Gt(() => i(u), [u, i]), Gt(() => {
    c.current && b && c.current.focus();
  }, [c.current, b]);
  const w = (I) => {
    h(I.target.value ?? "");
  }, y = (I) => {
    const T = u.indexOf(m);
    switch (I.key) {
      // Creates a new tag from the given input text.
      case "Enter":
        !m && d && p((R) => {
          const A = Array.from(/* @__PURE__ */ new Set([...R, d]));
          return h(""), rr(A, r);
        });
        break;
      // If there is no input text left, it will select the last tag.
      // If there is already a tag selected, it will remove that from the list.
      case "Backspace":
        !m && d.length === 0 && g(u[u.length - 1]), m && (v(m), g(""));
        break;
      // If there is a tag selected, it will select the previous one.
      case "ArrowLeft":
        m && T > 0 && g(u[T - 1]);
        break;
      // If there is a tag selected, it will select the next one.
      case "ArrowRight":
        m && T < u.length - 1 && g(u[T + 1]);
        break;
      default:
        m && g("");
    }
  }, v = (I) => {
    p((T) => {
      const R = [...T];
      return R.splice(R.indexOf(I), 1), R;
    });
  }, _ = b ? u.length : e || u.length, C = _ < u.length, S = u.slice(0, _);
  return /* @__PURE__ */ s.jsx(
    Rt,
    {
      ref: l,
      className: f(ut.root, a),
      onClick: () => x(!0),
      disabled: t,
      children: /* @__PURE__ */ s.jsxs("div", { className: ut.wrapper, "data-testid": "tags-wrapper", children: [
        S.map((I, T, R) => {
          const A = !b && R.length > 1 && T === R.length - 1;
          return /* @__PURE__ */ s.jsxs(Yt, { children: [
            A && /* @__PURE__ */ s.jsx(
              L.Paragraph,
              {
                variant: "3",
                color: "secondary",
                className: ut.divider,
                children: "or"
              }
            ),
            /* @__PURE__ */ s.jsx(
              Ie,
              {
                className: f(ut.tag, {
                  [ut.tagIsActive]: I === m
                }),
                onDelete: () => v(I),
                "data-testid": "tag",
                children: I
              },
              I
            )
          ] }, I);
        }),
        !b && C && /* @__PURE__ */ s.jsxs(
          Ie,
          {
            className: f(ut.tag, ut.tagButton),
            "data-testid": "tag",
            children: [
              "+",
              u.length - _
            ]
          }
        ),
        !b && !u.length && !d && /* @__PURE__ */ s.jsx(O, { className: ut.placeholder, alignItems: "center", gap: "200", children: n ? /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.placeholderText, variant: "2", children: n }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.placeholderText, variant: "2", children: "Type words or phrases and add with" }),
          /* @__PURE__ */ s.jsxs("div", { className: ut.iconBox, children: [
            /* @__PURE__ */ s.jsx(N, { name: "enter", color: "neutral.500" }),
            /* @__PURE__ */ s.jsx(L.Paragraph, { className: ut.iconText, children: "enter" })
          ] })
        ] }) }),
        /* @__PURE__ */ s.jsx(
          "input",
          {
            className: f(ut.input, {
              [ut.inputIsHidden]: !b
            }),
            onChange: w,
            onKeyDown: y,
            maxLength: bD,
            ref: c,
            type: "text",
            value: d,
            "data-testid": "tag-input"
          }
        )
      ] })
    }
  );
}, xD = "h-textWithHighlight--textWithHighlight__highlight", yD = {
  highlight: xD
}, _D = ({
  text: a,
  highlight: t,
  className: e,
  highlightClassName: n,
  ignoreCase: o = !0
}) => {
  if (!t?.trim())
    return /* @__PURE__ */ s.jsx(s.Fragment, { children: a });
  const r = new RegExp(
    $s(t.trim()),
    o ? "ig" : "g"
  ), i = a.match(r), l = a.split(r);
  return /* @__PURE__ */ s.jsx("span", { className: e, children: l.map((c, d) => /* @__PURE__ */ s.jsxs("span", { children: [
    c,
    i?.[d] && /* @__PURE__ */ s.jsx("em", { className: f(yD.highlight, n), children: i[d] })
  ] }, d)) });
}, CD = Mn(_D);
CD.name = "TextWithHighlight";
const wD = "h-timestamp--timestamp__timestamp", vD = {
  timestamp: wD
}, SD = 1e4;
class Yk extends _t {
  interval;
  static defaultProps = {
    refreshRate: SD
  };
  constructor(t) {
    super(t);
    const { relative: e, counter: n, initialFormat: o } = t;
    let r = o ?? "absolute";
    e ? r = "ago" : n && (r = "counter"), this.state = {
      format: r,
      pristine: !0
    }, this.handleClick = this.handleClick.bind(this), this.interval = null;
  }
  componentDidMount() {
    const { format: t } = this.state;
    (t === "ago" || t === "counter") && this.startTicker();
  }
  componentDidUpdate(t) {
    const { relative: e, initialFormat: n } = this.props, { pristine: o } = this.state;
    e !== t.relative && o && this.setState({
      format: e ? "ago" : "absolute"
    }), n && n !== t.initialFormat && this.setState({ format: n });
  }
  componentWillUnmount() {
    this.stopTicker();
  }
  startTicker() {
    this.interval = setInterval(() => {
      this.forceUpdate();
    }, this.props.refreshRate ?? 0);
  }
  stopTicker() {
    this.interval && clearInterval(this.interval);
  }
  handleClick(t) {
    const { onClick: e } = this.props, { format: n } = this.state;
    let o = this.state.format;
    n === "ago" ? (o = "full", this.stopTicker()) : n === "full" ? o = "absolute" : n === "absolute" && (o = "ago", this.startTicker()), this.setState({
      pristine: !1,
      format: o
    }), e?.(o, t);
  }
  getTimeString() {
    let { time: t } = this.props;
    const { isSecondsDisplayed: e, customFormatters: n } = this.props, { format: o } = this.state;
    let r = "";
    if (typeof t == "number") {
      const l = /* @__PURE__ */ new Date();
      l.setTime(t * 1e3), t = l;
    }
    const i = j(t).utc().local();
    if (o === "counter") {
      const l = j(t).utc(), d = j().utc().diff(l) / 1e3, h = Math.floor(d / (60 * 60)), u = Math.floor(h / 24), p = h % 24, m = h * 60 * 60, g = Math.floor((d - m) / 60), b = g * 60, x = Math.floor(
        d - m - b
      );
      r = [
        p.toString().padStart(2, "0"),
        g.toString().padStart(2, "0"),
        x.toString().padStart(2, "0")
      ].join(":"), u > 0 && (r = `${u} ${u === 1 ? "DAY" : "DAYS"} ${r}`);
    } else if (o === "full") {
      const l = n?.full ?? (e ? "MMM Do YYYY, hh:mm:ss A" : "lll");
      r = i.format(l);
    } else if (o === "absolute")
      if (j().diff(j(t), "hours") > 12) {
        const l = n?.absolute ?? `D MMMM LT${e ? "S" : ""}`;
        r = i.format(l);
      } else {
        const l = n?.absolute ?? `LT${e ? "S" : ""}`;
        r = i.format(l);
      }
    else
      r = Hh(i);
    return r;
  }
  render() {
    const {
      className: t,
      relative: e,
      time: n,
      refreshRate: o,
      counter: r,
      customFormatters: i,
      isSecondsDisplayed: l,
      initialFormat: c,
      onClick: d,
      ...h
    } = this.props, u = f(
      {
        [vD.timestamp]: !0
      },
      t
    );
    return /* @__PURE__ */ s.jsx(
      "span",
      {
        ...h,
        ...Kn(this.handleClick),
        className: u,
        children: this.getTimeString()
      }
    );
  }
}
const ID = "h-token--token__root", DD = "h-token--token__select", kD = "h-token--token__label", TD = "h-token--token__rootReadonly", jD = "h-token--token__rootPrimary", ND = "h-token--token__rootWithError", PD = "h-token--token__value", FD = "h-token--token__icon", At = {
  root: ID,
  select: DD,
  label: kD,
  rootReadonly: TD,
  rootPrimary: jD,
  rootWithError: ND,
  value: PD,
  icon: FD
};
class Qk extends D {
  render() {
    const {
      onDelete: t,
      id: e,
      label: n,
      options: o,
      valueLabel: r,
      primary: i,
      input: l,
      meta: c,
      defaultOption: d,
      className: h,
      ...u
    } = this.props, p = f(
      {
        [At.root]: !0,
        [At.rootPrimary]: i,
        [At.rootWithError]: c?.error,
        [At.rootReadonly]: !o && !t
      },
      h
    );
    let m = r;
    if (!m && l && o && o.length) {
      const g = o.filter(({ value: b }) => l.value === b);
      g.length && (m = g[0].label);
    }
    return !m && d && (m = d), /* @__PURE__ */ s.jsxs("div", { ...u, className: p, children: [
      !!o && /* @__PURE__ */ s.jsxs("select", { ...l, className: At.select, id: e, children: [
        !!d && /* @__PURE__ */ s.jsx("option", { disabled: !0, hidden: !0, value: "", children: d }),
        o.map((g) => /* @__PURE__ */ s.jsx("option", { value: g.value, children: g.label }, g.value?.toString()))
      ] }),
      /* @__PURE__ */ s.jsxs("label", { className: At.label, htmlFor: e, children: [
        n,
        /* @__PURE__ */ s.jsx("span", { className: At.value, children: m }),
        !!o && /* @__PURE__ */ s.jsx(N, { className: At.icon, name: "angle-down" }),
        !!t && /* @__PURE__ */ s.jsx("span", { ...Kn(t), children: /* @__PURE__ */ s.jsx(N, { className: At.icon, name: "close", onClick: t }) })
      ] })
    ] });
  }
}
const RD = "h-skeleton--skeleton__root", ED = "h-skeleton--skeleton__rootAnimationPulse", LD = "h-skeleton--skeleton__rootAnimationWave", vs = {
  root: RD,
  rootAnimationPulse: ED,
  rootAnimationWave: LD
};
function ar({ className: a, animation: t = "pulse", ...e }, n) {
  const o = f(
    {
      [vs.root]: !0,
      [vs.rootAnimationPulse]: t === "pulse",
      [vs.rootAnimationWave]: t === "wave"
    },
    a
  );
  return /* @__PURE__ */ s.jsx(rt, { className: o, ...e, ref: n });
}
const Xk = Object.assign($(ar), {
  name: ar.name
}), AD = "h-breadcrumbs--breadcrumbs__root", $D = "h-breadcrumbs--breadcrumbs__list", BD = "h-breadcrumbs--breadcrumbs__item", OD = "h-breadcrumbs--breadcrumbs__separator", jn = {
  root: AD,
  list: $D,
  item: BD,
  separator: OD
}, Zk = $(function({
  className: t,
  children: e,
  as: n,
  separator: o = /* @__PURE__ */ s.jsx(N, { name: "angle-right" }),
  "aria-label": r = "breadcrumb",
  ...i
}, l) {
  const c = n ?? "nav", d = Ft.toArray(e).filter(Boolean);
  return /* @__PURE__ */ s.jsx(
    c,
    {
      ...i,
      ref: l,
      className: f(jn.root, t),
      "aria-label": r,
      children: /* @__PURE__ */ s.jsx("ol", { className: jn.list, children: d.map((h, u) => {
        const p = u === d.length - 1, m = typeof h == "string" || typeof h == "number" ? /* @__PURE__ */ s.jsx("span", { children: h }) : h;
        return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(
            "li",
            {
              className: jn.item,
              "aria-current": p ? "page" : void 0,
              children: m
            },
            u
          ),
          !p && /* @__PURE__ */ s.jsx(
            "li",
            {
              className: jn.separator,
              "data-testid": "breadcrumbs-separator",
              "aria-hidden": "true",
              children: o
            }
          )
        ] });
      }) })
    }
  );
});
export {
  Bg as AddonTriggerContext,
  Og as AddonTriggerEvents,
  QD as Attachment,
  mr as Avatar,
  $u as AvatarSelectItem,
  XD as Badge,
  ZD as Banner,
  rt as Box,
  Zk as Breadcrumbs,
  Q as Button,
  JD as ButtonGroup,
  oo as ButtonList,
  ck as CheckableAvatarSelectItem,
  Ks as CheckableBaseItem,
  ak as CheckableSelectItem,
  lk as CheckableTagSelectItem,
  an as Checkbox,
  sp as Chip,
  ek as CollapseCard,
  nk as Collapsible,
  qn as ColorPicker,
  pt as Column,
  Yc as Columns,
  pd as CopyToClipboard,
  sk as CopyToClipboardButton,
  Tk as CountryFlag,
  ok as DataTable,
  jm as DatePicker,
  Qe as DatePickerOld,
  Cm as DateRangePicker,
  Uu as DeselectItem,
  uk as Dialer,
  Vn as Divider,
  Xt as Dropdown,
  re as DropdownButton,
  ln as DropdownButtonContext,
  Vs as DropdownInfinite,
  vo as DropdownItem,
  Gs as DropdownSelect,
  Pr as DropdownSelectContainer,
  pk as DropdownSelectMultiple,
  Ta as EMOJIS,
  eT as EmojiPicker,
  cn as EmptySelectItem,
  Hd as EmptyState,
  Bs as ErrorBoundary,
  nT as ErrorBoundaryContext,
  kk as FieldAddonDropdown,
  Yn as FieldAlert,
  mk as FieldButton,
  Dk as FieldColorPicker,
  gk as FieldDatePicker,
  fk as FieldDateRangePicker,
  zs as FieldLabel,
  xk as FieldRichText,
  yk as FieldSelect,
  _k as FieldSelectionList,
  Ck as FieldSlider,
  wk as FieldSwitch,
  Ts as FieldText,
  vk as FieldTextarea,
  Sk as FieldTimePicker,
  Ik as FieldTimeRangePicker,
  z as FieldWrapper,
  O as FlexBox,
  gr as FocusScope,
  Pk as FormField,
  Nk as FormGrid,
  Ms as HelpIcon,
  Fk as HelperField,
  N as Icon,
  K as IconButton,
  Os as Image,
  ig as InputDatePicker,
  nn as InputDateRangePicker,
  Rk as InputDuration,
  Zs as InputRichText,
  gx as InputSelectionList,
  Ut as InputText,
  Rt as InputWrapper,
  Ek as Lightbox,
  Lk as List,
  Lk as ListV2,
  Ak as MediaPlayer,
  Zv as Modal,
  $k as ModalBody,
  rI as ModalFoot,
  Bk as ModalHead,
  YD as NavigationButton,
  Ok as Page,
  Fd as Pagination,
  Kv as Portal,
  Tr as Presets,
  Hk as Radio,
  Mk as RemovableCard,
  Wk as ReverseScroll,
  Mr as SandboxIframe,
  Vk as ScrollShadow,
  zk as Scrollbar,
  Kk as SearchInput,
  Rp as Select,
  jr as SelectItem,
  Uk as SelectOption,
  Xb as SelectionList,
  fd as SimplePagination,
  qk as SimpleProgressBar,
  Xk as Skeleton,
  Fs as Slider,
  zn as Spinner,
  $x as Switch,
  mt as Table,
  Gn as TableContext,
  Qf as Tabs,
  Rs as TabsWithContent,
  Ie as Tag,
  hk as TagDeselectItem,
  ik as TagSelectItem,
  dk as TagSelectSuggestion,
  Gk as TagsInput,
  L as Text,
  CD as TextWithHighlight,
  Br as Textarea,
  en as TimePicker,
  um as TimeRangePicker,
  Yk as Timestamp,
  Qk as Token,
  gt as Tooltip,
  aT as addSvgIconsToDocument,
  Oi as badgeTestId,
  Kc as colorPickerTestId,
  jk as countryCodes,
  rk as datepickerDisableWeekends,
  sT as defaultElementType,
  vg as formattingOptions,
  Pe as getSelectionListContext,
  oT as iconMeta,
  Bo as inputRichTextCommands,
  mx as inputSelectionListTestId,
  PI as reverseScrollTestId,
  on as withErrorBoundary
};
//# sourceMappingURL=index.js.map
